import { useTheme, combineStyles, forwardRefWithAs, responsive as responsive_exports, ButtonCore, spacing, FocusRing, useRenderChildrenStatus, useInitialFocusElem, useMergeRefs, AddIcon as AddIcon_default, A11Y, LabelCore, TextCore, TextFieldCore as TextFieldCoreFR, InputCore, IssueIcon as IssueIcon_default, useComponentTheme, CartIcon as CartIcon_default, ToggleButtonCore, PlayIcon as PlayIcon_default, PauseIcon as PauseIcon_default, GroupIcon as GroupIcon_default, useIdsFeatureFlag, Flex, VisuallyHidden, useIsPantryEnabled, useAriaLabel, ChevronDownIcon as ChevronDownIcon_default, ChevronRightIcon as ChevronRightIcon_default, blendColors, aspectRatio, LinkCore, TextAreaCore, RadioDisabledSelectedIcon as RadioDisabledSelectedIcon_default, RadioSelectedIcon as RadioSelectedIcon_default, RadioDisabledUnselectedIcon as RadioDisabledUnselectedIcon_default, RadioUnselectedIcon as RadioUnselectedIcon_default, InformationIcon as InformationIcon_default, CloseIcon as CloseIcon_default, CheckboxCore, useAriaLoading, addAlphaToHex, elevation, POSITION_X_Y_CENTER, bodyScrollLock, SearchIcon as SearchIcon_default, TrashIcon as TrashIcon_default, SubtractIcon as SubtractIcon_default, useOnClickOutside, ColorCacheContext, computeInteractiveBackgroundColors, useIdsConfig, useFocusRing, extractDWebTypographyStyles, ChevronLeftIcon as ChevronLeftIcon_default, useRequiredContext, STRETCH_OVER_RELATIVE_PARENT, ConfirmIcon as ConfirmIcon_default, SVGIcon, MarkerIcon as MarkerIcon_default, ChevronUpIcon as ChevronUpIcon_default, FlagUSIcon as FlagUSIcon_default, FlagUKIcon as FlagUKIcon_default, FlagJPIcon as FlagJPIcon_default, FlagFRIcon as FlagFRIcon_default, FlagDEIcon as FlagDEIcon_default, FlagCAIcon as FlagCAIcon_default, FlagBRIcon as FlagBRIcon_default, FlagAUIcon as FlagAUIcon_default, CheckboxDisabledSelectedIcon as CheckboxDisabledSelectedIcon_default, CheckboxSelectedIcon as CheckboxSelectedIcon_default, CheckboxDisabledIndeterminateIcon as CheckboxDisabledIndeterminateIcon_default, CheckboxIndeterminateIcon as CheckboxIndeterminateIcon_default, CheckboxDisabledUnselectedIcon as CheckboxDisabledUnselectedIcon_default, CheckboxUnselectedIcon as CheckboxUnselectedIcon_default, layers, InstacartIcon as InstacartIcon_default, lineClamp, LikeIcon as LikeIcon_default, DislikeIcon as DislikeIcon_default, SpeedIcon as SpeedIcon_default, useAriaCurrent, DeliveryIcon as DeliveryIcon_default, PickupIcon as PickupIcon_default, StoreIcon as StoreIcon_default, PlaceholderDarkIcon as PlaceholderDarkIcon_default } from "./auth-service-tools24.js";
import { jsx, jsxs, Fragment as Fragment$1 } from "@emotion/react/jsx-runtime";
import React__default, { forwardRef, createContext, cloneElement, useState, useRef, useEffect, Fragment, useMemo, Children, useContext, isValidElement, useCallback, useLayoutEffect } from "react";
import { r as reactIsExports } from "./auth-service-tools136.js";
import { keyframes } from "@emotion/react";
import { unstable_useId } from "./auth-service-tools137.js";
import { Dialog } from "./auth-service-tools138.js";
import { Checkbox } from "./auth-service-tools139.js";
import { Radio } from "./auth-service-tools140.js";
import { useTooltipState } from "./auth-service-tools141.js";
import { TooltipReference } from "./auth-service-tools142.js";
import { Tooltip as Tooltip$1 } from "./auth-service-tools143.js";
import { TooltipArrow } from "./auth-service-tools144.js";
import { DialogBackdrop } from "./auth-service-tools145.js";
import { PopoverDisclosure } from "./auth-service-tools146.js";
import { Popover } from "./auth-service-tools147.js";
import { PopoverArrow } from "./auth-service-tools148.js";
import { useDialogState } from "./auth-service-tools149.js";
import { TabList as TabList$1 } from "./auth-service-tools150.js";
import { Tab as Tab$1 } from "./auth-service-tools151.js";
import { TabPanel as TabPanel$1 } from "./auth-service-tools152.js";
import TransitionGroup from "./auth-service-tools153.js";
import CSSTransition from "./auth-service-tools154.js";
import { usePopoverState } from "./auth-service-tools155.js";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;

var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);

  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};

var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

var __name = (target, value) => __defProp(target, "name", {
  value,
  configurable: true
});

var __objRest = (source, exclude) => {
  var target = {};

  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];

  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};

var __export = (target, all) => {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

var containerStyles = /* @__PURE__ */__name((_ref2) => {
  let {
    theme
  } = _ref2;
  return __spreadValues(__spreadProps(__spreadValues({}, theme.typography.bodySmall2), {
    color: theme.colors.systemGrayscale50
  }), lineClamp(2));
}, "containerStyles");

function ItemAttributeBase(_ref3) {
  let {
    children
  } = _ref3;
  const theme = useTheme();
  return /* @__PURE__ */jsx("div", {
    title: children,
    css: containerStyles({
      theme
    }),
    children
  });
}

__name(ItemAttributeBase, "ItemAttributeBase");

function ItemAttribute(props) {
  return /* @__PURE__ */jsx(ItemAttributeBase, __spreadValues({}, props));
}

__name(ItemAttribute, "ItemAttribute");

var getStyles = /* @__PURE__ */__name(() => ({
  container: {
    position: "relative"
  }
}), "getStyles");

var ItemBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function ItemBase2(props, ref) {
  const _a = props,
        {
    children,
    styles: propStyles
  } = _a,
        rest = __objRest(_a, ["children", "styles"]);

  const styles25 = combineStyles(getStyles(), propStyles);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    ref
  }, rest), {
    css: styles25.container,
    role: "group",
    children
  }));
}, "ItemBase"));

var baseStyles = /* @__PURE__ */__name((_ref4) => {
  let {
    theme,
    colorKey
  } = _ref4;
  return {
    container: {
      display: "flex",
      margin: `${spacing.s4}px 0px`,
      justifyContent: "flex-start",
      alignItems: "center"
    },
    label: __spreadValues(__spreadValues({
      color: theme.colors[colorKey]
    }, theme.typography.bodySmall1), lineClamp(2)),
    icon: {
      flex: "0 0 20px",
      lineHeight: theme.typography.bodySmall1.lineHeight,
      // aligned to the bottom
      display: "flex",
      justifyContent: "flex-start",
      flexDirection: "column"
    }
  };
}, "baseStyles");

var iconSize = 16;

function ItemDynamicLabelBase(_ref5) {
  let {
    children,
    color: colorKey = "systemGrayscale70",
    styles: styles25
  } = _ref5;
  const theme = useTheme();
  const {
    container: containerCss,
    label: labelCss,
    icon: iconCss
  } = combineStyles(baseStyles({
    theme,
    colorKey
  }), styles25);

  if (typeof children === "string" || typeof children === "number") {
    return /* @__PURE__ */jsx("div", {
      css: containerCss,
      children: /* @__PURE__ */jsx("div", {
        css: labelCss,
        children
      })
    });
  }

  const tree = Children.toArray(children);
  const label = tree[1];
  const icon = reactIsExports.isElement(tree[0]) && /*#__PURE__*/cloneElement(tree[0], __spreadProps(__spreadValues({}, tree[0].props), {
    color: colorKey,
    size: iconSize
  }));
  return /* @__PURE__ */jsxs("div", {
    css: containerCss,
    children: [/* @__PURE__ */jsx("div", {
      css: iconCss,
      children: icon
    }), /* @__PURE__ */jsx("div", {
      css: labelCss,
      children: label
    })]
  });
}

__name(ItemDynamicLabelBase, "ItemDynamicLabelBase");

function ItemDynamicLabel(props) {
  return /* @__PURE__ */jsx(ItemDynamicLabelBase, __spreadValues({}, props));
}

__name(ItemDynamicLabel, "ItemDynamicLabel");

var getStyles2 = /* @__PURE__ */__name(theme => __spreadValues({
  img: {
    maxWidth: "100%",
    maxHeight: "100%",
    borderRadius: theme.radius.r12
  }
}, aspectRatio(1, 1)), "getStyles");

var ItemImageBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function ItemImageBase2(props, ref) {
  const _a = props,
        {
    styles: styles25,
    src,
    alt,
    children
  } = _a,
        rest = __objRest(_a, ["styles", "src", "alt", "children"]);

  const theme = useTheme();
  const {
    box,
    boxInside,
    img
  } = combineStyles(getStyles2(theme), styles25);
  return /* @__PURE__ */jsx("div", {
    css: box,
    children: /* @__PURE__ */jsxs("div", {
      css: boxInside,
      children: [/* @__PURE__ */jsx("img", __spreadProps(__spreadValues({}, rest), {
        ref,
        css: img,
        src,
        alt
      })), children]
    })
  });
}, "ItemImageBase"));

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function ItemImage2(props, ref) {
  return /* @__PURE__ */jsx(ItemImageBase, __spreadValues({
    ref
  }, props));
}, "ItemImage"));

var getStyles3 = /* @__PURE__ */__name(theme => ({
  a: {
    textDecoration: "none",
    // so we get one solid focus ring
    display: "block",
    // so the focus ring can use position: absolute
    position: "relative"
  },
  focusRing: {
    border: `2px solid ${theme.colors.systemGrayscale70}`,
    content: '""',
    display: "block",
    position: "absolute",
    top: -4,
    bottom: -4,
    left: -4,
    right: -4
  }
}), "getStyles");

var ItemLinkBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function ItemLinkBase2(props, ref) {
  const _a = props,
        {
    children,
    styles: styles25
  } = _a,
        rest = __objRest(_a, ["children", "styles"]);

  const theme = useTheme();
  const {
    a,
    focusRing
  } = combineStyles(getStyles3(theme), styles25);
  const aStyles = [a, {
    "&:hover": {
      // surpress the native underlines
      textDecoration: "none"
    },
    "&:focus": {
      // surpress the native focus ring
      outline: "none",
      // surpress the native underlines
      textDecoration: "none"
    },
    "&.focus-visible::after": focusRing
  }];
  return /* @__PURE__ */jsx("a", __spreadProps(__spreadValues({
    ref,
    css: aStyles
  }, rest), {
    children
  }));
}, "ItemLinkBase"));

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function ItemLink2(props, ref) {
  return /* @__PURE__ */jsx(ItemLinkBase, __spreadValues({
    ref
  }, props));
}, "ItemLink"));

var getStyles4 = /* @__PURE__ */__name(theme => ({
  name: __spreadValues(__spreadProps(__spreadValues({}, theme.typography.bodyMedium2), {
    color: theme.colors.systemGrayscale70
  }), lineClamp(3))
}), "getStyles");

function ItemNameBase(props) {
  const {
    children
  } = props;
  const theme = useTheme();
  const {
    name
  } = combineStyles(getStyles4(theme), props.styles);
  return /* @__PURE__ */jsx("div", {
    title: children,
    css: name,
    children
  });
}

__name(ItemNameBase, "ItemNameBase");

function ItemName(props) {
  return /* @__PURE__ */jsx(ItemNameBase, __spreadValues({}, props));
}

__name(ItemName, "ItemName");

var getStyles5 = /* @__PURE__ */__name((_ref6) => {
  let {
    theme
  } = _ref6;
  return {
    span: __spreadProps(__spreadValues({}, theme.typography.bodyMedium1), {
      color: theme.colors.systemGrayscale70
    })
  };
}, "getStyles");

function ItemPriceBase(props) {
  const {
    children,
    styles: styles25
  } = props;
  const theme = useTheme();
  const {
    span
  } = combineStyles(getStyles5({
    theme
  }), styles25);
  return /* @__PURE__ */jsx("span", {
    css: span,
    children
  });
}

__name(ItemPriceBase, "ItemPriceBase");

function ItemPrice(props) {
  return /* @__PURE__ */jsx(ItemPriceBase, __spreadValues({}, props));
}

__name(ItemPrice, "ItemPrice");

var getStyles6 = /* @__PURE__ */__name(() => ({
  container: {}
}), "getStyles");

function ItemPriceSetBase(props) {
  const _a = props,
        {
    children,
    styles: propStyles
  } = _a,
        rest = __objRest(_a, ["children", "styles"]);

  const styles25 = combineStyles(getStyles6(), propStyles);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({}, rest), {
    css: styles25.container,
    children
  }));
}

__name(ItemPriceSetBase, "ItemPriceSetBase");

function ItemPriceSet(props) {
  return /* @__PURE__ */jsx(ItemPriceSetBase, __spreadValues({}, props));
}

__name(ItemPriceSet, "ItemPriceSet");

var getStyles7 = /* @__PURE__ */__name((_ref7) => {
  let {
    theme
  } = _ref7;
  return {
    span: __spreadProps(__spreadValues({}, theme.typography.bodySmall2), {
      color: theme.colors.systemGrayscale50
    })
  };
}, "getStyles");

function ItemRegularPriceBase(props) {
  const theme = useTheme();
  const {
    span
  } = getStyles7({
    theme
  });
  return /* @__PURE__ */jsx("span", {
    css: span,
    children: props.children
  });
}

__name(ItemRegularPriceBase, "ItemRegularPriceBase");

function ItemRegularPrice(props) {
  return /* @__PURE__ */jsx(ItemRegularPriceBase, __spreadValues({}, props));
}

__name(ItemRegularPrice, "ItemRegularPrice");

var {
  s4
} = spacing;

var getStyles8 = /* @__PURE__ */__name(theme => {
  const {
    colors: {
      brandPromotionalRegular
    }
  } = theme;
  return {
    span: {
      color: brandPromotionalRegular,
      marginRight: s4
    }
  };
}, "getStyles");

function ItemSalePrice(props) {
  const theme = useTheme();
  return /* @__PURE__ */jsx(ItemPriceBase, __spreadValues({
    styles: getStyles8(theme)
  }, props));
}

__name(ItemSalePrice, "ItemSalePrice");

var containerStyles2 = /* @__PURE__ */__name((_ref8) => {
  let {
    theme
  } = _ref8;
  return __spreadProps(__spreadValues({}, theme.typography.bodySmall1), {
    color: theme.colors.systemGrayscale50
  });
}, "containerStyles");

function ItemWeightBase(_ref9) {
  let {
    children
  } = _ref9;
  const theme = useTheme();
  return /* @__PURE__ */jsx("div", {
    title: children,
    css: containerStyles2({
      theme
    }),
    children
  });
}

__name(ItemWeightBase, "ItemWeightBase");

function ItemWeight(props) {
  return /* @__PURE__ */jsx(ItemWeightBase, __spreadValues({}, props));
}

__name(ItemWeight, "ItemWeight");

function RetailerLogoIcon(_a) {
  var _b = _a,
      {
    size,
    alt
  } = _b,
      rest = __objRest(_b, ["size", "alt"]);

  const theme = useTheme();
  return /* @__PURE__ */jsx("img", __spreadProps(__spreadValues({
    css: {
      backgroundColor: theme.colors.systemGrayscale00,
      border: `1px solid ${theme.colors.systemGrayscale20}`,
      borderRadius: "50%",
      width: `${size}px`,
      height: `${size}px`
    }
  }, rest), {
    alt
  }));
}

__name(RetailerLogoIcon, "RetailerLogoIcon");

var getStyles9 = /* @__PURE__ */__name((_ref10) => {
  let {
    theme
  } = _ref10;
  return {
    container: {
      alignItems: "flex-start",
      backgroundColor: theme.colors.systemGrayscale10,
      boxSizing: "border-box",
      display: "flex",
      gap: `${spacing.s8}px`,
      position: "relative",
      width: "100%",
      padding: `${spacing.s16}px`,
      [responsive_exports.down("c")]: {
        padding: `${spacing.s8}px ${spacing.s16}px`
      }
    },
    icon: {
      minWidth: 24
    }
  };
}, "getStyles");

var ServiceMessageBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function ServiceMessageBase2(props, ref) {
  const theme = useTheme();

  const _a = props,
        {
    children,
    styles: propStyles,
    icon: Icon,
    color
  } = _a,
        rest = __objRest(_a, ["children", "styles", "icon", "color"]);

  const {
    container,
    icon
  } = combineStyles(getStyles9({
    theme
  }), propStyles);
  return /* @__PURE__ */jsxs("div", __spreadProps(__spreadValues({
    ref
  }, rest), {
    css: container,
    children: [Icon && /* @__PURE__ */jsx(Icon, {
      size: 24,
      css: icon,
      color
    }), children]
  }));
}, "ServiceMessageBase"));
ServiceMessageBase.displayName = "ServiceMessageBase";

var getStyles10 = /* @__PURE__ */__name((theme, stepperValue) => ({
  active: {},
  button: {},
  icon: {},
  hover: {},
  content: __spreadValues({
    alignItems: "center",
    display: "flex",
    gap: spacing.s4,
    justifyContent: "center",
    whiteSpace: "nowrap"
  }, theme.typography.bodyEmphasized),
  text: __spreadValues({}, stepperValue === 0 && {
    [responsive_exports.down("c")]: {
      display: "none"
    }
  }),
  wrapper: {}
}), "getStyles");

var defaultIconColor = "systemGrayscale80";
var AddItemButtonBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function AddItemButtonBase2(_a, ref) {
  var _b = _a,
      {
    iconColor: iconColor6 = defaultIconColor,
    inline,
    stepperValue = 0,
    styles: styles25,
    value: textValue
  } = _b,
      rest = __objRest(_b, ["iconColor", "inline", "stepperValue", "styles", "value"]);

  const theme = useTheme();

  const _a2 = combineStyles(getStyles10(theme, stepperValue), styles25),
        {
    button: buttonCSS,
    content: contentCSS,
    icon: iconCSS,
    text: textCSS,
    wrapper: wrapperCSS
  } = _a2,
        restStyles = __objRest(_a2, ["button", "content", "icon", "text", "wrapper"]);

  return /* @__PURE__ */jsx("div", {
    css: wrapperCSS,
    children: /* @__PURE__ */jsxs(ButtonCore, __spreadProps(__spreadValues({}, rest), {
      ref,
      styles: __spreadValues({
        button: buttonCSS,
        content: contentCSS
      }, restStyles),
      children: [(stepperValue === 0 || !textValue) && /* @__PURE__ */jsx(AddIcon_default, {
        css: iconCSS,
        size: 24,
        color: iconColor6
      }), textValue && /* @__PURE__ */jsx("span", {
        css: textCSS,
        children: textValue
      })]
    }))
  });
}, "AddItemButtonBase"));
var buttonSizeStyles = {
  buttonWrapper: {},
  button: {
    border: 0,
    height: 36,
    minWidth: 36
  }
};

var getStyles11 = /* @__PURE__ */__name((_ref11) => {
  let {
    inline,
    stepperValue,
    theme,
    value
  } = _ref11;
  return {
    wrapper: __spreadValues({
      backgroundColor: inline ? theme.colors.systemGrayscale00 : theme.colors.brandPrimaryRegular,
      borderRadius: inline ? theme.radius.r8 : theme.radius.round,
      display: "inline-block"
    }, !inline ? __spreadValues({
      border: 0
    }, elevation.pantryLow2.shadow) : {
      border: `1px solid ${theme.colors.systemGrayscale30}`
    }),
    active: {
      backgroundColor: inline ? theme.colors.systemGrayscale00 : theme.colors.brandPrimaryExtraDark,
      border: inline ? `1px solid ${theme.colors.systemGrayscale80}` : void 0
    },
    button: __spreadProps(__spreadValues(__spreadValues({
      backgroundColor: inline ? theme.colors.systemGrayscale00 : theme.colors.brandPrimaryRegular,
      borderRadius: inline ? theme.radius.r8 : theme.radius.round,
      justifyContent: "space-evenly",
      position: "relative",
      transition: "padding 0.1s ease-out"
    }, buttonSizeStyles.button), value === void 0 ? {
      paddingLeft: 0,
      paddingRight: 0
    } : __spreadValues({
      paddingLeft: stepperValue === 0 ? spacing.s8 : spacing.s12,
      paddingRight: spacing.s12
    }, stepperValue === 0 && {
      '&[data-focus-visible="true"]': {
        paddingLeft: spacing.s12,
        paddingRight: spacing.s16
      }
    })), {
      [responsive_exports.down("c")]: {
        paddingLeft: stepperValue === 0 ? 0 : spacing.s12,
        paddingRight: stepperValue === 0 ? 0 : spacing.s12,
        '&[data-focus-visible="true"]': {
          paddingLeft: stepperValue === 0 ? 0 : spacing.s12,
          paddingRight: stepperValue === 0 ? 0 : spacing.s12
        }
      }
    }),
    hover: __spreadProps(__spreadValues({
      backgroundColor: inline ? theme.colors.systemGrayscale00 : theme.colors.brandPrimaryDark
    }, value !== void 0 && stepperValue === 0 && {
      paddingLeft: spacing.s12,
      paddingRight: spacing.s16
    }), {
      [responsive_exports.down("c")]: {
        paddingLeft: stepperValue === 0 ? 0 : spacing.s12,
        paddingRight: stepperValue === 0 ? 0 : spacing.s12
      }
    }),
    content: {
      color: inline ? theme.colors.systemGrayscale80 : theme.colors.systemGrayscale00
    }
  };
}, "getStyles");

var AddItemButton = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function AddItemButton2(_a, ref) {
  var _b = _a,
      {
    inline,
    stepperValue = 0,
    value
  } = _b,
      props = __objRest(_b, ["inline", "stepperValue", "value"]);

  const theme = useTheme();
  const styles25 = getStyles11({
    inline,
    stepperValue,
    theme,
    value
  });
  return /* @__PURE__ */jsx(FocusRing, {
    borderRadiusOfComponent: `${inline ? theme.radius.r8 : theme.radius.round}px`,
    contrastBorder: !inline,
    offsetOverride: "2px",
    children: /* @__PURE__ */jsx(AddItemButtonBase, __spreadProps(__spreadValues({}, props), {
      iconColor: "systemGrayscale00",
      inline,
      styles: styles25,
      ref,
      stepperValue,
      value
    }))
  });
}, "AddItemButton"));
var disabledColor = "brandPrimaryExtraDark";
var enabledColor = "systemGrayscale80";
var baseStyles2 = {
  buttonContent: {
    display: "flex"
  },
  decrementButton: {
    display: "flex",
    flexWrap: "nowrap",
    // For iOS Safari issue where there's unnecessary padding applied
    padding: 0,
    justifyContent: "center",
    alignItems: "center"
  },
  focusRing: {},
  incrementButton: {
    display: "flex",
    flexWrap: "nowrap",
    // iOS Safari issue where there's unnecessary padding applied
    padding: 0,
    justifyContent: "center",
    alignItems: "center"
  },
  text: {
    userSelect: "none"
  },
  wrapper: {
    display: "flex",
    flexWrap: "nowrap",
    justifyContent: "space-between",
    alignItems: "center"
  }
};

function StepperBase(_ref12) {
  let {
    allowIncrement,
    allowDecrement,
    ariaIncrement,
    ariaDecrement,
    ariaValue,
    decrementType,
    decrementIconProps,
    disabled,
    onIncrement,
    onDecrement,
    styles: styles25,
    incrementButtonRef,
    incrementIconProps,
    value,
    valueText
  } = _ref12;
  const {
    buttonContent: buttonContentCSS,
    decrementButton: decrementCSS,
    focusRing: focusRingCSS,
    incrementButton: incrementCSS,
    text: textCSS,
    wrapper: wrapperCSS
  } = combineStyles(baseStyles2, styles25);
  const incrementDisabled = !allowIncrement || disabled;
  const decrementDisabled = !allowDecrement || disabled;
  return /* @__PURE__ */jsxs("span", {
    css: wrapperCSS,
    children: [/* @__PURE__ */jsx(ButtonCore, {
      "aria-label": ariaDecrement,
      styles: {
        button: decrementCSS,
        content: buttonContentCSS,
        focusRing: focusRingCSS
      },
      onPress: onDecrement,
      disabled: decrementDisabled,
      children: decrementType === "trash" ? /* @__PURE__ */jsx(TrashIcon_default, __spreadValues({
        size: 24,
        color: decrementDisabled ? disabledColor : enabledColor
      }, decrementIconProps)) : /* @__PURE__ */jsx(SubtractIcon_default, __spreadValues({
        size: 24,
        color: decrementDisabled ? disabledColor : enabledColor
      }, decrementIconProps))
    }), /* @__PURE__ */jsxs("span", {
      "aria-live": "polite",
      "aria-atomic": true,
      css: textCSS,
      children: [/* @__PURE__ */jsx(VisuallyHidden, {
        children: ariaValue
      }), /* @__PURE__ */jsx("span", {
        children: valueText || value
      })]
    }), /* @__PURE__ */jsx(ButtonCore, {
      "aria-label": ariaIncrement,
      styles: {
        button: incrementCSS,
        content: buttonContentCSS,
        focusRing: focusRingCSS
      },
      onPress: onIncrement,
      disabled: incrementDisabled,
      ref: incrementButtonRef,
      children: /* @__PURE__ */jsx(AddIcon_default, __spreadValues({
        size: 24,
        color: incrementDisabled ? disabledColor : enabledColor
      }, incrementIconProps))
    })]
  });
}

__name(StepperBase, "StepperBase");

var getButtonStyles = /* @__PURE__ */__name((_ref13) => {
  let {
    theme,
    disabled,
    expanded,
    inline
  } = _ref13;
  return {
    backgroundColor: expanded || inline ? theme.colors.systemGrayscale00 : theme.colors.brandPrimaryRegular,
    border: 0,
    borderRadius: theme.radius.round,
    position: "relative",
    height: 36,
    width: 36,
    "&:focus": {
      outline: "none"
    },
    '&[data-focus-visible="true"]': {
      backgroundColor: !disabled && (expanded || inline ? theme.colors.systemGrayscale20 : theme.colors.brandPrimaryExtraDark) || void 0
    },
    '&[data-focus-visible="true"]::before': {
      border: `2px solid ${theme.colors.systemGrayscale00}`,
      borderRadius: theme.radius.round,
      content: '""',
      display: "block",
      position: "absolute",
      top: -2,
      bottom: -2,
      left: -2,
      right: -2
    },
    "&:hover": {
      backgroundColor: !disabled && (expanded || inline ? theme.colors.systemGrayscale10 : theme.colors.brandPrimaryDark) || void 0
    },
    "&:active": {
      backgroundColor: !disabled && (expanded || inline ? theme.colors.systemGrayscale20 : theme.colors.brandPrimaryExtraDark) || void 0
    },
    "&:disabled": {}
  };
}, "getButtonStyles");

var getStyles12 = /* @__PURE__ */__name((theme, _ref14) => {
  let {
    allowIncrement,
    allowDecrement,
    disabled,
    expanded,
    inline
  } = _ref14;
  return {
    buttonContent: {},
    decrementButton: __spreadValues({}, getButtonStyles({
      theme,
      disabled: !allowDecrement || disabled,
      expanded,
      inline
    })),
    focusRing: {
      border: `2px solid ${theme.colors.systemGrayscale80}`,
      borderRadius: theme.radius.round
    },
    incrementButton: __spreadValues({}, getButtonStyles({
      theme,
      disabled: !allowIncrement || disabled,
      expanded,
      inline
    })),
    text: __spreadProps(__spreadValues({}, theme.typography.bodyEmphasized), {
      padding: `0 ${spacing.s4}px`,
      color: disabled ? theme.colors.systemGrayscale30 : expanded || inline ? theme.colors.systemGrayscale80 : theme.colors.systemGrayscale00
    }),
    wrapper: {
      minWidth: 120,
      minHeight: 36,
      [responsive_exports.up("r")]: {
        minWidth: 140
      }
    }
  };
}, "getStyles");

function AddItemStepperBase(props) {
  const theme = useTheme();
  const baseStyles16 = getStyles12(theme, props);
  const styles25 = combineStyles(baseStyles16, props.styles);
  const isExpandedOrInline = props.expanded || props.inline;
  const isDisabledOrCannotIncrement = props.disabled || !props.allowIncrement;
  const decrementFill = isExpandedOrInline ? theme.colors.systemGrayscale80 : theme.colors.systemGrayscale00;
  const incrementFill = isDisabledOrCannotIncrement ? theme.colors.systemGrayscale30 : isExpandedOrInline ? theme.colors.systemGrayscale80 : theme.colors.systemGrayscale00;
  const iconProps = {
    decrementIconProps: {
      fill: decrementFill
    },
    incrementIconProps: {
      fill: incrementFill
    }
  };
  return /* @__PURE__ */jsx(StepperBase, __spreadProps(__spreadValues(__spreadValues({}, props), iconProps), {
    styles: styles25
  }));
}

__name(AddItemStepperBase, "AddItemStepperBase");

var getStyles13 = /* @__PURE__ */__name((theme, inline) => ({
  wrapper: __spreadValues({
    background: inline ? theme.colors.systemGrayscale00 : theme.colors.brandPrimaryRegular,
    borderRadius: theme.radius.round
  }, !inline ? __spreadValues({}, elevation.pantryLow2.shadow) : {
    border: `1px solid ${theme.colors.systemGrayscale30}`
  }),
  decrementButton: {},
  incrementButton: {}
}), "getStyles");

function AddItemExpanded(_a) {
  var _b = _a,
      {
    inline
  } = _b,
      props = __objRest(_b, ["inline"]);

  const theme = useTheme();
  const styles25 = getStyles13(theme, inline);
  return /* @__PURE__ */jsx(AddItemStepperBase, __spreadProps(__spreadValues({}, props), {
    inline,
    styles: styles25
  }));
}

__name(AddItemExpanded, "AddItemExpanded");

var styles = /* @__PURE__ */__name((theme, inline) => {
  return {
    wrapper: __spreadProps(__spreadValues({
      display: "inline-block",
      maxWidth: 136,
      // unlike other AddItemExpanded* this is fixed as we prefer text to wrap
      borderRadius: theme.radius.r8,
      background: theme.colors.systemGrayscale00
    }, !inline ? __spreadValues({}, elevation.pantryLow2.shadow) : {
      border: `1px solid ${theme.colors.systemGrayscale30}`
    }), {
      [responsive_exports.up("r")]: {
        maxWidth: 144 // unlike other AddItemExpanded* this is fixed as we prefer text to wrap

      }
    }),
    disclaimer: __spreadValues({
      marginTop: spacing.s4,
      paddingLeft: spacing.s8,
      paddingRight: spacing.s8,
      paddingBottom: spacing.s8,
      color: theme.colors.systemGrayscale80,
      cursor: "default",
      textAlign: "center"
    }, theme.typography.accent)
  };
}, "styles");

function AddItemExpandedDisclaimer(_a) {
  var _b = _a,
      {
    disclaimer
  } = _b,
      addItemProps = __objRest(_b, ["disclaimer"]);

  const theme = useTheme();
  const {
    wrapper: wrapperCss,
    disclaimer: disclaimerCss
  } = styles(theme, addItemProps.inline);
  return /* @__PURE__ */jsxs("div", {
    css: wrapperCss,
    children: [/* @__PURE__ */jsx(AddItemStepperBase, __spreadProps(__spreadValues({}, addItemProps), {
      expanded: true
    })), /* @__PURE__ */jsx("div", {
      "aria-live": "polite",
      css: disclaimerCss,
      children: disclaimer
    })]
  });
}

__name(AddItemExpandedDisclaimer, "AddItemExpandedDisclaimer");

var baseStyles3 = {
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    whiteSpace: "nowrap"
  }
};

function RadioPillGroupBase(_ref15) {
  let {
    name,
    accessibleLabel,
    disabled,
    onChange,
    styles: styles25,
    value,
    children
  } = _ref15;
  const {
    wrapper: wrapperCSS
  } = combineStyles(baseStyles3, styles25);
  return /* @__PURE__ */jsx("div", {
    css: wrapperCSS,
    "aria-label": accessibleLabel,
    role: "radiogroup",
    onChange: e3 => {
      onChange(e3.target.value);
    },
    children: children && Children.map(children, child => {
      return /*#__PURE__*/cloneElement(child, {
        name,
        selectedValue: value,
        groupDisabled: disabled
      });
    })
  });
}

__name(RadioPillGroupBase, "RadioPillGroupBase");

function RadioPillGroup(props) {
  return /* @__PURE__ */jsx(RadioPillGroupBase, __spreadValues({}, props));
}

__name(RadioPillGroup, "RadioPillGroup");

function RadioButtonGroupWrap(props) {
  return /* @__PURE__ */jsx(RadioPillGroupBase, __spreadProps(__spreadValues({}, props), {
    styles: {
      wrapper: {
        flexWrap: "wrap"
      }
    }
  }));
}

__name(RadioButtonGroupWrap, "RadioButtonGroupWrap");

var baseStyles4 = {
  input: __spreadProps(__spreadValues({}, A11Y.visuallyHidden), {
    // TODO: @aref-kashani when IDS pill designs are finalized, move this to a Pill implementation
    "+label": {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }),
  inputWrapper: {
    float: "left",
    marginRight: 8,
    marginTop: 4,
    marginBottom: 4,
    ":last-child": {
      marginRight: 0
    }
  }
};

function RadioPillBase(_ref16) {
  let {
    styles: styles25,
    value,
    selectedValue,
    disabled,
    groupDisabled,
    name,
    children
  } = _ref16;
  const {
    inputWrapper: inputWrapperCSS,
    input: inputCSS
  } = combineStyles(baseStyles4, styles25);
  return (// we don't care bout a11y because we're not doing any handling, just fixing weird browser behaviors
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events

    /* @__PURE__ */
    jsxs("span", {
      css: inputWrapperCSS,
      onClick: e3 => {
        e3.stopPropagation();
      },
      children: [/* @__PURE__ */jsx("input", {
        defaultChecked: value === selectedValue,
        "aria-checked": value === selectedValue,
        css: inputCSS,
        disabled: groupDisabled || disabled,
        id: value,
        name,
        type: "radio",
        value,
        tabIndex: value === selectedValue ? 0 : -1
      }), /* @__PURE__ */jsx("label", {
        htmlFor: value,
        children
      })]
    }, value)
  );
}

__name(RadioPillBase, "RadioPillBase");

var getStyles14 = /* @__PURE__ */__name(theme => ({
  input: {
    "+label": __spreadValues({
      background: theme.colors.systemGrayscale20,
      // We need a border box in all cases so the controls don't move, border is transparent in normal state
      boxSizing: "border-box",
      borderRadius: 18,
      color: theme.colors.systemGrayscale80,
      cursor: "pointer",
      minWidth: 44,
      padding: `${spacing.s8}px ${spacing.s16}px`,
      userSelect: "none"
    }, theme.typography.bodyMedium1),
    "&:enabled:hover+label": {
      background: theme.colors.systemGrayscale60
    },
    "&:enabled:checked:hover+label": {
      background: theme.colors.systemGrayscale60
    },
    "&:enabled:checked:active+label": {
      background: theme.colors.systemGrayscale50
    },
    "&:enabled:not(:checked):hover+label": {
      background: theme.colors.systemGrayscale30
    },
    "&:enabled:not(:checked):active+label": {
      background: theme.colors.systemGrayscale40
    },
    "&:checked+label": {
      background: theme.colors.systemGrayscale80,
      color: theme.colors.systemGrayscale00
    },
    "&:disabled+label": {
      background: theme.colors.systemGrayscale10,
      color: theme.colors.systemGrayscale30,
      cursor: "default"
    },
    "&:disabled:checked+label": {
      cursor: "default"
    }
  }
}), "getStyles");

function RadioPill(props) {
  const theme = useTheme();
  const styles25 = getStyles14(theme);
  return /* @__PURE__ */jsx(RadioPillBase, __spreadProps(__spreadValues({}, props), {
    styles: styles25
  }));
}

__name(RadioPill, "RadioPill");

var styles2 = /* @__PURE__ */__name((theme, inline) => {
  return {
    wrapper: __spreadProps(__spreadValues({
      display: "inline-block",
      minWidth: 120,
      background: theme.colors.systemGrayscale00,
      borderRadius: theme.radius.r8
    }, !inline ? __spreadValues({}, elevation.pantryLow2.shadow) : {
      border: `1px solid ${theme.colors.systemGrayscale30}`
    }), {
      [responsive_exports.up("r")]: {
        minWidth: 140
      }
    }),
    modes: {
      marginTop: 2,
      paddingLeft: 8,
      paddingRight: 8,
      paddingBottom: 8
    }
  };
}, "styles");

var radioGroupStyles = {
  wrapper: {
    justifyContent: "space-between"
  }
};

function AddItemExpandedUnit(_a) {
  var _b = _a,
      {
    modes: modes2
  } = _b,
      addItemProps = __objRest(_b, ["modes"]);

  const theme = useTheme();
  const {
    wrapper: wrapperCss,
    modes: modesCss
  } = styles2(theme, addItemProps.inline);
  return /* @__PURE__ */jsxs("div", {
    css: wrapperCss,
    children: [/* @__PURE__ */jsx(AddItemStepperBase, __spreadProps(__spreadValues({}, addItemProps), {
      expanded: true
    })), /* @__PURE__ */jsx("div", {
      style: modesCss,
      children: /* @__PURE__ */jsx(RadioPillGroupBase, __spreadProps(__spreadValues({}, modes2), {
        styles: radioGroupStyles,
        children: modes2.options.map(opt => /* @__PURE__ */jsx(RadioPill, {
          value: opt.id,
          children: opt.label
        }, opt.id))
      }))
    })]
  });
}

__name(AddItemExpandedUnit, "AddItemExpandedUnit");

function isExpandedMessage(props) {
  return !!props.disclaimer;
}

__name(isExpandedMessage, "isExpandedMessage");

function isExpandedUnit(props) {
  return props.modes !== void 0;
}

__name(isExpandedUnit, "isExpandedUnit");

var onMouseDown = /* @__PURE__ */__name(event => {
  event.preventDefault();
}, "onMouseDown");

var styles3 = {
  floatingInteractive: {
    position: "absolute",
    top: 0,
    right: 0
  },
  interactiveContainer: __spreadValues({
    position: "relative"
  }, buttonSizeStyles.buttonWrapper),
  interactivePlaceholder: __spreadValues({}, buttonSizeStyles.button)
};

function AddItem(_a) {
  var _b = _a,
      {
    accessibleLabel,
    buttonValueText,
    buttonProps,
    inline,
    isInteracting,
    setInteracting
  } = _b,
      props = __objRest(_b, ["accessibleLabel", "buttonValueText", "buttonProps", "inline", "isInteracting", "setInteracting"]);

  const wrapperRef = useRef(null);
  const incrementButtonRef = useRef(null);
  useOnClickOutside(wrapperRef, () => {
    if (isInteracting) {
      setInteracting(false);
    }
  });
  useEffect(() => {
    var _a2;

    if (isInteracting) {
      (_a2 = incrementButtonRef.current) == null ? void 0 : _a2.focus();
    }
  }, [isInteracting, incrementButtonRef]);
  useEffect(() => {
    if (inline && !isInteracting && props.value === 0) setInteracting(true);
  }, [inline, isInteracting, props.value, setInteracting]);

  const expandedComponent = /* @__PURE__ */__name(() => {
    if (isExpandedMessage(props)) {
      return /* @__PURE__ */jsx(AddItemExpandedDisclaimer, __spreadProps(__spreadValues({}, props), {
        incrementButtonRef,
        inline
      }));
    }

    if (isExpandedUnit(props)) {
      return /* @__PURE__ */jsx(AddItemExpandedUnit, __spreadProps(__spreadValues({}, props), {
        incrementButtonRef,
        inline
      }));
    }

    return /* @__PURE__ */jsx(AddItemExpanded, __spreadProps(__spreadValues({}, props), {
      incrementButtonRef,
      inline
    }));
  }, "expandedComponent");

  return (// This isn't to handle user interaction, so we don't need a11y
    // It's to prevent a parent item from becoming focused when child elements get clicked
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions

    /* @__PURE__ */
    jsxs("div", {
      ref: wrapperRef,
      onMouseDown,
      children: [!isInteracting && /* @__PURE__ */jsx(AddItemButton, __spreadValues({
        "aria-label": accessibleLabel,
        inline,
        onClick: event => {
          event.preventDefault();
          setInteracting(true);
        },
        stepperValue: props.value,
        value: buttonValueText
      }, buttonProps)), isInteracting && /* @__PURE__ */jsxs("div", {
        css: styles3.interactiveContainer,
        children: [/* @__PURE__ */jsx("div", {
          css: styles3.interactivePlaceholder
        }), /* @__PURE__ */jsx("div", {
          css: styles3.floatingInteractive,
          children: expandedComponent()
        })]
      })]
    })
  );
}

__name(AddItem, "AddItem");

var _TemplateString = class _TemplateString2 {
  constructor(template) {
    __publicField(this, "pieces");

    __publicField(this, "template");

    __publicField(this, "assemble", /* @__PURE__ */__name(values => {
      return this.pieces.reduce((previous, current) => {
        if (typeof current === "string") {
          return `${previous}${current}`;
        }

        const variableName = current.name;
        const variableDefault = current.defaultValue;
        const variableValue = values[variableName];
        const valueIsNullish = variableValue === null || variableValue === void 0;

        if (valueIsNullish && !variableDefault) {
          throw new Error(`Failed to assemble templateString
${this.template}
Missing value for variable ${variableName}`);
        }

        return `${previous}${variableValue != null ? variableValue : variableDefault}`;
      }, "");
    }, "assemble"));

    this.template = template;
    this.pieces = parse(this.template);
  }

};

__name(_TemplateString, "TemplateString");

var TemplateString = _TemplateString;
var templateVariableKeyValueRegExpString = `{([^}=]+)=([^}]*)?}`;

function parse(template) {
  const templateVariableRegExp = new RegExp(templateVariableKeyValueRegExpString, "g");
  const variables = [];
  let match;

  while ((match = templateVariableRegExp.exec(template)) != null) {
    const [variableString, key, defaultValue] = match;

    if (!key) {
      throw new Error(`Failed to get variable key from:
${variableString}
in template: 
${template}`);
    }

    variables.push({
      name: key,
      defaultValue,
      templateIndex: match.index,
      templateMatchLength: variableString.length
    });
  }

  if (!variables.length) {
    return [template != null ? template : ""];
  }

  return variables.reduce( // eslint-disable-next-line max-params
  (_ref17, variable, index, array) => {
    let [templateEndIndex, pieces] = _ref17;
    const variableIndexStart = variable.templateIndex;
    const variableIndexEnd = variableIndexStart + variable.templateMatchLength;
    const templatePart = template.slice(templateEndIndex, variableIndexStart);
    pieces.push(templatePart, variable);

    if (index === array.length - 1) {
      pieces.push(template.slice(variableIndexEnd));
    }

    return [variableIndexEnd, pieces];
  }, // a tuple of currentEndIndex and the set
  [0, []])[1];
}

__name(parse, "parse");

var getRetinaImageAttributes = /* @__PURE__ */__name((_ref18) => {
  let {
    templateUrl,
    width,
    height
  } = _ref18;

  if (!templateUrl) {
    return {
      srcSet: ""
    };
  }

  const itemUrlTemplate = new TemplateString(templateUrl);
  const COMMON_PIXEL_RATIOS = [1, 1.5, 2, 3, 4];
  const scaledImageUrls = COMMON_PIXEL_RATIOS.map(ratio => {
    const responsiveUrl = itemUrlTemplate.assemble({
      width: width ? Math.round(width * ratio) : "",
      height: height ? Math.round(height * ratio) : ""
    }).replace(/ /g, "%20");

    if (ratio === 1) {
      return responsiveUrl;
    }

    return `${responsiveUrl} ${ratio}x`;
  });
  const srcSet = scaledImageUrls.join(", ");
  return {
    srcSet
  };
}, "getRetinaImageAttributes");

var Image = /*#__PURE__*/forwardRef((props, ref) => {
  const _a = props,
        rest = __objRest(_a, ["templateUrl"]);

  if (!props.templateUrl) {
    return /* @__PURE__ */jsx("img", __spreadProps(__spreadValues({}, rest), {
      ref
    }));
  }

  const {
    srcSet
  } = getRetinaImageAttributes(props);
  return /* @__PURE__ */jsx("img", __spreadProps(__spreadValues({}, rest), {
    srcSet,
    ref
  }));
});
Image.displayName = "Image";
var AVATAR_BORDER_PX = 1;

var getStyles15 = /* @__PURE__ */__name((_ref19) => {
  let {
    theme,
    width,
    height,
    fillColor
  } = _ref19;
  return {
    container: {
      boxSizing: "border-box",
      width,
      height,
      border: `${AVATAR_BORDER_PX}px solid rgba(0, 0, 0, 0.12)`,
      backgroundColor: fillColor != null ? fillColor : theme.colors.systemGrayscale00,
      overflow: "hidden"
    },
    image: {
      width: "100%",
      height: "100%",
      objectFit: "contain"
    }
  };
}, "getStyles");

var AvatarBase = /*#__PURE__*/forwardRef((props, ref) => {
  const theme = useTheme();
  const {
    width,
    height
  } = props;

  const _a = props,
        {
    fillColor,
    styles: styles25
  } = _a,
        rest = __objRest(_a, ["fillColor", "styles"]);

  const combinedStyles = combineStyles(getStyles15({
    theme,
    width,
    height: height != null ? height : width,
    fillColor
  }), styles25);
  return /* @__PURE__ */jsx("div", {
    css: combinedStyles.container,
    children: /* @__PURE__ */jsx(Image, __spreadProps(__spreadValues({}, rest), {
      css: combinedStyles.image,
      ref
    }))
  });
});
AvatarBase.displayName = "AvatarBase";
var BACKGROUND_VARIANT_STYLES = {
  one: {
    backgroundColor: "#003D29",
    color: "#FFFFFF"
  },
  two: {
    backgroundColor: "#FF90F7",
    color: "#242529"
  },
  three: {
    backgroundColor: "#ECAA01",
    color: "#242529"
  },
  four: {
    backgroundColor: "#5D5FEF",
    color: "#FFFFFF"
  }
};

var getStyles16 = /* @__PURE__ */__name((desktopWidth, mobileWidth, backgroundVariant) => ({
  container: __spreadValues({
    height: mobileWidth,
    width: mobileWidth,
    [responsive_exports.DESKTOP_SIZE]: {
      height: desktopWidth,
      width: desktopWidth
    },
    borderRadius: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, backgroundVariant && BACKGROUND_VARIANT_STYLES[backgroundVariant]),
  initial: {},
  image: {
    width: mobileWidth,
    height: mobileWidth,
    [responsive_exports.DESKTOP_SIZE]: {
      width: desktopWidth,
      height: desktopWidth
    }
  }
}), "getStyles");

var PersonAvatarBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function PersonAvatarBase2(props, ref) {
  var _a;

  const styles25 = combineStyles(getStyles16(props.responsiveSizes.desktop.width, props.responsiveSizes.mobile.width, "backgroundVariant" in props ? props.backgroundVariant : void 0), props.styles);

  if ("backgroundVariant" in props) {
    return /* @__PURE__ */jsx("div", {
      "aria-hidden": true,
      "data-testid": "person-avatar",
      css: styles25.container,
      ref,
      children: /* @__PURE__ */jsx("span", {
        css: styles25.initial,
        children: (_a = props.initial) == null ? void 0 : _a.charAt(0)
      })
    });
  }

  const _b = props,
        {
    responsiveSizes: responsiveSizes10,
    src,
    srcSet,
    templateUrl
  } = _b,
        rest = __objRest(_b, ["responsiveSizes", "src", "srcSet", "templateUrl"]);

  const imageProps = {
    src,
    srcSet,
    width: responsiveSizes10.desktop.width,
    height: responsiveSizes10.desktop.width,
    templateUrl
  };
  return /* @__PURE__ */jsx(AvatarBase, __spreadProps(__spreadValues(__spreadValues({
    "aria-hidden": true
  }, rest), imageProps), {
    styles: styles25,
    ref,
    "data-testid": "person-avatar"
  }));
}, "PersonAvatarBase"));
PersonAvatarBase.displayName = "PersonAvatarBase";
var responsiveSizes = {
  desktop: {
    width: 48
  },
  mobile: {
    width: 36
  }
};

var getStyles17 = /* @__PURE__ */__name(theme => {
  return {
    container: {},
    image: {},
    initial: __spreadValues({}, theme.typography.subtitle)
  };
}, "getStyles");

var PersonAvatarSmall = /*#__PURE__*/forwardRef((props, ref) => {
  const theme = useTheme();
  const styles25 = getStyles17(theme);
  return /* @__PURE__ */jsx(PersonAvatarBase, __spreadProps(__spreadValues({}, props), {
    responsiveSizes,
    styles: styles25,
    ref
  }));
});
PersonAvatarSmall.displayName = "PersonAvatarSmall";
var responsiveSizes2 = {
  desktop: {
    width: 72
  },
  mobile: {
    width: 48
  }
};

var getStyles18 = /* @__PURE__ */__name(theme => {
  return {
    container: {},
    image: {},
    initial: __spreadValues({}, theme.typography.title)
  };
}, "getStyles");

var PersonAvatarMedium = /*#__PURE__*/forwardRef((props, ref) => {
  const theme = useTheme();
  const styles25 = getStyles18(theme);
  return /* @__PURE__ */jsx(PersonAvatarBase, __spreadProps(__spreadValues({}, props), {
    responsiveSizes: responsiveSizes2,
    styles: styles25,
    ref
  }));
});
PersonAvatarMedium.displayName = "PersonAvatarMedium";
var responsiveSizes3 = {
  desktop: {
    width: 96
  },
  mobile: {
    width: 64
  }
};

var getStyles19 = /* @__PURE__ */__name(theme => {
  return {
    container: {},
    image: {},
    initial: __spreadValues({}, theme.typography.headline)
  };
}, "getStyles");

var PersonAvatarLarge = /*#__PURE__*/forwardRef((props, ref) => {
  const theme = useTheme();
  const styles25 = getStyles19(theme);
  return /* @__PURE__ */jsx(PersonAvatarBase, __spreadProps(__spreadValues({
    responsiveSizes: responsiveSizes3
  }, props), {
    styles: styles25,
    ref
  }));
});
PersonAvatarLarge.displayName = "PersonAvatarLarge";
var PADDING_PX = 2;

var getStyles20 = /* @__PURE__ */__name((desktopWidth, mobileWidth) => {
  return {
    container: {
      height: mobileWidth,
      width: mobileWidth,
      [responsive_exports.DESKTOP_SIZE]: {
        height: desktopWidth,
        width: desktopWidth
      },
      borderRadius: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    image: {
      width: mobileWidth - PADDING_PX * 2,
      height: mobileWidth - PADDING_PX * 2,
      [responsive_exports.DESKTOP_SIZE]: {
        width: desktopWidth - PADDING_PX * 2,
        height: desktopWidth - PADDING_PX * 2
      }
    }
  };
}, "getStyles");

var AdvertiserAvatarBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function AdvertiserAvatarBase2(props, ref) {
  const styles25 = getStyles20(props.responsiveSizes.desktop.width, props.responsiveSizes.mobile.width);

  const _a = props,
        {
    responsiveSizes: responsiveSizes10,
    src,
    srcSet,
    templateUrl
  } = _a,
        rest = __objRest(_a, ["responsiveSizes", "src", "srcSet", "templateUrl"]);

  const imageProps = {
    src,
    srcSet,
    width: responsiveSizes10.desktop.width,
    height: responsiveSizes10.desktop.width,
    templateUrl
  };
  return /* @__PURE__ */jsx(AvatarBase, __spreadProps(__spreadValues(__spreadValues({}, rest), imageProps), {
    styles: styles25,
    ref
  }));
}, "AdvertiserAvatarBase"));
AdvertiserAvatarBase.displayName = "AdvertiserAvatarBase";
var responsiveSizes4 = {
  desktop: {
    width: 48
  },
  mobile: {
    width: 36
  }
};
var AdvertiserAvatarSmall = /*#__PURE__*/forwardRef((props, ref) => {
  return /* @__PURE__ */jsx(AdvertiserAvatarBase, __spreadProps(__spreadValues({
    responsiveSizes: responsiveSizes4
  }, props), {
    ref
  }));
});
AdvertiserAvatarSmall.displayName = "AdvertiserAvatarSmall";
var responsiveSizes5 = {
  desktop: {
    width: 72
  },
  mobile: {
    width: 48
  }
};
var AdvertiserAvatarMedium = /*#__PURE__*/forwardRef((props, ref) => {
  return /* @__PURE__ */jsx(AdvertiserAvatarBase, __spreadProps(__spreadValues({
    responsiveSizes: responsiveSizes5
  }, props), {
    ref
  }));
});
AdvertiserAvatarMedium.displayName = "AdvertiserAvatarMedium";
var responsiveSizes6 = {
  desktop: {
    width: 96
  },
  mobile: {
    width: 64
  }
};
var AdvertiserAvatarLarge = /*#__PURE__*/forwardRef((props, ref) => {
  return /* @__PURE__ */jsx(AdvertiserAvatarBase, __spreadProps(__spreadValues({
    responsiveSizes: responsiveSizes6
  }, props), {
    ref
  }));
});
AdvertiserAvatarLarge.displayName = "AdvertiserAvatarLarge";
var Text = forwardRefWithAs( /* @__PURE__ */__name(function Text2(_a, ref) {
  var _b = _a,
      {
    typography,
    as = "div",
    color,
    highlightColor,
    children
  } = _b,
      rest = __objRest(_b, ["typography", "as", "color", "highlightColor", "children"]);

  const theme = useTheme();
  const typographyStyles = theme.typography[typography];
  const passedColorValue = color ? theme.colors[color] : void 0;
  const textColorWithHighlight = highlightColor ? theme.colors.brandMaxDark : void 0;
  const colorValue = passedColorValue || textColorWithHighlight || theme.colors.systemGrayscale80;
  const sharedProps = {
    css: [{
      color: colorValue
    }, typographyStyles],
    ref
  };
  const content = highlightColor ? /* @__PURE__ */jsx(Highlighter, {
    colorValue,
    highlightColor,
    typography,
    children
  }) : children;

  if (as === "label") {
    return /* @__PURE__ */jsx(LabelCore, __spreadProps(__spreadValues(__spreadValues({}, sharedProps), rest), {
      children: content
    }));
  }

  return /* @__PURE__ */jsx(TextCore, __spreadProps(__spreadValues(__spreadValues({}, sharedProps), rest), {
    elementType: as,
    children: content
  }));
}, "Text"));
Text.displayName = "Text";

function Highlighter(_ref20) {
  let {
    children,
    highlightColor,
    colorValue,
    typography
  } = _ref20;
  const theme = useTheme();
  const highlightStyles = {
    backgroundColor: "none",
    color: colorValue,
    boxDecorationBreak: "clone",
    // The highlight only applies to the text, and line-height does not affect
    // this. We need to add padding to each line equal to the difference between
    // the line height and the font size.
    padding: `calc((${theme.typography[typography].lineHeight} - ${theme.typography[typography].fontSize}px) / 2) 2px`,
    // Using a background gradient allows us to add highlight animations in a
    // future PR. Position 0 is highlighted, 100% is not highlighted. Delaying
    // this work until Motion Atoms are completed.
    background: `linear-gradient(90deg, ${theme.colors[highlightColor]} 50%, rgba(255, 255, 255, 0) 50%)`,
    backgroundSize: "200% 100%",
    backgroundPosition: `var(--highlight-position, 0) 0`
  };
  return /* @__PURE__ */jsx("mark", {
    css: highlightStyles,
    children: /* @__PURE__ */jsx("span", {
      css: {
        position: "relative"
      },
      children
    })
  });
}

__name(Highlighter, "Highlighter");

var DESKTOP_HEIGHT = 56;
var MOBILE_HEIGHT = 48;
var LABEL_TOP_OFFSET = 8;
var issueIconColor = "systemDetrimentalRegular";

var getStyles21 = /* @__PURE__ */__name((_ref21) => {
  let {
    theme,
    hasValue,
    invalid,
    disabled,
    hasLeadingIcon
  } = _ref21;
  return {
    fieldWrapper: {},
    wrapper: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      alignItems: "center",
      paddingTop: 0,
      paddingBottom: 0,
      borderRadius: theme.radius.r12,
      // We use box-shadow instead of border because we are transitioning it.
      // CSS transitions of border snap to pixel values on most browsers which
      // leads to a poor looking transition.
      boxShadow: `0 0 0 1px ${disabled ? theme.colors.systemGrayscale20 : invalid ? theme.colors.systemDetrimentalRegular : hasValue ? theme.colors.systemGrayscale50 : theme.colors.systemGrayscale40}`,
      height: MOBILE_HEIGHT,
      boxSizing: "border-box",
      "& *": {
        boxSizing: "border-box"
      },
      "&:hover": {
        boxShadow: `0 0 0 1px ${disabled ? theme.colors.systemGrayscale20 : invalid ? theme.colors.systemDetrimentalDark : hasValue ? theme.colors.systemGrayscale70 : theme.colors.systemGrayscale50}`
      },
      transition: "box-shadow ease-out 100ms",
      background: disabled ? theme.colors.systemGrayscale10 : invalid ? theme.colors.systemDetrimentalLight : theme.colors.systemGrayscale00,
      maxWidth: 600,
      [responsive_exports.up("r")]: {
        height: DESKTOP_HEIGHT
      }
    },
    focusRing: {
      boxShadow: `0 0 0 2px ${invalid ? theme.colors.systemDetrimentalRegular : theme.colors.systemGrayscale70}`
    },
    input: __spreadProps(__spreadValues({
      padding: 0,
      paddingTop: 22
    }, theme.typography.bodyLarge2), {
      width: "100%",
      height: "100%",
      paddingRight: spacing.s12,
      paddingBottom: spacing.s8,
      border: "none",
      borderRadius: theme.radius.r12,
      paddingLeft: hasLeadingIcon ? 0 : spacing.s12,
      "&::placeholder": {
        opacity: 1
      },
      "&:placeholder-shown::placeholder": {
        opacity: 0
      },
      '&:placeholder-shown:not([data-focused="true"]) + *': __spreadProps(__spreadValues({
        color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80
      }, theme.typography.bodyRegular), {
        transform: `translate(0, calc(${MOBILE_HEIGHT / 2}px - 50% - ${LABEL_TOP_OFFSET}px))`
      }),
      background: "transparent",
      [responsive_exports.up("r")]: {
        '&:placeholder-shown:not([data-focused="true"]) + *': {
          transform: `translate(0, calc(${DESKTOP_HEIGHT / 2}px - 50% - ${LABEL_TOP_OFFSET}px))`
        }
      }
    }),
    label: __spreadProps(__spreadValues({
      transformOrigin: "top left",
      transform: "scale(calc(4/5))"
    }, theme.typography.bodyRegular), {
      position: "absolute",
      left: hasLeadingIcon ? 0 : spacing.s12,
      top: LABEL_TOP_OFFSET,
      cursor: "text",
      opacity: 1,
      transition: "transform ease-out 150ms",
      transitionProperty: "color, transform",
      pointerEvents: "none",
      color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80,
      userSelect: "none",
      right: spacing.s12,
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden"
    }),
    textWrapper: {
      height: "100%",
      position: "relative",
      flexGrow: 1
    },
    leadingIcon: {
      paddingLeft: spacing.s12,
      paddingRight: spacing.s8,
      display: "flex",
      flexShrink: 0
    },
    trailingIcon: {
      paddingLeft: spacing.s8,
      paddingRight: spacing.s12,
      display: "flex",
      flexShrink: 0
    },
    invalidText: {
      margin: `${spacing.s4}px 0 0 0`
    },
    description: {
      margin: `${spacing.s4}px 0 0 0`
    },
    errorIcon: {
      marginRight: spacing.s4,
      verticalAlign: "bottom"
    }
  };
}, "getStyles");

var TextInputBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function TextInputBase2(props, ref) {
  var _b;

  const _a = props,
        {
    description,
    leadingIcon: LeadingIcon,
    trailingIcon: TrailingIcon,
    invalid,
    invalidText,
    disabled,
    styles: styles25
  } = _a,
        rest = __objRest(_a, ["description", "leadingIcon", "trailingIcon", "invalid", "invalidText", "disabled", "styles"]);

  const theme = useTheme();
  const combinedStyles = combineStyles(getStyles21({
    theme,
    hasValue: ((_b = rest.value) != null ? _b : "") !== "",
    invalid: !!invalid,
    disabled: !!disabled,
    hasLeadingIcon: Boolean(LeadingIcon)
  }), styles25);
  const placeholder = rest.placeholder || rest.label || " ";
  return /* @__PURE__ */jsxs(TextFieldCoreFR, __spreadProps(__spreadValues({
    css: combinedStyles.fieldWrapper,
    invalid,
    disabled
  }, rest), {
    placeholder,
    children: [/* @__PURE__ */jsxs("div", {
      css: [combinedStyles.wrapper, {
        '[data-focus-within="true"] > &': [combinedStyles.focusRing],
        '[data-focus-within="true"] > & input': {
          outline: "none"
        }
      }],
      children: [LeadingIcon && /* @__PURE__ */jsx("div", {
        css: combinedStyles.leadingIcon,
        children: reactIsExports.isElement(LeadingIcon) ? LeadingIcon : /* @__PURE__ */jsx(LeadingIcon, {
          size: 24
        })
      }), /* @__PURE__ */jsxs("div", {
        css: combinedStyles.textWrapper,
        children: [/* @__PURE__ */jsx(InputCore, {
          css: combinedStyles.input,
          ref
        }), /* @__PURE__ */jsx(Text, {
          as: "label",
          css: combinedStyles.label,
          typography: "bodyRegular"
        })]
      }), TrailingIcon && /* @__PURE__ */jsx("div", {
        css: combinedStyles.trailingIcon,
        children: reactIsExports.isElement(TrailingIcon) ? TrailingIcon : /* @__PURE__ */jsx(TrailingIcon, {
          size: 24
        })
      })]
    }), !invalid && description && /* @__PURE__ */jsx(Text, {
      slot: TextFieldCoreFR.slots.description,
      as: "p",
      color: "systemGrayscale60",
      css: combinedStyles.description,
      typography: "accent",
      children: description
    }), invalid && invalidText && /* @__PURE__ */jsxs(Text, {
      slot: TextFieldCoreFR.slots.errorMessage,
      as: "p",
      color: "systemDetrimentalExtraDark",
      css: combinedStyles.invalidText,
      typography: "accent",
      children: [/* @__PURE__ */jsx(IssueIcon_default, {
        color: issueIconColor,
        css: combinedStyles.errorIcon,
        size: 16
      }), invalidText]
    })]
  }));
}, "TextInputBase"));

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function SingleLineTextInput(_a, ref) {
  var _b = _a,
      {
    icon,
    disabled
  } = _b,
      rest = __objRest(_b, ["icon", "disabled"]);

  const theme = useTheme();
  return /* @__PURE__ */jsx(TextInputBase, __spreadProps(__spreadValues({
    styles: {
      leadingIcon: {
        "& > svg": {
          fill: disabled ? theme.colors.systemGrayscale30 : void 0
        }
      }
    },
    leadingIcon: icon,
    disabled
  }, rest), {
    ref
  }));
}, "SingleLineTextInput"));

var parseNumber = /* @__PURE__ */__name((color, len) => {
  if (typeof color !== "number") return;

  if (len === 3) {
    return {
      mode: "rgb",
      r: (color >> 8 & 15 | color >> 4 & 240) / 255,
      g: (color >> 4 & 15 | color & 240) / 255,
      b: (color & 15 | color << 4 & 240) / 255
    };
  }

  if (len === 4) {
    return {
      mode: "rgb",
      r: (color >> 12 & 15 | color >> 8 & 240) / 255,
      g: (color >> 8 & 15 | color >> 4 & 240) / 255,
      b: (color >> 4 & 15 | color & 240) / 255,
      alpha: (color & 15 | color << 4 & 240) / 255
    };
  }

  if (len === 6) {
    return {
      mode: "rgb",
      r: (color >> 16 & 255) / 255,
      g: (color >> 8 & 255) / 255,
      b: (color & 255) / 255
    };
  }

  if (len === 8) {
    return {
      mode: "rgb",
      r: (color >> 24 & 255) / 255,
      g: (color >> 16 & 255) / 255,
      b: (color >> 8 & 255) / 255,
      alpha: (color & 255) / 255
    };
  }
}, "parseNumber");

var parseNumber_default = parseNumber;
var named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  // Added in CSS Colors Level 4:
  // https://drafts.csswg.org/css-color/#changes-from-3
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
var named_default = named;

var parseNamed = /* @__PURE__ */__name(color => {
  return parseNumber_default(named_default[color.toLowerCase()], 6);
}, "parseNamed");

var parseNamed_default = parseNamed;
var hex = /^#?([0-9a-f]{8}|[0-9a-f]{6}|[0-9a-f]{4}|[0-9a-f]{3})$/i;

var parseHex = /* @__PURE__ */__name(color => {
  let match;
  return (match = color.match(hex)) ? parseNumber_default(parseInt(match[1], 16), match[1].length) : void 0;
}, "parseHex");

var parseHex_default = parseHex;
var num = "([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)";
var per = `${num}%`;
var num_per = `(?:${num}%|${num})`;
var c = `\\s*,\\s*`;
var rgb_num_old = new RegExp(`^rgba?\\(\\s*${num}${c}${num}${c}${num}\\s*(?:,\\s*${num_per}\\s*)?\\)$`);
var rgb_per_old = new RegExp(`^rgba?\\(\\s*${per}${c}${per}${c}${per}\\s*(?:,\\s*${num_per}\\s*)?\\)$`);

var parseRgbLegacy = /* @__PURE__ */__name(color => {
  let res = {
    mode: "rgb"
  };
  let match;

  if (match = color.match(rgb_num_old)) {
    if (match[1] !== void 0) {
      res.r = match[1] / 255;
    }

    if (match[2] !== void 0) {
      res.g = match[2] / 255;
    }

    if (match[3] !== void 0) {
      res.b = match[3] / 255;
    }
  } else if (match = color.match(rgb_per_old)) {
    if (match[1] !== void 0) {
      res.r = match[1] / 100;
    }

    if (match[2] !== void 0) {
      res.g = match[2] / 100;
    }

    if (match[3] !== void 0) {
      res.b = match[3] / 100;
    }
  } else {
    return void 0;
  }

  if (match[4] !== void 0) {
    res.alpha = Math.max(0, Math.min(1, match[4] / 100));
  } else if (match[5] !== void 0) {
    res.alpha = Math.max(0, Math.min(1, +match[5]));
  }

  return res;
}, "parseRgbLegacy");

var parseRgbLegacy_default = parseRgbLegacy;

var prepare = /* @__PURE__ */__name((color, mode) => color === void 0 ? void 0 : typeof color !== "object" ? parse_default(color) : color.mode !== void 0 ? color : mode ? __spreadProps(__spreadValues({}, color), {
  mode
}) : void 0, "prepare");

var prepare_default = prepare;

var converter = /* @__PURE__ */__name(function () {
  let target_mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "rgb";
  return color => (color = prepare_default(color, target_mode)) !== void 0 ? // if the color's mode corresponds to our target mode
  color.mode === target_mode ? // then just return the color
  color : // otherwise check to see if we have a dedicated
  // converter for the target mode
  converters[color.mode][target_mode] ? // and return its result...
  converters[color.mode][target_mode](color) : // ...otherwise pass through RGB as an intermediary step.
  // if the target mode is RGB...
  target_mode === "rgb" ? // just return the RGB
  converters[color.mode].rgb(color) : // otherwise convert color.mode -> RGB -> target_mode
  converters.rgb[target_mode](converters[color.mode].rgb(color)) : void 0;
}, "converter");

var converter_default = converter;
var converters = {};
var modes = {};
var parsers = [];
var colorProfiles = {};

var identity = /* @__PURE__ */__name(v => v, "identity");

var useMode = /* @__PURE__ */__name(definition5 => {
  converters[definition5.mode] = __spreadValues(__spreadValues({}, converters[definition5.mode]), definition5.toMode);
  Object.keys(definition5.fromMode || {}).forEach(k3 => {
    if (!converters[k3]) {
      converters[k3] = {};
    }

    converters[k3][definition5.mode] = definition5.fromMode[k3];
  });

  if (!definition5.ranges) {
    definition5.ranges = {};
  }

  if (!definition5.difference) {
    definition5.difference = {};
  }

  definition5.channels.forEach(channel => {
    if (definition5.ranges[channel] === void 0) {
      definition5.ranges[channel] = [0, 1];
    }

    if (!definition5.interpolate[channel]) {
      throw new Error(`Missing interpolator for: ${channel}`);
    }

    if (typeof definition5.interpolate[channel] === "function") {
      definition5.interpolate[channel] = {
        use: definition5.interpolate[channel]
      };
    }

    if (!definition5.interpolate[channel].fixup) {
      definition5.interpolate[channel].fixup = identity;
    }
  });
  modes[definition5.mode] = definition5;
  (definition5.parse || []).forEach(parser => {
    useParser(parser, definition5.mode);
  });
  return converter_default(definition5.mode);
}, "useMode");

var getMode = /* @__PURE__ */__name(mode => modes[mode], "getMode");

var useParser = /* @__PURE__ */__name((parser, mode) => {
  if (typeof parser === "string") {
    if (!mode) {
      throw new Error(`'mode' required when 'parser' is a string`);
    }

    colorProfiles[parser] = mode;
  } else if (typeof parser === "function") {
    if (parsers.indexOf(parser) < 0) {
      parsers.push(parser);
    }
  }
}, "useParser");

var IdentStartCodePoint = /[^\x00-\x7F]|[a-zA-Z_]/;
var IdentCodePoint = /[^\x00-\x7F]|[-\w]/;
var Tok = {
  Function: "function",
  Ident: "ident",
  Number: "number",
  Percentage: "percentage",
  ParenClose: ")",
  None: "none",
  Hue: "hue",
  Alpha: "alpha"
};
var _i = 0;

function is_num(chars) {
  let ch = chars[_i];
  let ch1 = chars[_i + 1];

  if (ch === "-" || ch === "+") {
    return /\d/.test(ch1) || ch1 === "." && /\d/.test(chars[_i + 2]);
  }

  if (ch === ".") {
    return /\d/.test(ch1);
  }

  return /\d/.test(ch);
}

__name(is_num, "is_num");

function is_ident(chars) {
  if (_i >= chars.length) {
    return false;
  }

  let ch = chars[_i];

  if (IdentStartCodePoint.test(ch)) {
    return true;
  }

  if (ch === "-") {
    if (chars.length - _i < 2) {
      return false;
    }

    let ch1 = chars[_i + 1];

    if (ch1 === "-" || IdentStartCodePoint.test(ch1)) {
      return true;
    }

    return false;
  }

  return false;
}

__name(is_ident, "is_ident");

var huenits = {
  deg: 1,
  rad: 180 / Math.PI,
  grad: 9 / 10,
  turn: 360
};

function num2(chars) {
  let value = "";

  if (chars[_i] === "-" || chars[_i] === "+") {
    value += chars[_i++];
  }

  value += digits(chars);

  if (chars[_i] === "." && /\d/.test(chars[_i + 1])) {
    value += chars[_i++] + digits(chars);
  }

  if (chars[_i] === "e" || chars[_i] === "E") {
    if ((chars[_i + 1] === "-" || chars[_i + 1] === "+") && /\d/.test(chars[_i + 2])) {
      value += chars[_i++] + chars[_i++] + digits(chars);
    } else if (/\d/.test(chars[_i + 1])) {
      value += chars[_i++] + digits(chars);
    }
  }

  if (is_ident(chars)) {
    let id = ident(chars);

    if (id === "deg" || id === "rad" || id === "turn" || id === "grad") {
      return {
        type: Tok.Hue,
        value: value * huenits[id]
      };
    }

    return void 0;
  }

  if (chars[_i] === "%") {
    _i++;
    return {
      type: Tok.Percentage,
      value: +value
    };
  }

  return {
    type: Tok.Number,
    value: +value
  };
}

__name(num2, "num");

function digits(chars) {
  let v = "";

  while (/\d/.test(chars[_i])) {
    v += chars[_i++];
  }

  return v;
}

__name(digits, "digits");

function ident(chars) {
  let v = "";

  while (_i < chars.length && IdentCodePoint.test(chars[_i])) {
    v += chars[_i++];
  }

  return v;
}

__name(ident, "ident");

function identlike(chars) {
  let v = ident(chars);

  if (chars[_i] === "(") {
    _i++;
    return {
      type: Tok.Function,
      value: v
    };
  }

  if (v === "none") {
    return {
      type: Tok.None,
      value: void 0
    };
  }

  return {
    type: Tok.Ident,
    value: v
  };
}

__name(identlike, "identlike");

function tokenize() {
  let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  let chars = str.trim();
  let tokens = [];
  let ch;
  _i = 0;

  while (_i < chars.length) {
    ch = chars[_i++];

    if (ch === "\n" || ch === "	" || ch === " ") {
      while (_i < chars.length && (chars[_i] === "\n" || chars[_i] === "	" || chars[_i] === " ")) {
        _i++;
      }

      continue;
    }

    if (ch === ",") {
      return void 0;
    }

    if (ch === ")") {
      tokens.push({
        type: Tok.ParenClose
      });
      continue;
    }

    if (ch === "+") {
      _i--;

      if (is_num(chars)) {
        tokens.push(num2(chars));
        continue;
      }

      return void 0;
    }

    if (ch === "-") {
      _i--;

      if (is_num(chars)) {
        tokens.push(num2(chars));
        continue;
      }

      if (is_ident(chars)) {
        tokens.push({
          type: Tok.Ident,
          value: ident(chars)
        });
        continue;
      }

      return void 0;
    }

    if (ch === ".") {
      _i--;

      if (is_num(chars)) {
        tokens.push(num2(chars));
        continue;
      }

      return void 0;
    }

    if (ch === "/") {
      while (_i < chars.length && (chars[_i] === "\n" || chars[_i] === "	" || chars[_i] === " ")) {
        _i++;
      }

      let alpha;

      if (is_num(chars)) {
        alpha = num2(chars);

        if (alpha.type !== Tok.Hue) {
          tokens.push({
            type: Tok.Alpha,
            value: alpha
          });
          continue;
        }
      }

      if (is_ident(chars)) {
        if (ident(chars) === "none") {
          tokens.push({
            type: Tok.Alpha,
            value: {
              type: Tok.None,
              value: void 0
            }
          });
          continue;
        }
      }

      return void 0;
    }

    if (/\d/.test(ch)) {
      _i--;
      tokens.push(num2(chars));
      continue;
    }

    if (IdentStartCodePoint.test(ch)) {
      _i--;
      tokens.push(identlike(chars));
      continue;
    }

    return void 0;
  }

  return tokens;
}

__name(tokenize, "tokenize");

function parseColorSyntax(tokens) {
  tokens._i = 0;
  let token = tokens[tokens._i++];

  if (!token || token.type !== Tok.Function || token.value !== "color") {
    return void 0;
  }

  token = tokens[tokens._i++];

  if (token.type !== Tok.Ident) {
    return void 0;
  }

  const mode = colorProfiles[token.value];

  if (!mode) {
    return void 0;
  }

  const res = {
    mode
  };
  const coords = consumeCoords(tokens, false);

  if (!coords) {
    return void 0;
  }

  const channels = getMode(mode).channels;

  for (let ii = 0, c2, ch; ii < channels.length; ii++) {
    c2 = coords[ii];
    ch = channels[ii];

    if (c2.type !== Tok.None) {
      res[ch] = c2.type === Tok.Number ? c2.value : c2.value / 100;

      if (ch === "alpha") {
        res[ch] = Math.max(0, Math.min(1, res[ch]));
      }
    }
  }

  return res;
}

__name(parseColorSyntax, "parseColorSyntax");

function consumeCoords(tokens, includeHue) {
  const coords = [];
  let token;

  while (tokens._i < tokens.length) {
    token = tokens[tokens._i++];

    if (token.type === Tok.None || token.type === Tok.Number || token.type === Tok.Alpha || token.type === Tok.Percentage || includeHue && token.type === Tok.Hue) {
      coords.push(token);
      continue;
    }

    if (token.type === Tok.ParenClose) {
      if (tokens._i < tokens.length) {
        return void 0;
      }

      continue;
    }

    return void 0;
  }

  if (coords.length < 3 || coords.length > 4) {
    return void 0;
  }

  if (coords.length === 4) {
    if (coords[3].type !== Tok.Alpha) {
      return void 0;
    }

    coords[3] = coords[3].value;
  }

  if (coords.length === 3) {
    coords.push({
      type: Tok.None,
      value: void 0
    });
  }

  return coords.every(c2 => c2.type !== Tok.Alpha) ? coords : void 0;
}

__name(consumeCoords, "consumeCoords");

function parseModernSyntax(tokens, includeHue) {
  tokens._i = 0;
  let token = tokens[tokens._i++];

  if (!token || token.type !== Tok.Function) {
    return void 0;
  }

  let coords = consumeCoords(tokens, includeHue);

  if (!coords) {
    return void 0;
  }

  coords.unshift(token.value);
  return coords;
}

__name(parseModernSyntax, "parseModernSyntax");

var parse2 = /* @__PURE__ */__name(color => {
  if (typeof color !== "string") {
    return void 0;
  }

  const tokens = tokenize(color);
  const parsed = tokens ? parseModernSyntax(tokens, true) : void 0;
  let result = void 0;
  let i = 0;
  let len = parsers.length;

  while (i < len) {
    if ((result = parsers[i++](color, parsed)) !== void 0) {
      return result;
    }
  }

  return tokens ? parseColorSyntax(tokens) : void 0;
}, "parse");

var parse_default = parse2;

function parseRgb(color, parsed) {
  if (!parsed || parsed[0] !== "rgb" && parsed[0] !== "rgba") {
    return void 0;
  }

  const res = {
    mode: "rgb"
  };
  const [, r2, g, b, alpha] = parsed;

  if (r2.type === Tok.Hue || g.type === Tok.Hue || b.type === Tok.Hue) {
    return void 0;
  }

  if (r2.type !== Tok.None) {
    res.r = r2.type === Tok.Number ? r2.value / 255 : r2.value / 100;
  }

  if (g.type !== Tok.None) {
    res.g = g.type === Tok.Number ? g.value / 255 : g.value / 100;
  }

  if (b.type !== Tok.None) {
    res.b = b.type === Tok.Number ? b.value / 255 : b.value / 100;
  }

  if (alpha.type !== Tok.None) {
    res.alpha = Math.min(1, Math.max(0, alpha.type === Tok.Number ? alpha.value : alpha.value / 100));
  }

  return res;
}

__name(parseRgb, "parseRgb");

var parseRgb_default = parseRgb;

var parseTransparent = /* @__PURE__ */__name(c2 => c2 === "transparent" ? {
  mode: "rgb",
  r: 0,
  g: 0,
  b: 0,
  alpha: 0
} : void 0, "parseTransparent");

var parseTransparent_default = parseTransparent;

var lerp = /* @__PURE__ */__name((a, b, t) => a + t * (b - a), "lerp");

var get_classes = /* @__PURE__ */__name(arr => {
  let classes = [];

  for (let i = 0; i < arr.length - 1; i++) {
    let a = arr[i];
    let b = arr[i + 1];

    if (a === void 0 && b === void 0) {
      classes.push(void 0);
    } else if (a !== void 0 && b !== void 0) {
      classes.push([a, b]);
    } else {
      classes.push(a !== void 0 ? [a, a] : [b, b]);
    }
  }

  return classes;
}, "get_classes");

var interpolatorPiecewise = /* @__PURE__ */__name(interpolator => arr => {
  let classes = get_classes(arr);
  return t => {
    let cls = t * classes.length;
    let idx = t >= 1 ? classes.length - 1 : Math.max(Math.floor(cls), 0);
    let pair = classes[idx];
    return pair === void 0 ? void 0 : interpolator(pair[0], pair[1], cls - idx);
  };
}, "interpolatorPiecewise");

var interpolatorLinear = interpolatorPiecewise(lerp);

var fixupAlpha = /* @__PURE__ */__name(arr => {
  let some_defined = false;
  let res = arr.map(v => {
    if (v !== void 0) {
      some_defined = true;
      return v;
    }

    return 1;
  });
  return some_defined ? res : arr;
}, "fixupAlpha");

var definition = {
  mode: "rgb",
  channels: ["r", "g", "b", "alpha"],
  parse: [parseRgb_default, parseHex_default, parseRgbLegacy_default, parseNamed_default, parseTransparent_default, "srgb"],
  serialize: "srgb",
  interpolate: {
    r: interpolatorLinear,
    g: interpolatorLinear,
    b: interpolatorLinear,
    alpha: {
      use: interpolatorLinear,
      fixup: fixupAlpha
    }
  },
  gamut: true,
  white: {
    r: 1,
    g: 1,
    b: 1
  },
  black: {
    r: 0,
    g: 0,
    b: 0
  }
};
var definition_default = definition;

var fn = /* @__PURE__ */__name(function () {
  let c2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  const abs = Math.abs(c2);

  if (abs <= 0.04045) {
    return c2 / 12.92;
  }

  return (Math.sign(c2) || 1) * Math.pow((abs + 0.055) / 1.055, 2.4);
}, "fn");

var convertRgbToLrgb = /* @__PURE__ */__name((_ref22) => {
  let {
    r: r2,
    g,
    b,
    alpha
  } = _ref22;
  let res = {
    mode: "lrgb",
    r: fn(r2),
    g: fn(g),
    b: fn(b)
  };
  if (alpha !== void 0) res.alpha = alpha;
  return res;
}, "convertRgbToLrgb");

var convertRgbToLrgb_default = convertRgbToLrgb;

var fn2 = /* @__PURE__ */__name(function () {
  let c2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  const abs = Math.abs(c2);

  if (abs > 31308e-7) {
    return (Math.sign(c2) || 1) * (1.055 * Math.pow(abs, 1 / 2.4) - 0.055);
  }

  return c2 * 12.92;
}, "fn");

var convertLrgbToRgb = /* @__PURE__ */__name(function (_ref23) {
  let {
    r: r2,
    g,
    b,
    alpha
  } = _ref23;
  let mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "rgb";
  let res = {
    mode,
    r: fn2(r2),
    g: fn2(g),
    b: fn2(b)
  };
  if (alpha !== void 0) res.alpha = alpha;
  return res;
}, "convertLrgbToRgb");

var convertLrgbToRgb_default = convertLrgbToRgb;

var differenceEuclidean = /* @__PURE__ */__name(function () {
  let mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "rgb";
  let weights = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [1, 1, 1, 0];
  let def = getMode(mode);
  let channels = def.channels;
  let diffs = def.difference;
  let conv = converter_default(mode);
  return (std, smp) => {
    let ConvStd = conv(std);
    let ConvSmp = conv(smp);
    return Math.sqrt(channels.reduce((sum, k3, idx) => {
      let delta = diffs[k3] ? diffs[k3](ConvStd, ConvSmp) : ConvStd[k3] - ConvSmp[k3];
      return sum + (weights[idx] || 0) * Math.pow(isNaN(delta) ? 0 : delta, 2);
    }, 0));
  };
}, "differenceEuclidean");

var D50 = {
  X: 0.3457 / 0.3585,
  Y: 1,
  Z: (1 - 0.3457 - 0.3585) / 0.3585
};
var k2 = Math.pow(29, 3) / Math.pow(3, 3);
var e2 = Math.pow(6, 3) / Math.pow(29, 3);

var fn3 = /* @__PURE__ */__name(v => Math.pow(v, 3) > e2 ? Math.pow(v, 3) : (116 * v - 16) / k2, "fn");

var convertLabToXyz50 = /* @__PURE__ */__name((_ref24) => {
  let {
    l,
    a,
    b,
    alpha
  } = _ref24;
  if (l === void 0) l = 0;
  if (a === void 0) a = 0;
  if (b === void 0) b = 0;
  let fy = (l + 16) / 116;
  let fx = a / 500 + fy;
  let fz = fy - b / 200;
  let res = {
    mode: "xyz50",
    x: fn3(fx) * D50.X,
    y: fn3(fy) * D50.Y,
    z: fn3(fz) * D50.Z
  };

  if (alpha !== void 0) {
    res.alpha = alpha;
  }

  return res;
}, "convertLabToXyz50");

var convertLabToXyz50_default = convertLabToXyz50;

var convertXyz50ToRgb = /* @__PURE__ */__name((_ref25) => {
  let {
    x,
    y,
    z,
    alpha
  } = _ref25;
  if (x === void 0) x = 0;
  if (y === void 0) y = 0;
  if (z === void 0) z = 0;
  let res = convertLrgbToRgb_default({
    r: x * 3.1341359569958707 - y * 1.6173863321612538 - 0.4906619460083532 * z,
    g: x * -0.978795502912089 + y * 1.916254567259524 + 0.03344273116131949 * z,
    b: x * 0.07195537988411677 - y * 0.2289768264158322 + 1.405386058324125 * z
  });

  if (alpha !== void 0) {
    res.alpha = alpha;
  }

  return res;
}, "convertXyz50ToRgb");

var convertXyz50ToRgb_default = convertXyz50ToRgb;

var convertLabToRgb = /* @__PURE__ */__name(lab => convertXyz50ToRgb_default(convertLabToXyz50_default(lab)), "convertLabToRgb");

var convertLabToRgb_default = convertLabToRgb;

var convertRgbToXyz50 = /* @__PURE__ */__name(rgb2 => {
  let {
    r: r2,
    g,
    b,
    alpha
  } = convertRgbToLrgb_default(rgb2);
  let res = {
    mode: "xyz50",
    x: 0.436065742824811 * r2 + 0.3851514688337912 * g + 0.14307845442264197 * b,
    y: 0.22249319175623702 * r2 + 0.7168870538238823 * g + 0.06061979053616537 * b,
    z: 0.013923904500943465 * r2 + 0.09708128566574634 * g + 0.7140993584005155 * b
  };

  if (alpha !== void 0) {
    res.alpha = alpha;
  }

  return res;
}, "convertRgbToXyz50");

var convertRgbToXyz50_default = convertRgbToXyz50;

var f = /* @__PURE__ */__name(value => value > e2 ? Math.cbrt(value) : (k2 * value + 16) / 116, "f");

var convertXyz50ToLab = /* @__PURE__ */__name((_ref26) => {
  let {
    x,
    y,
    z,
    alpha
  } = _ref26;
  if (x === void 0) x = 0;
  if (y === void 0) y = 0;
  if (z === void 0) z = 0;
  let f0 = f(x / D50.X);
  let f1 = f(y / D50.Y);
  let f2 = f(z / D50.Z);
  let res = {
    mode: "lab",
    l: 116 * f1 - 16,
    a: 500 * (f0 - f1),
    b: 200 * (f1 - f2)
  };

  if (alpha !== void 0) {
    res.alpha = alpha;
  }

  return res;
}, "convertXyz50ToLab");

var convertXyz50ToLab_default = convertXyz50ToLab;

var convertRgbToLab = /* @__PURE__ */__name(rgb2 => {
  let res = convertXyz50ToLab_default(convertRgbToXyz50_default(rgb2));

  if (rgb2.r === rgb2.b && rgb2.b === rgb2.g) {
    res.a = res.b = 0;
  }

  return res;
}, "convertRgbToLab");

var convertRgbToLab_default = convertRgbToLab;

function parseLab(color, parsed) {
  if (!parsed || parsed[0] !== "lab") {
    return void 0;
  }

  const res = {
    mode: "lab"
  };
  const [, l, a, b, alpha] = parsed;

  if (l.type === Tok.Hue || a.type === Tok.Hue || b.type === Tok.Hue) {
    return void 0;
  }

  if (l.type !== Tok.None) {
    res.l = Math.min(Math.max(0, l.value), 100);
  }

  if (a.type !== Tok.None) {
    res.a = a.type === Tok.Number ? a.value : a.value * 125 / 100;
  }

  if (b.type !== Tok.None) {
    res.b = b.type === Tok.Number ? b.value : b.value * 125 / 100;
  }

  if (alpha.type !== Tok.None) {
    res.alpha = Math.min(1, Math.max(0, alpha.type === Tok.Number ? alpha.value : alpha.value / 100));
  }

  return res;
}

__name(parseLab, "parseLab");

var parseLab_default = parseLab;
var definition2 = {
  mode: "lab",
  toMode: {
    xyz50: convertLabToXyz50_default,
    rgb: convertLabToRgb_default
  },
  fromMode: {
    xyz50: convertXyz50ToLab_default,
    rgb: convertRgbToLab_default
  },
  channels: ["l", "a", "b", "alpha"],
  ranges: {
    l: [0, 100],
    a: [-100, 100],
    b: [-100, 100]
  },
  parse: [parseLab_default],
  serialize: /* @__PURE__ */__name(c2 => `lab(${c2.l !== void 0 ? c2.l : "none"} ${c2.a !== void 0 ? c2.a : "none"} ${c2.b !== void 0 ? c2.b : "none"}${c2.alpha < 1 ? ` / ${c2.alpha}` : ""})`, "serialize"),
  interpolate: {
    l: interpolatorLinear,
    a: interpolatorLinear,
    b: interpolatorLinear,
    alpha: {
      use: interpolatorLinear,
      fixup: fixupAlpha
    }
  }
};
var definition_default2 = definition2;

var definition3 = __spreadProps(__spreadValues({}, definition_default), {
  mode: "lrgb",
  toMode: {
    rgb: convertLrgbToRgb_default
  },
  fromMode: {
    rgb: convertRgbToLrgb_default
  },
  parse: ["srgb-linear"],
  serialize: "srgb-linear"
});

var definition_default3 = definition3;

var convertLrgbToOklab = /* @__PURE__ */__name((_ref27) => {
  let {
    r: r2,
    g,
    b,
    alpha
  } = _ref27;
  if (r2 === void 0) r2 = 0;
  if (g === void 0) g = 0;
  if (b === void 0) b = 0;
  let L = Math.cbrt(0.41222147079999993 * r2 + 0.5363325363 * g + 0.0514459929 * b);
  let M = Math.cbrt(0.2119034981999999 * r2 + 0.6806995450999999 * g + 0.1073969566 * b);
  let S = Math.cbrt(0.08830246189999998 * r2 + 0.2817188376 * g + 0.6299787005000002 * b);
  let res = {
    mode: "oklab",
    l: 0.2104542553 * L + 0.793617785 * M - 0.0040720468 * S,
    a: 1.9779984951 * L - 2.428592205 * M + 0.4505937099 * S,
    b: 0.0259040371 * L + 0.7827717662 * M - 0.808675766 * S
  };

  if (alpha !== void 0) {
    res.alpha = alpha;
  }

  return res;
}, "convertLrgbToOklab");

var convertLrgbToOklab_default = convertLrgbToOklab;

var convertRgbToOklab = /* @__PURE__ */__name(rgb2 => {
  let res = convertLrgbToOklab_default(convertRgbToLrgb_default(rgb2));

  if (rgb2.r === rgb2.b && rgb2.b === rgb2.g) {
    res.a = res.b = 0;
  }

  return res;
}, "convertRgbToOklab");

var convertRgbToOklab_default = convertRgbToOklab;

var convertOklabToLrgb = /* @__PURE__ */__name((_ref28) => {
  let {
    l,
    a,
    b,
    alpha
  } = _ref28;
  if (l === void 0) l = 0;
  if (a === void 0) a = 0;
  if (b === void 0) b = 0;
  let L = Math.pow(l * 0.9999999984505198 + 0.39633779217376786 * a + 0.2158037580607588 * b, 3);
  let M = Math.pow(l * 1.0000000088817609 - 0.10556134232365635 * a - 0.06385417477170591 * b, 3);
  let S = Math.pow(l * 1.0000000546724108 - 0.08948418209496575 * a - 1.2914855378640917 * b, 3);
  let res = {
    mode: "lrgb",
    r: 4.076741661347994 * L - 3.307711590408193 * M + 0.230969928729428 * S,
    g: -1.2684380040921763 * L + 2.6097574006633715 * M - 0.3413193963102197 * S,
    b: -0.004196086541837188 * L - 0.7034186144594493 * M + 1.7076147009309444 * S
  };

  if (alpha !== void 0) {
    res.alpha = alpha;
  }

  return res;
}, "convertOklabToLrgb");

var convertOklabToLrgb_default = convertOklabToLrgb;

var convertOklabToRgb = /* @__PURE__ */__name(c2 => convertLrgbToRgb_default(convertOklabToLrgb_default(c2)), "convertOklabToRgb");

var convertOklabToRgb_default = convertOklabToRgb;

function parseOklab(color, parsed) {
  if (!parsed || parsed[0] !== "oklab") {
    return void 0;
  }

  const res = {
    mode: "oklab"
  };
  const [, l, a, b, alpha] = parsed;

  if (l.type === Tok.Hue || a.type === Tok.Hue || b.type === Tok.Hue) {
    return void 0;
  }

  if (l.type !== Tok.None) {
    res.l = Math.min(Math.max(0, l.type === Tok.Number ? l.value : l.value / 100), 1);
  }

  if (a.type !== Tok.None) {
    res.a = a.type === Tok.Number ? a.value : a.value * 0.4 / 100;
  }

  if (b.type !== Tok.None) {
    res.b = b.type === Tok.Number ? b.value : b.value * 0.4 / 100;
  }

  if (alpha.type !== Tok.None) {
    res.alpha = Math.min(1, Math.max(0, alpha.type === Tok.Number ? alpha.value : alpha.value / 100));
  }

  return res;
}

__name(parseOklab, "parseOklab");

var parseOklab_default = parseOklab;

var definition4 = __spreadProps(__spreadValues({}, definition_default2), {
  mode: "oklab",
  toMode: {
    lrgb: convertOklabToLrgb_default,
    rgb: convertOklabToRgb_default
  },
  fromMode: {
    lrgb: convertLrgbToOklab_default,
    rgb: convertRgbToOklab_default
  },
  ranges: {
    l: [0, 1],
    a: [-0.4, 0.4],
    b: [-0.4, 0.4]
  },
  parse: [parseOklab_default],
  serialize: /* @__PURE__ */__name(c2 => `oklab(${c2.l !== void 0 ? c2.l : "none"} ${c2.a !== void 0 ? c2.a : "none"} ${c2.b !== void 0 ? c2.b : "none"}${c2.alpha < 1 ? ` / ${c2.alpha}` : ""})`, "serialize")
});

var definition_default4 = definition4;

var r = /* @__PURE__ */__name((value, precision) => Math.round(value * (precision = Math.pow(10, precision))) / precision, "r");

var round = /* @__PURE__ */__name(function () {
  let precision = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
  return value => typeof value === "number" ? r(value, precision) : value;
}, "round");

var round_default = round;
var twoDecimals = round_default(2);

var clamp = /* @__PURE__ */__name(value => Math.max(0, Math.min(1, value || 0)), "clamp");

var fixup = /* @__PURE__ */__name(value => Math.round(clamp(value) * 255), "fixup");

var rgb = converter_default("rgb");
converter_default("hsl");

var serializeHex = /* @__PURE__ */__name(color => {
  if (color === void 0) {
    return void 0;
  }

  let r2 = fixup(color.r);
  let g = fixup(color.g);
  let b = fixup(color.b);
  return "#" + (1 << 24 | r2 << 16 | g << 8 | b).toString(16).slice(1);
}, "serializeHex");

var serializeRgb = /* @__PURE__ */__name(color => {
  if (color === void 0) {
    return void 0;
  }

  let r2 = fixup(color.r);
  let g = fixup(color.g);
  let b = fixup(color.b);

  if (color.alpha === void 0 || color.alpha === 1) {
    return `rgb(${r2}, ${g}, ${b})`;
  } else {
    return `rgba(${r2}, ${g}, ${b}, ${twoDecimals(clamp(color.alpha))})`;
  }
}, "serializeRgb");

var formatHex = /* @__PURE__ */__name(c2 => serializeHex(rgb(c2)), "formatHex");

var formatRgb = /* @__PURE__ */__name(c2 => serializeRgb(rgb(c2)), "formatRgb");

var hoverMult = 0.18;
var activeMult = 0.34;

function useComputeInteractiveColors(_ref29) {
  let {
    backgroundColor,
    theme,
    opacity
  } = _ref29;

  var _a, _b;

  const rgb2 = useMode(definition_default);
  const oklab = useMode(definition_default4);
  const lrgb = useMode(definition_default3);
  const differenceEuclidean2 = differenceEuclidean("lrgb");
  const {
    cache: colorCache
  } = useContext(ColorCacheContext);
  const colorToCompute = typeof backgroundColor === "object" ? backgroundColor.color : backgroundColor;
  let computedColorOverrides = {};

  if (typeof backgroundColor === "object") {
    if (backgroundColor.colorBackgroundType === "static-color" && backgroundColor.color) {
      computedColorOverrides = {
        activeColor: backgroundColor.pressColor,
        hoverColor: backgroundColor.hoverColor,
        textColor: backgroundColor.textColor
      };
    } else {
      const colorsFromTokens = computeInteractiveBackgroundColors({
        color: backgroundColor.color,
        color2: backgroundColor.color2,
        hoverColor: backgroundColor.hoverColor,
        hoverColor2: backgroundColor.hoverColor2,
        pressColor: backgroundColor.pressColor,
        pressColor2: backgroundColor.pressColor2
      }, backgroundColor.colorBackgroundType);

      if (colorsFromTokens.primaryColor) {
        return {
          activeColor: colorsFromTokens.activeColor,
          hoverColor: colorsFromTokens.hoverColor,
          primaryColor: colorsFromTokens.primaryColor,
          textColor: backgroundColor.textColor
        };
      }
    }
  }

  if (colorCache.has(colorToCompute)) {
    return colorCache.get(colorToCompute) || null;
  }

  if (!colorToCompute) return null;
  const buttonPrimaryColorRGB = rgb2(theme.colors[colorToCompute] || colorToCompute);
  if (!buttonPrimaryColorRGB) return null;

  if (opacity !== void 0) {
    buttonPrimaryColorRGB.alpha = opacity;
  }

  const inverseColor = ((_b = (_a = oklab(buttonPrimaryColorRGB)) == null ? void 0 : _a.l) != null ? _b : 0) < 0.5;
  const buttonPrimaryColor = oklab(buttonPrimaryColorRGB);
  const buttonHoverColor = oklab(buttonPrimaryColorRGB);
  const buttonActiveColor = oklab(buttonPrimaryColorRGB);

  if (buttonHoverColor) {
    buttonHoverColor.l *= 1 + (inverseColor ? 1 : -1) * hoverMult;
  }

  if (buttonActiveColor) {
    buttonActiveColor.l *= 1 + (inverseColor ? 1 : -1) * activeMult;
  }

  const primaryColorLRGB = lrgb(buttonPrimaryColor);
  const distance00 = differenceEuclidean2(primaryColorLRGB, lrgb(theme.colors.systemGrayscale00));
  const distance80 = differenceEuclidean2(primaryColorLRGB, lrgb(theme.colors.systemGrayscale80));
  const textColor = distance00 > distance80 ? theme.colors.systemGrayscale00 : theme.colors.systemGrayscale80;

  const formatColor = /* @__PURE__ */__name(color => {
    if (opacity !== void 0) {
      return formatRgb(color);
    }

    return formatHex(color);
  }, "formatColor");

  const computedColors = {
    activeColor: computedColorOverrides.activeColor || formatColor(buttonActiveColor),
    hoverColor: computedColorOverrides.hoverColor || formatColor(buttonHoverColor),
    primaryColor: formatColor(buttonPrimaryColor),
    textColor: computedColorOverrides.textColor || textColor
  };
  colorCache.set(colorToCompute, computedColors);
  return computedColors;
}

__name(useComputeInteractiveColors, "useComputeInteractiveColors");

var HEIGHT_PX = "56px";

var normalizeBorderRadius = /* @__PURE__ */__name(borderRadius => {
  if (typeof borderRadius === "string") {
    return borderRadius;
  }

  return `${borderRadius}px`;
}, "normalizeBorderRadius");

function useButtonBaseStyles(_ref30) {
  let {
    buttonColor,
    buttonSize = SIZE_REGULAR,
    componentTokens,
    loading
  } = _ref30;
  const isPantryButtonsEnabled = useIdsFeatureFlag("pantryButtons") === "variant";
  const theme = useTheme();
  const isCoreXTypographyEnabled = useIdsFeatureFlag("coreXTypography") === "variant";
  const {
    isMezcal
  } = useIdsConfig();

  const height = (() => {
    var _a;

    switch (buttonSize) {
      case SIZE_COMPACT:
        return componentTokens.heightCompact;

      case SIZE_SMALL:
        return componentTokens.heightSmall;

      case SIZE_REGULAR:
        return (_a = componentTokens.heightStandard) != null ? _a : HEIGHT_PX;

      default:
        {
          const exhaustiveCheck = buttonSize;
          return exhaustiveCheck;
        }
    }
  })();

  const borderRadius = (() => {
    var _a, _b, _c, _d, _e, _f;

    const pantryFallback = isPantryButtonsEnabled ? `calc(${height} / 2)` : void 0;

    switch (buttonSize) {
      case SIZE_COMPACT:
        return normalizeBorderRadius((_b = (_a = componentTokens.radiusCompact) != null ? _a : pantryFallback) != null ? _b : theme.radius.r8);

      case SIZE_SMALL:
        return normalizeBorderRadius((_d = (_c = componentTokens.radiusSmall) != null ? _c : pantryFallback) != null ? _d : theme.radius.r8);

      case SIZE_REGULAR:
        return normalizeBorderRadius((_f = (_e = componentTokens.radiusStandard) != null ? _e : pantryFallback) != null ? _f : theme.radius.r12);

      default:
        {
          const exhaustiveCheck = buttonSize;
          return exhaustiveCheck;
        }
    }
  })();

  const {
    ringStylesOnly
  } = useFocusRing({
    borderRadiusOfComponent: isPantryButtonsEnabled ? `${height} / 2` : borderRadius
  });

  const horizontalPadding = (() => {
    switch (buttonSize) {
      case SIZE_COMPACT:
        return {
          mobile: componentTokens.spaceHorizontalCompact,
          desktop: componentTokens.spaceHorizontalCompactDesktop
        };

      case SIZE_SMALL:
        return {
          mobile: componentTokens.spaceHorizontalSmall,
          desktop: componentTokens.spaceHorizontalSmallDesktop
        };

      case SIZE_REGULAR:
        return {
          mobile: componentTokens.spaceHorizontalStandard,
          desktop: componentTokens.spaceHorizontalStandardDesktop
        };

      default:
        {
          const exhaustiveCheck = buttonSize;
          return exhaustiveCheck;
        }
    }
  })();

  const {
    activeColor,
    hoverColor,
    primaryColor,
    textColor
  } = useComputeInteractiveColors({
    backgroundColor: buttonColor,
    theme
  }) || {};
  return useMemo(() => {
    const typography = (() => {
      if (isCoreXTypographyEnabled) {
        switch (buttonSize) {
          case SIZE_COMPACT:
            return componentTokens.typographyCompact;

          case SIZE_SMALL:
            if (isMezcal) return componentTokens.typographySmall;
            return __spreadProps(__spreadValues({}, theme.typography.subtitle), {
              [responsive_exports.DESKTOP_SIZE]: extractDWebTypographyStyles(theme.typography.bodyEmphasized)
            });

          case SIZE_REGULAR:
            if (isMezcal) return componentTokens.typographyStandard;
            return __spreadProps(__spreadValues({}, theme.typography.title), {
              [responsive_exports.DESKTOP_SIZE]: extractDWebTypographyStyles(theme.typography.subtitle)
            });
        }
      }

      if (isPantryButtonsEnabled) {
        switch (buttonSize) {
          case SIZE_COMPACT:
            return theme.typography.subtitleSmall;

          case SIZE_SMALL:
            return theme.typography.subtitleMedium;

          case SIZE_REGULAR:
            return theme.typography.subtitleLarge;
        }
      }

      switch (buttonSize) {
        case SIZE_COMPACT:
          return theme.typography.bodySmall1;

        case SIZE_SMALL:
          return theme.typography.bodyMedium1;

        case SIZE_REGULAR:
          return theme.typography.bodyLarge1;
      }
    })();

    return {
      button: {
        boxShadow: componentTokens.elevationShadow,
        zIndex: componentTokens.elevationDepth,
        background: loading ? activeColor : primaryColor,
        borderRadius,
        color: textColor,
        height,
        paddingLeft: horizontalPadding.mobile,
        paddingRight: horizontalPadding.mobile,
        [responsive_exports.DESKTOP_SIZE]: {
          paddingLeft: horizontalPadding.desktop,
          paddingRight: horizontalPadding.desktop
        }
      },
      content: __spreadProps(__spreadValues({}, typography), {
        marginLeft: spacing.s8,
        marginRight: spacing.s8
      }),
      focusRing: ringStylesOnly,
      hover: {
        background: hoverColor
      },
      active: {
        background: activeColor
      },
      disabled: {
        background: componentTokens.disabledColor,
        color: componentTokens.disabledTextColor,
        // TODO: Split this into borderColor and borderWidth when Button borderWidth tokens have been added
        border: componentTokens.disabledBorderColor ? `1px solid ${componentTokens.disabledBorderColor}` : "none"
      },
      loading: {
        background: activeColor
      },
      loadingAnimation: {}
    };
  }, [theme, borderRadius, height, horizontalPadding, ringStylesOnly, isCoreXTypographyEnabled, isPantryButtonsEnabled, isMezcal, buttonSize, activeColor, hoverColor, primaryColor, textColor, loading, componentTokens]);
}

__name(useButtonBaseStyles, "useButtonBaseStyles");

var loadingDotSize = "calc(1em - 5px)";
var loadingDotGap = "calc(0.75em - 3px)";

function LoadingDots(_ref31) {
  let {
    children
  } = _ref31;
  const loadingDots = keyframes`
    0%, {
      opacity: 1;
    }

    13% {
      opacity: 1;
    }

    33%, 100% {
      opacity: 0.5;
    }
  `;
  const dot = {
    width: loadingDotSize,
    height: loadingDotSize,
    animation: `${loadingDots} 1500ms infinite linear`,
    borderRadius: "50%",
    backgroundColor: "currentcolor",
    opacity: 0.5,
    flex: "0 0 auto"
  };
  return /* @__PURE__ */jsxs(Fragment$1, {
    children: [/* @__PURE__ */jsxs("span", {
      "data-testid": "button-loading-dots",
      css: {
        display: "flex",
        gap: loadingDotGap,
        alignItems: "center",
        justifyContent: "center"
      },
      children: [/* @__PURE__ */jsx("span", {
        css: [dot, {
          animationDelay: "0ms"
        }]
      }), /* @__PURE__ */jsx("span", {
        css: [dot, {
          animationDelay: `500ms`
        }]
      }), /* @__PURE__ */jsx("span", {
        css: [dot, {
          animationDelay: `1000ms`
        }]
      })]
    }), /* @__PURE__ */jsx("span", {
      children
    })]
  });
}

__name(LoadingDots, "LoadingDots");

var SIZE_REGULAR = "regular";
var SIZE_SMALL = "small";
var SIZE_COMPACT = "compact";

var useStyles = /* @__PURE__ */__name(() => {
  return {
    button: {
      border: "none",
      padding: 0,
      margin: 0,
      cursor: "pointer",
      userSelect: "none"
    },
    content: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "block"
    },
    loadingAnimation: {},
    hover: {},
    active: {},
    disabled: {
      cursor: "default",
      pointerEvents: "none"
    },
    loading: {},
    focusRing: {}
  };
}, "useStyles");

var ButtonBase2 = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function ButtonBase3(_a, ref) {
  var _b = _a,
      {
    styles: styleOverrides,
    buttonColor,
    buttonSize,
    fullWidth = false,
    loading = false,
    loadingAnimation
  } = _b,
      rest = __objRest(_b, ["styles", "buttonColor", "buttonSize", "fullWidth", "loading", "loadingAnimation"]);

  const componentTokens = useComponentTheme("button");
  const sharedStyles = useButtonBaseStyles({
    buttonColor,
    buttonSize,
    componentTokens,
    loading
  });
  const baseStyles16 = combineStyles(useStyles(), sharedStyles);
  const styles25 = combineStyles(baseStyles16, styleOverrides);
  return /* @__PURE__ */jsx(ButtonCore, __spreadProps(__spreadValues({
    styles: styles25
  }, rest), {
    fullWidth,
    loading,
    loadingAnimation: loadingAnimation != null ? loadingAnimation : /* @__PURE__ */jsx(LoadingDots, {}),
    ref
  }));
}, "ButtonBase"));
ButtonBase2.displayName = "ButtonBase";

var baseStyles5 = /* @__PURE__ */__name(fullWidth => ({
  button: {
    minWidth: 80,
    maxWidth: !fullWidth ? 166 : void 0
  },
  disabled: {},
  content: {},
  focusRing: {},
  hover: {},
  active: {},
  loading: {}
}), "baseStyles");

var ButtonCompactBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function ButtonCompactBase2(_a, ref) {
  var _b = _a,
      {
    fullWidth,
    styles: styles25
  } = _b,
      props = __objRest(_b, ["fullWidth", "styles"]);

  const combinedStyles = combineStyles(baseStyles5(fullWidth), styles25);
  return /* @__PURE__ */jsx(ButtonBase2, __spreadProps(__spreadValues({}, props), {
    buttonSize: "compact",
    fullWidth,
    styles: combinedStyles,
    ref
  }));
}, "ButtonCompactBase"));
var activeIconColor = "systemGrayscale00";
var inactiveIconColor = "systemGrayscale80";
var baseStyles6 = {
  buttonWrapper: {
    position: "relative"
  },
  button: {},
  content: {
    alignItems: "center",
    display: "flex",
    gap: spacing.s4
  },
  hover: {},
  active: {},
  disabled: {},
  focusRing: {}
};
var ButtonPillBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function ButtonPill(_a, ref) {
  var _b = _a,
      {
    active,
    children,
    leadingIcon: LeadingIcon,
    trailingIcon: TrailingIcon,
    styles: styles25
  } = _b,
      rest = __objRest(_b, ["active", "children", "leadingIcon", "trailingIcon", "styles"]);

  const _a2 = combineStyles(baseStyles6, styles25),
        {
    buttonWrapper: buttonWrapperCSS
  } = _a2,
        restStyles = __objRest(_a2, ["buttonWrapper"]);

  const iconColor6 = active ? activeIconColor : inactiveIconColor;
  return /* @__PURE__ */jsx("span", {
    css: buttonWrapperCSS,
    ref,
    children: /* @__PURE__ */jsxs(ButtonCore, __spreadProps(__spreadValues({
      styles: restStyles,
      "aria-current": active || void 0,
      loadingAnimation: /* @__PURE__ */jsx(LoadingDots, {})
    }, rest), {
      children: [LeadingIcon && /* @__PURE__ */jsx(LeadingIcon, {
        color: iconColor6,
        size: spacing.s16
      }), children, TrailingIcon && /* @__PURE__ */jsx(TrailingIcon, {
        color: iconColor6,
        size: spacing.s16
      })]
    }))
  });
}, "ButtonPill"));

function getSharedPillStyles(theme) {
  return __spreadProps(__spreadValues({
    textDecoration: "none",
    boxSizing: "border-box",
    userSelect: "none",
    border: `${BORDER_WIDTH}px solid transparent`,
    minWidth: 58,
    height: spacing.s32,
    backgroundColor: theme.colors.systemGrayscale20,
    borderRadius: 18,
    color: theme.colors.systemGrayscale80
  }, theme.typography.bodyMedium1), {
    cursor: "pointer",
    margin: spacing.s4,
    whiteSpace: "nowrap"
  });
}

__name(getSharedPillStyles, "getSharedPillStyles");

var BORDER_WIDTH = 2;

var getStyles22 = /* @__PURE__ */__name((theme, isSelected) => ({
  button: __spreadValues(__spreadProps(__spreadValues({}, getSharedPillStyles(theme)), {
    position: "relative",
    padding: `0px ${spacing.s16}px`
  }), isSelected && {
    backgroundColor: theme.colors.systemGrayscale80,
    border: `${BORDER_WIDTH}px solid ${theme.colors.systemGrayscale80}`,
    color: theme.colors.systemGrayscale00
  }),
  focusRing: {
    borderRadius: theme.radius.round,
    border: `${BORDER_WIDTH}px solid ${theme.colors.systemGrayscale80}`,
    content: '""',
    display: "block",
    position: "absolute",
    top: -5,
    bottom: -5,
    left: -5,
    right: -5
  },
  hover: __spreadValues({
    backgroundColor: theme.colors.systemGrayscale30
  }, isSelected && {
    backgroundColor: theme.colors.systemGrayscale60,
    borderColor: theme.colors.systemGrayscale60
  }),
  active: __spreadValues({
    backgroundColor: theme.colors.systemGrayscale40
  }, isSelected && {
    backgroundColor: theme.colors.systemGrayscale50,
    borderColor: theme.colors.systemGrayscale50
  }),
  disabled: __spreadValues({
    cursor: "default",
    backgroundColor: theme.colors.systemGrayscale10,
    borderColor: theme.colors.systemGrayscale10,
    color: theme.colors.systemGrayscale30
  }, isSelected && {
    backgroundColor: theme.colors.systemGrayscale20,
    borderColor: theme.colors.systemGrayscale20,
    color: theme.colors.systemGrayscale40
  })
}), "getStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function ButtonPill3(_a, ref) {
  var _b = _a,
      {
    children,
    active,
    disabled,
    onClick
  } = _b,
      rest = __objRest(_b, ["children", "active", "disabled", "onClick"]);

  const theme = useTheme();
  const styles25 = getStyles22(theme, active);
  return /* @__PURE__ */jsx(ButtonPillBase, __spreadProps(__spreadValues({}, rest), {
    disabled,
    styles: styles25,
    onClick,
    active,
    ref,
    children
  }));
}, "ButtonPill"));

var baseStyles7 = /* @__PURE__ */__name(fullWidth => ({
  button: {
    minWidth: 80,
    maxWidth: !fullWidth ? 192 : void 0
  },
  disabled: {},
  content: {},
  focusRing: {},
  hover: {},
  active: {},
  loading: {}
}), "baseStyles");

var ButtonSmallBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function ButtonSmallBase2(_a, ref) {
  var _b = _a,
      {
    fullWidth,
    styles: styles25
  } = _b,
      props = __objRest(_b, ["fullWidth", "styles"]);

  const combinedStyles = combineStyles(baseStyles7(fullWidth), styles25);
  return /* @__PURE__ */jsx(ButtonBase2, __spreadProps(__spreadValues({}, props), {
    buttonSize: "small",
    fullWidth,
    styles: combinedStyles,
    ref
  }));
}, "ButtonSmallBase"));
var baseStyles8 = {
  button: {},
  content: {
    alignItems: "center",
    display: "flex",
    marginLeft: 0,
    marginRight: 0
  },
  text: {}
};
var CartButtonBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function CartButtonBase2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    itemCount,
    v2CartButton
  } = _b,
      props = __objRest(_b, ["styles", "itemCount", "v2CartButton"]);

  const _a2 = combineStyles(baseStyles8, styles25),
        {
    text: textCSS
  } = _a2,
        restCSS = __objRest(_a2, ["text"]);

  const showText = !(itemCount === 0 && v2CartButton);
  return /* @__PURE__ */jsxs(ButtonBase2, __spreadProps(__spreadValues({}, props), {
    ref,
    styles: restCSS,
    children: [/* @__PURE__ */jsx(CartIcon_default, {
      style: {
        flexShrink: 0
      },
      size: 24,
      color: itemCount === 0 ? "systemGrayscale80" : "systemGrayscale00"
    }), showText && /* @__PURE__ */jsx("span", {
      css: textCSS,
      children: itemCount
    })]
  }));
}, "CartButtonBase"));

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function CartButton2(_a, ref) {
  var _b = _a,
      {
    itemCount
  } = _b,
      rest = __objRest(_b, ["itemCount"]);

  const theme = useTheme();
  const coreStyles = {
    button: {
      border: 0,
      display: "flex",
      height: "36px",
      minWidth: "fit-content",
      padding: `${spacing.s8}px ${spacing.s12}px`,
      width: "auto",
      [responsive_exports.up("r")]: {
        height: `${spacing.s40}px`,
        padding: `${spacing.s8}px ${spacing.s16}px`
      }
    },
    content: __spreadProps(__spreadValues({}, theme.typography.subtitle), {
      alignItems: "center",
      color: itemCount === 0 ? theme.colors.systemGrayscale80 : theme.colors.systemGrayscale00,
      display: "flex",
      gap: spacing.s4
    }),
    text: {}
  };
  return /* @__PURE__ */jsx(CartButtonBase, __spreadProps(__spreadValues({}, rest), {
    buttonColor: itemCount === 0 ? "systemGrayscale10" : "brandPrimaryRegular",
    itemCount,
    styles: coreStyles,
    ref
  }));
}, "CartButton"));

var STYLES = /* @__PURE__ */__name(theme => ({
  button: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 24,
    width: 24,
    backgroundColor: theme.colors.systemGrayscale00,
    borderRadius: theme.radius.round
  },
  outerRing: {
    position: "absolute",
    height: 24,
    width: 24,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  icon: {
    position: "absolute",
    alignSelf: "center",
    justifySelf: "center",
    display: "flex",
    pointerEvents: "none"
  },
  hover: {
    backgroundColor: theme.colors.systemGrayscale10
  },
  active: {
    backgroundColor: theme.colors.systemGrayscale20
  },
  disabled: {
    backgroundColor: theme.colors.systemGrayscale10
  }
}), "STYLES");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function CarouselPlayToggleButton2(_a, ref) {
  var _b = _a,
      {
    disabled,
    styles: styleOverrides,
    accessibleLabel
  } = _b,
      rest = __objRest(_b, ["disabled", "styles", "accessibleLabel"]);

  const theme = useTheme();
  const getStyles168 = STYLES(theme);
  const combinedStyles = combineStyles(getStyles168, styleOverrides);
  return /* @__PURE__ */jsx(FocusRing, {
    borderRadiusOfComponent: "100%",
    contrastBorder: true,
    offsetOverride: "2px",
    children: /* @__PURE__ */jsx(ToggleButtonCore, __spreadProps(__spreadValues({
      "aria-label": accessibleLabel,
      styles: combinedStyles,
      disabled
    }, rest), {
      ref,
      children: state => {
        if ((state == null ? void 0 : state.isSelected) !== void 0) {
          const Icon = state.isSelected ? PlayIcon_default : PauseIcon_default;
          return /* @__PURE__ */jsx(Icon, {
            "data-testid": state.isSelected ? "pause-icon" : "play-icon",
            size: 16,
            color: disabled ? "systemGrayscale30" : "systemGrayscale80",
            css: combinedStyles.icon
          });
        }

        return null;
      }
    }))
  });
}, "CarouselPlayToggleButton"));

var CategoryTabContextNonTabStateReturnValuesKeys = /* @__PURE__ */(CategoryTabContextNonTabStateReturnValuesKeys2 => {
  CategoryTabContextNonTabStateReturnValuesKeys2["alignment"] = "alignment";
  CategoryTabContextNonTabStateReturnValuesKeys2["inverseColorPalette"] = "inverseColorPalette";
  return CategoryTabContextNonTabStateReturnValuesKeys2;
})(CategoryTabContextNonTabStateReturnValuesKeys || {});

var CategoryTabContext = /*#__PURE__*/createContext({
  alignment: "spaceBetween",
  inverseColorPalette: false
});

function CategoryTabs(_ref32) {
  let {
    alignment,
    children,
    tabState,
    inverseColorPalette = false
  } = _ref32;
  const value = useMemo(() => __spreadProps(__spreadValues({}, tabState), {
    alignment,
    orientation: "horizontal",
    manual: true,
    inverseColorPalette
  }), [tabState, inverseColorPalette, alignment]);
  return /* @__PURE__ */jsx(CategoryTabContext.Provider, {
    value,
    children
  });
}

__name(CategoryTabs, "CategoryTabs");

var useTabMinHeight = /* @__PURE__ */__name(() => {
  const coreXTypographyEnabled = useIdsFeatureFlag("coreXTypography") === "variant";
  return coreXTypographyEnabled ? 68 : 58;
}, "useTabMinHeight");

var TAB_MIN_WIDTH = 64;
var ICON_SIZE = 24;
var PAGE_BUTTON_HOVER_COLOR = "#EFE9E1";

function PageButton(_ref33) {
  let {
    alignment,
    onClick,
    backgroundColor
  } = _ref33;
  const theme = useTheme();
  const tab = useContext(CategoryTabContext);
  const horizontalPositioning = {
    left: alignment === "left" ? 0 : "auto",
    right: alignment === "right" ? 0 : "auto"
  };
  const Icon = alignment === "left" ? ChevronLeftIcon_default : ChevronRightIcon_default;
  const gradientAngle = alignment === "left" ? 90 : 270;
  const hideOnMweb = {
    [`${responsive_exports.down("c")} and (pointer: none)`]: {
      display: "none"
    },
    [`${responsive_exports.down("c")} and (pointer: coarse)`]: {
      display: "none"
    }
  };
  const foregroundColorKey = tab.inverseColorPalette ? "systemGrayscale00" : "systemGrayscale80";
  const buttonBorderColor = tab.inverseColorPalette ? theme.colors.systemGrayscale00 : theme.colors.systemGrayscale30;
  const hoverColor = tab.inverseColorPalette ? theme.colors.systemGrayscale30 : PAGE_BUTTON_HOVER_COLOR;
  return /* @__PURE__ */jsxs(Fragment$1, {
    children: [/* @__PURE__ */jsx("div", {
      css: __spreadValues(__spreadProps(__spreadValues({
        position: "absolute",
        top: 0,
        bottom: 0
      }, horizontalPositioning), {
        width: 102,
        zIndex: 1,
        backgroundImage: `linear-gradient(${gradientAngle}deg, ${theme.colors[backgroundColor]} 50%, ${addAlphaToHex(theme.colors[backgroundColor], 0)} 100%)`,
        pointerEvents: "none"
      }), hideOnMweb)
    }), /* @__PURE__ */jsx("div", {
      css: __spreadValues(__spreadProps(__spreadValues({
        // This prevents the faded portion of the tab from being clickable
        position: "absolute",
        top: 0,
        bottom: 0
      }, horizontalPositioning), {
        width: 58,
        zIndex: 1,
        backgroundColor: "transparent"
      }), hideOnMweb)
    }), /* @__PURE__ */jsx("button", {
      "aria-hidden": true,
      tabIndex: -1,
      css: __spreadValues(__spreadProps(__spreadValues({
        position: "absolute",
        top: 0,
        bottom: 0
      }, horizontalPositioning), {
        zIndex: 1,
        width: 36,
        height: 36,
        '[data-collapsed="true"] > &': {
          width: 32,
          height: 32
        },
        borderRadius: "100%",
        marginTop: "auto",
        marginBottom: "auto",
        backgroundColor: theme.colors[backgroundColor],
        border: `1px solid ${buttonBorderColor}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "background-color 50ms ease-in-out, width 200ms ease-in-out, height 200ms ease-in-out",
        "&:hover": {
          backgroundColor: hoverColor
        }
      }), hideOnMweb),
      type: "button",
      onClick,
      children: /* @__PURE__ */jsx(Icon, {
        size: 18,
        color: foregroundColorKey
      })
    })]
  });
}

__name(PageButton, "PageButton");

function omit(keys, obj) {
  return Object.entries(obj).reduce((acc, _ref34) => {
    let [key, value] = _ref34;

    if (!keys.includes(key)) {
      return __spreadProps(__spreadValues({}, acc), {
        [key]: value
      });
    }

    return acc;
  }, {});
}

__name(omit, "omit");

function omitNonTabProps(tab) {
  return omit(Object.values(CategoryTabContextNonTabStateReturnValuesKeys), tab);
}

__name(omitNonTabProps, "omitNonTabProps");

var getButtonStyles2 = /* @__PURE__ */__name(visible => __spreadProps(__spreadValues({
  "&:focus": {
    outline: "none"
  },
  backgroundColor: "rgba(0, 0, 0, 0)",
  border: "none"
}, visible && {
  opacity: 1,
  "&:hover": {
    cursor: "pointer"
  }
}), {
  "@media (pointer: none), (pointer: coarse)": {
    display: "none"
  },
  position: "absolute",
  top: 0,
  bottom: 0
}), "getButtonStyles");

var getWrapperStyles = /* @__PURE__ */__name((type, visible, _ref35) => {
  let {
    colors
  } = _ref35;
  return __spreadValues(__spreadProps(__spreadValues(__spreadValues({
    transition: "opacity .1s linear",
    opacity: 0,
    "& svg": {
      display: "none"
    },
    "&:hover svg": {
      display: "inherit"
    },
    position: "absolute",
    backgroundSize: "50% 100%",
    backgroundRepeat: "no-repeat",
    top: 0,
    bottom: 0,
    focus: {
      border: "none"
    },
    width: 44,
    alignItems: "center",
    zIndex: 1,
    display: "flex",
    justifyContent: type === "next" ? "flex-end" : "flex-start"
  }, type === "next" && {
    right: 0
  }), type === "previous" && {
    left: 0
  }), {
    backgroundImage: `linear-gradient(to ${type === "next" ? "left" : "right"}, ${colors.systemGrayscale00}, ${addAlphaToHex(colors.systemGrayscale00, 0)})`,
    backgroundPosition: type === "next" ? "right" : "left"
  }), visible && {
    opacity: 1,
    "&:hover": {
      cursor: "pointer"
    }
  });
}, "getWrapperStyles");

function ScrollButton(_ref36) {
  let {
    visible,
    type,
    onClick
  } = _ref36;
  const theme = useTheme();
  return /* @__PURE__ */jsx("div", {
    css: getWrapperStyles(type, visible, theme),
    children: /* @__PURE__ */jsx("button", {
      "aria-hidden": true,
      tabIndex: -1,
      css: getButtonStyles2(visible),
      onClick: visible ? onClick : void 0,
      children: type === "next" ? /* @__PURE__ */jsx(ChevronRightIcon_default, {
        color: "systemGrayscale30"
      }) : /* @__PURE__ */jsx(ChevronLeftIcon_default, {
        color: "systemGrayscale30"
      })
    })
  });
}

__name(ScrollButton, "ScrollButton");

var OverflowingStackContext = /*#__PURE__*/createContext(null);
var childWrapper = {
  paddingLeft: spacing.s16,
  paddingRight: spacing.s16,
  scrollSnapAlign: "start",
  "&:first-of-type": {
    willChange: "margin-left",
    paddingLeft: 0
  },
  "&:last-of-type": {
    paddingRight: 0
  }
};

function AnimatingChildWrapper(_ref37) {
  let {
    children
  } = _ref37;
  const {
    offset,
    setOffset
  } = useRequiredContext(OverflowingStackContext);

  const onTransitionEnd = /* @__PURE__ */__name(() => {
    setOffset(null);
  }, "onTransitionEnd");

  return /* @__PURE__ */jsx("li", {
    onTransitionEnd,
    css: childWrapper,
    style: __spreadValues(__spreadValues({}, offset !== null && {
      marginLeft: offset
    }), offset === 0 && {
      transition: "margin-left .2s ease-in-out"
    }),
    children
  });
}

__name(AnimatingChildWrapper, "AnimatingChildWrapper");

function useScrollButtonVisibilityHandler(_ref38) {
  let {
    setShowPreviousButton,
    setShowNextButton,
    listRef,
    children
  } = _ref38;
  useEffect(() => {
    if (!listRef.current || listRef.current.childElementCount < 2) {
      return;
    }

    const options = {
      root: listRef.current,
      rootMargin: `0px`,
      threshold: 0.99 // https://bugs.chromium.org/p/chromium/issues/detail?id=1020466

    };
    const intersectionObserver = new window.IntersectionObserver(entries => {
      entries.forEach(entry => {
        var _a, _b;

        const shouldBeVisible = !entry.isIntersecting;

        if (entry.target === ((_a = listRef.current) == null ? void 0 : _a.firstElementChild)) {
          setShowPreviousButton(shouldBeVisible);
        }

        if (entry.target === ((_b = listRef.current) == null ? void 0 : _b.lastElementChild)) {
          setShowNextButton(shouldBeVisible);
        }
      });
    }, options);
    intersectionObserver.observe(listRef.current.firstElementChild);
    intersectionObserver.observe(listRef.current.lastElementChild);
    return () => {
      intersectionObserver.disconnect();
    };
  }, [children, setShowPreviousButton, setShowNextButton, listRef]);
}

__name(useScrollButtonVisibilityHandler, "useScrollButtonVisibilityHandler");

function useTransitionIntoView(_ref39) {
  let {
    listRef,
    offset,
    setOffset
  } = _ref39;

  function transitionIntoView(determineScrollTarget) {
    var _a;

    if (!listRef.current) {
      return;
    }

    const scrollLeftBeforeMove = listRef.current.scrollLeft;
    const childrenArray = Array.from((_a = listRef.current.children) != null ? _a : []);
    const nextScrollableChild = determineScrollTarget(listRef.current, childrenArray);

    if (!nextScrollableChild) {
      return;
    }

    listRef.current.scrollLeft = scrollLeftBeforeMove + nextScrollableChild.scrollWidth * (nextScrollableChild.offsetLeft < scrollLeftBeforeMove ? -1 : 1);

    if (window.matchMedia("(prefers-reduced-motion)").matches) {
      return;
    }

    const leftPosAfterMove = listRef.current.scrollLeft;
    const scrollAmount = leftPosAfterMove - scrollLeftBeforeMove;
    setOffset(scrollAmount);
  }

  __name(transitionIntoView, "transitionIntoView");

  useEffect(() => {
    if (offset !== 0 && offset !== null) {
      requestAnimationFrame(() => {
        setOffset(0);
      });
    }
  }, [offset, setOffset]);
  return transitionIntoView;
}

__name(useTransitionIntoView, "useTransitionIntoView");

var STYLES2 = {
  list: {
    listStyle: "none",
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "auto",
    touchAction: "pan-x",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      width: 0,
      height: 0
    },
    "@media (pointer: none), (pointer: coarse)": {
      overflowX: "auto",
      scrollSnapType: "x mandatory"
    },
    paddingLeft: 0,
    paddingRight: 0,
    marginTop: 0,
    marginBottom: 0
  },
  wrapper: {
    position: "relative",
    minWidth: 0
  }
};

function OverflowingStack(_a) {
  var _b = _a,
      {
    children
  } = _b,
      rest = __objRest(_b, ["children"]);

  const listRef = useRef(null);
  const [showPreviousButton, setShowPreviousButton] = useState(false);
  const [showNextButton, setShowNextButton] = useState(false);
  const [offset, setOffset] = useState(null);
  const transitionIntoView = useTransitionIntoView({
    listRef,
    offset,
    setOffset
  });
  const disableScroll = offset !== null;

  const scrollNext = /* @__PURE__ */__name(() => {
    if (disableScroll) {
      return;
    }

    transitionIntoView((list, childElements) => {
      const scrollLeftBeforeMove = list.scrollLeft;
      const listClientWidth = list.clientWidth;
      return childElements.find(c2 => {
        return c2.offsetLeft + c2.clientWidth > scrollLeftBeforeMove + listClientWidth;
      });
    });
  }, "scrollNext");

  const scrollPrevious = /* @__PURE__ */__name(() => {
    if (disableScroll) {
      return;
    }

    transitionIntoView((list, childElements) => {
      const scrollLeftBeforeMove = list.scrollLeft;
      return childElements.reverse().find(c2 => {
        return c2.offsetLeft < scrollLeftBeforeMove;
      });
    });
  }, "scrollPrevious");

  useScrollButtonVisibilityHandler({
    children,
    listRef,
    setShowNextButton,
    setShowPreviousButton
  });
  const wrappedChildren = useMemo(() => Children.map(children, (c2, i) => {
    if (!c2) {
      return null;
    }

    if (c2.key === null) {
      if (process.env.NODE_ENV !== "production") {
        throw new Error('Each child in OverflowingStack must have a unique "key" prop.');
      }
    }

    return i === 0 ? /* @__PURE__ */jsx(AnimatingChildWrapper, {
      children: c2
    }) : /* @__PURE__ */jsx("li", {
      css: childWrapper,
      children: c2
    });
  }), [children]);
  return /* @__PURE__ */jsxs("div", {
    css: STYLES2.wrapper,
    children: [/* @__PURE__ */jsx(ScrollButton, {
      type: "previous",
      visible: showPreviousButton,
      onClick: scrollPrevious
    }), /* @__PURE__ */jsx("ul", __spreadProps(__spreadValues({}, rest), {
      ref: listRef,
      css: STYLES2.list,
      children: /* @__PURE__ */jsx(OverflowingStackContext.Provider, {
        value: {
          offset,
          setOffset
        },
        children: wrappedChildren
      })
    })), /* @__PURE__ */jsx(ScrollButton, {
      type: "next",
      visible: showNextButton,
      onClick: scrollNext
    })]
  });
}

__name(OverflowingStack, "OverflowingStack");

var getStyles23 = /* @__PURE__ */__name((theme, _ref40) => {
  let {
    alignment,
    backgroundColor,
    tabMinHeight,
    collapsed
  } = _ref40;
  return {
    container: {
      position: "relative",
      backgroundColor: theme.colors[backgroundColor],
      paddingTop: spacing.s4,
      paddingLeft: 0,
      paddingRight: 0,
      [`${responsive_exports.down("c")} and (pointer: none)`]: {
        paddingLeft: 0,
        paddingRight: 0
      },
      [`${responsive_exports.down("c")} and (pointer: coarse)`]: {
        paddingLeft: 0,
        paddingRight: 0
      }
    },
    tabList: {
      overflowY: "hidden",
      overflowX: "auto",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        width: 0,
        height: 0
      },
      display: "flex",
      justifyContent: alignment === "spaceBetween" ? "space-between" : "flex-start",
      gap: alignment === "left" ? spacing.s8 : void 0,
      maxHeight: collapsed ? tabMinHeight - ICON_SIZE : tabMinHeight,
      transition: "max-height 200ms ease-in-out",
      boxSizing: "content-box"
    }
  };
}, "getStyles");

function CategoryTabList(_a) {
  var _b = _a,
      {
    styles: styles25,
    collapsed,
    children,
    accessibleLabel,
    backgroundColor
  } = _b,
      rest = __objRest(_b, ["styles", "collapsed", "children", "accessibleLabel", "backgroundColor"]);

  var _a2;

  const theme = useTheme();
  const tab = useContext(CategoryTabContext);
  const tabMinHeight = useTabMinHeight();
  const combinedStyles = combineStyles(getStyles23(theme, {
    backgroundColor,
    collapsed,
    tabMinHeight,
    alignment: tab.alignment
  }), styles25);
  const currentItem = (_a2 = tab.items) == null ? void 0 : _a2.find((_ref41) => {
    let {
      id
    } = _ref41;
    return id === tab.selectedId;
  });
  const [showPreviousButton, setShowPreviousButton] = useState(false);
  const [showNextButton, setShowNextButton] = useState(false);
  const tabListRef = useRef(null);
  useScrollButtonVisibilityHandler({
    setShowNextButton,
    setShowPreviousButton,
    listRef: tabListRef,
    children
  });
  useScrollItemToCenterOnFocus({
    containerRef: tabListRef
  });
  useScrollFadedItemIntoViewOnSelect(currentItem == null ? void 0 : currentItem.ref, tabListRef);
  const onPageLeftClick = useCallback(() => {
    var _a3, _b2, _c;

    (_c = tabListRef.current) == null ? void 0 : _c.scrollBy({
      left: -1 * ((_b2 = (_a3 = tabListRef.current) == null ? void 0 : _a3.clientWidth) != null ? _b2 : 0) - TAB_MIN_WIDTH * 3,
      behavior: "smooth"
    });
  }, []);
  const onPageRightClick = useCallback(() => {
    var _a3, _b2, _c;

    (_c = tabListRef.current) == null ? void 0 : _c.scrollBy({
      left: ((_b2 = (_a3 = tabListRef.current) == null ? void 0 : _a3.clientWidth) != null ? _b2 : 0) - TAB_MIN_WIDTH * 3,
      behavior: "smooth"
    });
  }, []);
  return /* @__PURE__ */jsxs("div", {
    "data-collapsed": collapsed,
    css: combinedStyles.container,
    children: [showPreviousButton && /* @__PURE__ */jsx(PageButton, {
      backgroundColor,
      alignment: "left",
      onClick: onPageLeftClick
    }), /* @__PURE__ */jsx(TabList$1, __spreadProps(__spreadValues(__spreadValues({
      ref: tabListRef,
      css: combinedStyles.tabList,
      "aria-label": accessibleLabel
    }, omitNonTabProps(tab)), rest), {
      children
    })), showNextButton && /* @__PURE__ */jsx(PageButton, {
      backgroundColor,
      alignment: "right",
      onClick: onPageRightClick
    })]
  });
}

__name(CategoryTabList, "CategoryTabList");

function useScrollFadedItemIntoViewOnSelect(currentItemRef, tabListRef) {
  useEffect(() => {
    const currentItemElement = currentItemRef == null ? void 0 : currentItemRef.current;
    const tabListElement = tabListRef == null ? void 0 : tabListRef.current;

    if (!currentItemElement || !tabListElement) {
      return;
    }

    const offsetFromLeftEdge = currentItemElement.getBoundingClientRect().left - tabListElement.getBoundingClientRect().left;
    const offsetFromRightEdge = tabListElement.getBoundingClientRect().right - currentItemElement.getBoundingClientRect().right;
    const FADE_OFFSET_FROM_EDGE = 86;
    const PEAK_ADJACENT_TAB = TAB_MIN_WIDTH / 2;
    let scrollAmount = 0;

    if (offsetFromLeftEdge <= FADE_OFFSET_FROM_EDGE) {
      scrollAmount = -1 * (FADE_OFFSET_FROM_EDGE - offsetFromLeftEdge + PEAK_ADJACENT_TAB);
    } else if (offsetFromRightEdge <= FADE_OFFSET_FROM_EDGE) {
      scrollAmount = FADE_OFFSET_FROM_EDGE - offsetFromRightEdge + PEAK_ADJACENT_TAB;
    } else {
      return;
    }

    tabListElement.scrollBy({
      left: scrollAmount,
      behavior: "smooth"
    });
  }, [currentItemRef, tabListRef]);
}

__name(useScrollFadedItemIntoViewOnSelect, "useScrollFadedItemIntoViewOnSelect");

function useScrollItemToCenterOnFocus(_ref42) {
  let {
    containerRef
  } = _ref42;
  useEffect(() => {
    if (!containerRef.current) {
      return;
    }

    const tabListElement = containerRef.current;
    tabListElement.addEventListener("keydown", onTabFocused);

    function onTabFocused(e3) {
      if (!tabListElement || !["ArrowLeft", "ArrowRight"].includes(e3.key)) {
        return;
      }

      const eventTarget = e3.target;
      const currentItemElement = e3.key === "ArrowRight" ? eventTarget.nextElementSibling : eventTarget.previousElementSibling;

      if (!currentItemElement) {
        return;
      }

      tabListElement.scrollTo({
        left: currentItemElement.offsetLeft - tabListElement.clientWidth / 2 + currentItemElement.clientWidth / 2
      });
    }

    __name(onTabFocused, "onTabFocused");

    return () => {
      tabListElement.removeEventListener("keydown", onTabFocused);
    };
  }, [containerRef]);
}

__name(useScrollItemToCenterOnFocus, "useScrollItemToCenterOnFocus");

var PADDING_X_SIDE = 8;
var TEXT_MAX_WIDTH = 128;

function CategoryTab(_a) {
  var _b = _a,
      {
    children,
    icon: Icon,
    selectedIcon: SelectedIcon
  } = _b,
      rest = __objRest(_b, ["children", "icon", "selectedIcon"]);

  const theme = useTheme();
  const tab = useContext(CategoryTabContext);
  const foregroundColorKey = tab.inverseColorPalette ? "systemGrayscale00" : "systemGrayscale80";
  const foregroundColor = theme.colors[foregroundColorKey];
  const coreXTypographyEnabled = useIdsFeatureFlag("coreXTypography") === "variant";
  const tabMinHeight = useTabMinHeight();
  const selectedUnderlineCss = {
    borderRadius: 1,
    content: '""',
    display: "block",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: 2,
    background: foregroundColor
  };
  return /* @__PURE__ */jsxs(Tab$1, __spreadProps(__spreadValues(__spreadValues({}, omitNonTabProps(tab)), rest), {
    type: "button",
    css: {
      flexShrink: 0,
      minHeight: tabMinHeight - ICON_SIZE,
      cursor: "pointer",
      backgroundColor: "transparent",
      position: "relative",
      borderRadius: theme.radius.r8,
      maxWidth: TEXT_MAX_WIDTH + PADDING_X_SIDE * 2,
      paddingTop: spacing.s4,
      paddingRight: PADDING_X_SIDE,
      paddingBottom: coreXTypographyEnabled ? 12 : 10,
      paddingLeft: PADDING_X_SIDE,
      color: foregroundColor,
      border: "0",
      minWidth: TAB_MIN_WIDTH + spacing.s16 - 4,
      [responsive_exports.up("r")]: {
        minWidth: TAB_MIN_WIDTH + spacing.s32 - 4
      },
      // Prevent sticky hover on touch devices
      "@media(hover: hover) and (pointer: fine)": {
        "&:hover::before": selectedUnderlineCss
      },
      '&[aria-selected="true"]::before': selectedUnderlineCss,
      "&:focus": {
        outline: "none"
      },
      // Add a border to indicate focus
      "&.focus-visible::after": {
        borderRadius: `${theme.radius.r12}px ${theme.radius.r12}px 0 0`,
        content: '""',
        display: "block",
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 4,
        left: 0,
        border: `solid 2px ${foregroundColor}`
      },
      "& span": {
        display: "block",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
      },
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    },
    children: [/* @__PURE__ */jsxs("span", {
      css: {
        position: "relative",
        maxHeight: ICON_SIZE,
        minHeight: 0,
        marginBottom: coreXTypographyEnabled ? spacing.s8 : spacing.s4,
        flexShrink: 1,
        minWidth: TAB_MIN_WIDTH
      },
      children: [/* @__PURE__ */jsx(Icon, {
        css: {
          opacity: 1,
          '[aria-selected="true"] > span > &, button:active &': {
            opacity: 0
          },
          transition: "opacity 200ms ease-in-out"
        },
        size: ICON_SIZE,
        "aria-hidden": true,
        color: foregroundColorKey
      }), /* @__PURE__ */jsx(SelectedIcon, {
        css: {
          position: "absolute",
          transition: "opacity 200ms ease-in-out",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          marginLeft: "auto",
          marginRight: "auto",
          opacity: 0,
          '[aria-selected="true"] > span > &, button:active &': {
            opacity: 1
          }
        },
        size: ICON_SIZE,
        "aria-hidden": true,
        color: foregroundColorKey
      })]
    }), /* @__PURE__ */jsx("span", {
      css: __spreadProps(__spreadValues({}, theme.typography.bodySmall1), {
        '[data-collapsed="true"] &': {
          padding: `${spacing.s4}px 0`
        },
        flexShrink: 0,
        minWidth: TAB_MIN_WIDTH,
        maxWidth: TEXT_MAX_WIDTH
      }),
      children
    })]
  }));
}

__name(CategoryTab, "CategoryTab");

function CategoryTabPanel(props) {
  const tab = useContext(CategoryTabContext);
  const theme = useTheme();
  const foregroundColor = tab.inverseColorPalette ? theme.colors.systemGrayscale00 : theme.colors.systemGrayscale80;
  return /* @__PURE__ */jsx(TabPanel$1, __spreadProps(__spreadValues(__spreadValues({}, omitNonTabProps(tab)), props), {
    css: {
      position: "relative",
      "&:focus": {
        outline: "none"
      },
      "&.focus-visible::after": {
        borderRadius: theme.radius.r12,
        content: '""',
        display: "block",
        position: "absolute",
        top: -4,
        right: -4,
        bottom: -4,
        left: -4,
        border: `solid 2px ${foregroundColor}`
      }
    }
  }));
}

__name(CategoryTabPanel, "CategoryTabPanel");

var CouponClipButton = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function CouponClipButton2(_a, ref) {
  var _b = _a,
      {
    children,
    applied
  } = _b,
      rest = __objRest(_b, ["children", "applied"]);

  const theme = useTheme();
  const styles25 = {
    button: {
      backgroundColor: theme.colors.brandPromotionalLight,
      color: theme.colors.brandPromotionalRegular,
      height: 32,
      width: "100%",
      borderRadius: theme.radius.r8
    },
    content: __spreadProps(__spreadValues({}, theme.typography.bodySmall1), {
      marginLeft: spacing.s12,
      marginRight: spacing.s12,
      [responsive_exports.up("r")]: __spreadValues({}, theme.typography.bodyMedium1)
    }),
    focusRing: {
      borderRadius: theme.radius.r12
    },
    hover: {
      color: theme.colors.brandPromotionalDark
    },
    active: {
      backgroundColor: theme.colors.brandPromotionalLight,
      color: theme.colors.brandPromotionalDark
    },
    disabled: {
      // button is disabled when coupon is applied
      backgroundColor: theme.colors.systemGrayscale00,
      color: theme.colors.brandPromotionalDark
    },
    loading: {
      backgroundColor: theme.colors.brandPromotionalLight,
      color: theme.colors.brandPromotionalDark
    }
  };
  return /* @__PURE__ */jsx(ButtonBase2, __spreadProps(__spreadValues({}, rest), {
    styles: styles25,
    ref,
    disabled: applied,
    children
  }));
}, "CouponClipButton"));

var getStyles24 = /* @__PURE__ */__name(theme => ({
  button: {
    borderRadius: theme.radius.round,
    height: spacing.s40,
    width: spacing.s40
  },
  disabled: {
    backgroundColor: "transparent"
  },
  hover: {},
  active: {},
  focusRing: {
    borderRadius: theme.radius.round
  },
  content: {
    display: "block",
    lineHeight: 1
  }
}), "getStyles");

var IconButtonBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function IconButton(_a, ref) {
  var _b = _a,
      {
    accessibleLabel,
    color,
    disabled,
    icon: Icon,
    styles: styles25
  } = _b,
      props = __objRest(_b, ["accessibleLabel", "color", "disabled", "icon", "styles"]);

  const theme = useTheme();
  const combinedStyles = combineStyles(getStyles24(theme), styles25);
  return /* @__PURE__ */jsx(ButtonCore, __spreadProps(__spreadValues({
    "aria-label": accessibleLabel,
    styles: combinedStyles,
    disabled
  }, props), {
    ref,
    children: /* @__PURE__ */jsx(Icon, {
      size: 24,
      color: disabled ? "systemGrayscale30" : color
    })
  }));
}, "IconButton"));
var iconColor = "systemGrayscale00";
var DarkOverlayIconButton = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function DarkOverlayIconButton2(props, ref) {
  const theme = useTheme();
  const interactiveColors = useComputeInteractiveColors({
    backgroundColor: "systemGrayscale80",
    theme,
    opacity: 0.24
  });
  const styles25 = {
    button: {
      backgroundColor: interactiveColors == null ? void 0 : interactiveColors.primaryColor,
      backdropFilter: "blur(6px)"
    },
    disabled: {
      backgroundColor: theme.colors.systemGrayscale10
    },
    hover: {
      backgroundColor: interactiveColors == null ? void 0 : interactiveColors.hoverColor
    },
    active: {
      backgroundColor: interactiveColors == null ? void 0 : interactiveColors.activeColor
    },
    focusRing: {},
    content: {}
  };
  return /* @__PURE__ */jsx(IconButtonBase, __spreadProps(__spreadValues({
    color: iconColor,
    styles: styles25
  }, props), {
    ref
  }));
}, "DarkOverlayIconButton"));
DarkOverlayIconButton.displayName = "DarkOverlayIconButton";

var getStyles25 = /* @__PURE__ */__name(theme => ({
  divider: {
    width: "100%",
    height: 1,
    backgroundColor: theme.colors.systemGrayscale20
  }
}), "getStyles");

function DividerBase(_ref43) {
  let {
    styles: styleOverrides
  } = _ref43;
  const theme = useTheme();
  const styles25 = combineStyles(getStyles25(theme), styleOverrides);
  return /* @__PURE__ */jsx("div", {
    role: "separator",
    css: styles25.divider
  });
}

__name(DividerBase, "DividerBase");

function Divider(props) {
  return /* @__PURE__ */jsx(DividerBase, __spreadProps(__spreadValues({}, props), {
    styles: {
      divider: {
        marginTop: spacing.s16,
        marginBottom: spacing.s16
      }
    }
  }));
}

__name(Divider, "Divider");

var baseStyles9 = {
  button: {},
  content: {
    alignItems: "center",
    display: "flex",
    marginLeft: 0,
    marginRight: 0
  },
  text: {}
};

var getIconProps = /* @__PURE__ */__name(itemCount => ({
  color: itemCount === 0 ? "systemGrayscale80" : "systemGrayscale00",
  size: 24,
  style: {
    flexShrink: 0
  }
}), "getIconProps");

var GroupCartButtonBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function GroupCartButtonBase2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    itemCount,
    v2CartButton
  } = _b,
      rest = __objRest(_b, ["styles", "itemCount", "v2CartButton"]);

  const _a2 = combineStyles(baseStyles9, styles25),
        {
    text: textCSS
  } = _a2,
        restCSS = __objRest(_a2, ["text"]);

  const iconProps = getIconProps(itemCount);
  const showText = !(itemCount === 0 && v2CartButton);
  return /* @__PURE__ */jsxs(ButtonBase2, __spreadProps(__spreadValues({}, rest), {
    ref,
    styles: restCSS,
    children: [/* @__PURE__ */jsx(GroupIcon_default, __spreadValues({}, iconProps)), /* @__PURE__ */jsx(CartIcon_default, __spreadValues({}, iconProps)), showText && /* @__PURE__ */jsx("span", {
      css: textCSS,
      children: itemCount
    })]
  }));
}, "GroupCartButtonBase"));

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function GroupCartButton2(_a, ref) {
  var _b = _a,
      {
    itemCount
  } = _b,
      rest = __objRest(_b, ["itemCount"]);

  const theme = useTheme();
  const coreStyles = {
    button: {
      border: 0,
      display: "flex",
      height: "36px",
      minWidth: "fit-content",
      padding: `${spacing.s8}px ${spacing.s12}px`,
      width: "auto",
      [responsive_exports.up("r")]: {
        height: spacing.s40,
        padding: `${spacing.s8}px ${spacing.s16}px`
      }
    },
    content: __spreadProps(__spreadValues({}, theme.typography.subtitle), {
      alignItems: "center",
      color: itemCount === 0 ? theme.colors.systemGrayscale80 : theme.colors.systemGrayscale00,
      display: "flex",
      gap: spacing.s4
    }),
    text: {}
  };
  return /* @__PURE__ */jsx(GroupCartButtonBase, __spreadProps(__spreadValues({}, rest), {
    itemCount,
    buttonColor: itemCount === 0 ? "systemGrayscale10" : "brandPrimaryRegular",
    styles: coreStyles,
    ref
  }));
}, "GroupCartButton"));

var getStyles26 = /* @__PURE__ */__name((_ref44) => {
  let {
    elevationShadow,
    elevationDepth,
    heightStandard,
    radiusStandard,
    spaceHorizontalStandard,
    spaceHorizontalStandardDesktop,
    borderColor,
    borderHoverColor,
    borderPressColor,
    textColor
  } = _ref44;
  return {
    button: {
      boxShadow: elevationShadow,
      zIndex: elevationDepth,
      height: heightStandard,
      borderRadius: radiusStandard,
      paddingLeft: spaceHorizontalStandard,
      paddingRight: spaceHorizontalStandard,
      border: borderColor ? `1px solid ${borderColor}` : void 0,
      color: textColor,
      [responsive_exports.DESKTOP_SIZE]: {
        paddingLeft: spaceHorizontalStandardDesktop,
        paddingRight: spaceHorizontalStandardDesktop
      }
    },
    focusRing: {
      borderRadius: radiusStandard
    },
    disabled: {},
    hover: {
      borderColor: borderHoverColor
    },
    active: {
      borderColor: borderPressColor
    }
  };
}, "getStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function DetrimentalButton2(_a, ref) {
  var _b = _a,
      {
    fullWidth = true,
    loading
  } = _b,
      props = __objRest(_b, ["fullWidth", "loading"]);

  const _a2 = useComponentTheme("buttonDetrimental"),
        {
    colorBackgroundType,
    color,
    color2,
    hoverColor,
    hoverColor2,
    pressColor,
    pressColor2
  } = _a2,
        componentTokens = __objRest(_a2, ["colorBackgroundType", "color", "color2", "hoverColor", "hoverColor2", "pressColor", "pressColor2"]);

  const styles25 = getStyles26(componentTokens);
  return /* @__PURE__ */jsx(ButtonBase2, __spreadProps(__spreadValues({
    loading
  }, props), {
    buttonColor: {
      colorBackgroundType,
      color,
      color2,
      hoverColor,
      hoverColor2,
      pressColor,
      pressColor2
    },
    fullWidth,
    styles: styles25,
    ref
  }));
}, "DetrimentalButton"));

var getStyles27 = /* @__PURE__ */__name((_ref45) => {
  let {
    elevationShadow,
    elevationDepth,
    heightCompact,
    radiusCompact,
    spaceHorizontalCompact,
    spaceHorizontalCompactDesktop,
    borderColor,
    borderHoverColor,
    borderPressColor,
    textColor
  } = _ref45;
  return {
    button: {
      boxShadow: elevationShadow,
      zIndex: elevationDepth,
      height: heightCompact,
      borderRadius: radiusCompact,
      paddingLeft: spaceHorizontalCompact,
      paddingRight: spaceHorizontalCompact,
      border: borderColor ? `1px solid ${borderColor}` : void 0,
      color: textColor,
      [responsive_exports.DESKTOP_SIZE]: {
        paddingLeft: spaceHorizontalCompactDesktop,
        paddingRight: spaceHorizontalCompactDesktop
      }
    },
    focusRing: {
      borderRadius: radiusCompact
    },
    disabled: {},
    hover: {
      borderColor: borderHoverColor
    },
    active: {
      borderColor: borderPressColor
    }
  };
}, "getStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function DetrimentalButtonCompact2(_a, ref) {
  var _b = _a,
      {
    fullWidth,
    loading
  } = _b,
      props = __objRest(_b, ["fullWidth", "loading"]);

  const _a2 = useComponentTheme("buttonDetrimental"),
        {
    colorBackgroundType,
    color,
    color2,
    hoverColor,
    hoverColor2,
    pressColor,
    pressColor2
  } = _a2,
        componentTokens = __objRest(_a2, ["colorBackgroundType", "color", "color2", "hoverColor", "hoverColor2", "pressColor", "pressColor2"]);

  const styles25 = getStyles27(componentTokens);
  return /* @__PURE__ */jsx(ButtonCompactBase, __spreadProps(__spreadValues({
    loading
  }, props), {
    buttonColor: {
      colorBackgroundType,
      color,
      color2,
      hoverColor,
      hoverColor2,
      pressColor,
      pressColor2
    },
    fullWidth,
    styles: styles25,
    ref
  }));
}, "DetrimentalButtonCompact"));

var getStyles28 = /* @__PURE__ */__name((_ref46) => {
  let {
    elevationShadow,
    elevationDepth,
    heightSmall,
    radiusSmall,
    spaceHorizontalSmall,
    spaceHorizontalSmallDesktop,
    borderColor,
    borderHoverColor,
    borderPressColor,
    textColor
  } = _ref46;
  return {
    button: {
      boxShadow: elevationShadow,
      zIndex: elevationDepth,
      height: heightSmall,
      borderRadius: radiusSmall,
      paddingLeft: spaceHorizontalSmall,
      paddingRight: spaceHorizontalSmall,
      border: borderColor ? `1px solid ${borderColor}` : void 0,
      color: textColor,
      [responsive_exports.DESKTOP_SIZE]: {
        paddingLeft: spaceHorizontalSmallDesktop,
        paddingRight: spaceHorizontalSmallDesktop
      }
    },
    focusRing: {
      borderRadius: radiusSmall
    },
    disabled: {},
    hover: {
      borderColor: borderHoverColor
    },
    active: {
      borderColor: borderPressColor
    }
  };
}, "getStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function DetrimentalButtonSmall2(_a, ref) {
  var _b = _a,
      {
    fullWidth,
    loading
  } = _b,
      props = __objRest(_b, ["fullWidth", "loading"]);

  const _a2 = useComponentTheme("buttonDetrimental"),
        {
    colorBackgroundType,
    color,
    color2,
    hoverColor,
    hoverColor2,
    pressColor,
    pressColor2
  } = _a2,
        componentTokens = __objRest(_a2, ["colorBackgroundType", "color", "color2", "hoverColor", "hoverColor2", "pressColor", "pressColor2"]);

  const styles25 = getStyles28(componentTokens);
  return /* @__PURE__ */jsx(ButtonSmallBase, __spreadProps(__spreadValues({
    loading
  }, props), {
    buttonColor: {
      colorBackgroundType,
      color,
      color2,
      hoverColor,
      hoverColor2,
      pressColor,
      pressColor2
    },
    fullWidth,
    styles: styles25,
    ref
  }));
}, "DetrimentalButtonSmall"));
var IconButton2 = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function IconButton3(props, ref) {
  const theme = useTheme();
  const styles25 = {
    button: {},
    disabled: {},
    hover: {
      backgroundColor: theme.colors.systemGrayscale10
    },
    active: {
      backgroundColor: theme.colors.systemGrayscale20
    },
    focusRing: {},
    content: {}
  };
  return /* @__PURE__ */jsx(IconButtonBase, __spreadProps(__spreadValues({
    styles: styles25
  }, props), {
    ref
  }));
}, "IconButton"));
IconButton2.displayName = "IconButton";

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function InstacartPlusButton2(_a, ref) {
  var _b = _a,
      {
    fullWidth = true,
    loading
  } = _b,
      props = __objRest(_b, ["fullWidth", "loading"]);

  return /* @__PURE__ */jsx(ButtonBase2, __spreadProps(__spreadValues({
    loading
  }, props), {
    buttonColor: "plusRegular",
    fullWidth,
    ref
  }));
}, "InstacartPlusButton"));

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function InstacartPlusButtonCompact2(_a, ref) {
  var _b = _a,
      {
    fullWidth,
    loading
  } = _b,
      props = __objRest(_b, ["fullWidth", "loading"]);

  return /* @__PURE__ */jsx(ButtonCompactBase, __spreadProps(__spreadValues({
    loading
  }, props), {
    buttonColor: "plusRegular",
    fullWidth,
    ref
  }));
}, "InstacartPlusButtonCompact"));

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function InstacartPlusButtonSmall2(_a, ref) {
  var _b = _a,
      {
    fullWidth,
    loading
  } = _b,
      props = __objRest(_b, ["fullWidth", "loading"]);

  return /* @__PURE__ */jsx(ButtonSmallBase, __spreadProps(__spreadValues({
    loading
  }, props), {
    buttonColor: "plusRegular",
    fullWidth,
    ref
  }));
}, "InstacartPlusButtonSmall"));
var buttonStyles = {
  content: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }
};
var PriceButtonBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function PriceButtonBase2(_a, ref) {
  var _b = _a,
      {
    buttonColor,
    children,
    price,
    strikethroughPrice,
    strikethroughPriceCurrentPriceLabel,
    strikethroughPriceOriginalPriceLabel
  } = _b,
      rest = __objRest(_b, ["buttonColor", "children", "price", "strikethroughPrice", "strikethroughPriceCurrentPriceLabel", "strikethroughPriceOriginalPriceLabel"]);

  const grayscale = useIdsFeatureFlag("grayscale") === "grayscale";
  return /* @__PURE__ */jsxs(ButtonBase2, __spreadProps(__spreadValues({}, rest), {
    buttonColor: grayscale ? "systemGrayscale80" : buttonColor,
    fullWidth: true,
    styles: buttonStyles,
    ref,
    children: [/* @__PURE__ */jsx("div", {
      css: {
        flexShrink: 0
      },
      children
    }), /* @__PURE__ */jsxs(Flex, {
      alignItems: "center",
      flexShrink: 0,
      gap: spacing.s4,
      justifyContent: "center",
      marginLeft: spacing.s8,
      minWidth: 54,
      width: "fit-content",
      children: [/* @__PURE__ */jsxs(Text, {
        color: "systemGrayscale00",
        typography: "bodyStrikethrough",
        children: [strikethroughPriceOriginalPriceLabel && /* @__PURE__ */jsx(VisuallyHidden, {
          children: strikethroughPriceOriginalPriceLabel
        }), strikethroughPrice]
      }), strikethroughPriceCurrentPriceLabel && /* @__PURE__ */jsx(VisuallyHidden, {
        children: strikethroughPriceCurrentPriceLabel
      }), price]
    })]
  }));
}, "PriceButtonBase"));

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function InstacartPlusPriceButton2(props, ref) {
  return /* @__PURE__ */jsx(PriceButtonBase, __spreadProps(__spreadValues({}, props), {
    buttonColor: "plusRegular",
    ref
  }));
}, "InstacartPlusPriceButton"));
var TRACK_CONTAINER_CLASS = "switchBase-switchTrack";

function getDimensions(pantryEnabled) {
  if (pantryEnabled) {
    return {
      transitionDurationMs: 100,
      controlPosStart: 2,
      controlPosEnd: 25,
      trackHeight: 28,
      trackWidth: 51,
      switchHeight: 24
    };
  }

  return {
    transitionDurationMs: 100,
    controlPosStart: 4,
    controlPosEnd: 30,
    trackHeight: 32,
    trackWidth: 58,
    switchHeight: 24
  };
}

__name(getDimensions, "getDimensions");

var getStyles29 = /* @__PURE__ */__name((_ref47) => {
  let {
    theme,
    value,
    isDisabled,
    grayscale,
    pantryEnabled
  } = _ref47;
  const selectedColor = grayscale ? theme.colors.systemGrayscale80 : theme.colors.systemSuccessRegular;
  const currentColour = isDisabled ? theme.colors.systemGrayscale20 : value ? selectedColor : theme.colors.systemGrayscale40;
  const shadow = pantryEnabled ? elevation.pantryLow2.shadow : elevation.low.shadow;
  const {
    controlPosEnd,
    controlPosStart,
    switchHeight,
    trackHeight,
    trackWidth,
    transitionDurationMs
  } = getDimensions(pantryEnabled);
  return {
    container: {
      display: "inline-block",
      position: "relative",
      boxSizing: "border-box",
      width: trackWidth,
      height: trackHeight,
      "&:hover": {
        cursor: isDisabled ? "not-allowed" : "inherit"
      }
    },
    switchTrack: __spreadProps(__spreadValues({}, STRETCH_OVER_RELATIVE_PARENT), {
      borderRadius: 16,
      backgroundColor: currentColour,
      transition: `background-color ${transitionDurationMs}ms ease-in-out`,
      pointerEvents: "none"
    }),
    switchControl: __spreadProps(__spreadValues(__spreadValues({
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: switchHeight,
      width: switchHeight,
      borderRadius: "50%",
      backgroundColor: "white",
      top: controlPosStart,
      transform: value ? `translateX(${controlPosEnd}px)` : `translateX(${controlPosStart}px)`,
      transition: `transform ${transitionDurationMs}ms ease-in-out`,
      pointerEvents: "none"
    }, elevation.low.depth), !isDisabled && shadow), {
      "& svg": {
        fill: currentColour,
        transition: `fill ${transitionDurationMs}ms ease-in-out`
      }
    }),
    input: __spreadProps(__spreadValues({}, STRETCH_OVER_RELATIVE_PARENT), {
      width: trackWidth,
      opacity: 0,
      outline: "none",
      "&:hover": {
        cursor: "pointer"
      }
    }),
    focusRing: {
      border: `2px solid ${theme.colors.systemGrayscale70}`,
      content: '""',
      display: "block",
      position: "absolute",
      top: -4,
      bottom: -4,
      left: -4,
      right: -4,
      borderRadius: 20
    }
  };
}, "getStyles");

var SwitchBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function SwitchBase2(props, ref) {
  const _a = props,
        {
    styles: styles25,
    children,
    disabled = false,
    checked,
    description,
    showIcons: showIconsProp
  } = _a,
        rest = __objRest(_a, ["styles", "children", "disabled", "checked", "description", "showIcons"]);

  const theme = useTheme();
  const grayscale = useIdsFeatureFlag("grayscale") !== "control";
  const pantryEnabled = useIsPantryEnabled();
  const {
    container,
    switchTrack,
    switchControl,
    input,
    focusRing
  } = combineStyles(getStyles29({
    theme,
    value: checked,
    isDisabled: disabled,
    grayscale,
    pantryEnabled
  }), styles25);
  const describedBy = useAriaLabel({
    description
  });
  const showIcons = !pantryEnabled && showIconsProp !== false || pantryEnabled && showIconsProp;
  const inputCss = [input, {
    [`&.focus-visible + .${TRACK_CONTAINER_CLASS}::after`]: focusRing
  }];
  const Icon = checked ? ConfirmIcon_default : CloseIcon_default;
  return /* @__PURE__ */jsxs("div", {
    role: "presentation",
    css: container,
    ref,
    children: [/* @__PURE__ */jsx(Checkbox, __spreadValues(__spreadValues({
      css: inputCss,
      checked,
      disabled,
      "data-testid": "switch-base-input"
    }, rest), describedBy)), /* @__PURE__ */jsx("div", {
      "aria-hidden": true,
      css: switchTrack,
      className: TRACK_CONTAINER_CLASS
    }), /* @__PURE__ */jsx("div", {
      "aria-hidden": true,
      css: switchControl,
      children: showIcons && /* @__PURE__ */jsx(Icon, {
        "data-testid": "swb-icon",
        size: 16
      })
    })]
  });
}, "SwitchBase"));

var getStyles30 = /* @__PURE__ */__name((_ref48) => {
  let {
    isDisabled,
    theme,
    value
  } = _ref48;
  const currentColor = isDisabled ? theme.colors.systemGrayscale20 : value ? theme.colors.plusRegular : theme.colors.systemGrayscale30;
  return {
    switchTrack: {
      backgroundColor: currentColor
    }
  };
}, "getStyles");

function InstacartPlusSwitch(_a) {
  var _b = _a,
      {
    checked,
    disabled = false
  } = _b,
      props = __objRest(_b, ["checked", "disabled"]);

  const theme = useTheme();
  const styles25 = getStyles30({
    isDisabled: disabled,
    theme,
    value: checked
  });
  return /* @__PURE__ */jsx(SwitchBase, __spreadValues({
    checked,
    disabled,
    styles: styles25
  }, props));
}

__name(InstacartPlusSwitch, "InstacartPlusSwitch");

var SHIMMER_WIDTH_PERCENTAGE = 55;
var TRANSLATE_X_START = -100;
var TRANSLATE_X_END = 1 / (SHIMMER_WIDTH_PERCENTAGE / 100) * 100;
var ANIMATION_DURATION_MS = 1e3;

var generateAnimatingShimmerStyles = /* @__PURE__ */__name(theme => {
  const gradientColor = theme.colors.systemGrayscale00;
  const gradientStart = addAlphaToHex(gradientColor, 0);
  const gradientMid = addAlphaToHex(gradientColor, 0.75);
  const gradientEnd = gradientStart;
  const shimmerSweep = keyframes`
      0% {
        transform: translate3d(${TRANSLATE_X_START}%,0,0);
      }

      100% {
        transform: translate3d(${TRANSLATE_X_END}%,0,0);
      }
    `;
  return {
    position: "relative",
    overflow: "hidden",
    "&:before": {
      left: 0,
      width: `${SHIMMER_WIDTH_PERCENTAGE}%`,
      content: "''",
      position: "absolute",
      height: "100%",
      background: `linear-gradient(to right, ${gradientStart}, ${gradientMid}, ${gradientEnd})`,
      animationName: shimmerSweep,
      animationDuration: `${ANIMATION_DURATION_MS}ms`,
      animationTimingFunction: "ease-in-out",
      animationIterationCount: "infinite"
    }
  };
}, "generateAnimatingShimmerStyles");

var getStyles31 = /* @__PURE__ */__name(theme => ({
  container: __spreadValues({
    height: spacing.s24,
    width: spacing.s24,
    borderRadius: "50%",
    backgroundColor: theme.colors.systemGrayscale20
  }, generateAnimatingShimmerStyles(theme))
}), "getStyles");

var LoadingLockupIconBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function LoadingLockupIconBase2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const theme = useTheme();
  const {
    container
  } = combineStyles(getStyles31(theme), styles25);
  return /* @__PURE__ */jsx("div", __spreadValues({
    ref,
    css: container,
    "aria-busy": "true",
    "data-testid": "loading-lockup-icon-base"
  }, rest));
}, "LoadingLockupIconBase"));
var ASSET_CONTAINER_PERCENTAGE_OF_PARENT = "62.5%";
var ASSET_PERCENTAGE_OF_PARENT = "46%";
var RELATIVE_BORDER_RADIUS_PERCENTAGE = "16%";

var getStyles32 = /* @__PURE__ */__name(theme => ({
  container: __spreadValues({
    width: "200px",
    height: "200px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: RELATIVE_BORDER_RADIUS_PERCENTAGE
  }, generateAnimatingShimmerStyles(theme)),
  assetContainer: {
    width: ASSET_CONTAINER_PERCENTAGE_OF_PARENT,
    height: ASSET_CONTAINER_PERCENTAGE_OF_PARENT,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignContent: "space-between"
  },
  asset: {
    width: ASSET_PERCENTAGE_OF_PARENT,
    height: ASSET_PERCENTAGE_OF_PARENT,
    backgroundColor: theme.colors.systemGrayscale20
  },
  circleAsset: {
    borderRadius: "50%"
  },
  squareAsset: {
    borderRadius: "15%"
  }
}), "getStyles");

var LoadingLockupImageBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function LoadingLockupImageBase2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const theme = useTheme();
  const {
    container,
    assetContainer,
    asset,
    circleAsset,
    squareAsset
  } = combineStyles(getStyles32(theme), styles25);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    ref,
    css: container,
    "aria-busy": "true",
    "data-testid": "loading-lockup-image-base"
  }, rest), {
    children: /* @__PURE__ */jsxs("div", {
      css: assetContainer,
      children: [/* @__PURE__ */jsx("div", {
        css: [asset, squareAsset]
      }), /* @__PURE__ */jsx("div", {
        css: [asset, circleAsset]
      }), /* @__PURE__ */jsx("div", {
        css: [asset, circleAsset]
      }), /* @__PURE__ */jsx("div", {
        css: [asset, squareAsset]
      })]
    })
  }));
}, "LoadingLockupImageBase"));

var getStyles33 = /* @__PURE__ */__name(theme => ({
  container: __spreadValues({
    width: "100%",
    height: spacing.s16,
    borderRadius: theme.radius.r8,
    backgroundColor: theme.colors.systemGrayscale20
  }, generateAnimatingShimmerStyles(theme))
}), "getStyles");

var LoadingLockupTextBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function LoadingLockupTextBase2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const theme = useTheme();
  const {
    container
  } = combineStyles(getStyles33(theme), styles25);
  return /* @__PURE__ */jsx("div", __spreadValues({
    ref,
    css: container,
    "aria-busy": "true",
    "data-testid": "loading-lockup-text-base"
  }, rest));
}, "LoadingLockupTextBase"));

var getStyles34 = /* @__PURE__ */__name(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: "340px"
  },
  image: {
    width: "200px",
    height: "200px",
    marginBottom: spacing.s16
  },
  text: {
    width: "100%"
  }
}), "getStyles");

var firstLineTextStyles = {
  container: {
    height: "16px",
    width: "258px",
    marginBottom: spacing.s24
  }
};
var secondLineTextStyles = {
  container: {
    height: "14px",
    width: "96px",
    marginBottom: spacing.s24
  }
};
var thirdLineTextStyles = {
  container: {
    height: "12px",
    width: "166px"
  }
};

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function LoadingLockupDetailItem2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const {
    container,
    image,
    text
  } = combineStyles(getStyles34(), styles25);
  return /* @__PURE__ */jsxs("div", __spreadProps(__spreadValues({
    ref,
    css: container,
    "data-testid": "loading-lockup-detail-item"
  }, rest), {
    children: [/* @__PURE__ */jsx(LoadingLockupImageBase, {
      css: image
    }), /* @__PURE__ */jsxs("div", {
      css: text,
      children: [/* @__PURE__ */jsx(LoadingLockupTextBase, {
        styles: firstLineTextStyles
      }), /* @__PURE__ */jsx(LoadingLockupTextBase, {
        styles: secondLineTextStyles
      }), /* @__PURE__ */jsx(LoadingLockupTextBase, {
        styles: thirdLineTextStyles
      })]
    })]
  }));
}, "LoadingLockupDetailItem"));

var getStyles35 = /* @__PURE__ */__name(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  image: {
    width: "172px",
    height: "172px",
    marginBottom: "9px"
  }
}), "getStyles");

var firstLineTextStyles2 = {
  container: {
    height: "12px",
    width: "96px",
    marginBottom: "10px"
  }
};
var secondLineTextStyles2 = {
  container: {
    height: "12px",
    width: "156px",
    marginBottom: spacing.s12
  }
};
var thirdLineTextStyles2 = {
  container: {
    height: "10px",
    width: "72px"
  }
};
var LoadingLockupGridItem = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function LoadingLockupGridItem2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const {
    container,
    image
  } = combineStyles(getStyles35(), styles25);
  return /* @__PURE__ */jsxs("div", __spreadProps(__spreadValues({
    ref,
    css: container,
    "data-testid": "loading-lockup-grid-item"
  }, rest), {
    children: [/* @__PURE__ */jsx(LoadingLockupImageBase, {
      css: image
    }), /* @__PURE__ */jsxs("div", {
      children: [/* @__PURE__ */jsx(LoadingLockupTextBase, {
        styles: firstLineTextStyles2
      }), /* @__PURE__ */jsx(LoadingLockupTextBase, {
        styles: secondLineTextStyles2
      }), /* @__PURE__ */jsx(LoadingLockupTextBase, {
        styles: thirdLineTextStyles2
      })]
    })]
  }));
}, "LoadingLockupGridItem"));

var getStyles36 = /* @__PURE__ */__name(() => ({
  container: {
    width: "100%",
    marginBottom: spacing.s32
  },
  primary: {
    height: "14px",
    maxWidth: "432px",
    marginBottom: spacing.s12
  },
  secondary: {
    height: "12px",
    width: "70%",
    maxWidth: "310px"
  }
}), "getStyles");

var LoadingLockupTextRow = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function LoadingLockupTextRow2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const {
    container,
    primary,
    secondary
  } = combineStyles(getStyles36(), styles25);
  return /* @__PURE__ */jsxs("div", __spreadProps(__spreadValues({
    ref,
    css: container,
    "data-testid": "loading-lockup-text-row"
  }, rest), {
    children: [/* @__PURE__ */jsx(LoadingLockupTextBase, {
      css: primary
    }), /* @__PURE__ */jsx(LoadingLockupTextBase, {
      css: secondary
    })]
  }));
}, "LoadingLockupTextRow"));
var ICON_VERTICAL_OFFSET = 4;

var getStyles37 = /* @__PURE__ */__name(() => ({
  container: {
    display: "flex",
    paddingTop: ICON_VERTICAL_OFFSET
  },
  icon: {
    marginRight: spacing.s8,
    marginTop: ICON_VERTICAL_OFFSET * -1,
    flexShrink: 0
  }
}), "getStyles");

var LoadingLockupIconRow = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function LoadingLockupIconRow2(_a, ref) {
  var _b = _a,
      {
    styles: styles25
  } = _b,
      rest = __objRest(_b, ["styles"]);

  const {
    container,
    icon
  } = combineStyles(getStyles37(), styles25);
  return /* @__PURE__ */jsxs("div", __spreadProps(__spreadValues({
    ref,
    css: container,
    "data-testid": "loading-lockup-icon-row"
  }, rest), {
    children: [/* @__PURE__ */jsx(LoadingLockupIconBase, {
      css: icon
    }), /* @__PURE__ */jsx(LoadingLockupTextRow, {})]
  }));
}, "LoadingLockupIconRow"));

var getStyles38 = /* @__PURE__ */__name(() => ({
  container: {
    display: "flex",
    alignItems: "center",
    marginBottom: spacing.s24
  }
}), "getStyles");

var LoadingLockupImageRow = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function LoadingLockupImageRow2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const theme = useTheme();
  const {
    container
  } = combineStyles(getStyles38(), styles25);
  const imageStyles = {
    container: {
      backgroundColor: theme.colors.systemGrayscale20,
      marginRight: spacing.s12,
      width: 48,
      height: 48,
      flexShrink: 0
    },
    asset: {
      backgroundColor: theme.colors.systemGrayscale00
    }
  };
  const rowStyles = {
    container: {
      marginBottom: 0
    }
  };
  return /* @__PURE__ */jsxs("div", __spreadProps(__spreadValues({
    ref,
    css: container,
    "data-testid": "loading-lockup-image-row"
  }, rest), {
    children: [/* @__PURE__ */jsx(LoadingLockupImageBase, {
      styles: imageStyles
    }), /* @__PURE__ */jsx(LoadingLockupTextRow, {
      styles: rowStyles
    })]
  }));
}, "LoadingLockupImageRow"));

var getStyles39 = /* @__PURE__ */__name(() => ({
  container: {
    width: "100%",
    marginBottom: spacing.s32
  },
  title: {
    height: "16px",
    maxWidth: "125px",
    marginBottom: "34px"
  }
}), "getStyles");

var LoadingLockupLayout = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function LoadingLockupLayout2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const {
    container,
    title
  } = combineStyles(getStyles39(), styles25);
  return /* @__PURE__ */jsxs("div", __spreadProps(__spreadValues({
    css: container,
    ref,
    "data-testid": "loading-lockup-layout"
  }, rest), {
    children: [/* @__PURE__ */jsx(LoadingLockupTextBase, {
      css: title
    }), children]
  }));
}, "LoadingLockupLayout"));

var getStyles40 = /* @__PURE__ */__name(() => ({
  container: {
    display: "flex"
  },
  image: {
    width: "120px",
    height: "120px",
    marginRight: spacing.s12,
    flexShrink: 0
  },
  text: {
    marginTop: spacing.s24,
    width: "100%"
  },
  primaryText: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px"
  },
  secondaryText: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: spacing.s12
  }
}), "getStyles");

var firstLineTextStyles3 = {
  container: {
    height: "12px",
    width: "96px"
  }
};
var secondLineTextStyles3 = {
  container: {
    height: "12px",
    width: "156px"
  }
};
var thirdLineTextStyles3 = {
  container: {
    height: "10px",
    width: "72px"
  }
};
var firstLineSupportingTextStyles = {
  container: {
    height: "12px",
    width: "72px",
    [responsive_exports.down("r")]: {
      display: "none"
    }
  }
};
var secondLineSupportingTextStyles = {
  container: {
    height: "10px",
    width: "26px",
    [responsive_exports.down("r")]: {
      display: "none"
    }
  }
};
var LoadingLockupListItem = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function LoadingLockupGridItem3(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const {
    container,
    image,
    text,
    primaryText,
    secondaryText
  } = combineStyles(getStyles40(), styles25);
  return /* @__PURE__ */jsxs("div", __spreadProps(__spreadValues({
    ref,
    css: container,
    "data-testid": "loading-lockup-list-item"
  }, rest), {
    children: [/* @__PURE__ */jsx(LoadingLockupImageBase, {
      css: image
    }), /* @__PURE__ */jsxs("div", {
      css: text,
      children: [/* @__PURE__ */jsxs("div", {
        css: primaryText,
        children: [/* @__PURE__ */jsx(LoadingLockupTextBase, {
          styles: firstLineTextStyles3
        }), /* @__PURE__ */jsx(LoadingLockupTextBase, {
          styles: firstLineSupportingTextStyles
        })]
      }), /* @__PURE__ */jsxs("div", {
        css: secondaryText,
        children: [/* @__PURE__ */jsx(LoadingLockupTextBase, {
          styles: secondLineTextStyles3
        }), /* @__PURE__ */jsx(LoadingLockupTextBase, {
          styles: secondLineSupportingTextStyles
        })]
      }), /* @__PURE__ */jsx(LoadingLockupTextBase, {
        styles: thirdLineTextStyles3
      })]
    })]
  }));
}, "LoadingLockupGridItem"));

var getStyles41 = /* @__PURE__ */__name((theme, colorStyle) => ({
  button: {
    backgroundColor: "transparent"
  },
  focusRing: {
    borderRadius: 16,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  content: __spreadProps(__spreadValues({
    padding: `${spacing.s4}px ${spacing.s12}px`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 2
  }, theme.typography.bodySmall1), {
    color: colorStyle ? theme.colors[colorStyle] : theme.colors.systemGrayscale70
  })
}), "getStyles");

var LoadingAnimation = /* @__PURE__ */jsxs(Flex, {
  alignItems: "center",
  gap: 4,
  children: [/* @__PURE__ */jsx(LoadingLockupTextBase, {}), /* @__PURE__ */jsx(LoadingLockupIconBase, {
    css: {
      flexShrink: 0
    },
    styles: {
      container: {
        height: spacing.s16,
        width: spacing.s16
      }
    }
  })]
});
var InlineTextButton = /*#__PURE__*/forwardRef((props, ref) => {
  const theme = useTheme();

  const _a = props,
        {
    leadingIcon: LeadingIcon,
    children,
    colorStyle
  } = _a,
        rest = __objRest(_a, ["leadingIcon", "children", "colorStyle"]);

  const styles25 = getStyles41(theme, colorStyle);
  const TrailingIcon = LeadingIcon ? ChevronDownIcon_default : ChevronRightIcon_default;
  return /* @__PURE__ */jsxs(ButtonCore, __spreadProps(__spreadValues({
    loadingAnimation: LoadingAnimation,
    styles: styles25
  }, rest), {
    ref,
    children: [LeadingIcon && (reactIsExports.isElement(LeadingIcon) ? renderIconElement(LeadingIcon) : /* @__PURE__ */jsx(LeadingIcon, {
      size: 14
    })), /* @__PURE__ */jsx("span", {
      children
    }), /* @__PURE__ */jsx(TrailingIcon, {
      size: 14
    })]
  }));
});

function renderIconElement(element) {
  return /*#__PURE__*/cloneElement(element, {
    "aria-hidden": true,
    size: 14
  });
}

__name(renderIconElement, "renderIconElement");

InlineTextButton.displayName = "InlineTextButton";

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function ItemB2(props, ref) {
  const {
    styles: containerStyles3
  } = props;
  const theme = useTheme();
  const styles25 = {
    container: __spreadProps(__spreadValues({}, containerStyles3), {
      // TODO: spec says r16 but it doesn't exist in ids-core
      // TODO: verify with design if this should be on the container, figma is not consistent
      //       it's definitely on the focus ring
      borderRadius: theme.radius.r12
    })
  };
  return /* @__PURE__ */jsx(ItemBase, __spreadProps(__spreadValues({
    ref
  }, props), {
    styles: styles25
  }));
}, "ItemB"));

function Bottom(props) {
  const {
    children
  } = props;
  return /* @__PURE__ */jsx("div", {
    children
  });
}

__name(Bottom, "Bottom");

var styles4 = {
  marginBottom: spacing.s8
};

function Top(props) {
  const {
    children
  } = props;
  return /* @__PURE__ */jsx("div", {
    css: styles4,
    children
  });
}

__name(Top, "Top");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function ItemBLink2(props, ref) {
  const theme = useTheme();
  const styles25 = {
    a: __spreadValues({}, props.styles),
    focusRing: {
      // TODO: find a way to tie `a` borderRadius to the focusRing automagically
      borderRadius: theme.radius.r12
    }
  };
  return /* @__PURE__ */jsx(ItemLinkBase, __spreadProps(__spreadValues({
    ref
  }, props), {
    styles: styles25
  }));
}, "ItemBLink"));

var getStyles42 = /* @__PURE__ */__name(theme => ({
  a: {
    textDecoration: "none",
    // so we get one solid focus ring
    display: "block",
    // so the focus ring can use position: absolute
    position: "relative"
  },
  focusRing: {
    border: `2px solid ${theme.colors.systemGrayscale70}`,
    content: '""',
    display: "block",
    position: "absolute",
    top: -4,
    bottom: -4,
    left: -4,
    right: -4
  }
}), "getStyles");

function ItemButtonBase(props) {
  const _a = props,
        {
    children,
    styles: styles25
  } = _a,
        rest = __objRest(_a, ["children", "styles"]);

  const theme = useTheme();
  const {
    a,
    focusRing
  } = combineStyles(getStyles42(theme), styles25);
  const aStyles = [a, {
    "&:hover": {
      // surpress the native underlines
      textDecoration: "none"
    },
    "&:focus": {
      // surpress the native focus ring
      outline: "none",
      // surpress the native underlines
      textDecoration: "none"
    },
    "&.focus-visible::after": focusRing
  }];
  return /* @__PURE__ */jsx("a", __spreadProps(__spreadValues({
    role: "button",
    css: aStyles
  }, rest), {
    children
  }));
}

__name(ItemButtonBase, "ItemButtonBase");

function ItemBButton(props) {
  const theme = useTheme();
  const styles25 = {
    a: __spreadValues({}, props.styles),
    focusRing: {
      // TODO: find a way to tie `button` borderRadius to the focusRing automagically
      borderRadius: theme.radius.r12
    }
  };
  return /* @__PURE__ */jsx(ItemButtonBase, __spreadProps(__spreadValues({}, props), {
    styles: styles25
  }));
}

__name(ItemBButton, "ItemBButton");

var {
  s4: s42
} = spacing;
var styles5 = {
  position: "absolute",
  top: s42,
  right: s42,
  // make sure this is above the item itself for clicking
  zIndex: 2,
  // because ItemBLink sets it's own pointer, we need to override here
  cursor: "auto"
};

function ItemBAddItem(props) {
  return (// this isn't to handle user interaction, so we don't need a11y
    // it's to prevent a parent item from taking the default action when an element in the
    // addItem popover is clicked
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events

    /* @__PURE__ */
    jsx("div", {
      css: styles5,
      onClick: e3 => {
        e3.preventDefault();
      },
      children: /* @__PURE__ */jsx(AddItem, __spreadValues({}, props))
    })
  );
}

__name(ItemBAddItem, "ItemBAddItem");

var {
  s4: s43
} = spacing;
var styles6 = {
  paddingTop: s43,
  // because ItemBLink sets it's own pointer, we need to override here
  cursor: "auto"
};

function ItemBCouponClipButton(props) {
  return (// this isn't to handle user interaction, so we don't need a11y
    // it's to prevent a parent item from taking the default action when an element in the
    // addItem popover is clicked
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events

    /* @__PURE__ */
    jsx("div", {
      css: styles6,
      onClick: e3 => {
        e3.preventDefault();
      },
      children: /* @__PURE__ */jsx(CouponClipButton, __spreadValues({}, props))
    })
  );
}

__name(ItemBCouponClipButton, "ItemBCouponClipButton");

var {
  s12,
  s16
} = spacing;

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function ItemC2(props, ref) {
  const {
    styles: containerStyles3
  } = props;
  const theme = useTheme();
  const styles25 = {
    container: __spreadProps(__spreadValues({}, containerStyles3), {
      padding: `${s12}px ${s16}px`,
      // TODO: spec says r16 but it doesn't exist in ids-core
      // TODO: verify with design if this should be on the container, figma is not consistent
      //       it's definitely on the focus ring
      borderRadius: theme.radius.r12,
      display: "flex",
      flexFlow: "row nowrap"
    })
  };
  return /* @__PURE__ */jsx(ItemBase, __spreadProps(__spreadValues({
    ref
  }, props), {
    styles: styles25
  }));
}, "ItemC"));
var styles7 = {
  flex: "1 1 auto"
};

function Right(props) {
  const {
    children
  } = props;
  return /* @__PURE__ */jsx("div", {
    css: styles7,
    children
  });
}

__name(Right, "Right");

var styles8 = {
  marginRight: spacing.s12,
  flex: "0 0 96px"
};

function Left(props) {
  const {
    children
  } = props;
  return /* @__PURE__ */jsx("div", {
    css: styles8,
    children
  });
}

__name(Left, "Left");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function ItemCLink2(props, ref) {
  const theme = useTheme();
  const styles25 = {
    a: __spreadProps(__spreadValues({}, props.styles), {
      // make the `a` not disrupt parent display
      display: "inherit",
      // fill out the width to not disrupt parent display
      width: "100%"
    }),
    focusRing: {
      // TODO: find a way to tie `a` borderRadius to the focusRing automagically
      borderRadius: theme.radius.r12
    }
  };
  return /* @__PURE__ */jsx(ItemLinkBase, __spreadProps(__spreadValues({
    ref
  }, props), {
    styles: styles25
  }));
}, "ItemCLink"));
var {
  s4: s44
} = spacing;
var styles9 = {
  paddingLeft: s44,
  // because ItemCLink sets it's own pointer, we need to override here
  cursor: "auto"
};

function ItemCAddItem(props) {
  return (// this isn't to handle user interaction, so we don't need a11y
    // it's to prevent a parent item from taking the default action when an element in the
    // addItem popover is clicked
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events

    /* @__PURE__ */
    jsx("div", {
      css: styles9,
      onClick: e3 => {
        e3.preventDefault();
      },
      children: /* @__PURE__ */jsx(AddItem, __spreadValues({}, props))
    })
  );
}

__name(ItemCAddItem, "ItemCAddItem");

var {
  s4: s45
} = spacing;
var styles10 = {
  paddingTop: s45,
  // because ItemCLink sets it's own pointer, we need to override here
  cursor: "auto"
};

function ItemCCouponClipButton(props) {
  return (// this isn't to handle user interaction, so we don't need a11y
    // it's to prevent a parent item from taking the default action when an element in the
    // addItem popover is clicked
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events

    /* @__PURE__ */
    jsx("div", {
      css: styles10,
      onClick: e3 => {
        e3.preventDefault();
      },
      children: /* @__PURE__ */jsx(CouponClipButton, __spreadValues({}, props))
    })
  );
}

__name(ItemCCouponClipButton, "ItemCCouponClipButton");

var ItemD = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function ItemD2(props, ref) {
  const {
    styles: containerStyles3
  } = props;
  const theme = useTheme();
  const styles25 = {
    container: [containerStyles3 == null ? void 0 : containerStyles3.container, {
      borderRadius: theme.radius.r12,
      display: "flex",
      flexFlow: "row nowrap",
      width: "100%",
      [responsive_exports.down("c")]: {
        width: 375
      }
    }]
  };
  return /* @__PURE__ */jsx(ItemBase, __spreadProps(__spreadValues({
    ref
  }, props), {
    styles: styles25
  }));
}, "ItemD"));
ItemD.displayName = "ItemD";
var styles11 = {
  flex: `0 0 ${spacing.s40}px`,
  margin: `${spacing.s12}px 0 ${spacing.s12}px ${spacing.s16}px`,
  [responsive_exports.up("r")]: {
    marginLeft: 0
  }
};

function Left2(props) {
  const {
    children
  } = props;
  return /* @__PURE__ */jsx("div", {
    css: styles11,
    children
  });
}

__name(Left2, "Left");

var styles12 = {
  cursor: "default",
  flex: "1 1 auto",
  margin: `${spacing.s12}px ${spacing.s8}px`
};

function Middle(props) {
  const {
    children
  } = props;
  return /* @__PURE__ */jsx("div", {
    css: styles12,
    children
  });
}

__name(Middle, "Middle");

var styles13 = {
  display: "flex",
  flexDirection: "row",
  marginTop: spacing.s8,
  button: {
    "&:not(:first-of-type)": {
      marginLeft: spacing.s8
    }
  }
};

function MiddleBottom(props) {
  const {
    children
  } = props;
  return /* @__PURE__ */jsx("div", {
    css: styles13,
    children
  });
}

__name(MiddleBottom, "MiddleBottom");

function MiddleTop(props) {
  const {
    children
  } = props;
  return /* @__PURE__ */jsx("div", {
    children
  });
}

__name(MiddleTop, "MiddleTop");

var styles14 = {
  alignItems: "flex-end",
  display: "flex",
  flex: "1 1 auto",
  flexDirection: "column",
  margin: `${spacing.s12}px ${spacing.s16}px ${spacing.s12}px 0`,
  input: {
    marginBottom: spacing.s4
  },
  [responsive_exports.up("r")]: {
    marginRight: 0
  }
};

function Right2(props) {
  const {
    children
  } = props;
  return /* @__PURE__ */jsx("div", {
    css: styles14,
    children
  });
}

__name(Right2, "Right");

var ItemModifierButton = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function ItemModifierButton2(_a, ref) {
  var _b = _a,
      {
    children
  } = _b,
      rest = __objRest(_b, ["children"]);

  const theme = useTheme();
  const styles25 = {
    button: {
      backgroundColor: theme.colors.systemGrayscale10,
      color: theme.colors.systemGrayscale70,
      height: spacing.s32,
      // @note: inferred from mock, needs ux review
      minWidth: 87,
      borderRadius: theme.radius.r8
    },
    content: __spreadProps(__spreadValues({}, theme.typography.bodyMedium1), {
      margin: `${spacing.s4}px ${spacing.s12}px`
    }),
    hover: {
      backgroundColor: blendColors(theme.colors.systemGrayscale10, theme.colors.systemGrayscale20, 50)
    },
    focusRing: {
      borderRadius: theme.radius.r12
    }
  };
  return /* @__PURE__ */jsx(ButtonBase2, __spreadProps(__spreadValues({}, rest), {
    styles: styles25,
    ref,
    children
  }));
}, "ItemModifierButton"));
ItemModifierButton.displayName = "ItemModifierButton";

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function ItemDLink2(props, ref) {
  const theme = useTheme();
  const styles25 = {
    a: __spreadProps(__spreadValues({}, props.styles), {
      display: "inherit",
      width: "100%"
    }),
    focusRing: {
      borderRadius: theme.radius.r12
    }
  };
  return /* @__PURE__ */jsx(ItemLinkBase, __spreadProps(__spreadValues({
    ref
  }, props), {
    styles: styles25
  }));
}, "ItemDLink"));

var getStyles43 = /* @__PURE__ */__name((_ref49) => {
  let {
    theme
  } = _ref49;
  return {
    input: __spreadProps(__spreadValues({}, theme.typography.bodyMedium1), {
      border: `solid 1px ${theme.colors.systemGrayscale30}`,
      borderRadius: `${spacing.s8}px`,
      boxSizing: "border-box",
      color: theme.colors.systemGrayscale70,
      height: spacing.s32,
      padding: `6px ${spacing.s4}px`,
      position: "relative",
      textAlign: "center",
      width: spacing.s48,
      // @note: focusRing can't be used with input elements as it is a replaced element,
      // this prevents us from applying a -4px absolute positioning
      "&:focus": {
        border: `2px solid ${theme.colors.systemGrayscale70}`,
        outline: "none"
      },
      "&:hover": {
        border: `1px solid ${theme.colors.systemGrayscale50}`
      }
    })
  };
}, "getStyles");

var ItemQtyBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function ItemQtyBase2(_a, ref) {
  var _b = _a,
      {
    onChange,
    styles: styles25
  } = _b,
      rest = __objRest(_b, ["onChange", "styles"]);

  const theme = useTheme();
  const {
    input
  } = combineStyles(getStyles43({
    theme
  }), styles25);
  return /* @__PURE__ */jsx("input", __spreadProps(__spreadValues({
    onChange: e3 => onChange(e3.target.value)
  }, rest), {
    css: input,
    ref,
    type: "text"
  }));
}, "ItemQtyBase"));
ItemQtyBase.displayName = "ItemQtyBase";

function ItemQty(props) {
  return /* @__PURE__ */jsx(ItemQtyBase, __spreadValues({}, props));
}

__name(ItemQty, "ItemQty");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function ItemXL2(props, ref) {
  const {
    styles: containerStyles3
  } = props;
  const theme = useTheme();
  const styles25 = {
    container: __spreadProps(__spreadValues({}, containerStyles3), {
      borderRadius: theme.radius.r12,
      border: `1px solid ${theme.colors.systemGrayscale30}`,
      padding: "32px 24px"
    })
  };
  return /* @__PURE__ */jsx(ItemBase, __spreadProps(__spreadValues({
    ref
  }, props), {
    styles: styles25
  }));
}, "ItemXL"));
var styles15 = {
  marginBottom: spacing.s8
};

function Top2(props) {
  const {
    children
  } = props;
  return /* @__PURE__ */jsx("div", {
    css: styles15,
    children
  });
}

__name(Top2, "Top");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function ItemImageXL2(props, ref) {
  const XLRatio = aspectRatio(2, 1);
  return /* @__PURE__ */jsx(ItemImageBase, __spreadProps(__spreadValues({
    ref
  }, props), {
    styles: XLRatio
  }));
}, "ItemImageXL"));
var iconColor2 = "systemGrayscale80";
var LightOverlayIconButton = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function LightOverlayIconButton2(props, ref) {
  const theme = useTheme();
  const interactiveColors = useComputeInteractiveColors({
    backgroundColor: "systemGrayscale00",
    theme,
    opacity: 0.24
  });
  const styles25 = {
    button: {
      backgroundColor: interactiveColors == null ? void 0 : interactiveColors.primaryColor,
      backdropFilter: "blur(6px)"
    },
    disabled: {
      backgroundColor: theme.colors.systemGrayscale10
    },
    hover: {
      backgroundColor: interactiveColors == null ? void 0 : interactiveColors.hoverColor
    },
    active: {
      backgroundColor: interactiveColors == null ? void 0 : interactiveColors.activeColor
    },
    focusRing: {},
    content: {}
  };
  return /* @__PURE__ */jsx(IconButtonBase, __spreadProps(__spreadValues({
    color: iconColor2,
    styles: styles25
  }, props), {
    ref
  }));
}, "LightOverlayIconButton"));
LightOverlayIconButton.displayName = "LightOverlayIconButton";

var getColorStates = /* @__PURE__ */__name(theme => ({
  brandPrimaryRegular: {
    base: theme.colors.brandPrimaryRegular,
    visited: theme.colors.brandPrimaryRegular,
    hover: blendColors(theme.colors.brandPrimaryRegular, theme.colors.brandPrimaryDark, 51),
    active: theme.colors.brandPrimaryDark
  },
  systemGrayscale00: {
    base: theme.colors.systemGrayscale00,
    visited: theme.colors.systemGrayscale00,
    hover: blendColors(theme.colors.systemGrayscale00, theme.colors.systemGrayscale20, 51),
    active: theme.colors.systemGrayscale20
  },
  systemGrayscale50: {
    base: theme.colors.systemGrayscale50,
    visited: theme.colors.systemGrayscale50,
    hover: blendColors(theme.colors.systemGrayscale50, theme.colors.systemGrayscale70, 51),
    active: theme.colors.systemGrayscale70
  },
  systemGrayscale60: {
    base: theme.colors.systemGrayscale60,
    visited: theme.colors.systemGrayscale60,
    hover: blendColors(theme.colors.systemGrayscale60, theme.colors.systemGrayscale80, 51),
    active: theme.colors.systemGrayscale80
  },
  systemGrayscale70: {
    base: theme.colors.systemGrayscale70,
    visited: theme.colors.systemGrayscale70,
    hover: blendColors(theme.colors.systemGrayscale70, theme.colors.systemGrayscale90, 51),
    active: theme.colors.systemGrayscale90
  },
  systemGrayscale80: {
    base: theme.colors.systemGrayscale80,
    visited: theme.colors.systemGrayscale80,
    hover: blendColors(theme.colors.systemGrayscale80, theme.colors.systemGrayscale99, 51),
    active: theme.colors.systemGrayscale99
  }
}), "getColorStates");

var getStyles44 = /* @__PURE__ */__name((theme, typographyStyle, colorState) => ({
  link: __spreadValues({
    color: colorState.base,
    "&:visited": {
      color: colorState.visited
    },
    position: "relative"
  }, theme.typography[typographyStyle]),
  focusRing: {},
  hover: {
    color: colorState.hover
  },
  active: {
    color: colorState.active
  }
}), "getStyles");

var LinkBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function LinkBase2(props, ref) {
  const theme = useTheme();
  const colorStates = getColorStates(theme);

  const _a = props,
        {
    colorStyle,
    typographyStyle,
    styles: styles25
  } = _a,
        rest = __objRest(_a, ["colorStyle", "typographyStyle", "styles"]);

  const grayscale = useIdsFeatureFlag("grayscale") !== "control";
  let selectedColor = colorStyle;

  if (grayscale && selectedColor !== "systemGrayscale50") {
    selectedColor = "systemGrayscale70";
  }

  const baseStyles16 = getStyles44(theme, typographyStyle, colorStates[typographyStyle.includes("legal") ? "brandPrimaryRegular" : selectedColor != null ? selectedColor : "brandPrimaryRegular"]);
  const combinedStyles = combineStyles(baseStyles16, styles25);
  const css = [combinedStyles.link, {
    "&:focus": {
      outline: "none"
    },
    "&.focus-visible::after": combinedStyles.focusRing,
    "&:hover": combinedStyles.hover,
    "&:active": combinedStyles.active
  }];
  return /* @__PURE__ */jsx(LinkCore, __spreadProps(__spreadValues({
    css
  }, rest), {
    ref
  }));
}, "LinkBase"));

var getStyles45 = /* @__PURE__ */__name(theme => ({
  link: {},
  focusRing: {
    border: `2px solid ${theme.colors.systemGrayscale70}`,
    content: '""',
    display: "block",
    position: "absolute",
    top: -4,
    bottom: -4,
    left: -4,
    right: -4,
    borderRadius: theme.radius.r4
  },
  hover: {},
  active: {}
}), "getStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function Link2(props, ref) {
  const theme = useTheme();
  const styles25 = getStyles45(theme);
  return /* @__PURE__ */jsx(LinkBase, __spreadProps(__spreadValues({
    styles: styles25
  }, props), {
    ref
  }));
}, "Link"));
var BORDER_WIDTH2 = 2;
var activeIconColor2 = "systemGrayscale00";
var inactiveIconColor2 = "systemGrayscale80";

var getStyles46 = /* @__PURE__ */__name(theme => ({
  anchor: __spreadProps(__spreadValues({
    display: "inline-flex",
    gap: spacing.s4,
    alignItems: "center",
    position: "relative"
  }, getSharedPillStyles(theme)), {
    "&.focus-visible::after": {
      borderRadius: theme.radius.round,
      border: `${BORDER_WIDTH2}px solid ${theme.colors.systemGrayscale80}`,
      content: '""',
      display: "block",
      position: "absolute",
      top: -5,
      bottom: -5,
      left: -5,
      right: -5
    },
    "&:focus": {
      outline: "none"
    },
    "&.focus-visible": {
      outline: "none"
    },
    "&:hover": {
      backgroundColor: blendColors(theme.colors.systemGrayscale20, theme.colors.systemGrayscale30, 51)
    },
    "&:active": {
      backgroundColor: theme.colors.systemGrayscale30
    },
    padding: `3px ${spacing.s12}px`
  }),
  container: {
    display: "inline-block"
  }
}), "getStyles");

var getActiveStyles = /* @__PURE__ */__name(theme => ({
  backgroundColor: theme.colors.systemGrayscale80,
  border: `${BORDER_WIDTH2}px solid ${theme.colors.systemGrayscale80}`,
  color: theme.colors.systemGrayscale00,
  "&:hover": {
    backgroundColor: theme.colors.systemGrayscale60,
    borderColor: theme.colors.systemGrayscale60
  },
  "&:active": {
    backgroundColor: theme.colors.systemGrayscale50,
    borderColor: theme.colors.systemGrayscale50
  }
}), "getActiveStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function LinkPill2(_a, ref) {
  var _b = _a,
      {
    active,
    children,
    href,
    leadingIcon: LeadingIcon,
    trailingIcon: TrailingIcon
  } = _b,
      restProps = __objRest(_b, ["active", "children", "href", "leadingIcon", "trailingIcon"]);

  const theme = useTheme();
  const styles25 = getStyles46(theme);
  const activeStyles = active ? getActiveStyles(theme) : {};
  const iconColor6 = active ? activeIconColor2 : inactiveIconColor2;
  return /* @__PURE__ */jsx("span", {
    css: styles25.container,
    children: /* @__PURE__ */jsxs("a", __spreadProps(__spreadValues({
      ref,
      href,
      css: [styles25.anchor, activeStyles],
      "aria-current": active,
      className: "ids-link"
    }, restProps), {
      children: [LeadingIcon && /* @__PURE__ */jsx(LeadingIcon, {
        color: iconColor6,
        size: spacing.s16
      }), children, TrailingIcon && /* @__PURE__ */jsx(TrailingIcon, {
        color: iconColor6,
        size: spacing.s16
      })]
    }))
  });
}, "LinkPill"));
var {
  s8,
  s12: s122,
  s16: s162,
  s24
} = spacing;
var {
  up
} = responsive_exports;
var styles16 = {
  containerStyles: {
    display: "grid",
    gridGap: `${s122}px ${s162}px`,
    // TODO: decide between minmax(172px, 172px) and minmax(172px, 1fr)
    // using 1fr for now until design can sign off
    gridTemplateColumns: "repeat(auto-fill, minmax(172px, 1fr))",
    padding: `${s8}px ${s162}px`,
    [up("r")]: {
      gridGap: `${s162}px`,
      padding: `${s8}px 0`
    },
    [up("xl")]: {
      gridGap: `${s24}px`,
      padding: `${s122}px 0`
    },
    // Hide empty child elements
    "& > *:empty": {
      display: "none"
    },
    listStyle: "none"
  }
};

function LockupB(props) {
  const {
    children
  } = props;
  const wrappedChildren = useMemo(() => Children.map(children, c2 => {
    if (!c2) {
      return null;
    }

    if (c2.key === null) {
      if (process.env.NODE_ENV !== "production") {
        throw new Error('Each child in LockupB must have a unique "key" prop.');
      }
    }

    return /* @__PURE__ */jsx("li", {
      children: c2
    });
  }), [children]);
  return /* @__PURE__ */jsx("ul", {
    css: styles16.containerStyles,
    children: wrappedChildren
  });
}

__name(LockupB, "LockupB");

var styles17 = {
  containerStyles: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: 0,
    // Hide empty child elements
    "& > *:empty": {
      display: "none"
    },
    listStyle: "none"
  }
};

function LockupD(props) {
  const {
    children
  } = props;
  const wrappedChildren = useMemo(() => Children.map(children, c2 => {
    if (!c2) {
      return null;
    }

    if (c2.key === null) {
      if (process.env.NODE_ENV !== "production") {
        throw new Error('Each child in LockupD must have a unique "key" prop.');
      }
    }

    return /* @__PURE__ */jsx("li", {
      children: c2
    });
  }), [children]);
  return /* @__PURE__ */jsx("ul", {
    css: styles17.containerStyles,
    children: wrappedChildren
  });
}

__name(LockupD, "LockupD");

LockupD.displayName = "LockupD";

function MaxBadgeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 66 66",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "m25.36 58.016-6.14 4.569-.6-7.687-7.18 2.634 1.566-7.561-7.628.498 3.602-6.803-7.438-1.695 5.355-5.49-6.678-3.762 6.678-3.762-5.359-5.49 7.442-1.695-3.602-6.803 7.628.498-1.567-7.562 7.184 2.634.596-7.686 6.14 4.569L28.092.219l4.628 6.152L37.344.219l2.731 7.203 6.14-4.57.6 7.687L54 7.905l-1.567 7.562 7.625-.498-3.602 6.803 7.442 1.694-5.359 5.491 6.681 3.762-6.68 3.761 5.358 5.491-7.442 1.695 3.602 6.803-7.625-.498 1.564 7.561-7.18-2.634-.6 7.687-6.14-4.57-2.732 7.204-4.625-6.152-4.628 6.152z"
      })
    }))
  }, props));
}

__name(MaxBadgeIcon, "MaxBadgeIcon");

var MaxBadgeIcon_default = MaxBadgeIcon;

var useStyles2 = /* @__PURE__ */__name(function (theme, size) {
  let rotateRight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const degrees = 12;
  const transform = `rotate(-${degrees}deg)`;
  const reverseTransform = `rotate(${degrees}deg)`;
  const fontProperties = {
    fontVariationSettings: "'wght' 700, 'opsz' 48",
    fontFamily: "Instacart Sans",
    color: theme.colors.brandMaxDark
  };
  return {
    container: {
      backgroundPosition: "center",
      backgroundSize: "cover",
      height: `${size}px`,
      width: `${size}px`,
      position: "relative",
      flexWrap: "wrap"
    },
    icon: {
      position: "absolute"
    },
    textContainer: {
      position: "relative",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      textAlign: "center",
      transform: rotateRight ? reverseTransform : transform
    },
    descriptionTop: {
      lineHeight: "9px"
    },
    maxBadgeLarge: __spreadValues({
      fontSize: 16,
      lineHeight: "18px"
    }, fontProperties),
    maxBadgeSmall: __spreadValues({
      fontSize: 10,
      lineHeight: "10px"
    }, fontProperties)
  };
}, "useStyles");

function MaxBadge(_ref50) {
  let {
    size = 56,
    amount,
    description,
    descriptionAbove,
    rotateRight,
    styles: propsStyles
  } = _ref50;
  const theme = useTheme();
  const styles25 = combineStyles(useStyles2(theme, size, rotateRight), propsStyles);
  return /* @__PURE__ */jsxs("div", {
    css: styles25.container,
    children: [/* @__PURE__ */jsx(MaxBadgeIcon_default, {
      size,
      color: "brandMaxLight",
      css: styles25.icon
    }), /* @__PURE__ */jsxs("div", {
      css: styles25.textContainer,
      "data-testid": "max-badge-copy",
      children: [descriptionAbove && /* @__PURE__ */jsx("span", {
        css: [styles25.maxBadgeSmall, styles25.descriptionTop],
        color: "brandMaxDark",
        children: description
      }), /* @__PURE__ */jsx("span", {
        color: "brandMaxDark",
        css: styles25.maxBadgeLarge,
        children: amount
      }), !descriptionAbove && /* @__PURE__ */jsx("span", {
        color: "brandMaxDark",
        css: styles25.maxBadgeSmall,
        children: description
      })]
    })]
  });
}

__name(MaxBadge, "MaxBadge");

var getStyles47 = /* @__PURE__ */__name((_ref51) => {
  let {
    elevationShadow,
    elevationDepth,
    heightStandard,
    radiusStandard,
    spaceHorizontalStandard,
    spaceHorizontalStandardDesktop,
    borderColor,
    borderHoverColor,
    borderPressColor,
    textColor
  } = _ref51;
  return {
    button: {
      boxShadow: elevationShadow,
      zIndex: elevationDepth,
      height: heightStandard,
      borderRadius: radiusStandard,
      paddingLeft: spaceHorizontalStandard,
      paddingRight: spaceHorizontalStandard,
      // TODO: Split this into borderColor and borderWidth when Button borderWidth tokens have been added. Apply to all buttons.
      border: borderColor ? `1px solid ${borderColor}` : void 0,
      color: textColor,
      [responsive_exports.DESKTOP_SIZE]: {
        paddingLeft: spaceHorizontalStandardDesktop,
        paddingRight: spaceHorizontalStandardDesktop
      }
    },
    focusRing: {
      borderRadius: radiusStandard
    },
    disabled: {},
    hover: {
      borderColor: borderHoverColor
    },
    active: {
      borderColor: borderPressColor
    }
  };
}, "getStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function PrimaryButton2(_a, ref) {
  var _b = _a,
      {
    fullWidth = true,
    loading
  } = _b,
      props = __objRest(_b, ["fullWidth", "loading"]);

  const grayscale = useIdsFeatureFlag("grayscale") === "grayscale";

  const _a2 = useComponentTheme("buttonPrimary"),
        {
    colorBackgroundType,
    color,
    color2,
    hoverColor,
    hoverColor2,
    pressColor,
    pressColor2
  } = _a2,
        componentTokens = __objRest(_a2, ["colorBackgroundType", "color", "color2", "hoverColor", "hoverColor2", "pressColor", "pressColor2"]);

  const styles25 = getStyles47(componentTokens);
  return /* @__PURE__ */jsx(ButtonBase2, __spreadProps(__spreadValues({
    loading
  }, props), {
    buttonColor: grayscale ? "systemGrayscale80" : {
      colorBackgroundType,
      color,
      color2,
      hoverColor,
      hoverColor2,
      pressColor,
      pressColor2
    },
    fullWidth,
    styles: styles25,
    ref
  }));
}, "PrimaryButton"));

var getStyles48 = /* @__PURE__ */__name((_ref52) => {
  let {
    elevationShadow,
    elevationDepth,
    heightCompact,
    radiusCompact,
    spaceHorizontalCompact,
    spaceHorizontalCompactDesktop,
    borderColor,
    borderHoverColor,
    borderPressColor,
    textColor
  } = _ref52;
  return {
    button: {
      boxShadow: elevationShadow,
      zIndex: elevationDepth,
      height: heightCompact,
      borderRadius: radiusCompact,
      paddingLeft: spaceHorizontalCompact,
      paddingRight: spaceHorizontalCompact,
      border: borderColor ? `1px solid ${borderColor}` : void 0,
      color: textColor,
      [responsive_exports.DESKTOP_SIZE]: {
        paddingLeft: spaceHorizontalCompactDesktop,
        paddingRight: spaceHorizontalCompactDesktop
      }
    },
    focusRing: {
      borderRadius: radiusCompact
    },
    disabled: {},
    hover: {
      borderColor: borderHoverColor
    },
    active: {
      borderColor: borderPressColor
    }
  };
}, "getStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function PrimaryButtonCompact2(_a, ref) {
  var _b = _a,
      {
    fullWidth,
    loading
  } = _b,
      props = __objRest(_b, ["fullWidth", "loading"]);

  const grayscale = useIdsFeatureFlag("grayscale") === "grayscale";

  const _a2 = useComponentTheme("buttonPrimary"),
        {
    colorBackgroundType,
    color,
    color2,
    hoverColor,
    hoverColor2,
    pressColor,
    pressColor2
  } = _a2,
        componentTokens = __objRest(_a2, ["colorBackgroundType", "color", "color2", "hoverColor", "hoverColor2", "pressColor", "pressColor2"]);

  const styles25 = getStyles48(componentTokens);
  return /* @__PURE__ */jsx(ButtonCompactBase, __spreadProps(__spreadValues({
    loading
  }, props), {
    buttonColor: grayscale ? "systemGrayscale80" : {
      colorBackgroundType,
      color,
      color2,
      hoverColor,
      hoverColor2,
      pressColor,
      pressColor2
    },
    fullWidth,
    styles: styles25,
    ref
  }));
}, "PrimaryButtonCompact"));

var getStyles49 = /* @__PURE__ */__name((_ref53) => {
  let {
    elevationShadow,
    elevationDepth,
    heightSmall,
    radiusSmall,
    spaceHorizontalSmall,
    spaceHorizontalSmallDesktop,
    borderColor,
    borderHoverColor,
    borderPressColor,
    textColor
  } = _ref53;
  return {
    button: {
      boxShadow: elevationShadow,
      zIndex: elevationDepth,
      height: heightSmall,
      borderRadius: radiusSmall,
      paddingLeft: spaceHorizontalSmall,
      paddingRight: spaceHorizontalSmall,
      border: borderColor ? `1px solid ${borderColor}` : void 0,
      color: textColor,
      [responsive_exports.DESKTOP_SIZE]: {
        paddingLeft: spaceHorizontalSmallDesktop,
        paddingRight: spaceHorizontalSmallDesktop
      }
    },
    focusRing: {
      borderRadius: radiusSmall
    },
    disabled: {},
    hover: {
      borderColor: borderHoverColor
    },
    active: {
      borderColor: borderPressColor
    }
  };
}, "getStyles");

var PrimaryButtonSmall = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function PrimaryButtonSmall2(_a, ref) {
  var _b = _a,
      {
    fullWidth,
    loading
  } = _b,
      props = __objRest(_b, ["fullWidth", "loading"]);

  const grayscale = useIdsFeatureFlag("grayscale") === "grayscale";

  const _a2 = useComponentTheme("buttonPrimary"),
        {
    colorBackgroundType,
    color,
    color2,
    hoverColor,
    hoverColor2,
    pressColor,
    pressColor2
  } = _a2,
        componentTokens = __objRest(_a2, ["colorBackgroundType", "color", "color2", "hoverColor", "hoverColor2", "pressColor", "pressColor2"]);

  const styles25 = getStyles49(componentTokens);
  return /* @__PURE__ */jsx(ButtonSmallBase, __spreadProps(__spreadValues({
    loading
  }, props), {
    buttonColor: grayscale ? "systemGrayscale80" : {
      colorBackgroundType,
      color,
      color2,
      hoverColor,
      hoverColor2,
      pressColor,
      pressColor2
    },
    fullWidth,
    styles: styles25,
    ref
  }));
}, "PrimaryButtonSmall"));
var iconColor3 = "systemGrayscale00";
var PrimaryIconButton = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function PrimaryIconButton2(props, ref) {
  const theme = useTheme();
  const interactiveColors = useComputeInteractiveColors({
    backgroundColor: "brandPrimaryRegular",
    theme
  });
  const styles25 = {
    button: {
      backgroundColor: interactiveColors == null ? void 0 : interactiveColors.primaryColor
    },
    disabled: {
      backgroundColor: theme.colors.systemGrayscale10
    },
    hover: {
      backgroundColor: interactiveColors == null ? void 0 : interactiveColors.hoverColor
    },
    active: {
      backgroundColor: interactiveColors == null ? void 0 : interactiveColors.activeColor
    },
    focusRing: {},
    content: {}
  };
  return /* @__PURE__ */jsx(IconButtonBase, __spreadProps(__spreadValues({
    color: iconColor3,
    styles: styles25
  }, props), {
    ref
  }));
}, "PrimaryIconButton"));
PrimaryIconButton.displayName = "PrimaryIconButton";

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function PrimaryPriceButton2(props, ref) {
  return /* @__PURE__ */jsx(PriceButtonBase, __spreadProps(__spreadValues({}, props), {
    buttonColor: "brandPrimaryRegular",
    ref
  }));
}, "PrimaryPriceButton"));

var getStyles50 = /* @__PURE__ */__name(props => ({
  container: {
    position: "relative",
    height: props.responsiveSizes.mobile.height,
    width: props.responsiveSizes.mobile.width,
    borderRadius: props.responsiveSizes.mobile.radius,
    display: "flex",
    justifyContent: "center",
    [responsive_exports.DESKTOP_SIZE]: {
      height: props.responsiveSizes.desktop.height,
      width: props.responsiveSizes.desktop.width,
      borderRadius: props.responsiveSizes.desktop.radius
    }
  },
  image: {
    position: "absolute",
    top: -1 * AVATAR_BORDER_PX,
    width: props.responsiveSizes.mobile.height,
    height: props.responsiveSizes.mobile.height,
    [responsive_exports.DESKTOP_SIZE]: {
      height: props.responsiveSizes.desktop.height,
      width: props.responsiveSizes.desktop.height
    }
  }
}), "getStyles");

var RetailerAvatarBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function RetailerAvatarBase2(props, ref) {
  const styles25 = getStyles50(props);

  const _a = props,
        {
    responsiveSizes: responsiveSizes10,
    src,
    srcSet,
    templateUrl
  } = _a,
        rest = __objRest(_a, ["responsiveSizes", "src", "srcSet", "templateUrl"]);

  const imageProps = {
    src,
    srcSet,
    width: responsiveSizes10.desktop.height,
    height: responsiveSizes10.desktop.height,
    templateUrl
  };
  return /* @__PURE__ */jsx(AvatarBase, __spreadProps(__spreadValues(__spreadValues({}, rest), imageProps), {
    styles: styles25,
    ref
  }));
}, "RetailerAvatarBase"));
RetailerAvatarBase.displayName = "RetailerAvatarBase";
var responsiveSizes7 = {
  desktop: {
    width: 48,
    height: 36,
    radius: 8
  },
  mobile: {
    width: 36,
    height: 28,
    radius: 6
  }
};
var RetailerAvatarSmall = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function RetailerAvatarSmall2(props, ref) {
  return /* @__PURE__ */jsx(RetailerAvatarBase, __spreadProps(__spreadValues({}, props), {
    responsiveSizes: responsiveSizes7,
    ref
  }));
}, "RetailerAvatarSmall"));
RetailerAvatarSmall.displayName = "RetailerAvatarSmall";
var responsiveSizes8 = {
  desktop: {
    width: 72,
    height: 54,
    radius: 8
  },
  mobile: {
    width: 48,
    height: 36,
    radius: 8
  }
};
var RetailerAvatarMedium = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function RetailerAvatarMedium2(props, ref) {
  return /* @__PURE__ */jsx(RetailerAvatarBase, __spreadProps(__spreadValues({}, props), {
    responsiveSizes: responsiveSizes8,
    ref
  }));
}, "RetailerAvatarMedium"));
RetailerAvatarMedium.displayName = "RetailerAvatarMedium";
var responsiveSizes9 = {
  desktop: {
    width: 96,
    height: 72,
    radius: 8
  },
  mobile: {
    width: 64,
    height: 48,
    radius: 8
  }
};
var RetailerAvatarLarge = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function RetailerAvatarLarge2(props, ref) {
  return /* @__PURE__ */jsx(RetailerAvatarBase, __spreadProps(__spreadValues({}, props), {
    responsiveSizes: responsiveSizes9,
    ref
  }));
}, "RetailerAvatarLarge"));
RetailerAvatarLarge.displayName = "RetailerAvatarLarge";

var getStyles51 = /* @__PURE__ */__name(theme => ({
  button: {
    display: "flex",
    padding: `0 ${spacing.s12}px`
  },
  content: {
    alignItems: "center",
    display: "flex",
    gap: `${spacing.s8}px`,
    justifyContent: "start",
    width: "100%"
  },
  icon: {},
  focusRing: {
    borderRadius: theme.radius.round
  },
  hover: {},
  active: {},
  disabled: {}
}), "getStyles");

var SearchButtonBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function SearchButtonBase2(_a, ref) {
  var _b = _a,
      {
    children,
    icon = "search",
    styles: styles25
  } = _b,
      props = __objRest(_b, ["children", "icon", "styles"]);

  const theme = useTheme();
  const {
    button: buttonCSS,
    content: contentCSS,
    hover,
    active,
    disabled,
    focusRing
  } = combineStyles(getStyles51(theme), styles25);
  const searchButtonCSS = [buttonCSS, {
    "&:focus": {
      outline: "none"
    },
    "&.focus-visible::after": focusRing,
    "&:hover": hover,
    "&:active": active,
    "&:disabled": disabled
  }];
  const Icon = icon === "search" ? SearchIcon_default : MarkerIcon_default;
  return /* @__PURE__ */jsxs(ButtonCore, __spreadProps(__spreadValues({}, props), {
    ref,
    styles: {
      button: searchButtonCSS,
      content: contentCSS
    },
    children: [/* @__PURE__ */jsx(Icon, {
      size: 24
    }), children]
  }));
}, "SearchButtonBase"));

var getStyles52 = /* @__PURE__ */__name((_ref54) => {
  let {
    elevationShadow,
    elevationDepth,
    heightStandard,
    radiusStandard,
    spaceHorizontalStandard,
    spaceHorizontalStandardDesktop,
    borderColor,
    borderHoverColor,
    borderPressColor,
    textColor
  } = _ref54;
  return {
    button: {
      boxShadow: elevationShadow,
      zIndex: elevationDepth,
      height: heightStandard,
      borderRadius: radiusStandard,
      paddingLeft: spaceHorizontalStandard,
      paddingRight: spaceHorizontalStandard,
      border: borderColor ? `1px solid ${borderColor}` : void 0,
      color: textColor,
      [responsive_exports.DESKTOP_SIZE]: {
        paddingLeft: spaceHorizontalStandardDesktop,
        paddingRight: spaceHorizontalStandardDesktop
      }
    },
    focusRing: {
      borderRadius: radiusStandard
    },
    disabled: {},
    hover: {
      borderColor: borderHoverColor
    },
    active: {
      borderColor: borderPressColor
    }
  };
}, "getStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function SecondaryButton2(_a, ref) {
  var _b = _a,
      {
    fullWidth = true,
    loading
  } = _b,
      props = __objRest(_b, ["fullWidth", "loading"]);

  const _a2 = useComponentTheme("buttonSecondary"),
        {
    colorBackgroundType,
    color,
    color2,
    hoverColor,
    hoverColor2,
    pressColor,
    pressColor2
  } = _a2,
        componentTokens = __objRest(_a2, ["colorBackgroundType", "color", "color2", "hoverColor", "hoverColor2", "pressColor", "pressColor2"]);

  const styles25 = getStyles52(componentTokens);
  return /* @__PURE__ */jsx(ButtonBase2, __spreadProps(__spreadValues({
    loading
  }, props), {
    buttonColor: {
      colorBackgroundType,
      color,
      color2,
      hoverColor,
      hoverColor2,
      pressColor,
      pressColor2
    },
    fullWidth,
    styles: styles25,
    ref
  }));
}, "SecondaryButton"));

var getStyles53 = /* @__PURE__ */__name((_ref55) => {
  let {
    elevationShadow,
    elevationDepth,
    heightCompact,
    radiusCompact,
    spaceHorizontalCompact,
    spaceHorizontalCompactDesktop,
    borderColor,
    borderHoverColor,
    borderPressColor,
    textColor
  } = _ref55;
  return {
    button: {
      boxShadow: elevationShadow,
      zIndex: elevationDepth,
      height: heightCompact,
      borderRadius: radiusCompact,
      paddingLeft: spaceHorizontalCompact,
      paddingRight: spaceHorizontalCompact,
      border: borderColor ? `1px solid ${borderColor}` : void 0,
      color: textColor,
      [responsive_exports.DESKTOP_SIZE]: {
        paddingLeft: spaceHorizontalCompactDesktop,
        paddingRight: spaceHorizontalCompactDesktop
      }
    },
    focusRing: {
      borderRadius: radiusCompact
    },
    disabled: {},
    hover: {
      borderColor: borderHoverColor
    },
    active: {
      borderColor: borderPressColor
    }
  };
}, "getStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function SecondaryButtonCompact2(_a, ref) {
  var _b = _a,
      {
    fullWidth,
    loading
  } = _b,
      props = __objRest(_b, ["fullWidth", "loading"]);

  const _a2 = useComponentTheme("buttonSecondary"),
        {
    colorBackgroundType,
    color,
    color2,
    hoverColor,
    hoverColor2,
    pressColor,
    pressColor2
  } = _a2,
        componentTokens = __objRest(_a2, ["colorBackgroundType", "color", "color2", "hoverColor", "hoverColor2", "pressColor", "pressColor2"]);

  const styles25 = getStyles53(componentTokens);
  return /* @__PURE__ */jsx(ButtonCompactBase, __spreadProps(__spreadValues({
    loading
  }, props), {
    buttonColor: {
      colorBackgroundType,
      color,
      color2,
      hoverColor,
      hoverColor2,
      pressColor,
      pressColor2
    },
    fullWidth,
    styles: styles25,
    ref
  }));
}, "SecondaryButtonCompact"));

var getStyles54 = /* @__PURE__ */__name((_ref56) => {
  let {
    elevationShadow,
    elevationDepth,
    heightSmall,
    radiusSmall,
    spaceHorizontalSmall,
    spaceHorizontalSmallDesktop,
    borderColor,
    borderHoverColor,
    borderPressColor,
    textColor
  } = _ref56;
  return {
    button: {
      boxShadow: elevationShadow,
      zIndex: elevationDepth,
      height: heightSmall,
      borderRadius: radiusSmall,
      paddingLeft: spaceHorizontalSmall,
      paddingRight: spaceHorizontalSmall,
      border: borderColor ? `1px solid ${borderColor}` : void 0,
      color: textColor,
      [responsive_exports.DESKTOP_SIZE]: {
        paddingLeft: spaceHorizontalSmallDesktop,
        paddingRight: spaceHorizontalSmallDesktop
      }
    },
    focusRing: {
      borderRadius: radiusSmall
    },
    disabled: {},
    hover: {
      borderColor: borderHoverColor
    },
    active: {
      borderColor: borderPressColor
    }
  };
}, "getStyles");

var SecondaryButtonSmall = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function SecondaryButtonSmall2(_a, ref) {
  var _b = _a,
      {
    fullWidth,
    loading
  } = _b,
      props = __objRest(_b, ["fullWidth", "loading"]);

  const _a2 = useComponentTheme("buttonSecondary"),
        {
    colorBackgroundType,
    color,
    color2,
    hoverColor,
    hoverColor2,
    pressColor,
    pressColor2
  } = _a2,
        componentTokens = __objRest(_a2, ["colorBackgroundType", "color", "color2", "hoverColor", "hoverColor2", "pressColor", "pressColor2"]);

  const styles25 = getStyles54(componentTokens);
  return /* @__PURE__ */jsx(ButtonSmallBase, __spreadProps(__spreadValues({
    loading
  }, props), {
    buttonColor: {
      colorBackgroundType,
      color,
      color2,
      hoverColor,
      hoverColor2,
      pressColor,
      pressColor2
    },
    fullWidth,
    styles: styles25,
    ref
  }));
}, "SecondaryButtonSmall"));
var iconColor4 = "systemGrayscale80";
var SecondaryIconButton = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function SecondaryIconButton2(props, ref) {
  const theme = useTheme();
  const interactiveColors = useComputeInteractiveColors({
    backgroundColor: "systemGrayscale20",
    theme
  });
  const styles25 = {
    button: {
      backgroundColor: interactiveColors == null ? void 0 : interactiveColors.primaryColor
    },
    disabled: {
      backgroundColor: theme.colors.systemGrayscale10
    },
    hover: {
      backgroundColor: interactiveColors == null ? void 0 : interactiveColors.hoverColor
    },
    active: {
      backgroundColor: interactiveColors == null ? void 0 : interactiveColors.activeColor
    },
    focusRing: {},
    content: {}
  };
  return /* @__PURE__ */jsx(IconButtonBase, __spreadProps(__spreadValues({
    color: iconColor4,
    styles: styles25
  }, props), {
    ref
  }));
}, "SecondaryIconButton"));
SecondaryIconButton.displayName = "SecondaryIconButton";

var getStyles55 = /* @__PURE__ */__name((_ref57) => {
  let {
    theme,
    isSubtitle,
    disabled,
    href
  } = _ref57;
  return {
    container: {
      alignItems: "center",
      display: "flex",
      gap: `${spacing.s16}px`,
      padding: `${spacing.s12}px 0`
    },
    content: {
      alignItems: "flex-start",
      display: "flex",
      flex: 1,
      flexDirection: "column"
    },
    leadingElement: {
      display: "flex",
      flexShrink: 0
    },
    secondaryText: __spreadProps(__spreadValues({}, theme.typography.bodyRegular), {
      color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80
    }),
    title: __spreadValues(__spreadProps(__spreadValues({}, isSubtitle ? theme.typography.subtitle : theme.typography.title), {
      color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80,
      margin: "0"
    }), href && __spreadValues({
      textDecoration: "none"
    }, !disabled && {
      "&:hover": {
        color: theme.colors.systemGrayscale60
      },
      "&:active": {
        color: theme.colors.systemGrayscale80
      }
    })),
    trailingElement: {
      alignItems: "flex-end",
      display: "flex",
      flexDirection: "column"
    }
  };
}, "getStyles");

/*#__PURE__*/
forwardRef((_a, ref) => {
  var _b = _a,
      {
    disabled = false,
    headingLevel = "h2",
    href,
    isSubtitle = false,
    leadingElement,
    secondaryText,
    title,
    trailingElement,
    styles: styles25
  } = _b,
      props = __objRest(_b, ["disabled", "headingLevel", "href", "isSubtitle", "leadingElement", "secondaryText", "title", "trailingElement", "styles"]);

  const theme = useTheme();
  const HeadingTag = headingLevel;
  const TitleComponent = href ? "a" : HeadingTag;
  const baseStyles16 = getStyles55({
    theme,
    isSubtitle,
    disabled,
    href
  });
  const {
    container: containerCSS,
    content: contentCSS,
    leadingElement: leadingElementCSS,
    secondaryText: secondaryTextCSS,
    title: titleCSS,
    trailingElement: trailingElementCSS
  } = combineStyles(baseStyles16, styles25);
  const linkProps = href ? disabled ? {
    role: "link",
    "aria-disabled": true
  } : {
    href
  } : {};
  return /* @__PURE__ */jsxs("div", __spreadProps(__spreadValues({
    ref,
    css: containerCSS
  }, props), {
    children: [leadingElement && /* @__PURE__ */jsx("div", {
      css: leadingElementCSS,
      children: leadingElement
    }), /* @__PURE__ */jsxs("div", {
      css: contentCSS,
      children: [/* @__PURE__ */jsx(FocusRing, {
        borderRadiusOfComponent: `${theme.radius.r4}px`,
        children: /* @__PURE__ */jsx(TitleComponent, __spreadProps(__spreadValues({
          css: [titleCSS]
        }, linkProps), {
          children: title
        }))
      }), secondaryText && /* @__PURE__ */jsx("div", {
        css: [secondaryTextCSS],
        children: secondaryText
      })]
    }), trailingElement && /* @__PURE__ */jsx("div", {
      css: trailingElementCSS,
      children: trailingElement
    })]
  }));
});
var SelectProvider = /*#__PURE__*/createContext({
  isOpen: false,
  toggleOpen: /* @__PURE__ */__name(() => {}, "toggleOpen"),
  setIsOpen: /* @__PURE__ */__name(() => {}, "setIsOpen"),
  selectedValue: "",
  wrapperId: void 0,
  labelId: void 0,
  selectedId: void 0,
  disabled: false,
  buttonRef: void 0
});

var useSelectContext = /* @__PURE__ */__name(() => useContext(SelectProvider), "useSelectContext");

var baseStyles10 = {
  select: {}
};

var useSelect = /* @__PURE__ */__name(disabled => {
  const selectRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  useOnClickOutside(selectRef, () => setIsOpen(false));

  const toggleOpen = /* @__PURE__ */__name(() => {
    if (disabled) return;

    if (isOpen) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  }, "toggleOpen");

  return {
    selectRef,
    toggleOpen,
    isOpen,
    setIsOpen
  };
}, "useSelect");

function SelectBase(props) {
  const {
    styles: styles25,
    children,
    selectedValue,
    disabled
  } = props;
  const {
    id: wrapperId
  } = unstable_useId();
  const {
    id: labelId
  } = unstable_useId();
  const {
    id: selectedId
  } = unstable_useId();
  const {
    selectRef,
    toggleOpen,
    isOpen,
    setIsOpen
  } = useSelect(disabled);
  const {
    select: selectCss
  } = combineStyles(baseStyles10, styles25);
  const buttonRef = useRef(null);
  return /* @__PURE__ */jsx(SelectProvider.Provider, {
    value: {
      isOpen,
      toggleOpen,
      selectedValue,
      setIsOpen,
      wrapperId,
      labelId,
      selectedId,
      disabled,
      buttonRef
    },
    children: /* @__PURE__ */jsx("div", {
      css: selectCss,
      ref: selectRef,
      id: wrapperId,
      children
    })
  });
}

__name(SelectBase, "SelectBase");

var baseStyles11 = {
  option: {
    cursor: "pointer"
  },
  selectedOption: {
    textDecoration: "underline"
  }
};

function SelectOptionBase(_ref58) {
  let {
    styles: styles25,
    children,
    value,
    disabled,
    onClick
  } = _ref58;
  const {
    selectedValue,
    toggleOpen,
    labelId
  } = useSelectContext();
  const selected = selectedValue === value;
  const {
    option: optionCss,
    selectedOption: selectedOptionCss
  } = combineStyles(baseStyles11, styles25);

  const handleClick = /* @__PURE__ */__name(() => {
    if (disabled) return;
    onClick();
    toggleOpen();
  }, "handleClick");

  return (// eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions

    /* @__PURE__ */
    jsx("li", {
      "aria-disabled": disabled,
      role: "option",
      tabIndex: -1,
      "aria-selected": selected,
      id: `${labelId}-${value}`,
      onClick: handleClick,
      css: [optionCss, selected ? selectedOptionCss : {}],
      children
    })
  );
}

__name(SelectOptionBase, "SelectOptionBase");

var baseStyles12 = {
  options: {
    display: "none",
    position: "absolute"
  },
  optionsActive: {
    display: "block"
  }
};

function useSelectKeypress(options) {
  const {
    selectedValue,
    isOpen,
    setIsOpen,
    wrapperId,
    labelId,
    buttonRef
  } = useSelectContext();
  const [focusedValue, setFocusedValue] = useState(selectedValue);
  const enabledOptions = useMemo(() => options.filter(opt => !opt.disabled), [options]);
  const handleKeyPress = useCallback(e3 => {
    var _a, _b;

    const currIndex = enabledOptions.findIndex(opt => opt.value === focusedValue);

    const changeOption = /* @__PURE__ */__name(indexDifference => {
      const newOpt = enabledOptions[currIndex + indexDifference];
      const el = document.getElementById(`${labelId}-${newOpt.value}`);
      el == null ? void 0 : el.focus();
      setFocusedValue(newOpt.value);
    }, "changeOption");

    const openOnArrow = /* @__PURE__ */__name(() => {
      setIsOpen(true);
      const opt = enabledOptions[currIndex];
      const el = document.getElementById(`${labelId}-${opt.value}`);
      el == null ? void 0 : el.focus();
    }, "openOnArrow");

    switch (e3.key) {
      case "ArrowUp":
        e3.preventDefault();

        if (isOpen) {
          if (currIndex > 0) {
            changeOption(-1);
          }
        } else {
          openOnArrow();
        }

        break;

      case "ArrowDown":
        e3.preventDefault();

        if (isOpen) {
          if (currIndex < enabledOptions.length - 1) {
            changeOption(1);
          }
        } else {
          openOnArrow();
        }

        break;

      case "Enter":
        e3.preventDefault();

        if (focusedValue) {
          const opt = enabledOptions[currIndex];
          if (opt) opt.onClick();
        }

        setIsOpen(false);
        (_a = buttonRef == null ? void 0 : buttonRef.current) == null ? void 0 : _a.focus();
        break;

      case "Escape":
        setIsOpen(false);
        (_b = buttonRef == null ? void 0 : buttonRef.current) == null ? void 0 : _b.focus();
        break;

      case "Tab":
        setIsOpen(false);
        break;
    }
  }, [enabledOptions, focusedValue, isOpen, setIsOpen, buttonRef, labelId]);
  useEffect(() => {
    const select = wrapperId ? document.getElementById(wrapperId) : null;
    if (!select) return;
    select.addEventListener("keydown", handleKeyPress);
    return () => {
      select.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress, wrapperId]);
}

__name(useSelectKeypress, "useSelectKeypress");

function SelectOptionsBase(_ref59) {
  let {
    styles: styles25,
    children
  } = _ref59;
  const {
    isOpen,
    labelId
  } = useSelectContext();
  const {
    options: optionsCss,
    optionsActive: optionsActiveCss
  } = combineStyles(baseStyles12, styles25);
  const childProps = (Children.map(children, child => {
    if (child && typeof child === "object" && "props" in child) {
      return child.props;
    }
  }) || []).filter(Boolean);
  useSelectKeypress(childProps);
  return /* @__PURE__ */jsx("ul", {
    css: [optionsCss, isOpen ? optionsActiveCss : []],
    role: "listbox",
    "aria-labelledby": labelId,
    children
  });
}

__name(SelectOptionsBase, "SelectOptionsBase");

var baseStyles13 = {
  button: {
    cursor: "pointer"
  },
  content: {},
  buttonActive: {},
  focusRing: {
    border: "none"
  }
};

function SelectButtonBase(_a) {
  var _b = _a,
      {
    styles: styles25,
    children,
    onClick
  } = _b,
      rest = __objRest(_b, ["styles", "children", "onClick"]);

  const {
    isOpen,
    toggleOpen,
    selectedValue,
    selectedId,
    labelId,
    disabled,
    buttonRef
  } = useSelectContext();

  const _a2 = combineStyles(baseStyles13, styles25),
        {
    buttonActive: buttonActiveCss
  } = _a2,
        restStyles = __objRest(_a2, ["buttonActive"]);

  const onClickHandler = useCallback(e3 => {
    toggleOpen();
    onClick == null ? void 0 : onClick(e3);
  }, [onClick, toggleOpen]);
  return /* @__PURE__ */jsx(ButtonCore, __spreadProps(__spreadValues({}, rest), {
    ref: buttonRef,
    role: "combobox",
    "aria-haspopup": "listbox",
    "aria-labelledby": `${labelId} ${selectedId}`,
    "aria-expanded": isOpen,
    "aria-activedescendant": `${labelId}-${selectedValue}`,
    css: isOpen && buttonActiveCss,
    styles: restStyles,
    onClick: onClickHandler,
    "aria-controls": labelId,
    disabled,
    type: "button",
    children
  }));
}

__name(SelectButtonBase, "SelectButtonBase");

var baseStyles14 = {
  text: {}
};

function SelectButtonValueBase(_ref60) {
  let {
    styles: styles25,
    children
  } = _ref60;
  const {
    selectedId
  } = useSelectContext();
  const {
    text: textCss
  } = combineStyles(baseStyles14, styles25);
  return /* @__PURE__ */jsx("span", {
    css: textCss,
    id: selectedId,
    children
  });
}

__name(SelectButtonValueBase, "SelectButtonValueBase");

var baseStyles15 = {
  text: {}
};

function SelectButtonLabelBase(_ref61) {
  let {
    styles: styles25,
    children
  } = _ref61;
  const {
    labelId
  } = useSelectContext();
  const {
    text: textCss
  } = combineStyles(baseStyles15, styles25);
  return /* @__PURE__ */jsx("span", {
    css: textCss,
    id: labelId,
    children
  });
}

__name(SelectButtonLabelBase, "SelectButtonLabelBase");

var getStyles56 = /* @__PURE__ */__name(() => ({
  select: {
    position: "relative"
  }
}), "getStyles");

function Select(props) {
  const styles25 = getStyles56();
  return /* @__PURE__ */jsx(SelectBase, __spreadProps(__spreadValues({}, props), {
    styles: styles25
  }));
}

__name(Select, "Select");

var getStyles57 = /* @__PURE__ */__name(theme => ({
  button: __spreadProps(__spreadValues({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: `${spacing.s8}px ${spacing.s12}px`,
    color: theme.colors.systemGrayscale70,
    backgroundColor: theme.colors.systemGrayscale00,
    border: `1px solid ${theme.colors.systemGrayscale30}`,
    borderRadius: theme.radius.r8,
    boxSizing: "border-box"
  }, theme.typography.bodyMedium1), {
    whiteSpace: "nowrap",
    height: 40,
    "&:hover": {
      backgroundColor: theme.colors.systemGrayscale10
    },
    "&:active": {
      borderColor: theme.colors.systemGrayscale70,
      backgroundColor: theme.colors.systemGrayscale20
    },
    "&:focus": {
      outline: 0
    },
    ":focus-visible:": {
      outline: 0
    },
    "&.focus-visible::after": {
      borderRadius: theme.radius.r12,
      border: `2px solid ${theme.colors.systemGrayscale70}`,
      content: '""',
      position: "absolute",
      top: -4,
      bottom: -4,
      left: -4,
      right: -4
    },
    "&:disabled": {
      backgroundColor: theme.colors.systemGrayscale10,
      color: theme.colors.systemGrayscale30,
      cursor: "default",
      border: `1px solid transparent`
    }
  }),
  content: {
    display: "flex",
    alignItems: "center"
  },
  buttonActive: {
    borderColor: theme.colors.systemGrayscale70,
    backgroundColor: theme.colors.systemGrayscale20
  }
}), "getStyles");

var childWrapperStyles = {
  marginRight: spacing.s8,
  textAlign: "left"
};

function SelectButton(props) {
  const {
    children
  } = props;
  const {
    isOpen,
    disabled
  } = useSelectContext();
  const theme = useTheme();
  const styles25 = getStyles57(theme);
  const iconColor6 = disabled ? "systemGrayscale30" : "systemGrayscale70";
  return /* @__PURE__ */jsxs(SelectButtonBase, __spreadProps(__spreadValues({}, props), {
    styles: styles25,
    children: [/* @__PURE__ */jsx("div", {
      css: childWrapperStyles,
      children
    }), isOpen ? /* @__PURE__ */jsx(ChevronUpIcon_default, {
      color: iconColor6
    }) : /* @__PURE__ */jsx(ChevronDownIcon_default, {
      color: iconColor6
    })]
  }));
}

__name(SelectButton, "SelectButton");

var getStyles58 = /* @__PURE__ */__name(theme => ({
  text: __spreadValues({}, theme.typography.bodyMedium1)
}), "getStyles");

function SelectButtonLabel(props) {
  const theme = useTheme();
  const styles25 = getStyles58(theme);
  return /* @__PURE__ */jsx(SelectButtonLabelBase, __spreadProps(__spreadValues({}, props), {
    styles: styles25
  }));
}

__name(SelectButtonLabel, "SelectButtonLabel");

var getStyles59 = /* @__PURE__ */__name(theme => ({
  text: __spreadValues({}, theme.typography.bodyRegular)
}), "getStyles");

function SelectButtonValue(props) {
  const theme = useTheme();
  const styles25 = getStyles59(theme);
  return /* @__PURE__ */jsx(SelectButtonValueBase, __spreadProps(__spreadValues({}, props), {
    styles: styles25
  }));
}

__name(SelectButtonValue, "SelectButtonValue");

var getStyles60 = /* @__PURE__ */__name((theme, disabled) => ({
  option: __spreadProps(__spreadValues({
    boxSizing: "border-box",
    display: "flex",
    width: "100%",
    textAlign: "left",
    justifyContent: "space-between",
    padding: spacing.s8,
    backgroundColor: theme.colors.systemGrayscale00,
    color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale70,
    borderRadius: theme.radius.r8,
    border: "2px solid transparent"
  }, theme.typography.bodyMedium1), {
    cursor: disabled ? "default" : "pointer",
    ":hover": {
      outline: "none",
      borderRadius: theme.radius.r8,
      backgroundColor: theme.colors.systemGrayscale10
    },
    ":active": {
      backgroundColor: theme.colors.systemGrayscale20
    },
    "&:focus": {
      outline: "none",
      borderColor: theme.colors.systemGrayscale70
    },
    ":disabled": {
      color: theme.colors.systemGrayscale30
    }
  }),
  selectedOption: {
    textDecoration: "none"
  }
}), "getStyles");

var iconStyles = {
  position: "relative",
  width: 24,
  marginLeft: spacing.s8,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};

function SelectOption(props) {
  const {
    value,
    children,
    disabled
  } = props;
  const {
    selectedValue
  } = useSelectContext();
  const selected = selectedValue === value;
  const theme = useTheme();
  const styles25 = getStyles60(theme, disabled);
  return /* @__PURE__ */jsxs(SelectOptionBase, __spreadProps(__spreadValues({}, props), {
    styles: styles25,
    children: [children, /* @__PURE__ */jsx("div", {
      css: iconStyles,
      children: selected && /* @__PURE__ */jsx(ConfirmIcon_default, {
        size: "17",
        color: "systemSuccessRegular"
      })
    })]
  }));
}

__name(SelectOption, "SelectOption");

var getStyles61 = /* @__PURE__ */__name((theme, leftAligned) => ({
  options: __spreadValues(__spreadProps(__spreadValues({
    display: "none",
    position: "absolute",
    minWidth: `max(calc(100% - 16px), 204px)`,
    padding: spacing.s8,
    borderRadius: theme.radius.r12,
    backgroundColor: theme.colors.systemGrayscale00
  }, elevation.low.shadow), {
    zIndex: 500,
    listStyle: "none",
    margin: `${spacing.s8}px 0px`
  }), leftAligned ? {
    left: 0
  } : {
    right: 0
  }),
  optionsActive: {
    display: "block"
  }
}), "getStyles");

function SelectOptions(props) {
  const _a = props,
        {
    alignment
  } = _a,
        rest = __objRest(_a, ["alignment"]);

  const theme = useTheme();
  const styles25 = getStyles61(theme, alignment === "left");
  return /* @__PURE__ */jsx(SelectOptionsBase, __spreadProps(__spreadValues({}, rest), {
    styles: styles25
  }));
}

__name(SelectOptions, "SelectOptions");

var getStyles62 = /* @__PURE__ */__name((_ref62) => {
  let {
    elevationShadow,
    elevationDepth,
    heightStandard,
    radiusStandard,
    spaceHorizontalStandard,
    spaceHorizontalStandardDesktop,
    borderColor,
    borderHoverColor,
    borderPressColor,
    textColor
  } = _ref62;
  return {
    button: {
      boxShadow: elevationShadow,
      zIndex: elevationDepth,
      height: heightStandard,
      borderRadius: radiusStandard,
      paddingLeft: spaceHorizontalStandard,
      paddingRight: spaceHorizontalStandard,
      border: borderColor ? `1px solid ${borderColor}` : void 0,
      color: textColor,
      [responsive_exports.DESKTOP_SIZE]: {
        paddingLeft: spaceHorizontalStandardDesktop,
        paddingRight: spaceHorizontalStandardDesktop
      }
    },
    focusRing: {
      borderRadius: radiusStandard
    },
    disabled: {},
    hover: {
      borderColor: borderHoverColor
    },
    active: {
      borderColor: borderPressColor
    }
  };
}, "getStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function TertiaryButton2(_a, ref) {
  var _b = _a,
      {
    disabled,
    fullWidth = true,
    loading
  } = _b,
      props = __objRest(_b, ["disabled", "fullWidth", "loading"]);

  const _a2 = useComponentTheme("buttonTertiary"),
        {
    colorBackgroundType,
    color,
    color2,
    hoverColor,
    hoverColor2,
    pressColor,
    pressColor2
  } = _a2,
        componentTokens = __objRest(_a2, ["colorBackgroundType", "color", "color2", "hoverColor", "hoverColor2", "pressColor", "pressColor2"]);

  const styles25 = getStyles62(componentTokens);
  return /* @__PURE__ */jsx(ButtonBase2, __spreadProps(__spreadValues({
    disabled,
    loading
  }, props), {
    buttonColor: {
      colorBackgroundType,
      color,
      color2,
      hoverColor,
      hoverColor2,
      pressColor,
      pressColor2
    },
    fullWidth,
    styles: styles25,
    ref
  }));
}, "TertiaryButton"));

var getStyles63 = /* @__PURE__ */__name((_ref63) => {
  let {
    elevationShadow,
    elevationDepth,
    heightCompact,
    radiusCompact,
    spaceHorizontalCompact,
    spaceHorizontalCompactDesktop,
    borderColor,
    borderHoverColor,
    borderPressColor,
    textColor
  } = _ref63;
  return {
    button: {
      boxShadow: elevationShadow,
      zIndex: elevationDepth,
      height: heightCompact,
      borderRadius: radiusCompact,
      paddingLeft: spaceHorizontalCompact,
      paddingRight: spaceHorizontalCompact,
      border: borderColor ? `1px solid ${borderColor}` : void 0,
      color: textColor,
      [responsive_exports.DESKTOP_SIZE]: {
        paddingLeft: spaceHorizontalCompactDesktop,
        paddingRight: spaceHorizontalCompactDesktop
      }
    },
    focusRing: {
      borderRadius: radiusCompact
    },
    disabled: {},
    hover: {
      borderColor: borderHoverColor
    },
    active: {
      borderColor: borderPressColor
    }
  };
}, "getStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function TertiaryButtonCompact2(_a, ref) {
  var _b = _a,
      {
    disabled,
    fullWidth,
    loading
  } = _b,
      props = __objRest(_b, ["disabled", "fullWidth", "loading"]);

  const _a2 = useComponentTheme("buttonTertiary"),
        {
    colorBackgroundType,
    color,
    color2,
    hoverColor,
    hoverColor2,
    pressColor,
    pressColor2
  } = _a2,
        componentTokens = __objRest(_a2, ["colorBackgroundType", "color", "color2", "hoverColor", "hoverColor2", "pressColor", "pressColor2"]);

  const styles25 = getStyles63(componentTokens);
  return /* @__PURE__ */jsx(ButtonCompactBase, __spreadProps(__spreadValues({
    disabled,
    loading
  }, props), {
    buttonColor: {
      colorBackgroundType,
      color,
      color2,
      hoverColor,
      hoverColor2,
      pressColor,
      pressColor2
    },
    fullWidth,
    styles: styles25,
    ref
  }));
}, "TertiaryButtonCompact"));

var getStyles64 = /* @__PURE__ */__name((_ref64) => {
  let {
    elevationShadow,
    elevationDepth,
    heightSmall,
    radiusSmall,
    spaceHorizontalSmall,
    spaceHorizontalSmallDesktop,
    borderColor,
    borderHoverColor,
    borderPressColor,
    textColor
  } = _ref64;
  return {
    button: {
      boxShadow: elevationShadow,
      zIndex: elevationDepth,
      height: heightSmall,
      borderRadius: radiusSmall,
      paddingLeft: spaceHorizontalSmall,
      paddingRight: spaceHorizontalSmall,
      border: borderColor ? `1px solid ${borderColor}` : void 0,
      color: textColor,
      [responsive_exports.DESKTOP_SIZE]: {
        paddingLeft: spaceHorizontalSmallDesktop,
        paddingRight: spaceHorizontalSmallDesktop
      }
    },
    focusRing: {
      borderRadius: radiusSmall
    },
    disabled: {},
    hover: {
      borderColor: borderHoverColor
    },
    active: {
      borderColor: borderPressColor
    }
  };
}, "getStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function TertiaryButtonSmall2(_a, ref) {
  var _b = _a,
      {
    disabled,
    fullWidth,
    loading
  } = _b,
      props = __objRest(_b, ["disabled", "fullWidth", "loading"]);

  const _a2 = useComponentTheme("buttonTertiary"),
        {
    colorBackgroundType,
    color,
    color2,
    hoverColor,
    hoverColor2,
    pressColor,
    pressColor2
  } = _a2,
        componentTokens = __objRest(_a2, ["colorBackgroundType", "color", "color2", "hoverColor", "hoverColor2", "pressColor", "pressColor2"]);

  const styles25 = getStyles64(componentTokens);
  return /* @__PURE__ */jsx(ButtonSmallBase, __spreadProps(__spreadValues({
    disabled,
    loading
  }, props), {
    buttonColor: {
      colorBackgroundType,
      color,
      color2,
      hoverColor,
      hoverColor2,
      pressColor,
      pressColor2
    },
    fullWidth,
    styles: styles25,
    ref
  }));
}, "TertiaryButtonSmall"));
var iconColor5 = "systemGrayscale80";
var TertiaryIconButton = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function TertiaryIconButton2(_a, ref) {
  var _b = _a,
      {
    disabled
  } = _b,
      props = __objRest(_b, ["disabled"]);

  const theme = useTheme();
  const interactiveColors = useComputeInteractiveColors({
    backgroundColor: "systemGrayscale00",
    theme
  });
  const styles25 = {
    button: {
      backgroundColor: interactiveColors == null ? void 0 : interactiveColors.primaryColor,
      border: `1px solid ${disabled ? void 0 : theme.colors.systemGrayscale20}`
    },
    disabled: {
      backgroundColor: theme.colors.systemGrayscale10
    },
    hover: {
      backgroundColor: interactiveColors == null ? void 0 : interactiveColors.hoverColor
    },
    active: {
      backgroundColor: interactiveColors == null ? void 0 : interactiveColors.activeColor
    },
    focusRing: {},
    content: {}
  };
  return /* @__PURE__ */jsx(IconButtonBase, __spreadProps(__spreadValues({
    color: iconColor5,
    styles: styles25,
    disabled
  }, props), {
    ref
  }));
}, "TertiaryIconButton"));
TertiaryIconButton.displayName = "TertiaryIconButton";
var TRANSITION_DURATION_MS = 200;
var issueIconColor2 = "systemDetrimentalRegular";

var getStyles65 = /* @__PURE__ */__name(theme => ({
  wrapper: {
    position: "relative"
  },
  textarea: __spreadProps(__spreadValues({
    WebkitAppearance: "none",
    backgroundColor: theme.colors.systemGrayscale00,
    borderRadius: theme.radius.r8,
    boxShadow: `0 0 0 1px ${theme.colors.systemGrayscale20}`,
    boxSizing: "border-box",
    border: "none",
    color: theme.colors.systemGrayscale80,
    margin: 0,
    // Hack - use top border instead of padding to reserve space for the
    // label. This works while scrolling whereas top padding does not.
    borderTop: `${spacing.s24}px solid transparent`,
    padding: `0 ${spacing.s12}px ${spacing.s8}px ${spacing.s12}px`,
    position: "relative",
    touchAction: "manipulation",
    transition: `
        box-shadow ${TRANSITION_DURATION_MS}ms ease-in-out,
        color ${TRANSITION_DURATION_MS}ms ease-in-out
      `,
    width: "100%",
    flexGrow: 1
  }, theme.typography.bodyRegular), {
    "&::placeholder": {
      opacity: 1
    },
    "&:placeholder-shown::placeholder": {
      opacity: 0
    }
  }),
  focusRing: {
    outline: "none",
    boxShadow: `0 0 0 2px ${theme.colors.systemGrayscale80}`
  },
  hover: {
    boxShadow: `0 0 0 1px ${theme.colors.systemGrayscale80}`
  },
  disabled: {
    cursor: "default",
    boxShadow: `0 0 0 1px ${theme.colors.systemGrayscale20}`,
    backgroundColor: theme.colors.systemGrayscale10,
    color: theme.colors.systemGrayscale30,
    resize: "none"
  },
  invalid: {
    boxShadow: `0 0 0 1px ${theme.colors.systemDetrimentalDark}`,
    backgroundColor: theme.colors.systemDetrimentalLight
  },
  invalidHover: {
    boxShadow: `0 0 0 1px ${theme.colors.systemDetrimentalDark}`
  },
  invalidFocus: {
    boxShadow: `0 0 0 2px ${theme.colors.systemDetrimentalRegular}`
  },
  invalidText: {
    margin: 0
  },
  label: {
    cursor: "text",
    pointerEvents: "none",
    position: "absolute",
    transform: "translate(12px, 8px)",
    transformOrigin: "left top",
    transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
    userSelect: "none",
    zIndex: 1,
    color: theme.colors.systemGrayscale80,
    top: 0,
    left: 0,
    right: spacing.s24
  },
  disabledLabel: {
    color: theme.colors.systemGrayscale30
  },
  floatLabel: {
    '*:not(:placeholder-shown) + &,*[data-focused="true"] + &': __spreadProps(__spreadValues({}, theme.typography.accent), {
      cursor: "inherit",
      pointerEvents: "none",
      color: theme.colors.systemGrayscale80,
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden"
    }),
    "*[disabled]:not(:placeholder-shown) + &": {
      color: theme.colors.systemGrayscale30
    }
  },
  description: {
    margin: 0
  },
  errorIcon: {
    marginRight: spacing.s4,
    verticalAlign: "bottom"
  }
}), "getStyles");

var TextAreaBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function TextAreaBase2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    children,
    invalid = false,
    invalidText,
    label,
    placeholder: placeholderText,
    disabled,
    description,
    className
  } = _b,
      rest = __objRest(_b, ["styles", "children", "invalid", "invalidText", "label", "placeholder", "disabled", "description", "className"]);

  const theme = useTheme();
  const {
    wrapper,
    textarea,
    focusRing,
    disabled: disabledCss,
    hover,
    invalid: invalidStyle,
    invalidHover,
    invalidFocus,
    invalidText: invalidTextStyle,
    label: labelStyle,
    floatLabel,
    disabledLabel,
    description: descriptionStyle,
    errorIcon
  } = combineStyles(getStyles65(theme), styles25);
  const css = [textarea, {
    '[data-hovered="true"] > &': hover,
    '&[data-focused="true"]': focusRing,
    "&.invalid": invalidStyle,
    "&.invalid:hover": invalidHover,
    "&.invalid:focus": invalidFocus,
    '[data-disabled="true"] > &': disabledCss
  }];
  const labelCss = [labelStyle, floatLabel, disabled && disabledLabel];
  const placeholder = placeholderText || label || " ";
  return /* @__PURE__ */jsxs(TextFieldCoreFR, __spreadProps(__spreadValues({
    css: wrapper,
    invalid,
    disabled,
    rows: 6,
    autoComplete: "off"
  }, rest), {
    placeholder,
    label: label != null ? label : placeholderText,
    children: [/* @__PURE__ */jsx(TextAreaCore, {
      className: [invalid ? "invalid" : void 0, className].filter(Boolean).join(" "),
      css,
      ref
    }), placeholder && /* @__PURE__ */jsx(Text, {
      as: "label",
      typography: "bodyRegular",
      css: labelCss,
      children: placeholder
    }), !invalid && description && /* @__PURE__ */jsx(Text, {
      slot: TextFieldCoreFR.slots.description,
      as: "p",
      color: "systemGrayscale60",
      css: descriptionStyle,
      typography: "accent",
      children: description
    }), invalid && invalidText && /* @__PURE__ */jsxs(Text, {
      as: "p",
      typography: "accent",
      css: invalidTextStyle,
      slot: TextFieldCoreFR.slots.errorMessage,
      color: "systemDetrimentalExtraDark",
      children: [/* @__PURE__ */jsx(IssueIcon_default, {
        color: issueIconColor2,
        css: errorIcon,
        size: 16
      }), invalidText]
    })]
  }));
}, "TextAreaBase"));
TextAreaBase.displayName = "TextAreaBase";
var styles18 = {
  textarea: {
    resize: "none"
  }
};

function TextAreaFixed(props) {
  return /* @__PURE__ */jsx(TextAreaBase, __spreadValues({
    styles: styles18
  }, props));
}

__name(TextAreaFixed, "TextAreaFixed");

var styles19 = {
  textarea: {
    resize: "vertical",
    minHeight: "60px"
  }
};

function TextAreaDynamic(props) {
  return /* @__PURE__ */jsx(TextAreaBase, __spreadValues({
    styles: styles19
  }, props));
}

__name(TextAreaDynamic, "TextAreaDynamic");

var getStyles66 = /* @__PURE__ */__name((theme, colorStyle) => ({
  button: {
    backgroundColor: "transparent"
  },
  focusRing: {
    borderRadius: 32,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  content: __spreadProps(__spreadValues({
    padding: `10px ${spacing.s16}px`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: spacing.s4
  }, theme.typography.bodyMedium1), {
    color: colorStyle ? theme.colors[colorStyle] : theme.colors.systemGrayscale70,
    minWidth: 92,
    "& > svg": {
      flexShrink: 0
    }
  })
}), "getStyles");

var LoadingAnimation2 = /* @__PURE__ */jsxs(Flex, {
  alignItems: "center",
  gap: 4,
  children: [/* @__PURE__ */jsx(LoadingLockupTextBase, {
    styles: {
      container: {
        height: 20
      }
    }
  }), /* @__PURE__ */jsx(LoadingLockupIconBase, {
    css: {
      flexShrink: 0
    },
    styles: {
      container: {
        height: spacing.s16,
        width: spacing.s16
      }
    }
  })]
});
var TextButton = /*#__PURE__*/forwardRef((props, ref) => {
  const theme = useTheme();

  const _a = props,
        {
    leadingIcon: LeadingIcon,
    children,
    colorStyle
  } = _a,
        rest = __objRest(_a, ["leadingIcon", "children", "colorStyle"]);

  const styles25 = getStyles66(theme, props.colorStyle);
  const TrailingIcon = LeadingIcon ? ChevronDownIcon_default : ChevronRightIcon_default;
  return /* @__PURE__ */jsxs(ButtonCore, __spreadProps(__spreadValues({
    loadingAnimation: LoadingAnimation2,
    styles: styles25
  }, rest), {
    ref,
    children: [LeadingIcon && (reactIsExports.isElement(LeadingIcon) ? renderIconElement2(LeadingIcon) : /* @__PURE__ */jsx(LeadingIcon, {
      size: 16,
      css: {
        [responsive_exports.up("r")]: {
          height: 20,
          width: 20
        }
      }
    })), /* @__PURE__ */jsx("span", {
      css: {
        overflow: "hidden",
        textOverflow: "ellipsis"
      },
      children
    }), /* @__PURE__ */jsx(TrailingIcon, {
      size: 16
    })]
  }));
});

function renderIconElement2(element) {
  return /*#__PURE__*/cloneElement(element, {
    "aria-hidden": true,
    size: 16
  });
}

__name(renderIconElement2, "renderIconElement");

TextButton.displayName = "TextButton";

var getStyles67 = /* @__PURE__ */__name(theme => ({
  container: {
    backgroundColor: theme.colors.systemGrayscale10,
    borderRadius: theme.radius.r12,
    "&:hover": {
      backgroundColor: theme.colors.systemGrayscale20
    }
  }
}), "getStyles");

var TileBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function TileBase2(_a, ref) {
  var _b = _a,
      {
    styles: stylesProp,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const theme = useTheme();
  const styles25 = combineStyles(getStyles67(theme), stylesProp);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    ref,
    css: styles25.container
  }, rest), {
    children
  }));
}, "TileBase"));
var BORDER_WIDTH3 = 2;
var ACTIVE_BORDER_MARGIN = `-${spacing.s8}px`;

var getStyles68 = /* @__PURE__ */__name(theme => ({
  anchor: {
    position: "relative",
    margin: 0,
    cursor: "pointer",
    userSelect: "none",
    display: "flex",
    touchAction: "manipulation",
    textDecoration: "none",
    "&.focus-visible::after": {
      borderRadius: theme.radius.r12,
      border: `${BORDER_WIDTH3}px solid ${theme.colors.systemGrayscale70}`,
      content: '""',
      display: "block",
      position: "absolute",
      top: ACTIVE_BORDER_MARGIN,
      bottom: ACTIVE_BORDER_MARGIN,
      left: ACTIVE_BORDER_MARGIN,
      right: ACTIVE_BORDER_MARGIN
    },
    "&:focus": {
      outline: "none"
    },
    "&.focus-visible": {
      outline: "none"
    }
  }
}), "getStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function TileAnchor2(_a, ref) {
  var _b = _a,
      {
    href,
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["href", "styles", "children"]);

  const theme = useTheme();
  const {
    anchor
  } = combineStyles(getStyles68(theme), styles25);
  return /* @__PURE__ */jsx("a", __spreadProps(__spreadValues({
    ref,
    href,
    css: anchor
  }, rest), {
    children
  }));
}, "TileAnchor"));

var getStyles69 = /* @__PURE__ */__name(theme => ({
  text: __spreadValues({
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: theme.colors.systemGrayscale70
  }, theme.typography.bodyMedium1)
}), "getStyles");

function TileTitle(_a) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const theme = useTheme();
  const {
    text: textCSS
  } = combineStyles(getStyles69(theme), styles25);
  return /* @__PURE__ */jsx("span", __spreadProps(__spreadValues({
    css: textCSS
  }, rest), {
    children
  }));
}

__name(TileTitle, "TileTitle");

var getStyles70 = /* @__PURE__ */__name(theme => __spreadValues({
  img: {
    maxWidth: "100%",
    maxHeight: "100%",
    borderRadius: theme.radius.r8
  }
}, aspectRatio(1, 1)), "getStyles");

function TileImage(props) {
  const _a = props,
        {
    styles: styles25,
    src,
    alt,
    children
  } = _a,
        rest = __objRest(_a, ["styles", "src", "alt", "children"]);

  const theme = useTheme();
  const {
    box,
    img
  } = combineStyles(getStyles70(theme), styles25);
  return /* @__PURE__ */jsx("div", {
    css: box,
    children: /* @__PURE__ */jsx("img", __spreadProps(__spreadValues({}, rest), {
      css: img,
      src,
      alt
    }))
  });
}

__name(TileImage, "TileImage");

var getStyles71 = /* @__PURE__ */__name(() => ({
  container: {}
}), "getStyles");

var StoreCardBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function TileBase3(_a, ref) {
  var _b = _a,
      {
    styles: stylesProp,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const styles25 = combineStyles(getStyles71(), stylesProp);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    ref,
    css: styles25.container
  }, rest), {
    children
  }));
}, "TileBase"));

var getStyles72 = /* @__PURE__ */__name((theme, disabled) => ({
  anchor: {
    height: "100%",
    alignItems: "center",
    display: "grid",
    gridTemplateColumns: "min-content 1fr max-content",
    gridTemplateRows: "1fr min-content",
    gridTemplateAreas: '"image center right" "footer footer footer"',
    position: "relative",
    margin: 0,
    cursor: disabled ? "inherit" : "pointer",
    userSelect: "none",
    touchAction: "manipulation",
    textDecoration: "none",
    padding: spacing.s12,
    opacity: disabled ? 0.5 : 1,
    "&.focus-visible::after": {
      content: '""',
      display: "block",
      position: "absolute",
      top: -4,
      bottom: -4,
      left: -4,
      right: -4,
      border: `2px solid ${theme.colors.systemGrayscale70}`,
      borderRadius: theme.radius.r12
    },
    "&:focus": {
      outline: "none"
    },
    "&.focus-visible": {
      outline: "none"
    }
  }
}), "getStyles");

var StoreCardAnchor = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function StoreCardAnchor2(_a, ref) {
  var _b = _a,
      {
    href,
    styles: styles25,
    children,
    disabled
  } = _b,
      rest = __objRest(_b, ["href", "styles", "children", "disabled"]);

  const theme = useTheme();
  const {
    anchor
  } = combineStyles(getStyles72(theme, disabled), styles25);
  return /* @__PURE__ */jsx("a", __spreadProps(__spreadValues({
    ref,
    href: !disabled ? href : void 0,
    css: anchor
  }, rest), {
    "aria-disabled": disabled ? "true" : void 0,
    role: disabled ? "link" : void 0,
    children
  }));
}, "StoreCardAnchor"));
StoreCardAnchor.displayName = "StoreCardAnchor";

var getStyles73 = /* @__PURE__ */__name(theme => ({
  text: __spreadValues({
    display: "block",
    color: theme.colors.systemGrayscale70
  }, theme.typography.bodyMedium1)
}), "getStyles");

function StoreCardTitle(_a) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const theme = useTheme();
  const {
    text: textCSS
  } = combineStyles(getStyles73(theme), styles25);
  return /* @__PURE__ */jsx("span", __spreadProps(__spreadValues({
    css: textCSS
  }, rest), {
    children
  }));
}

__name(StoreCardTitle, "StoreCardTitle");

var getStyles74 = /* @__PURE__ */__name(theme => ({
  imgWrapper: {
    gridArea: "image",
    display: "flex",
    marginRight: spacing.s12,
    maxWidth: "100%",
    maxHeight: "100%",
    borderRadius: theme.radius.r8
  }
}), "getStyles");

function StoreCardImage(props) {
  const {
    styles: styles25,
    children
  } = props;
  const theme = useTheme();
  const {
    imgWrapper
  } = combineStyles(getStyles74(theme), styles25);
  return /* @__PURE__ */jsx("div", {
    css: imgWrapper,
    children
  });
}

__name(StoreCardImage, "StoreCardImage");

var getStyles75 = /* @__PURE__ */__name(() => ({
  container: {
    gridArea: "center",
    display: "block"
  }
}), "getStyles");

function StoreCardCenter(_a) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const {
    container
  } = combineStyles(getStyles75(), styles25);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    css: container
  }, rest), {
    children
  }));
}

__name(StoreCardCenter, "StoreCardCenter");

var getStyles76 = /* @__PURE__ */__name(() => ({
  container: {
    gridArea: "right",
    display: "flex",
    alignSelf: "center",
    marginLeft: "auto"
  }
}), "getStyles");

function StoreCardRight(_a) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const {
    container
  } = combineStyles(getStyles76(), styles25);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    css: container
  }, rest), {
    children
  }));
}

__name(StoreCardRight, "StoreCardRight");

var getStyles77 = /* @__PURE__ */__name(() => ({
  container: {}
}), "getStyles");

function StoreCardCenterFooter(_a) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const {
    container
  } = combineStyles(getStyles77(), styles25);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    css: container
  }, rest), {
    children
  }));
}

__name(StoreCardCenterFooter, "StoreCardCenterFooter");

var getStyles78 = /* @__PURE__ */__name(() => ({
  container: {
    gridArea: "footer",
    marginTop: spacing.s12,

    /**
     * Fixes an issue in Firefox where children containing a flex node do not properly apply overflow
     * @see https://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox
     */
    minWidth: 0
  }
}), "getStyles");

function StoreCardFooter(_a) {
  var _b = _a,
      {
    children,
    styles: propsStyles
  } = _b,
      rest = __objRest(_b, ["children", "styles"]);

  const styles25 = combineStyles(getStyles78(), propsStyles);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    css: styles25.container
  }, rest), {
    children
  }));
}

__name(StoreCardFooter, "StoreCardFooter");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function SingleLineTextInput3(props, ref) {
  return /* @__PURE__ */jsx(TextInputBase, __spreadProps(__spreadValues({}, props), {
    ref
  }));
}, "SingleLineTextInput"));

var getStyles79 = /* @__PURE__ */__name(theme => ({
  wrapper: {
    background: theme.colors.kaleDark,
    border: `1px solid ${theme.colors.kaleDark}`
  },
  label: {
    color: theme.colors.tertiaryRegular
  },
  input: {
    color: theme.colors.tertiaryRegular,
    caretColor: theme.colors.tertiaryRegular,
    "&:placeholder-shown:not(:focus) + *": {
      color: theme.colors.tertiaryRegular
    }
  }
}), "getStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function SingleLineTextInputDark2(props, ref) {
  const theme = useTheme();
  const styles25 = getStyles79(theme);
  return /* @__PURE__ */jsx(TextInputBase, __spreadProps(__spreadValues({}, props), {
    styles: styles25,
    ref
  }));
}, "SingleLineTextInputDark"));

var getPreviousItem = /* @__PURE__ */__name((rowIds, rowId) => {
  const findIndexInArray = rowIds.findIndex(currentRowId => {
    return currentRowId === rowId;
  });
  return findIndexInArray <= 0 ? rowIds.length - 1 : findIndexInArray - 1;
}, "getPreviousItem");

var getNextItem = /* @__PURE__ */__name((rowIds, rowId) => {
  if (!rowId) return 0;
  const findIndexInArray = rowIds.findIndex(currentRowId => {
    return currentRowId === rowId;
  });
  return findIndexInArray + 1 >= rowIds.length ? 0 : findIndexInArray + 1;
}, "getNextItem");

var handleArrowNavigation = /* @__PURE__ */__name((event, rows, row) => {
  let newIndex;
  let newItem;

  if (event.key === "ArrowUp") {
    event.preventDefault();
    newIndex = getPreviousItem(rows, row);
    newItem = document.getElementById(rows == null ? void 0 : rows[newIndex]);

    if ((newItem == null ? void 0 : newItem.disabled) && newIndex === 0) {
      newItem = document.getElementById(rows == null ? void 0 : rows[rows.length - 1]);
    }

    if (!newItem || (newItem == null ? void 0 : newItem.disabled)) {
      newItem = document.getElementById(rows == null ? void 0 : rows[newIndex - 1]);
    }
  }

  if (event.code === "ArrowDown") {
    event.preventDefault();
    newIndex = getNextItem(rows, row);
    newItem = document.getElementById(rows == null ? void 0 : rows[newIndex]);

    if ((newItem == null ? void 0 : newItem.disabled) && newIndex === 0) {
      newItem = document.getElementById(rows == null ? void 0 : rows[1]);
    }

    if (!newItem || newItem.disabled) {
      newIndex = newIndex + 1;
      newItem = document.getElementById(rows == null ? void 0 : rows[newIndex]);
    }
  }

  newItem == null ? void 0 : newItem.focus();
  return newIndex;
}, "handleArrowNavigation");

var SelectMenuContext = /*#__PURE__*/createContext({
  menuRef: null,
  buttonRef: null,
  dropdownRef: null,
  wrapperId: "",
  labelId: "",
  selectedId: "",
  options: [],
  optionIds: [],
  hasFixedFooter: false,
  selectedValue: "",
  setSelectedValue: /* @__PURE__ */__name(() => {}, "setSelectedValue"),
  visible: false,
  handleArrowNavigation,
  setVisible: /* @__PURE__ */__name(() => {}, "setVisible"),
  handleSubmit: /* @__PURE__ */__name(() => {}, "handleSubmit"),
  handleMenuKeyDown: /* @__PURE__ */__name(() => {}, "handleMenuKeyDown")
});

var useSelectMenuContext = /* @__PURE__ */__name(() => {
  return useContext(SelectMenuContext);
}, "useSelectMenuContext");

var getStyles80 = /* @__PURE__ */__name(theme => (disabled, selected) => {
  let optionTextColor = theme.colors.systemGrayscale50;

  if (disabled) {
    optionTextColor = theme.colors.systemGrayscale30;
  }

  if (selected) {
    optionTextColor = theme.colors.systemGrayscale70;
  }

  const cursor = disabled ? "default" : "pointer";
  return {
    option: __spreadProps(__spreadValues({
      boxSizing: "border-box",
      position: "relative",
      display: "flex",
      width: "100%",
      marginBottom: spacing.s4,
      textAlign: "left",
      justifyContent: "space-between",
      backgroundColor: "transparent",
      color: optionTextColor,
      border: "none"
    }, theme.typography.bodyMedium1), {
      ":hover": {
        outline: "none",
        borderRadius: theme.radius.r8,
        backgroundColor: disabled ? "transparent" : theme.colors.systemGrayscale10
      }
    }),
    label: __spreadProps(__spreadValues({
      width: "100%",
      display: "flex",
      padding: spacing.s8
    }, theme.typography.bodyMedium1), {
      cursor,
      ":hover": {
        cursor
      }
    }),
    input: {
      position: "absolute",
      top: 0,
      left: 0,
      height: "100%",
      width: "100%",
      appearance: "none",
      ":hover": {
        cursor
      },
      ":focus": {
        outline: "none"
      },
      ":focus-visible::after": {
        content: '""',
        display: "block",
        position: "absolute",
        left: 0,
        right: 0,
        top: -4,
        bottom: -4,
        outline: "none",
        border: `2px solid ${theme.colors.systemGrayscale70}`,
        borderRadius: theme.radius.r12
      },
      ":disabled": {
        color: theme.colors.systemGrayscale30
      }
    },
    selectedOption: {
      textDecoration: "none"
    },
    icon: {
      position: "relative",
      width: 24,
      marginLeft: "auto"
    }
  };
}, "getStyles");

function SingleSelectOption(props) {
  const _a = props,
        {
    index,
    children,
    id,
    keyString,
    value,
    disabled
  } = _a,
        rest = __objRest(_a, ["index", "children", "id", "keyString", "value", "disabled"]);

  const theme = useTheme();
  const {
    selectedValue,
    setSelectedValue,
    handleArrowNavigation: handleArrowNavigation2,
    optionIds,
    handleMenuKeyDown
  } = useSelectMenuContext();
  const stringValue = `${keyString}=${value}`;
  const selected = selectedValue === stringValue;
  const styles25 = getStyles80(theme)(disabled, selected);
  return /* @__PURE__ */jsxs("li", {
    css: styles25.option,
    children: [/* @__PURE__ */jsx("input", __spreadValues({
      id,
      type: "radio",
      css: styles25.input,
      checked: selected,
      onClick: () => {
        if (setSelectedValue) {
          setSelectedValue(stringValue);
        }
      },
      onKeyDown: event => {
        handleMenuKeyDown(event);

        if (event.code === "ArrowUp" || event.code === "ArrowDown") {
          handleArrowNavigation2(event, optionIds, id);
        }

        if (event.code === "Enter" || event.code === "Space") {
          if (setSelectedValue) {
            setSelectedValue(stringValue);
          }
        }
      },
      disabled
    }, rest)), /* @__PURE__ */jsxs("label", {
      css: styles25.label,
      htmlFor: id,
      children: [children, /* @__PURE__ */jsx("div", {
        css: styles25.icon,
        "aria-hidden": true,
        children: selected && /* @__PURE__ */jsx(ConfirmIcon_default, {
          size: "17",
          color: "systemSuccessRegular"
        })
      })]
    })]
  });
}

__name(SingleSelectOption, "SingleSelectOption");

var createSelectedOption = /* @__PURE__ */__name((key, value) => {
  const urlParam = new URLSearchParams();
  urlParam.set(key, value);
  return urlParam.toString();
}, "createSelectedOption");

function SingleSelectSubOption(props) {
  const _a = props,
        {
    children,
    value,
    id,
    keyString,
    optionLabel,
    disabled
  } = _a,
        rest = __objRest(_a, ["children", "value", "id", "keyString", "optionLabel", "disabled"]);

  const theme = useTheme();
  const {
    selectedValue,
    setSelectedValue,
    optionIds,
    handleArrowNavigation: handleArrowNavigation2,
    handleMenuKeyDown
  } = useSelectMenuContext();
  const selectedString = createSelectedOption(keyString, value);
  const selected = selectedValue === selectedString;
  const styles25 = getStyles80(theme)(disabled, selected);

  const selfStyles = __spreadValues({
    paddingLeft: spacing.s24
  }, theme.typography.bodyMedium2);

  const labelSelfStyles = __spreadValues({}, theme.typography.bodyMedium2);

  return /* @__PURE__ */jsxs("li", {
    css: [styles25.option, selfStyles],
    children: [/* @__PURE__ */jsx("input", __spreadProps(__spreadValues({
      id,
      type: "radio",
      css: [styles25.input, selfStyles],
      value,
      checked: selected,
      onClick: () => {
        if (setSelectedValue) {
          setSelectedValue(selectedString);
        }
      }
    }, rest), {
      onKeyDown: event => {
        handleMenuKeyDown(event);

        if (event.code === "ArrowUp" || event.code === "ArrowDown") {
          handleArrowNavigation2(event, optionIds, id);
        }

        if (event.key === "Enter" || event.code === "Space") {
          if (setSelectedValue) {
            setSelectedValue(selectedString);
          }
        }
      }
    })), /* @__PURE__ */jsxs("label", {
      css: [styles25.label, labelSelfStyles],
      htmlFor: id,
      children: [optionLabel && /* @__PURE__ */jsx("span", {
        css: A11Y.visuallyHidden,
        children: optionLabel
      }), children, selected && /* @__PURE__ */jsx("div", {
        css: styles25.icon,
        children: /* @__PURE__ */jsx(ConfirmIcon_default, {
          size: "17",
          color: "systemSuccessRegular"
        })
      })]
    })]
  });
}

__name(SingleSelectSubOption, "SingleSelectSubOption");

var getStyles81 = /* @__PURE__ */__name(theme => __spreadProps(__spreadValues({
  display: "block",
  position: "relative",
  textAlign: "left",
  width: "100%"
}, theme.typography.bodyMedium1), {
  background: theme.colors.systemGrayscale00,
  color: theme.colors.brandPrimaryRegular,
  marginTop: spacing.s12,
  marginBottom: spacing.s12,
  border: "none",
  padding: spacing.s8,
  paddingRight: spacing.s8,
  paddingLeft: spacing.s24,
  borderRadius: theme.radius.r12,
  cursor: "pointer",
  ":hover": {
    backgroundColor: theme.colors.systemGrayscale10
  },
  ":focus-visible": {
    outline: "none"
  },
  ":focus-visible::after": {
    content: '""',
    position: "absolute",
    top: -4,
    left: 0,
    bottom: -4,
    right: 0,
    border: `2px solid ${theme.colors.systemGrayscale70}`,
    borderRadius: theme.radius.r12
  }
}), "getStyles");

function SingleSelectViewMoreButton(props) {
  const _a = props,
        {
    children,
    viewMoreString
  } = _a,
        rest = __objRest(_a, ["children", "viewMoreString"]);

  const theme = useTheme();
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);
  const styles25 = getStyles81(theme);
  return /* @__PURE__ */jsx(Fragment, {
    children: !visible ? /* @__PURE__ */jsx("li", {
      ref,
      children: /* @__PURE__ */jsx("button", __spreadProps(__spreadValues({
        css: styles25,
        onClick: () => {
          var _a2, _b;

          setVisible(true);
          const el = (_b = (_a2 = ref == null ? void 0 : ref.current) == null ? void 0 : _a2.previousSibling) == null ? void 0 : _b.firstChild;

          if (el) {
            el.focus();
          }
        }
      }, rest), {
        children: viewMoreString
      }))
    }) : children
  });
}

__name(SingleSelectViewMoreButton, "SingleSelectViewMoreButton");

var styles20 = {
  display: "inline-block",
  position: "relative",
  marginRight: spacing.s8
};

function SelectMenu(props) {
  const _a = props,
        {
    children,
    selectedValue,
    setSelectedValue,
    options
  } = _a,
        rest = __objRest(_a, ["children", "selectedValue", "setSelectedValue", "options"]);

  const [elToFocus, setElToFocus] = useState(null);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);
  const {
    id: wrapperId
  } = unstable_useId();
  const {
    id: labelId
  } = unstable_useId();
  const {
    id: selectedId
  } = unstable_useId();
  const [visible, setVisible] = useState(false);
  const [hasFixedFooter, setHasFixedFooter] = useState(false);
  useEffect(() => {
    if (visible && elToFocus) {
      elToFocus.focus();
      setElToFocus(null);
    }
  }, [visible, elToFocus]);
  useOnClickOutside(menuRef, () => {
    setVisible(false);
  });

  const handleSubmit = /* @__PURE__ */__name(function (event) {
    let close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const buttonEl = buttonRef == null ? void 0 : buttonRef.current;

    if (buttonEl && event.key === "Enter") {
      event.preventDefault();

      if (close) {
        setVisible(false);
        buttonEl.focus();
      }
    }

    if (buttonEl && event.code === "Space") {
      if (close) {
        setVisible(false);
        buttonEl.focus();
      }
    }
  }, "handleSubmit");

  const handleMenuKeyDown = /* @__PURE__ */__name(event => {
    var _a2;

    if (event.key === "Escape") {
      setVisible(false);

      if ((_a2 = buttonRef == null ? void 0 : buttonRef.current) == null ? void 0 : _a2.focus) {
        buttonRef.current.focus();
      }
    }
  }, "handleMenuKeyDown");

  useEffect(() => {
    var _a2;

    const dropdownHeight = (_a2 = dropdownRef == null ? void 0 : dropdownRef.current) == null ? void 0 : _a2.offsetHeight;

    if (visible && dropdownHeight && dropdownHeight > 350) {
      setHasFixedFooter(true);
    }
  }, [visible, dropdownRef]);
  useEffect(() => {
    const handleTabOutside = /* @__PURE__ */__name(event => {
      if ((menuRef == null ? void 0 : menuRef.current) && !menuRef.current.contains(event.target)) {
        setVisible(false);
      }
    }, "handleTabOutside");

    document.addEventListener("focusin", handleTabOutside);
    return () => {
      document.removeEventListener("focusin", handleTabOutside);
    };
  }, [menuRef]);
  const optionIds = options == null ? void 0 : options.map(option => option.id);
  return /* @__PURE__ */jsx(SelectMenuContext.Provider, {
    value: {
      visible,
      setVisible,
      wrapperId,
      labelId,
      selectedId,
      menuRef,
      buttonRef,
      dropdownRef,
      hasFixedFooter,
      options: options || [],
      optionIds: optionIds || [],
      selectedValue,
      setSelectedValue,
      handleArrowNavigation,
      handleSubmit,
      handleMenuKeyDown
    },
    children: /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
      ref: menuRef,
      css: styles20,
      id: wrapperId
    }, rest), {
      children
    }))
  });
}

__name(SelectMenu, "SelectMenu");

var DROP_DOWN_WIDTH = 282;

var getStyles82 = /* @__PURE__ */__name((theme, visible) => __spreadValues(__spreadValues({
  position: "absolute",
  top: 48,
  width: DROP_DOWN_WIDTH,
  display: visible ? "block" : "none",
  borderRadius: theme.radius.r12,
  listStyle: "none",
  margin: 0,
  background: theme.colors.systemGrayscale00
}, elevation.low.depth), elevation.low.shadow), "getStyles");

function SelectMenuDropdown(props) {
  const _a = props,
        {
    children
  } = _a,
        rest = __objRest(_a, ["children"]);

  const {
    id
  } = unstable_useId(props);
  const [side, setSide] = useState("left");
  const {
    visible,
    dropdownRef
  } = useSelectMenuContext();
  const theme = useTheme();
  const styles25 = getStyles82(theme, visible);
  useEffect(() => {
    let observer = null;

    if (dropdownRef == null ? void 0 : dropdownRef.current) {
      observer = new window.IntersectionObserver(() => {
        var _a2;

        if (dropdownRef == null ? void 0 : dropdownRef.current) {
          const {
            left,
            width
          } = (_a2 = dropdownRef.current) == null ? void 0 : _a2.getBoundingClientRect();
          const isOverflowing = window.innerWidth < left + width;
          setSide(isOverflowing && !(window.innerWidth <= width) ? "right" : "left");
        }
      }, {
        root: dropdownRef.current.parentElement,
        rootMargin: "0px",
        threshold: 0.1
      });
      observer.observe(dropdownRef.current);
    }

    return () => {
      observer == null ? void 0 : observer.disconnect();
    };
  }, [dropdownRef]);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    ref: dropdownRef,
    tabIndex: -1,
    id,
    css: [styles25, {
      [side]: 0
    }]
  }, rest), {
    children
  }));
}

__name(SelectMenuDropdown, "SelectMenuDropdown");

var getStyles83 = /* @__PURE__ */__name(() => ({
  listStyle: "none",
  padding: spacing.s8,
  maxHeight: 300,
  overflow: "auto",
  margin: 0
}), "getStyles");

function SelectMenuList(props) {
  const _a = props,
        {
    children
  } = _a,
        rest = __objRest(_a, ["children"]);

  const {
    hasFixedFooter
  } = useSelectMenuContext();
  const styles25 = getStyles83();
  const fixedFooter = hasFixedFooter ? {
    paddingBottom: 40
  } : {};
  return /* @__PURE__ */jsx("ul", __spreadProps(__spreadValues({
    css: [styles25, fixedFooter]
  }, rest), {
    children
  }));
}

__name(SelectMenuList, "SelectMenuList");

var SELECT_BUTTON_HEIGHT = 40;

var getStyles84 = /* @__PURE__ */__name((theme, visible) => ({
  button: __spreadProps(__spreadValues({
    display: "flex",
    alignItems: "center",
    height: SELECT_BUTTON_HEIGHT,
    borderRadius: theme.radius.r8,
    padding: `${spacing.s8}px ${spacing.s12}px`,
    border: `1px solid ${theme.colors.systemGrayscale20}`,
    backgroundColor: visible ? theme.colors.systemGrayscale10 : theme.colors.systemGrayscale00,
    borderColor: theme.colors.systemGrayscale30,
    cursor: "pointer"
  }, theme.typography.bodyMedium1), {
    ":disabled": {
      backgroundColor: theme.colors.systemGrayscale10,
      border: "none",
      color: theme.colors.systemGrayscale30,
      cursor: "default",
      "& svg": {
        fill: theme.colors.systemGrayscale30
      }
    },
    ":hover": {
      backgroundColor: theme.colors.systemGrayscale10,
      borderColor: theme.colors.systemGrayscale30
    },
    "&:focus": {
      outline: 0
    },
    ":focus-visible:": {
      outline: 0
    },
    ":focus-visible::after": {
      display: "block",
      position: "absolute",
      content: '""',
      border: `2px solid ${theme.colors.systemGrayscale70}`,
      borderRadius: theme.radius.r12,
      top: -4,
      bottom: -4,
      left: -4,
      right: -4
    }
  }),
  icon: {
    position: "relative",
    top: 3,
    paddingLeft: 10
  }
}), "getStyles");

function SelectMenuButton(props) {
  const _a = props,
        {
    children
  } = _a,
        rest = __objRest(_a, ["children"]);

  const {
    visible,
    setVisible,
    buttonRef,
    selectedId,
    wrapperId,
    handleMenuKeyDown
  } = useSelectMenuContext();
  const theme = useTheme();
  const styles25 = getStyles84(theme, visible);
  const Icon = visible ? ChevronUpIcon_default : ChevronDownIcon_default;
  return /* @__PURE__ */jsxs("button", __spreadProps(__spreadValues({
    ref: buttonRef,
    css: styles25.button,
    onClick: () => {
      setVisible(!visible);
    },
    onKeyDown: event => {
      handleMenuKeyDown(event);
    },
    "aria-controls": wrapperId,
    "aria-expanded": visible
  }, rest), {
    children: [/* @__PURE__ */jsx("span", {
      id: selectedId,
      children
    }), /* @__PURE__ */jsx("div", {
      css: styles25.icon,
      children: /* @__PURE__ */jsx(Icon, {})
    })]
  }));
}

__name(SelectMenuButton, "SelectMenuButton");

var getStyles85 = /* @__PURE__ */__name((theme, hasFixedFooter) => ({
  display: "flex",
  padding: `${spacing.s8}px ${spacing.s12}px`,
  paddingTop: spacing.s12,
  backgroundColor: theme.colors.systemGrayscale00,
  boxShadow: hasFixedFooter ? elevation.high.shadow.boxShadow : "none",
  borderBottomRightRadius: theme.radius.r12,
  borderBottomLeftRadius: theme.radius.r12,
  "& button": {
    minWidth: "unset"
  },
  "& button:first-of-type": {
    marginRight: spacing.s8
  }
}), "getStyles");

function SelectMenuFooter(props) {
  const _a = props,
        {
    children
  } = _a,
        rest = __objRest(_a, ["children"]);

  const {
    hasFixedFooter
  } = useSelectMenuContext();
  const theme = useTheme();
  const styles25 = getStyles85(theme, hasFixedFooter);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    css: styles25
  }, rest), {
    children
  }));
}

__name(SelectMenuFooter, "SelectMenuFooter");

var getStyles86 = /* @__PURE__ */__name((theme, isApplyButton) => ({
  active: {
    backgroundColor: isApplyButton ? theme.colors.brandPrimaryDark : theme.colors.systemGrayscale20
  },
  loading: {
    backgroundColor: isApplyButton ? theme.colors.brandPrimaryDark : theme.colors.systemGrayscale20
  },
  button: {
    width: "50%",
    height: 40,
    backgroundColor: isApplyButton ? theme.colors.brandPrimaryRegular : theme.colors.systemGrayscale10,
    color: isApplyButton ? theme.colors.systemGrayscale00 : theme.colors.systemGrayscale70
  },
  content: __spreadValues({}, theme.typography.bodyMedium1),
  disabled: {
    backgroundColor: theme.colors.systemGrayscale10,
    color: theme.colors.systemGrayscale30
  },
  focusRing: {
    borderRadius: theme.radius.r8
  },
  hover: {
    backgroundColor: isApplyButton ? blendColors(theme.colors.brandPrimaryRegular, theme.colors.brandPrimaryDark, 51) : blendColors(theme.colors.systemGrayscale10, theme.colors.systemGrayscale20, 51)
  }
}), "getStyles");

function SelectMenuFooterButton(props) {
  const _a = props,
        {
    isApplyButton,
    children,
    onClick,
    closeOnClick = true
  } = _a,
        rest = __objRest(_a, ["isApplyButton", "children", "onClick", "closeOnClick"]);

  const {
    selectedValue,
    setVisible,
    handleSubmit,
    handleMenuKeyDown
  } = useSelectMenuContext();
  const theme = useTheme();
  const styles25 = getStyles86(theme, isApplyButton);
  const selectedValueNumber = (selectedValue == null ? void 0 : selectedValue.length) ? ` (${1}) ` : "";
  const valueNumber = isApplyButton ? selectedValueNumber : "";
  const ButtonComponent = isApplyButton ? PrimaryButtonSmall : SecondaryButtonSmall;
  return /* @__PURE__ */jsxs(ButtonComponent, __spreadProps(__spreadValues({
    styles: styles25,
    onClick: () => {
      onClick && onClick();

      if (closeOnClick) {
        setVisible(false);
      }
    },
    onKeyDown: e3 => {
      if (onClick && e3.key === "Enter") onClick();
      handleSubmit(e3, closeOnClick);
      handleMenuKeyDown(e3);
    }
  }, rest), {
    children: [children, valueNumber]
  }));
}

__name(SelectMenuFooterButton, "SelectMenuFooterButton");

var flagIconForCountryIso = /* @__PURE__ */__name(countryIsoString => {
  switch (countryIsoString) {
    case "AU":
      return FlagAUIcon_default;

    case "BR":
      return FlagBRIcon_default;

    case "CA":
      return FlagCAIcon_default;

    case "DE":
      return FlagDEIcon_default;

    case "FR":
      return FlagFRIcon_default;

    case "JP":
      return FlagJPIcon_default;

    case "UK":
      return FlagUKIcon_default;

    case "US":
      return FlagUSIcon_default;

    default:
      return FlagUSIcon_default;
  }
}, "flagIconForCountryIso");

var getStyles87 = /* @__PURE__ */__name((_ref65) => {
  let {
    theme,
    color: colorKey
  } = _ref65;
  return {
    containerStyles: __spreadProps(__spreadValues({}, theme.typography.bodySmall1), {
      display: "inline-block",
      padding: `3px ${spacing.s8}px`,
      borderRadius: theme.radius.r4,
      border: `solid 1px ${colorKey ? theme.colors[colorKey] : theme.colors.systemGrayscale30}`,
      color: colorKey ? theme.colors[colorKey] : theme.colors.systemGrayscale50
    })
  };
}, "getStyles");

function MarkerBase(props) {
  const {
    children,
    styles: styles25,
    color
  } = props;
  const theme = useTheme();
  const {
    containerStyles: containerStyles3
  } = combineStyles(getStyles87({
    theme,
    color
  }), styles25);
  return /* @__PURE__ */jsx("div", {
    css: containerStyles3,
    children
  });
}

__name(MarkerBase, "MarkerBase");

function Marker(props) {
  return /* @__PURE__ */jsx(MarkerBase, __spreadProps(__spreadValues({}, props), {
    children: props.children
  }));
}

__name(Marker, "Marker");

var iconStyles2 = {
  verticalAlign: "top",
  paddingRight: `${spacing.s4}px`,
  marginTop: "2px"
};

function MarkerIconLeft(_a) {
  var _b = _a,
      {
    icon: Icon,
    children
  } = _b,
      rest = __objRest(_b, ["icon", "children"]);

  return /* @__PURE__ */jsxs(MarkerBase, __spreadProps(__spreadValues({}, rest), {
    children: [/* @__PURE__ */jsx(Icon, {
      color: rest.color || "systemGrayscale50",
      size: 14,
      css: iconStyles2
    }), children]
  }));
}

__name(MarkerIconLeft, "MarkerIconLeft");

var iconStyles3 = {
  verticalAlign: "top",
  paddingLeft: `${spacing.s4}px`,
  marginTop: "2px"
};

function MarkerIconRight(_a) {
  var _b = _a,
      {
    icon: Icon,
    children
  } = _b,
      rest = __objRest(_b, ["icon", "children"]);

  return /* @__PURE__ */jsxs(MarkerBase, __spreadProps(__spreadValues({}, rest), {
    children: [children, /* @__PURE__ */jsx(Icon, {
      color: rest.color || "systemGrayscale50",
      size: 14,
      css: iconStyles3
    })]
  }));
}

__name(MarkerIconRight, "MarkerIconRight");

function MarkerChip(props) {
  const _a = props,
        {
    styles: propStyles
  } = _a,
        rest = __objRest(_a, ["styles"]);

  const theme = useTheme();
  const styles25 = {
    containerStyles: __spreadProps(__spreadValues({}, propStyles), {
      background: theme.colors.systemGrayscale20,
      color: theme.colors.systemGrayscale70,
      borderRadius: theme.radius.r12,
      padding: `1px ${spacing.s8}px`,
      border: "none"
    })
  };
  return /* @__PURE__ */jsx(MarkerBase, __spreadProps(__spreadValues({}, rest), {
    styles: styles25,
    children: props.children
  }));
}

__name(MarkerChip, "MarkerChip");

var getStyles88 = /* @__PURE__ */__name(() => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    padding: `${spacing.s12}px 0`,
    [responsive_exports.down("r")]: {
      padding: `${spacing.s12}px ${spacing.s16}px`
    }
  }
}), "getStyles");

var RowBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function RowBase2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const {
    container
  } = combineStyles(getStyles88(), styles25);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    ref,
    css: container
  }, rest), {
    "data-testid": "row-base",
    children
  }));
}, "RowBase"));
RowBase.displayName = "RowBase";
var ROW_BASE_TRANSITION_MS = 150;

function generateInteractiveRowStyles(theme, rowState) {
  return {
    container: {
      position: "relative",
      transition: `${ROW_BASE_TRANSITION_MS}ms color`,
      cursor: (rowState == null ? void 0 : rowState.disabled) ? "default" : "pointer",
      "& >*": {
        zIndex: 0
      },
      "&:focus": {
        outline: "none"
      },
      "&:focus-within:before": {
        borderColor: theme.colors.systemGrayscale70
      },
      "&:before": {
        content: '""',
        position: "absolute",
        top: 0,
        bottom: 0,
        left: -8,
        right: -8,
        border: "2px solid transparent",
        borderRadius: theme.radius.r8,
        transition: `${ROW_BASE_TRANSITION_MS}ms background-color`,
        transitionTimingFunction: "ease-out"
      },
      "&:active:before": {
        backgroundColor: !(rowState == null ? void 0 : rowState.disabled) ? theme.colors.systemGrayscale10 : "transparent"
      }
    }
  };
}

__name(generateInteractiveRowStyles, "generateInteractiveRowStyles");

var getStyles89 = /* @__PURE__ */__name(theme => ({
  container: __spreadProps(__spreadValues({}, theme.typography.bodyLarge2), {
    color: theme.colors.systemGrayscale70,
    transition: `color ${ROW_BASE_TRANSITION_MS}ms`,
    [responsive_exports.down("r")]: __spreadValues({}, theme.typography.bodyMedium2)
  })
}), "getStyles");

var RowTextPrimaryBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function RowTextPrimary(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const theme = useTheme();
  const {
    container
  } = combineStyles(getStyles89(theme), styles25);
  return /* @__PURE__ */jsx("span", __spreadProps(__spreadValues({
    ref,
    css: container
  }, rest), {
    children
  }));
}, "RowTextPrimary"));

var getStyles90 = /* @__PURE__ */__name(theme => ({
  container: __spreadProps(__spreadValues({}, theme.typography.bodyMedium2), {
    color: theme.colors.systemGrayscale50,
    [responsive_exports.down("r")]: __spreadValues({}, theme.typography.bodySmall2)
  })
}), "getStyles");

var RowTextSecondaryBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function RowTextSecondary(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const theme = useTheme();
  const {
    container
  } = combineStyles(getStyles90(theme), styles25);
  return /* @__PURE__ */jsx("span", __spreadProps(__spreadValues({
    ref,
    css: container
  }, rest), {
    children
  }));
}, "RowTextSecondary"));

var getStyles91 = /* @__PURE__ */__name(() => ({
  container: {
    display: "flex",
    flexDirection: "column"
  }
}), "getStyles");

var RowLayoutTextBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function RowLayoutTextBase2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const {
    container
  } = combineStyles(getStyles91(), styles25);
  return /* @__PURE__ */jsx("span", __spreadProps(__spreadValues({
    ref,
    css: container
  }, rest), {
    children
  }));
}, "RowLayoutTextBase"));
RowLayoutTextBase.displayName = "RowLayoutTextBase";

var getStyles92 = /* @__PURE__ */__name(() => ({
  container: {
    display: "flex",
    flexDirection: "row",
    paddingRight: spacing.s4
  }
}), "getStyles");

var RowLayoutLeftBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function RowLayoutLeftBase2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const {
    container
  } = combineStyles(getStyles92(), styles25);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    ref,
    css: container
  }, rest), {
    children
  }));
}, "RowLayoutLeftBase"));

var getStyles93 = /* @__PURE__ */__name(() => ({
  container: {
    textAlign: "right",
    display: "flex",
    flexDirection: "row",
    paddingLeft: spacing.s4
  }
}), "getStyles");

var RowLayoutRightBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function RowLayoutRightBase2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const {
    container
  } = combineStyles(getStyles93(), styles25);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    ref,
    css: container
  }, rest), {
    children
  }));
}, "RowLayoutRightBase"));
var selectionRowInitialValues = {
  checked: false,
  disabled: false
};
var SelectionRowContext = /*#__PURE__*/createContext(selectionRowInitialValues);
SelectionRowContext.displayName = "SelectionRowContext";

function SelectionRow(_a) {
  var _b = _a,
      {
    onClick
  } = _b,
      rest = __objRest(_b, ["onClick"]);

  const {
    checked,
    disabled
  } = rest;
  const theme = useTheme();
  const styles25 = generateInteractiveRowStyles(theme, {
    disabled
  });
  const handleClick = disabled ? void 0 : onClick;
  return /* @__PURE__ */jsx(SelectionRowContext.Provider, {
    value: {
      checked,
      disabled
    },
    children: /* @__PURE__ */jsx(RowBase, __spreadValues({
      styles: styles25,
      onClick: handleClick
    }, rest))
  });
}

__name(SelectionRow, "SelectionRow");

var CHECKBOX_SIZE = 24;

function CheckboxIcon(_ref66) {
  let {
    checked,
    disabled
  } = _ref66;
  const theme = useTheme();
  const grayscale = useIdsFeatureFlag("grayscale") !== "control";
  const fill = grayscale ? theme.colors.systemGrayscale80 : theme.colors.brandPrimaryRegular;
  const sharedProps = {
    size: CHECKBOX_SIZE
  };

  if (checked === true) {
    return disabled ? /* @__PURE__ */jsx(CheckboxDisabledSelectedIcon_default, __spreadProps(__spreadValues({}, sharedProps), {
      "data-testid": "disabled-selected"
    })) : /* @__PURE__ */jsx(CheckboxSelectedIcon_default, __spreadProps(__spreadValues({}, sharedProps), {
      fill,
      "data-testid": "selected"
    }));
  }

  if (checked === "indeterminate") {
    return disabled ? /* @__PURE__ */jsx(CheckboxDisabledIndeterminateIcon_default, __spreadProps(__spreadValues({}, sharedProps), {
      "data-testid": "disabled-indeterminate"
    })) : /* @__PURE__ */jsx(CheckboxIndeterminateIcon_default, __spreadProps(__spreadValues({}, sharedProps), {
      fill,
      "data-testid": "indeterminate"
    }));
  }

  return disabled ? /* @__PURE__ */jsx(CheckboxDisabledUnselectedIcon_default, __spreadProps(__spreadValues({}, sharedProps), {
    "data-testid": "disabled-unselected"
  })) : /* @__PURE__ */jsx(CheckboxUnselectedIcon_default, __spreadProps(__spreadValues({}, sharedProps), {
    "data-testid": "unselected"
  }));
}

__name(CheckboxIcon, "CheckboxIcon");

var ICON_CONTAINER_CLASS_NAME = "checkboxBase-checkboxContainer";

var getStyles94 = /* @__PURE__ */__name((theme, isDisabled) => ({
  container: {
    display: "inline-block",
    position: "relative",
    marginRight: spacing.s12,
    height: CHECKBOX_SIZE,
    width: CHECKBOX_SIZE,
    "&:hover": {
      cursor: isDisabled ? "not-allowed" : "inherit"
    }
  },
  input: __spreadProps(__spreadValues({}, STRETCH_OVER_RELATIVE_PARENT), {
    opacity: 0,
    outline: "none",
    "&:hover": {
      cursor: "pointer"
    }
  }),
  icon: __spreadProps(__spreadValues({}, STRETCH_OVER_RELATIVE_PARENT), {
    pointerEvents: "none",
    svg: __spreadProps(__spreadValues({}, POSITION_X_Y_CENTER), {
      position: "absolute",
      boxSizing: "content-box"
    })
  }),
  focusRing: {
    border: `2px solid ${theme.colors.systemGrayscale70}`,
    content: '""',
    display: "block",
    position: "absolute",
    top: -1,
    bottom: -1,
    left: -1,
    right: -1,
    borderRadius: "5px"
  }
}), "getStyles");

var LegacyCheckboxBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function CheckboxBase(props, ref) {
  const _a = props,
        {
    styles: styles25,
    children,
    checked,
    description,
    disabled = false,
    onChange
  } = _a,
        rest = __objRest(_a, ["styles", "children", "checked", "description", "disabled", "onChange"]);

  const theme = useTheme();
  const {
    container,
    icon,
    input,
    focusRing
  } = combineStyles(getStyles94(theme, disabled), styles25);
  const describedBy = useAriaLabel({
    description,
    describedByIds: rest["aria-describedby"]
  });
  const inputCss = [input, {
    [`&.focus-visible + .${ICON_CONTAINER_CLASS_NAME}::after`]: focusRing
  }];
  return /* @__PURE__ */jsxs("div", {
    css: container,
    children: [/* @__PURE__ */jsx("input", __spreadProps(__spreadValues(__spreadValues({
      type: "checkbox",
      css: inputCss,
      onChange: event => {
        if (disabled) return;

        if (checked === "indeterminate") {
          event.target.checked = false;
        }

        if (onChange) onChange(event);
      },
      checked: checked === true,
      disabled,
      "data-testid": "checkbox-base-input"
    }, rest), describedBy), {
      ref,
      "aria-checked": checked === "indeterminate" ? "mixed" : void 0
    })), /* @__PURE__ */jsx("div", {
      "aria-hidden": true,
      css: icon,
      "data-testid": "checkbox-custom-asset",
      className: ICON_CONTAINER_CLASS_NAME,
      children: /* @__PURE__ */jsx(CheckboxIcon, {
        checked,
        disabled
      })
    })]
  });
}, "CheckboxBase"));

var getStyles95 = /* @__PURE__ */__name(() => ({
  container: {
    marginRight: spacing.s8,
    marginTop: 1,
    flexShrink: 0,
    [responsive_exports.down("c")]: {
      marginTop: -1
    }
  },
  focusRing: {
    borderColor: "transparent"
  }
}), "getStyles");

var SelectionRowCheckbox = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function SelectionRowCheckbox2(props, ref) {
  const styles25 = getStyles95();
  const {
    checked,
    disabled
  } = useContext(SelectionRowContext);
  return /* @__PURE__ */jsx(LegacyCheckboxBase, __spreadProps(__spreadValues({}, props), {
    checked,
    disabled,
    styles: styles25,
    ref
  }));
}, "SelectionRowCheckbox"));
SelectionRowCheckbox.displayName = "SelectionRowCheckbox";

var getStyles96 = /* @__PURE__ */__name(() => ({
  container: {
    pointerEvents: "none",
    userSelect: "none",
    alignSelf: "center"
  }
}), "getStyles");

var SelectionRowLabel = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function SelectionRowLabel2(_a, ref) {
  var _b = _a,
      {
    htmlFor
  } = _b,
      rest = __objRest(_b, ["htmlFor"]);

  const {
    container
  } = getStyles96();
  return /* @__PURE__ */jsx("label", {
    css: container,
    htmlFor,
    ref,
    children: /* @__PURE__ */jsx(RowLayoutTextBase, __spreadValues({}, rest))
  });
}, "SelectionRowLabel"));
SelectionRowLabel.displayName = "SelectionRowLabel";
var SelectionRowLayoutLeft = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function SelectionRowLayoutLeft2(props, ref) {
  return /* @__PURE__ */jsx(RowLayoutLeftBase, __spreadProps(__spreadValues({}, props), {
    ref
  }));
}, "SelectionRowLayoutLeft"));
SelectionRowLayoutLeft.displayName = "SelectionRowLayoutLeft";

var getStyles97 = /* @__PURE__ */__name(() => ({
  container: {
    alignItems: "center"
  }
}), "getStyles");

var SelectionRowLayoutRight = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function SelectionRowLayoutRight2(props, ref) {
  const styles25 = getStyles97();
  return /* @__PURE__ */jsx(RowLayoutRightBase, __spreadProps(__spreadValues({}, props), {
    styles: styles25,
    ref
  }));
}, "SelectionRowLayoutRight"));
SelectionRowLayoutRight.displayName = "SelectionRowLayoutRight";
var RADIO_SIZE = 24;
var BORDER_WEIGHT = 2;
var ICON_CONTAINER_CLASS_NAME2 = "radioSelectorBase-radioContainer";

var getStyles98 = /* @__PURE__ */__name((theme, isDisabled) => ({
  container: {
    display: "inline-block",
    position: "relative",
    margin: BORDER_WEIGHT,
    height: RADIO_SIZE,
    width: RADIO_SIZE,
    "&:hover": {
      cursor: isDisabled ? "not-allowed" : "inherit"
    }
  },
  input: __spreadProps(__spreadValues({}, STRETCH_OVER_RELATIVE_PARENT), {
    opacity: 0,
    outline: "none",
    "&:hover": {
      cursor: "pointer"
    }
  }),
  icon: __spreadProps(__spreadValues({}, STRETCH_OVER_RELATIVE_PARENT), {
    pointerEvents: "none",
    svg: __spreadProps(__spreadValues({}, POSITION_X_Y_CENTER), {
      position: "absolute",
      // Necessary to override carrot app global styling
      boxSizing: "content-box",
      border: `${BORDER_WEIGHT}px solid transparent`,
      borderRadius: "50%"
    })
  }),
  focusRing: {
    borderColor: theme.colors.systemGrayscale70
  }
}), "getStyles");

var RadioSelectorBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function RadioSelectorBase2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    checked,
    disabled = false
  } = _b,
      rest = __objRest(_b, ["styles", "checked", "disabled"]);

  const theme = useTheme();
  const grayscale = useIdsFeatureFlag("grayscale") !== "control";
  const {
    input,
    icon,
    container,
    focusRing
  } = combineStyles(getStyles98(theme, disabled), styles25);
  const sharedRadioIconProps = {
    fill: grayscale ? theme.colors.systemGrayscale80 : theme.colors.brandPrimaryRegular,
    size: RADIO_SIZE
  };
  const inputCss = [input, {
    [`&.focus-visible + .${ICON_CONTAINER_CLASS_NAME2} svg`]: focusRing
  }];
  return /* @__PURE__ */jsxs("div", {
    css: container,
    children: [/* @__PURE__ */jsx(Radio, __spreadProps(__spreadValues({
      css: inputCss,
      checked,
      disabled
    }, rest), {
      ref
    })), /* @__PURE__ */jsx("span", {
      "aria-hidden": true,
      css: icon,
      className: ICON_CONTAINER_CLASS_NAME2,
      children: checked ? disabled ? /* @__PURE__ */jsx(RadioDisabledSelectedIcon_default, __spreadValues({}, sharedRadioIconProps)) : /* @__PURE__ */jsx(RadioSelectedIcon_default, __spreadValues({}, sharedRadioIconProps)) : disabled ? /* @__PURE__ */jsx(RadioDisabledUnselectedIcon_default, __spreadValues({}, sharedRadioIconProps)) : /* @__PURE__ */jsx(RadioUnselectedIcon_default, __spreadValues({}, sharedRadioIconProps))
    })]
  });
}, "RadioSelectorBase"));

var getStyles99 = /* @__PURE__ */__name(() => ({
  container: {
    marginLeft: 0,
    marginRight: spacing.s8,
    flexShrink: 0
  },
  focusRing: {
    borderColor: "transparent"
  }
}), "getStyles");

var SelectionRowRadioSelector = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function SelectionRowRadioSelector2(props, ref) {
  const styles25 = getStyles99();
  const {
    checked,
    disabled
  } = useContext(SelectionRowContext);
  return /* @__PURE__ */jsx(RadioSelectorBase, __spreadProps(__spreadValues({}, props), {
    checked,
    disabled,
    styles: styles25,
    ref
  }));
}, "SelectionRowRadioSelector"));
SelectionRowRadioSelector.displayName = "SelectionRowRadioSelector";

var getStyles100 = /* @__PURE__ */__name(() => ({
  container: {
    flexShrink: 0
  },
  focusRing: {
    borderColor: "transparent"
  }
}), "getStyles");

var SelectionRowSwitch = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function SelectionRowSwitch2(props, ref) {
  const styles25 = getStyles100();
  const {
    checked,
    disabled
  } = useContext(SelectionRowContext);
  return /* @__PURE__ */jsx(SwitchBase, __spreadProps(__spreadValues({}, props), {
    checked,
    disabled,
    styles: styles25,
    ref
  }));
}, "SelectionRowSwitch"));
SelectionRowSwitch.displayName = "SelectionRowSwitch";

function generateColorForState(theme, rowState, pantryEnabled) {
  if (pantryEnabled) {
    return rowState.disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80;
  }

  return rowState.disabled ? theme.colors.systemGrayscale30 : rowState.checked ? theme.colors.systemGrayscale70 : theme.colors.systemGrayscale50;
}

__name(generateColorForState, "generateColorForState");

var getStyles101 = /* @__PURE__ */__name((theme, context, pantryEnabled) => {
  const color = generateColorForState(theme, context, pantryEnabled);
  return {
    container: __spreadProps(__spreadValues({
      color
    }, theme.typography.bodyLarge1), {
      [responsive_exports.down("r")]: __spreadValues({}, theme.typography.bodyMedium1)
    })
  };
}, "getStyles");

var SelectionRowTextPrimary = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function SelectionRowTextPrimary2(props, ref) {
  const theme = useTheme();
  const pantryEnabled = useIsPantryEnabled();
  const context = useContext(SelectionRowContext);
  const styles25 = getStyles101(theme, context, pantryEnabled);
  return /* @__PURE__ */jsx(RowTextPrimaryBase, __spreadProps(__spreadValues({}, props), {
    styles: styles25,
    ref
  }));
}, "SelectionRowTextPrimary"));
SelectionRowTextPrimary.displayName = "SelectionRowTextPrimary";

var getStyles102 = /* @__PURE__ */__name((theme, context, pantryEnabled) => {
  const color = generateColorForState(theme, context, pantryEnabled);
  return {
    container: __spreadProps(__spreadValues({
      color
    }, theme.typography.bodyMedium2), {
      [responsive_exports.down("r")]: __spreadValues({}, theme.typography.bodySmall2)
    })
  };
}, "getStyles");

var SelectionRowTextSecondary = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function SelectionRowTextSecondary2(props, ref) {
  const theme = useTheme();
  const pantryEnabled = useIsPantryEnabled();
  const context = useContext(SelectionRowContext);
  const styles25 = getStyles102(theme, context, pantryEnabled);
  return /* @__PURE__ */jsx(RowTextSecondaryBase, __spreadProps(__spreadValues({}, props), {
    styles: styles25,
    ref
  }));
}, "SelectionRowTextSecondary"));
SelectionRowTextSecondary.displayName = "SelectionRowTextSecondary";

var getStyles103 = /* @__PURE__ */__name((theme, disabled) => ({
  container: __spreadProps(__spreadValues({
    padding: "0 11px"
  }, theme.typography.bodyMedium2), {
    ":hover": {
      backgroundColor: disabled ? "transparent" : theme.colors.systemGrayscale10,
      borderRadius: theme.radius.r8
    }
  }),
  checkbox: {
    padding: `${spacing.s12}px 0`
  }
}), "getStyles");

function MultiSelectListOptionBase(props) {
  const {
    isSelected,
    id,
    value,
    name,
    onClick,
    onKeyDown,
    disabled,
    children
  } = props;
  const {
    handleMenuKeyDown
  } = useSelectMenuContext();
  const theme = useTheme();
  const baseStyles16 = getStyles103(theme, disabled);
  const styles25 = combineStyles(baseStyles16, props.styles);
  return /* @__PURE__ */jsx("li", {
    css: [styles25.container, {
      "> div": styles25.checkbox
    }],
    children: /* @__PURE__ */jsx(SelectionRow, {
      checked: isSelected,
      onClick,
      disabled,
      children: /* @__PURE__ */jsxs(SelectionRowLayoutLeft, {
        children: [/* @__PURE__ */jsx(SelectionRowCheckbox, {
          value,
          id,
          name,
          onKeyDown: event => {
            handleMenuKeyDown(event);
            onKeyDown(event);
          }
        }), /* @__PURE__ */jsx(SelectionRowLabel, {
          htmlFor: id,
          children: /* @__PURE__ */jsx(SelectionRowTextPrimary, {
            children
          })
        })]
      })
    }, id)
  });
}

__name(MultiSelectListOptionBase, "MultiSelectListOptionBase");

var getStyles104 = /* @__PURE__ */__name(() => ({
  container: {},
  checkbox: {}
}), "getStyles");

function MultiSelectListOption(props) {
  const styles25 = getStyles104();
  return /* @__PURE__ */jsx(MultiSelectListOptionBase, __spreadProps(__spreadValues({}, props), {
    styles: styles25
  }));
}

__name(MultiSelectListOption, "MultiSelectListOption");

var ServiceMessageA_exports = {};

__export(ServiceMessageA_exports, {
  ServiceMessageA: () => ServiceMessageA3
});

function ServiceMessageCloseButton(props) {
  return /* @__PURE__ */jsx(ServiceMessageButtonBase, __spreadValues({
    icon: CloseIcon_default
  }, props));
}

__name(ServiceMessageCloseButton, "ServiceMessageCloseButton");

function ServiceMessageMoreButton(props) {
  return /* @__PURE__ */jsx(ServiceMessageButtonBase, __spreadValues({
    icon: ChevronRightIcon_default
  }, props));
}

__name(ServiceMessageMoreButton, "ServiceMessageMoreButton");

var getStyles105 = /* @__PURE__ */__name((_ref67) => {
  let {
    theme
  } = _ref67;
  return {
    paragraph: __spreadProps(__spreadValues({}, theme.typography.subtitle), {
      color: theme.colors.systemGrayscale80,
      maxWidth: `${responsive_exports.breakpoints.c.max}px`,
      margin: 0,
      paddingTop: 2
    })
  };
}, "getStyles");

function ServiceMessageInfoBase(props) {
  const theme = useTheme();
  const {
    paragraph
  } = getStyles105({
    theme
  });
  return /* @__PURE__ */jsx("p", {
    role: "region",
    "aria-live": "polite",
    css: paragraph,
    children: props.children
  });
}

__name(ServiceMessageInfoBase, "ServiceMessageInfoBase");

ServiceMessageInfoBase.displayName = "ServiceMessageInfoBase";

var getStyles106 = /* @__PURE__ */__name(theme => ({
  container: __spreadProps(__spreadValues({}, theme.typography.bodyRegular), {
    color: theme.colors.systemGrayscale80,
    maxWidth: `${responsive_exports.breakpoints.c.max}px`
  })
}), "getStyles");

function ServiceMessageDescriptionBase(_ref68) {
  let {
    children,
    styles: propsStyles
  } = _ref68;
  const theme = useTheme();
  const {
    container
  } = combineStyles(getStyles106(theme), propsStyles);
  return /* @__PURE__ */jsx("div", {
    css: container,
    children
  });
}

__name(ServiceMessageDescriptionBase, "ServiceMessageDescriptionBase");

var styles21 = {
  flexGrow: 1
};

function Left3(props) {
  const {
    children
  } = props;
  return /* @__PURE__ */jsx("div", {
    style: styles21,
    children
  });
}

__name(Left3, "Left");

var styles22 = {
  marginLeft: `${spacing.s8}px`,
  alignSelf: "baseline"
};

function Right3(props) {
  const {
    children
  } = props;
  return /* @__PURE__ */jsx("div", {
    css: styles22,
    children
  });
}

__name(Right3, "Right");

var ServiceMessageA = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function ServiceMessageA2(props, ref) {
  const {
    styles: styles25
  } = props;
  return /* @__PURE__ */jsx(ServiceMessageBase, __spreadProps(__spreadValues({
    ref
  }, props), {
    styles: {
      container: [styles25 == null ? void 0 : styles25.container, {
        minHeight: 40
      }]
    },
    icon: InformationIcon_default
  }));
}, "ServiceMessageA"));
ServiceMessageA.displayName = "ServiceMessageA";
var ServiceMessageA3 = {
  Left: Left3,
  Right: Right3,
  ServiceMessage: ServiceMessageA,
  ServiceMessageCloseButton,
  ServiceMessageInfo: ServiceMessageInfoBase,
  ServiceMessageMoreButton,
  ServiceMessageDescription: ServiceMessageDescriptionBase
};

var getStyles107 = /* @__PURE__ */__name(theme => ({
  container: __spreadValues({
    backgroundColor: theme.colors.systemGrayscale80,
    color: theme.colors.systemGrayscale00
  }, elevation.high.depth),
  arrow: {
    fill: theme.colors.systemGrayscale80
  }
}), "getStyles");

var TooltipBase = forwardRefWithAs( /* @__PURE__ */__name(function TooltipBase2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    placement,
    as: componentType = "div",
    title
  } = _b,
      rest = __objRest(_b, ["styles", "placement", "as", "title"]);

  const theme = useTheme();
  const combinedStyles = combineStyles(getStyles107(theme), styles25);
  const tooltip = useTooltipState({
    placement
  });
  tooltip.unstable_popoverStyles.display = void 0;
  return /* @__PURE__ */jsxs(Fragment$1, {
    children: [/* @__PURE__ */jsx(TooltipReference, __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, rest), {
      as: componentType
    }), tooltip), {
      ref
    })), /* @__PURE__ */jsxs(Tooltip$1, __spreadProps(__spreadValues({}, tooltip), {
      css: [combinedStyles.container, !tooltip.visible && A11Y.visuallyHidden],
      unstable_portal: false,
      hidden: void 0,
      children: [/* @__PURE__ */jsx(TooltipArrow, __spreadProps(__spreadValues({}, tooltip), {
        css: combinedStyles.arrow,
        "aria-hidden": true
      })), title]
    }))]
  });
}, "TooltipBase"));
TooltipBase.displayName = "TooltipBase";

var getStyles108 = /* @__PURE__ */__name(theme => ({
  container: __spreadProps(__spreadValues({
    backgroundColor: theme.colors.systemGrayscale80,
    color: theme.colors.systemGrayscale00,
    padding: spacing.s12,
    borderRadius: theme.radius.r8
  }, theme.typography.bodyMedium1), {
    maxWidth: 256
  }),
  arrow: {
    fill: theme.colors.systemGrayscale80
  }
}), "getStyles");

var Tooltip = forwardRefWithAs( /* @__PURE__ */__name(function Tooltip2(props, ref) {
  const theme = useTheme();
  const styles25 = getStyles108(theme);
  return /* @__PURE__ */jsx(TooltipBase, __spreadProps(__spreadValues({
    styles: styles25
  }, props), {
    ref
  }));
}, "Tooltip"));
Tooltip.displayName = "Tooltip";
var CriticalServiceMessageA = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function CriticalServiceMessage(props, ref) {
  var _a;

  const theme = useTheme();
  return /* @__PURE__ */jsx(ServiceMessageBase, __spreadProps(__spreadValues({}, props), {
    styles: {
      container: [(_a = props.styles) == null ? void 0 : _a.container, {
        backgroundColor: theme.colors.systemDetrimentalLight,
        minHeight: 40
      }]
    },
    icon: IssueIcon_default,
    color: "systemDetrimentalDark",
    ref
  }));
}, "CriticalServiceMessage"));
CriticalServiceMessageA.displayName = "CriticalServiceMessageA";

var STYLES3 = /* @__PURE__ */__name((theme, inverseColorPalette) => ({
  content: {
    lineHeight: 1
  },
  outerRing: {
    backgroundColor: inverseColorPalette ? theme.colors.systemGrayscale80 : theme.colors.systemGrayscale00,
    opacity: 0.24,
    height: 24,
    width: 24,
    borderRadius: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    '[data-hovered="true"] &': {
      opacity: 0.54
    },
    '[data-focus-visible="true"] &': {
      opacity: 0.84
    },
    '[data-pressed="true"] &': {
      opacity: 0.84
    }
  },
  stack: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 24,
    width: 24
  },
  icon: {
    alignSelf: "center",
    justifySelf: "center",
    display: "flex",
    pointerEvents: "none"
  },
  commonAbsolutePositioning: {
    position: "absolute"
  }
}), "STYLES");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function MediaControlButton2(_a, ref) {
  var _b = _a,
      {
    toggledOffIcon: ToggledOffIcon,
    toggledOnIcon: ToggledOnIcon,
    disabled,
    styles: styleOverrides,
    accessibleLabel,
    inverseColorPalette
  } = _b,
      rest = __objRest(_b, ["toggledOffIcon", "toggledOnIcon", "disabled", "styles", "accessibleLabel", "inverseColorPalette"]);

  const theme = useTheme();
  const getStyles168 = STYLES3(theme, inverseColorPalette || false);
  const combinedStyles = combineStyles(getStyles168, styleOverrides);

  function Icons(_ref69) {
    let {
      isFocusVisible,
      isSelected
    } = _ref69;
    const Icon = isSelected ? ToggledOnIcon : ToggledOffIcon;
    return /* @__PURE__ */jsxs("span", {
      css: combinedStyles.stack,
      children: [/* @__PURE__ */jsx("span", {
        css: [combinedStyles.outerRing, combinedStyles.commonAbsolutePositioning],
        "data-focus-visible": isFocusVisible
      }), /* @__PURE__ */jsx(Icon, {
        "data-testid": isSelected ? "toggled-on-icon" : "toggled-off-icon",
        size: 16,
        color: inverseColorPalette ? "systemGrayscale00" : "systemGrayscale80",
        opacity: 1,
        css: [combinedStyles.icon, combinedStyles.commonAbsolutePositioning]
      })]
    });
  }

  __name(Icons, "Icons");

  return /* @__PURE__ */jsx(FocusRing, {
    borderRadiusOfComponent: "100%",
    contrastBorder: true,
    offsetOverride: "2px",
    children: /* @__PURE__ */jsx(ToggleButtonCore, __spreadProps(__spreadValues({
      "aria-label": accessibleLabel,
      styles: combinedStyles,
      disabled
    }, rest), {
      ref,
      children: state => {
        if ((state == null ? void 0 : state.isSelected) !== void 0) {
          return /* @__PURE__ */jsx(Icons, {
            isFocusVisible: state == null ? void 0 : state.isFocusVisible,
            isSelected: state.isSelected
          });
        }

        return null;
      }
    }))
  });
}, "MediaControlButton"));

var getStyles109 = /* @__PURE__ */__name((theme, removeBorder, stringValue) => ({
  badge: {
    transform: !stringValue ? "translate(0, 4%)" : void 0,
    pointerEvents: "none"
  },
  container: __spreadProps(__spreadValues({
    alignItems: "center",
    border: removeBorder ? "none" : `2px solid ${theme.colors.systemGrayscale00}`,
    borderRadius: theme.radius.round,
    boxSizing: "content-box",
    color: theme.colors.systemGrayscale00,
    display: "flex",
    height: `${spacing.s16}px`,
    justifyContent: "center",
    padding: stringValue ? `0 ${spacing.s4}px` : void 0,
    position: "relative",
    whiteSpace: "nowrap",
    width: stringValue ? void 0 : `${spacing.s16}px`
  }, theme.typography.accentEmphasized), {
    [responsive_exports.up("r")]: {
      height: `20px`,
      padding: stringValue ? `0 ${spacing.s8}px` : void 0,
      width: stringValue ? void 0 : `20px`
    }
  }),
  dot: {
    "&:before": {
      backgroundColor: theme.colors.systemGrayscale00,
      borderRadius: theme.radius.round,
      content: '""',
      height: `${spacing.s4}px`,
      left: "50%",
      position: "absolute",
      top: "50%",
      transform: "translate(-50%, -50%)",
      width: `${spacing.s4}px`,
      [responsive_exports.up("r")]: {
        height: `${spacing.s8}px`,
        width: `${spacing.s8}px`
      }
    }
  }
}), "getStyles");

var BadgeBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function BadgeBase2(_a, ref) {
  var _b = _a,
      {
    description,
    removeBorder,
    styles: styles25,
    value
  } = _b,
      props = __objRest(_b, ["description", "removeBorder", "styles", "value"]);

  const theme = useTheme();
  const {
    badge,
    container,
    dot
  } = combineStyles(getStyles109(theme, removeBorder, typeof value === "string"), styles25);
  const ariaLabel = useAriaLabel({
    description: description || String(value)
  });

  if (!value || typeof value === "number" && value > 99) {
    return /* @__PURE__ */jsx("div", __spreadValues(__spreadValues({
      ref,
      css: [container, dot]
    }, ariaLabel), props));
  }

  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    ref,
    css: container
  }, props), {
    children: /* @__PURE__ */jsx("span", {
      css: badge,
      children: value
    })
  }));
}, "BadgeBase"));

var getStyles110 = /* @__PURE__ */__name(() => ({
  layout: {
    position: "relative",
    display: "inline-block"
  }
}), "getStyles");

var BadgeLayoutBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function BadgeLayoutBase2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    contentDescriptorId,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "contentDescriptorId", "children"]);

  const badgeDescriptor = {
    id: contentDescriptorId
  };
  const siblingDescriptor = useAriaLabel({
    describedByIds: contentDescriptorId
  });
  const {
    layout
  } = combineStyles(getStyles110(), styles25);
  const withAccessibleLabels = Children.map(children, (child, index) => {
    if ( /*#__PURE__*/isValidElement(child)) {
      if (index === 0) {
        return /*#__PURE__*/cloneElement(child, __spreadValues({}, siblingDescriptor));
      }

      return /*#__PURE__*/cloneElement(child, badgeDescriptor);
    }

    return child;
  });
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    ref,
    css: layout
  }, rest), {
    children: withAccessibleLabels
  }));
}, "BadgeLayoutBase"));

var getStyles111 = /* @__PURE__ */__name(theme => ({
  backdrop: __spreadValues({
    backgroundColor: addAlphaToHex(theme.colors.systemGrayscale70, 0.24),
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    position: "fixed"
  }, elevation.high.depth)
}), "getStyles");

var BackdropBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function BackdropBase2(_a, ref) {
  var _b = _a,
      {
    children,
    styles: styles25
  } = _b,
      rest = __objRest(_b, ["children", "styles"]);

  const theme = useTheme();
  const {
    backdrop
  } = combineStyles(getStyles111(theme), styles25);
  return /* @__PURE__ */jsx(DialogBackdrop, __spreadProps(__spreadValues({
    ref,
    css: backdrop
  }, rest), {
    children
  }));
}, "BackdropBase"));
var Backdrop = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function Backdrop2(_a, ref) {
  var _b = _a,
      {
    children
  } = _b,
      rest = __objRest(_b, ["children"]);

  return /* @__PURE__ */jsx(BackdropBase, __spreadProps(__spreadValues({
    ref
  }, rest), {
    children
  }));
}, "Backdrop"));

var getStyles112 = /* @__PURE__ */__name((theme, grayscale) => ({
  popover: {
    outline: "none",
    zIndex: layers.l1,
    position: "relative",
    "&:has(*.focus-visible)::after": {
      border: `2px solid ${theme.colors.systemGrayscale80}`,
      content: '""',
      display: "block",
      position: "absolute",
      top: -4,
      bottom: -4,
      left: -4,
      right: -4,
      borderRadius: theme.radius.r12
    },
    margin: spacing.s4
  },
  coachmark: __spreadProps(__spreadValues({
    backgroundColor: grayscale ? theme.colors.systemGrayscale80 : theme.colors.brandHighlightDark,
    padding: "11px 12px 13px",
    borderRadius: theme.radius.r8,
    color: theme.colors.systemGrayscale00,
    maxWidth: 256,
    [responsive_exports.up("r")]: {
      maxWidth: 320
    }
  }, theme.typography.bodyMedium1), {
    display: "grid",
    gap: spacing.s8,
    gridTemplateColumns: "auto 24px",
    alignItems: "center"
  }),
  arrow: {
    fill: grayscale ? theme.colors.systemGrayscale80 : theme.colors.brandHighlightDark
  },
  content: {
    "&:focus": {
      outline: "none"
    }
  },
  closeButton: {
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "center"
  },
  closeButtonContent: {
    display: "flex"
  },
  closeButtonFocusRing: {
    border: "1px solid white",
    borderRadius: theme.radius.r8
  }
}), "getStyles");

var CoachmarkDisclosure = forwardRefWithAs( /* @__PURE__ */__name(function CoachmarkDisclosure2(_a, ref) {
  var _b = _a,
      {
    toggle,
    as = "button"
  } = _b,
      rest = __objRest(_b, ["toggle", "as"]);

  const disclosureRef = useRef(null);
  const mergedRef = useMergeRefs(disclosureRef, ref);
  useEffect(() => {
    var _a2;

    (_a2 = disclosureRef.current) == null ? void 0 : _a2.removeAttribute("aria-controls");
  });
  return /* @__PURE__ */jsx(PopoverDisclosure, __spreadProps(__spreadValues({}, rest), {
    ref: mergedRef,
    as,
    "aria-controls": void 0,
    "aria-expanded": void 0,
    "aria-haspopup": void 0
  }));
}, "CoachmarkDisclosure"));
CoachmarkDisclosure.displayName = "CoachmarkDisclosure";
var Coachmark = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function Coachmark2(props, ref) {
  const _a = props,
        {
    styles: styleOverrides,
    children,
    closeLabel
  } = _a,
        coachmarkState = __objRest(_a, ["styles", "children", "closeLabel"]);

  const theme = useTheme();
  const grayscale = useIdsFeatureFlag("grayscale") !== "control";
  const styles25 = combineStyles(getStyles112(theme, grayscale), styleOverrides);
  const {
    id
  } = unstable_useId(props);
  return /* @__PURE__ */jsx(Popover, __spreadProps(__spreadValues({}, coachmarkState), {
    hideOnEsc: true,
    hideOnClickOutside: false,
    css: styles25.popover,
    role: void 0,
    "aria-labelledby": id,
    children: /* @__PURE__ */jsxs("div", {
      css: styles25 == null ? void 0 : styles25.coachmark,
      children: [/* @__PURE__ */jsx(PopoverArrow, __spreadProps(__spreadValues({
        size: 20,
        css: styles25.arrow
      }, coachmarkState), {
        "aria-hidden": true
      })), /* @__PURE__ */jsx("div", {
        tabIndex: 0,
        css: styles25.content,
        ref,
        id,
        children
      }), /* @__PURE__ */jsx(ButtonCore, {
        styles: {
          button: styles25.closeButton,
          content: styles25.closeButtonContent,
          focusRing: styles25.closeButtonFocusRing
        },
        onClick: coachmarkState.hide,
        "aria-label": closeLabel,
        children: /* @__PURE__ */jsx(CloseIcon_default, {
          "aria-hidden": true,
          size: 24,
          color: "systemGrayscale00"
        })
      })]
    })
  }));
}, "Coachmark"));
Coachmark.displayName = "Coachmark";
var ICON_CONTAINER_CLASS_NAME3 = "checkboxBase-checkboxContainer";

var getStyles113 = /* @__PURE__ */__name(() => ({
  container: {
    display: "inline-block",
    position: "relative",
    marginRight: spacing.s12,
    height: CHECKBOX_SIZE,
    width: CHECKBOX_SIZE
  },
  input: __spreadProps(__spreadValues({}, STRETCH_OVER_RELATIVE_PARENT), {
    display: "flex",
    alignItems: "center",
    gap: spacing.s8,
    outline: "none",
    "&:hover": {
      cursor: "pointer"
    }
  }),
  focusRing: {
    top: -1,
    bottom: -1,
    left: -1,
    right: -1,
    borderRadius: "5px"
  },
  disabled: {
    cursor: "not-allowed"
  }
}), "getStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function CheckboxBase3(props, ref) {
  const _a = props,
        {
    styles: styles25,
    children,
    checked,
    description,
    disabled = false,
    isDisabled,
    onChange,
    isIndeterminate
  } = _a,
        rest = __objRest(_a, ["styles", "children", "checked", "description", "disabled", "isDisabled", "onChange", "isIndeterminate"]);

  const {
    container,
    input,
    focusRing,
    disabled: disabledCss
  } = combineStyles(getStyles113(), styles25);
  const describedBy = useAriaLabel({
    description,
    describedByIds: rest["aria-describedby"]
  });
  const css = [input, {
    '&[data-focused="true"]::after': focusRing,
    '&[data-disabled="true"]': disabledCss
  }];
  const indeterminate = checked === "indeterminate" || isIndeterminate;
  const isChecked = checked === true && !indeterminate;
  return /* @__PURE__ */jsx("div", {
    css: container,
    className: ICON_CONTAINER_CLASS_NAME3,
    children: /* @__PURE__ */jsx(CheckboxCore, __spreadProps(__spreadValues(__spreadValues({
      css,
      "data-testid": "checkbox-base-input",
      isDisabled: disabled || isDisabled,
      isSelected: isChecked,
      isIndeterminate: indeterminate,
      onChange
    }, describedBy), rest), {
      ref,
      children: /* @__PURE__ */jsx(CheckboxIcon, {
        checked: indeterminate ? "indeterminate" : isChecked,
        disabled: disabled || isDisabled
      })
    }))
  });
}, "CheckboxBase"));
var TRANSITION_DURATION_MS2 = 200;

var getStyles114 = /* @__PURE__ */__name(theme => ({
  input: __spreadProps(__spreadValues({
    WebkitAppearance: "none",
    backgroundColor: theme.colors.systemGrayscale00,
    borderRadius: theme.radius.r8,
    boxShadow: `0 0 0 1px ${theme.colors.systemGrayscale40}`,
    boxSizing: "border-box",
    border: "none",
    color: theme.colors.systemGrayscale70,
    margin: 0,
    padding: "8px 12px 8px 12px",
    position: "relative",
    touchAction: "manipulation",
    transition: `box-shadow ${TRANSITION_DURATION_MS2}ms ease-in-out`,
    width: "100%",
    flexGrow: 1
  }, theme.typography.bodyMedium2), {
    "::placeholder": {
      color: theme.colors.systemGrayscale60
    }
  }),
  focusRing: {
    outline: "none",
    boxShadow: `0 0 0 2px ${theme.colors.systemGrayscale70}`
  },
  hover: {
    boxShadow: `0 0 0 1px ${theme.colors.systemGrayscale50}`
  },
  disabled: {
    cursor: "default",
    boxShadow: `0 0 0 1px ${theme.colors.systemGrayscale20}`,
    backgroundColor: theme.colors.systemGrayscale10,
    color: theme.colors.systemGrayscale30
  },
  invalid: {
    boxShadow: `0 0 0 1px ${theme.colors.systemDetrimentalRegular}`,
    backgroundColor: theme.colors.systemDetrimentalLight
  },
  invalidHover: {
    boxShadow: `0 0 0 1px ${theme.colors.systemDetrimentalDark}`
  },
  invalidFocus: {
    boxShadow: `0 0 0 2px ${theme.colors.systemDetrimentalRegular}`
  }
}), "getStyles");

var InputBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function InputBase2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    children,
    invalid = false,
    instructionInputTextId
  } = _b,
      rest = __objRest(_b, ["styles", "children", "invalid", "instructionInputTextId"]);

  const describedBy = useAriaLabel({
    describedByIds: instructionInputTextId
  });
  const theme = useTheme();
  const {
    input,
    focusRing,
    disabled,
    hover,
    invalid: invalidStyle,
    invalidHover,
    invalidFocus
  } = combineStyles(getStyles114(theme), styles25);
  const css = [input, {
    '&[data-hovered="true"]': hover,
    '&[data-focused="true"]': focusRing,
    "&.invalid": invalidStyle,
    '&.invalid[data-hovered="true"]': invalidHover,
    '&.invalid[data-focused="true"]': invalidFocus,
    '&[data-disabled="true"]': disabled
  }];
  return /* @__PURE__ */jsx(InputCore, __spreadValues(__spreadValues({
    ref,
    className: invalid ? "invalid" : void 0,
    css,
    autoComplete: "off"
  }, describedBy), rest));
}, "InputBase"));
InputBase.displayName = "InputBase";
var NUM_ICONS = 4;
var BASE_UNIT = 24;
var ANIMATION_DURATION_MS2 = 3e3;
var CURVE = "cubic-bezier(0.76, 0, 0.24, 1)";
var parentStyles = {
  position: "relative",
  width: `calc(${BASE_UNIT * 5}px)`,
  height: `calc(${BASE_UNIT * 2}px)`,
  display: "flex",
  alignItems: "center"
};

function generateIconArray(icon) {
  const baseArray = [/* @__PURE__ */jsx("div", {}), /* @__PURE__ */jsx("div", {}), /* @__PURE__ */jsx("div", {}), /* @__PURE__ */jsx("div", {})];
  baseArray.fill(icon || /* @__PURE__ */jsx(InstacartIcon_default, {}));
  return baseArray;
}

__name(generateIconArray, "generateIconArray");

function useGenerateSharedStyles(_ref70) {
  let {
    foregroundColor
  } = _ref70;
  const theme = useTheme();
  const fgColor = foregroundColor ? theme.colors[foregroundColor] : theme.colors.systemGrayscale30;
  const rotateInZ = keyframes`
    0%, 100% {
      transform: translateX(0);
      z-index: 0;
      fill: ${addAlphaToHex(fgColor, 0.4)};
    }

    25% {
      transform: translateX(${BASE_UNIT * 2}px) scale(2);
      fill: ${addAlphaToHex(fgColor, 1)};
      z-index: 1;
    }

    50% {
      transform: translateX(${BASE_UNIT * 4}px);
      fill: ${addAlphaToHex(fgColor, 0.4)};
      z-index: 0;
    }

    75% {
      transform: translateX(${BASE_UNIT * 2}px);
      z-index: -1;
      fill: ${addAlphaToHex(fgColor, 0)};
    }
  `;
  return {
    position: "absolute",
    animationName: rotateInZ,
    animationDirection: "reverse",
    animationTimingFunction: CURVE,
    animationIterationCount: "infinite",
    animationDuration: `${ANIMATION_DURATION_MS2}ms`
  };
}

__name(useGenerateSharedStyles, "useGenerateSharedStyles");

function generateAnimationDelayProperty(index) {
  const animationDelayInMs = ANIMATION_DURATION_MS2 * (index / NUM_ICONS);
  return {
    animationDelay: `-${animationDelayInMs}ms`
  };
}

__name(generateAnimationDelayProperty, "generateAnimationDelayProperty");

var loadingIconsMap = {
  cart: /* @__PURE__ */jsx(CartIcon_default, {}),
  delivery: /* @__PURE__ */jsx(DeliveryIcon_default, {}),
  instacart: /* @__PURE__ */jsx(InstacartIcon_default, {}),
  pickup: /* @__PURE__ */jsx(PickupIcon_default, {}),
  store: /* @__PURE__ */jsx(StoreIcon_default, {}),
  placeholder: /* @__PURE__ */jsx(PlaceholderDarkIcon_default, {})
};

function useIcons(props) {
  const {
    loadingIcons
  } = useIdsConfig();

  if ("icons" in props) {
    return props.icons || [];
  }

  if ("icon" in props) {
    return generateIconArray(props.icon);
  }

  if (loadingIcons) {
    return loadingIcons.map(iconName => loadingIconsMap[iconName]);
  }

  return generateIconArray();
}

__name(useIcons, "useIcons");

function LoadingGenericAnimation(props) {
  const resolvedIcons = useIcons(props);
  const sharedStyles = useGenerateSharedStyles({
    foregroundColor: props.foregroundColor
  });
  return /* @__PURE__ */jsx("div", {
    css: parentStyles,
    children: resolvedIcons.map((resolvedIcon, index) => {
      const css = __spreadValues(__spreadValues({}, sharedStyles), generateAnimationDelayProperty(index));

      return /* @__PURE__ */jsx(SVGIcon, {
        component: resolvedIcon,
        size: BASE_UNIT,
        css
      }, index);
    })
  });
}

__name(LoadingGenericAnimation, "LoadingGenericAnimation");

var getStyles115 = /* @__PURE__ */__name(theme => ({
  backdrop: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent"
  },
  container: {
    width: "225px",
    height: "80px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.colors.systemGrayscale00,
    borderRadius: theme.radius.r12
  }
}), "getStyles");

var LoadingGenericBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function LoadingGenericBase2(props, ref) {
  const {
    animationProps,
    backdropProps,
    label,
    styles: styles25
  } = splitProps(props);
  const theme = useTheme();
  const ariaDialog = useDialogState({
    baseId: label,
    visible: true,
    modal: false
  });
  const ariaLoading = useAriaLoading();
  const ariaLabel = useAriaLabel({
    description: label
  });
  const {
    backdrop,
    container
  } = combineStyles(getStyles115(theme), styles25);
  return /* @__PURE__ */jsx(Backdrop, __spreadProps(__spreadValues(__spreadValues({
    ref,
    css: backdrop
  }, backdropProps), ariaDialog), {
    children: /* @__PURE__ */jsx(Dialog, __spreadProps(__spreadValues(__spreadValues(__spreadValues({
      css: container
    }, ariaDialog), ariaLoading), ariaLabel), {
      hideOnClickOutside: false,
      hideOnEsc: false,
      children: /* @__PURE__ */jsx(LoadingGenericAnimation, __spreadValues({}, animationProps))
    }))
  }));
}, "LoadingGenericBase"));

function splitProps(_a) {
  var _b = _a,
      {
    styles: styles25,
    label = "loading"
  } = _b,
      rest = __objRest(_b, ["styles", "label"]);

  let animationProps = {};
  let backdropProps = rest;

  if ("icon" in rest) {
    const _a2 = rest,
          {
      icon
    } = _a2,
          nonAnimationProps = __objRest(_a2, ["icon"]);

    animationProps = {
      icon
    };
    backdropProps = nonAnimationProps;
  } else if ("icons" in rest) {
    const _b2 = rest,
          {
      icons
    } = _b2,
          nonAnimationProps = __objRest(_b2, ["icons"]);

    animationProps = {
      icons
    };
    backdropProps = nonAnimationProps;
  }

  return {
    animationProps,
    backdropProps,
    label,
    styles: styles25
  };
}

__name(splitProps, "splitProps");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function LoadingGenericOnEnter2(_a, ref) {
  var rest = __objRest(_a, []);

  return /* @__PURE__ */jsx(LoadingGenericBase, __spreadValues({
    ref,
    "data-testid": "loading-generic-on-enter"
  }, rest));
}, "LoadingGenericOnEnter"));

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function LoadingGenericOnExit2(_a, ref) {
  var rest = __objRest(_a, []);

  const styles25 = {
    backdrop: {
      backgroundColor: addAlphaToHex("000", 0.24)
    }
  };
  return /* @__PURE__ */jsx(LoadingGenericBase, __spreadValues({
    ref,
    styles: styles25,
    "data-testid": "loading-generic-on-exit"
  }, rest));
}, "LoadingGenericOnExit"));

function LoadingSpinner(_ref71) {
  let {
    color = "systemGrayscale80"
  } = _ref71;
  return /* @__PURE__ */jsx("div", {
    css: {
      boxSizing: "border-box",
      height: spacing.s32,
      width: spacing.s32,
      padding: spacing.s4
    },
    children: /* @__PURE__ */jsx(SpinnerSvg, {
      color
    })
  });
}

__name(LoadingSpinner, "LoadingSpinner");

var dash = keyframes`
  0% {
    stroke-dasharray: 5, 100;
    stroke-dashoffset: 0;
  }
  30% {
    stroke-dasharray: 60, 100;
  }
  100% {
    stroke-dasharray: 5, 100;
    stroke-dashoffset: -99;
  }
`;
var spin = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

function SpinnerSvg(_ref72) {
  let {
    color
  } = _ref72;
  const theme = useTheme();
  const stroke = theme.colors[color];
  return /* @__PURE__ */jsx("svg", {
    viewBox: "0 0 50 50",
    css: {
      animation: `${spin} 1s cubic-bezier(0.17, 0.17, 0.83, 0.83) infinite`,
      height: "100%",
      transformOrigin: "center",
      width: "100%"
    },
    children: /* @__PURE__ */jsx("circle", {
      cx: "25",
      cy: "25",
      r: "20",
      fill: "none",
      strokeWidth: "4",
      pathLength: "100",
      css: {
        stroke,
        strokeLinecap: "square",
        animation: `${dash} 1s cubic-bezier(0.70, 0.00, 0.30, 1.00) infinite`
      }
    })
  });
}

__name(SpinnerSvg, "SpinnerSvg");

var getStyles116 = /* @__PURE__ */__name((theme, steps) => ({
  stepContainer: {
    display: "grid",
    gap: spacing.s8,
    width: "100%",
    gridTemplateColumns: `repeat(${steps}, 1fr)`
  },
  step: {
    height: spacing.s4,
    backgroundColor: theme.colors.systemGrayscale20,
    borderRadius: theme.radius.r8,
    position: "relative"
  },
  filledStep: {
    borderRadius: theme.radius.r8,
    position: "absolute",
    backgroundColor: theme.colors.brandPrimaryRegular,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    content: '""',
    transition: "width linear 200ms",
    width: 0
  }
}), "getStyles");

var SteppedProgressIndicatorBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function SteppedProgressIndicatorBase2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    value,
    max,
    accessibleLabel
  } = _b,
      rest = __objRest(_b, ["styles", "value", "max", "accessibleLabel"]);

  const theme = useTheme();
  const {
    stepContainer,
    step,
    filledStep
  } = combineStyles(getStyles116(theme, max), styles25);
  return /* @__PURE__ */jsxs("div", {
    children: [/* @__PURE__ */jsxs("label", {
      css: A11Y.visuallyHidden,
      children: [accessibleLabel, /* @__PURE__ */jsx("progress", __spreadValues({
        tabIndex: -1,
        ref,
        value,
        max
      }, rest))]
    }), /* @__PURE__ */jsx("div", {
      "aria-hidden": true,
      css: stepContainer,
      children: [...Array(max)].map((_, index) => /* @__PURE__ */jsx("span", {
        css: [step, {
          "&::after": [filledStep, index <= value - 1 && {
            width: `100%`
          }, // Safeguard against Math.trunc(-0.8) = -0
          value >= 0 && index === Math.trunc(value) && {
            width: `${(value - Math.floor(value)) * 100}%`
          }]
        }]
      }, `${index}-of-${max}`))
    })]
  });
}, "SteppedProgressIndicatorBase"));

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function SteppedProgressIndicator2(props, ref) {
  return /* @__PURE__ */jsx(SteppedProgressIndicatorBase, __spreadProps(__spreadValues({}, props), {
    ref
  }));
}, "SteppedProgressIndicator"));
var TabContext = /*#__PURE__*/createContext({});

function Tabs(_ref73) {
  let {
    children,
    tabState
  } = _ref73;
  return /* @__PURE__ */jsx(TabContext.Provider, {
    value: tabState,
    children
  });
}

__name(Tabs, "Tabs");

function useResolvedElement(subscriber, refOrElement) {
  var lastReportRef = useRef(null);
  var refOrElementRef = useRef(null);
  refOrElementRef.current = refOrElement;
  var cbElementRef = useRef(null);
  useEffect(function () {
    evaluateSubscription();
  });
  var evaluateSubscription = useCallback(function () {
    var cbElement = cbElementRef.current;
    var refOrElement2 = refOrElementRef.current;
    var element = cbElement ? cbElement : refOrElement2 ? refOrElement2 instanceof Element ? refOrElement2 : refOrElement2.current : null;

    if (lastReportRef.current && lastReportRef.current.element === element && lastReportRef.current.subscriber === subscriber) {
      return;
    }

    if (lastReportRef.current && lastReportRef.current.cleanup) {
      lastReportRef.current.cleanup();
    }

    lastReportRef.current = {
      element,
      subscriber,
      // Only calling the subscriber, if there's an actual element to report.
      // Setting cleanup to undefined unless a subscriber returns one, as an existing cleanup function would've been just called.
      cleanup: element ? subscriber(element) : void 0
    };
  }, [subscriber]);
  useEffect(function () {
    return function () {
      if (lastReportRef.current && lastReportRef.current.cleanup) {
        lastReportRef.current.cleanup();
        lastReportRef.current = null;
      }
    };
  }, []);
  return useCallback(function (element) {
    cbElementRef.current = element;
    evaluateSubscription();
  }, [evaluateSubscription]);
}

__name(useResolvedElement, "useResolvedElement");

function extractSize(entry, boxProp, sizeType) {
  if (!entry[boxProp]) {
    if (boxProp === "contentBoxSize") {
      return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
    }

    return void 0;
  }

  return entry[boxProp][0] ? entry[boxProp][0][sizeType] : // TS complains about this, because the RO entry type follows the spec and does not reflect Firefox's current
  // behaviour of returning objects instead of arrays for `borderBoxSize` and `contentBoxSize`.
  // @ts-ignore
  entry[boxProp][sizeType];
}

__name(extractSize, "extractSize");

function useResizeObserver(opts) {
  if (opts === void 0) {
    opts = {};
  }

  var onResize = opts.onResize;
  var onResizeRef = useRef(void 0);
  onResizeRef.current = onResize;
  var round2 = opts.round || Math.round;
  var resizeObserverRef = useRef();

  var _useState = useState({
    width: void 0,
    height: void 0
  }),
      size = _useState[0],
      setSize = _useState[1];

  var didUnmount = useRef(false);
  useEffect(function () {
    didUnmount.current = false;
    return function () {
      didUnmount.current = true;
    };
  }, []);
  var previous = useRef({
    width: void 0,
    height: void 0
  });
  var refCallback = useResolvedElement(useCallback(function (element) {
    if (!resizeObserverRef.current || resizeObserverRef.current.box !== opts.box || resizeObserverRef.current.round !== round2) {
      resizeObserverRef.current = {
        box: opts.box,
        round: round2,
        instance: new ResizeObserver(function (entries) {
          var entry = entries[0];
          var boxProp = opts.box === "border-box" ? "borderBoxSize" : opts.box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
          var reportedWidth = extractSize(entry, boxProp, "inlineSize");
          var reportedHeight = extractSize(entry, boxProp, "blockSize");
          var newWidth = reportedWidth ? round2(reportedWidth) : void 0;
          var newHeight = reportedHeight ? round2(reportedHeight) : void 0;

          if (previous.current.width !== newWidth || previous.current.height !== newHeight) {
            var newSize = {
              width: newWidth,
              height: newHeight
            };
            previous.current.width = newWidth;
            previous.current.height = newHeight;

            if (onResizeRef.current) {
              onResizeRef.current(newSize);
            } else {
              if (!didUnmount.current) {
                setSize(newSize);
              }
            }
          }
        })
      };
    }

    resizeObserverRef.current.instance.observe(element, {
      box: opts.box
    });
    return function () {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.instance.unobserve(element);
      }
    };
  }, [opts.box, round2]), opts.ref);
  return useMemo(function () {
    return {
      ref: refCallback,
      width: size.width,
      height: size.height
    };
  }, [refCallback, size.width, size.height]);
}

__name(useResizeObserver, "useResizeObserver");

var getStyles117 = /* @__PURE__ */__name(theme => ({
  container: {
    position: "relative"
  },
  tabList: {
    display: "flex",
    [responsive_exports.up("r")]: {
      borderBottom: `solid 1px ${theme.colors.systemGrayscale20}`
    }
  },
  highlight: {
    borderRadius: 1,
    position: "absolute",
    bottom: 0,
    height: 2,
    background: theme.colors.systemGrayscale70,
    transitionDuration: "0.25s",
    transitionProperty: "width, transform"
  }
}), "getStyles");

function TabList(props) {
  var _a, _b;

  const theme = useTheme();
  const styles25 = combineStyles(getStyles117(theme), props.styles);
  const tab = useContext(TabContext);
  const currentItem = (_a = tab.items) == null ? void 0 : _a.find((_ref74) => {
    let {
      id
    } = _ref74;
    return id === tab.selectedId;
  });
  const ref = useRef(null);
  const getHighlightWidth = useCallback(() => {
    var _a2;

    return (_a2 = currentItem == null ? void 0 : currentItem.ref.current) == null ? void 0 : _a2.getBoundingClientRect().width;
  }, [currentItem == null ? void 0 : currentItem.ref]);
  const [highlightWidth, setHighlightWidth] = useState(getHighlightWidth());
  useEffect(() => {
    setHighlightWidth(getHighlightWidth());
  }, [getHighlightWidth]);
  useResizeObserver({
    ref,
    onResize: /* @__PURE__ */__name(() => setHighlightWidth(getHighlightWidth()), "onResize")
  });
  return /* @__PURE__ */jsxs("div", {
    css: styles25.container,
    children: [/* @__PURE__ */jsx(TabList$1, __spreadValues(__spreadValues({
      ref,
      css: styles25.tabList
    }, tab), props)), /* @__PURE__ */jsx("div", {
      css: [styles25.highlight, {
        width: highlightWidth,
        transform: `translateX(${(_b = currentItem == null ? void 0 : currentItem.ref.current) == null ? void 0 : _b.offsetLeft}px)`
      }]
    })]
  });
}

__name(TabList, "TabList");

function Tab(_a) {
  var _b = _a,
      {
    children
  } = _b,
      rest = __objRest(_b, ["children"]);

  const theme = useTheme();
  const tab = useContext(TabContext);
  return /* @__PURE__ */jsx(Tab$1, __spreadProps(__spreadValues(__spreadValues({}, tab), rest), {
    type: "button",
    css: [theme.typography.bodyMedium2, {
      position: "relative",
      borderRadius: theme.radius.r8,
      height: spacing.s40,
      background: theme.colors.systemGrayscale00,
      color: theme.colors.systemGrayscale50,
      minWidth: 96,
      maxWidth: 180,
      border: "0",
      marginLeft: spacing.s8,
      // When there are only two tabs the margin between tabs should be 12px instead of 8px
      "&:first-of-type:nth-last-of-type(2) + *": {
        marginLeft: spacing.s12
      },
      "&:first-of-type": {
        marginLeft: 0
      },
      '&[aria-selected="true"]': __spreadValues({
        borderRadius: `${theme.radius.r8}px ${theme.radius.r8}px 1px 1px`,
        color: theme.colors.systemGrayscale70
      }, theme.typography.bodyMedium1),
      "&:hover": {
        background: theme.colors.systemGrayscale10,
        cursor: "pointer"
      },
      "&:active": {
        background: theme.colors.systemGrayscale20
      },
      "&:focus": {
        outline: "none"
      },
      "&.focus-visible::after": {
        borderRadius: `${theme.radius.r12}px ${theme.radius.r12}px ${theme.radius.r4}px ${theme.radius.r4}px`,
        content: '""',
        display: "block",
        position: "absolute",
        top: -4,
        right: -4,
        bottom: -4,
        left: -4,
        border: `solid 2px ${theme.colors.systemGrayscale70}`
      },
      [responsive_exports.down("c")]: {
        flex: 1,
        minWidth: 64,
        maxWidth: 132
      },
      span: {
        display: "block",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
      }
    }],
    children: /* @__PURE__ */jsx("span", {
      children
    })
  }));
}

__name(Tab, "Tab");

function TabPanel(props) {
  const tab = useContext(TabContext);
  const theme = useTheme();
  return /* @__PURE__ */jsx(TabPanel$1, __spreadProps(__spreadValues(__spreadValues({}, tab), props), {
    css: {
      position: "relative",
      "&:focus": {
        outline: "none"
      },
      "&.focus-visible::after": {
        borderRadius: theme.radius.r12,
        content: '""',
        display: "block",
        position: "absolute",
        top: -4,
        right: -4,
        bottom: -4,
        left: -4,
        border: `solid 2px ${theme.colors.systemGrayscale70}`
      }
    }
  }));
}

__name(TabPanel, "TabPanel");

var TOAST_PADDING = spacing.s12;

function clamp2(v, min, max) {
  return Math.max(min, Math.min(v, max));
}

__name(clamp2, "clamp");

var V = {
  toVector(v, fallback) {
    if (v === void 0) v = fallback;
    return Array.isArray(v) ? v : [v, v];
  },

  add(v1, v2) {
    return [v1[0] + v2[0], v1[1] + v2[1]];
  },

  sub(v1, v2) {
    return [v1[0] - v2[0], v1[1] - v2[1]];
  },

  addTo(v1, v2) {
    v1[0] += v2[0];
    v1[1] += v2[1];
  },

  subTo(v1, v2) {
    v1[0] -= v2[0];
    v1[1] -= v2[1];
  }

};

function rubberband(distance, dimension, constant) {
  if (dimension === 0 || Math.abs(dimension) === Infinity) return Math.pow(distance, constant * 5);
  return distance * dimension * constant / (dimension + constant * distance);
}

__name(rubberband, "rubberband");

function rubberbandIfOutOfBounds(position, min, max) {
  let constant = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.15;
  if (constant === 0) return clamp2(position, min, max);
  if (position < min) return -rubberband(min - position, max - min, constant) + min;
  if (position > max) return +rubberband(position - max, max - min, constant) + max;
  return position;
}

__name(rubberbandIfOutOfBounds, "rubberbandIfOutOfBounds");

function computeRubberband(bounds, _ref75, _ref76) {
  let [Vx, Vy] = _ref75;
  let [Rx, Ry] = _ref76;
  const [[X0, X1], [Y0, Y1]] = bounds;
  return [rubberbandIfOutOfBounds(Vx, X0, X1, Rx), rubberbandIfOutOfBounds(Vy, Y0, Y1, Ry)];
}

__name(computeRubberband, "computeRubberband");

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

__name(_toPrimitive, "_toPrimitive");

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

__name(_toPropertyKey, "_toPropertyKey");

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

__name(_defineProperty, "_defineProperty");

function ownKeys(e3, r2) {
  var t = Object.keys(e3);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function (r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

__name(ownKeys, "ownKeys");

function _objectSpread2(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys(Object(t), true).forEach(function (r3) {
      _defineProperty(e3, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }

  return e3;
}

__name(_objectSpread2, "_objectSpread2");

var EVENT_TYPE_MAP = {
  pointer: {
    start: "down",
    change: "move",
    end: "up"
  },
  mouse: {
    start: "down",
    change: "move",
    end: "up"
  },
  touch: {
    start: "start",
    change: "move",
    end: "end"
  },
  gesture: {
    start: "start",
    change: "change",
    end: "end"
  }
};

function capitalize(string) {
  if (!string) return "";
  return string[0].toUpperCase() + string.slice(1);
}

__name(capitalize, "capitalize");

var actionsWithoutCaptureSupported = ["enter", "leave"];

function hasCapture() {
  let capture = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  let actionKey = arguments.length > 1 ? arguments[1] : undefined;
  return capture && !actionsWithoutCaptureSupported.includes(actionKey);
}

__name(hasCapture, "hasCapture");

function toHandlerProp(device) {
  let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  let capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const deviceProps = EVENT_TYPE_MAP[device];
  const actionKey = deviceProps ? deviceProps[action] || action : action;
  return "on" + capitalize(device) + capitalize(actionKey) + (hasCapture(capture, actionKey) ? "Capture" : "");
}

__name(toHandlerProp, "toHandlerProp");

var pointerCaptureEvents = ["gotpointercapture", "lostpointercapture"];

function parseProp(prop) {
  let eventKey = prop.substring(2).toLowerCase();
  const passive = !!~eventKey.indexOf("passive");
  if (passive) eventKey = eventKey.replace("passive", "");
  const captureKey = pointerCaptureEvents.includes(eventKey) ? "capturecapture" : "capture";
  const capture = !!~eventKey.indexOf(captureKey);
  if (capture) eventKey = eventKey.replace("capture", "");
  return {
    device: eventKey,
    capture,
    passive
  };
}

__name(parseProp, "parseProp");

function toDomEventType(device) {
  let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  const deviceProps = EVENT_TYPE_MAP[device];
  const actionKey = deviceProps ? deviceProps[action] || action : action;
  return device + actionKey;
}

__name(toDomEventType, "toDomEventType");

function isTouch(event) {
  return "touches" in event;
}

__name(isTouch, "isTouch");

function getPointerType(event) {
  if (isTouch(event)) return "touch";
  if ("pointerType" in event) return event.pointerType;
  return "mouse";
}

__name(getPointerType, "getPointerType");

function getCurrentTargetTouchList(event) {
  return Array.from(event.touches).filter(e3 => {
    var _event$currentTarget, _event$currentTarget$;

    return e3.target === event.currentTarget || ((_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || (_event$currentTarget$ = _event$currentTarget.contains) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$.call(_event$currentTarget, e3.target));
  });
}

__name(getCurrentTargetTouchList, "getCurrentTargetTouchList");

function getTouchList(event) {
  return event.type === "touchend" || event.type === "touchcancel" ? event.changedTouches : event.targetTouches;
}

__name(getTouchList, "getTouchList");

function getValueEvent(event) {
  return isTouch(event) ? getTouchList(event)[0] : event;
}

__name(getValueEvent, "getValueEvent");

function touchIds(event) {
  return getCurrentTargetTouchList(event).map(touch => touch.identifier);
}

__name(touchIds, "touchIds");

function pointerId(event) {
  const valueEvent = getValueEvent(event);
  return isTouch(event) ? valueEvent.identifier : valueEvent.pointerId;
}

__name(pointerId, "pointerId");

function pointerValues(event) {
  const valueEvent = getValueEvent(event);
  return [valueEvent.clientX, valueEvent.clientY];
}

__name(pointerValues, "pointerValues");

function getEventDetails(event) {
  const payload = {};
  if ("buttons" in event) payload.buttons = event.buttons;

  if ("shiftKey" in event) {
    const {
      shiftKey,
      altKey,
      metaKey,
      ctrlKey
    } = event;
    Object.assign(payload, {
      shiftKey,
      altKey,
      metaKey,
      ctrlKey
    });
  }

  return payload;
}

__name(getEventDetails, "getEventDetails");

function call(v) {
  if (typeof v === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return v(...args);
  } else {
    return v;
  }
}

__name(call, "call");

function noop() {}

__name(noop, "noop");

function chain() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  if (fns.length === 0) return noop;
  if (fns.length === 1) return fns[0];
  return function () {
    let result;

    for (const fn4 of fns) {
      result = fn4.apply(this, arguments) || result;
    }

    return result;
  };
}

__name(chain, "chain");

function assignDefault(value, fallback) {
  return Object.assign({}, fallback, value || {});
}

__name(assignDefault, "assignDefault");

var BEFORE_LAST_KINEMATICS_DELAY = 32;

var _Engine = class _Engine2 {
  constructor(ctrl, args, key) {
    this.ctrl = ctrl;
    this.args = args;
    this.key = key;

    if (!this.state) {
      this.state = {};
      this.computeValues([0, 0]);
      this.computeInitial();
      if (this.init) this.init();
      this.reset();
    }
  }

  get state() {
    return this.ctrl.state[this.key];
  }

  set state(state) {
    this.ctrl.state[this.key] = state;
  }

  get shared() {
    return this.ctrl.state.shared;
  }

  get eventStore() {
    return this.ctrl.gestureEventStores[this.key];
  }

  get timeoutStore() {
    return this.ctrl.gestureTimeoutStores[this.key];
  }

  get config() {
    return this.ctrl.config[this.key];
  }

  get sharedConfig() {
    return this.ctrl.config.shared;
  }

  get handler() {
    return this.ctrl.handlers[this.key];
  }

  reset() {
    const {
      state,
      shared,
      ingKey,
      args
    } = this;
    shared[ingKey] = state._active = state.active = state._blocked = state._force = false;
    state._step = [false, false];
    state.intentional = false;
    state._movement = [0, 0];
    state._distance = [0, 0];
    state._direction = [0, 0];
    state._delta = [0, 0];
    state._bounds = [[-Infinity, Infinity], [-Infinity, Infinity]];
    state.args = args;
    state.axis = void 0;
    state.memo = void 0;
    state.elapsedTime = state.timeDelta = 0;
    state.direction = [0, 0];
    state.distance = [0, 0];
    state.overflow = [0, 0];
    state._movementBound = [false, false];
    state.velocity = [0, 0];
    state.movement = [0, 0];
    state.delta = [0, 0];
    state.timeStamp = 0;
  }

  start(event) {
    const state = this.state;
    const config = this.config;

    if (!state._active) {
      this.reset();
      this.computeInitial();
      state._active = true;
      state.target = event.target;
      state.currentTarget = event.currentTarget;
      state.lastOffset = config.from ? call(config.from, state) : state.offset;
      state.offset = state.lastOffset;
      state.startTime = state.timeStamp = event.timeStamp;
    }
  }

  computeValues(values) {
    const state = this.state;
    state._values = values;
    state.values = this.config.transform(values);
  }

  computeInitial() {
    const state = this.state;
    state._initial = state._values;
    state.initial = state.values;
  }

  compute(event) {
    const {
      state,
      config,
      shared
    } = this;
    state.args = this.args;
    let dt = 0;

    if (event) {
      state.event = event;
      if (config.preventDefault && event.cancelable) state.event.preventDefault();
      state.type = event.type;
      shared.touches = this.ctrl.pointerIds.size || this.ctrl.touchIds.size;
      shared.locked = !!document.pointerLockElement;
      Object.assign(shared, getEventDetails(event));
      shared.down = shared.pressed = shared.buttons % 2 === 1 || shared.touches > 0;
      dt = event.timeStamp - state.timeStamp;
      state.timeStamp = event.timeStamp;
      state.elapsedTime = state.timeStamp - state.startTime;
    }

    if (state._active) {
      const _absoluteDelta = state._delta.map(Math.abs);

      V.addTo(state._distance, _absoluteDelta);
    }

    if (this.axisIntent) this.axisIntent(event);
    const [_m0, _m1] = state._movement;
    const [t0, t1] = config.threshold;
    const {
      _step,
      values
    } = state;

    if (config.hasCustomTransform) {
      if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && values[0];
      if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && values[1];
    } else {
      if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && Math.sign(_m0) * t0;
      if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && Math.sign(_m1) * t1;
    }

    state.intentional = _step[0] !== false || _step[1] !== false;
    if (!state.intentional) return;
    const movement = [0, 0];

    if (config.hasCustomTransform) {
      const [v0, v1] = values;
      movement[0] = _step[0] !== false ? v0 - _step[0] : 0;
      movement[1] = _step[1] !== false ? v1 - _step[1] : 0;
    } else {
      movement[0] = _step[0] !== false ? _m0 - _step[0] : 0;
      movement[1] = _step[1] !== false ? _m1 - _step[1] : 0;
    }

    if (this.restrictToAxis && !state._blocked) this.restrictToAxis(movement);
    const previousOffset = state.offset;
    const gestureIsActive = state._active && !state._blocked || state.active;

    if (gestureIsActive) {
      state.first = state._active && !state.active;
      state.last = !state._active && state.active;
      state.active = shared[this.ingKey] = state._active;

      if (event) {
        if (state.first) {
          if ("bounds" in config) state._bounds = call(config.bounds, state);
          if (this.setup) this.setup();
        }

        state.movement = movement;
        this.computeOffset();
      }
    }

    const [ox, oy] = state.offset;
    const [[x0, x1], [y0, y1]] = state._bounds;
    state.overflow = [ox < x0 ? -1 : ox > x1 ? 1 : 0, oy < y0 ? -1 : oy > y1 ? 1 : 0];
    state._movementBound[0] = state.overflow[0] ? state._movementBound[0] === false ? state._movement[0] : state._movementBound[0] : false;
    state._movementBound[1] = state.overflow[1] ? state._movementBound[1] === false ? state._movement[1] : state._movementBound[1] : false;
    const rubberband2 = state._active ? config.rubberband || [0, 0] : [0, 0];
    state.offset = computeRubberband(state._bounds, state.offset, rubberband2);
    state.delta = V.sub(state.offset, previousOffset);
    this.computeMovement();

    if (gestureIsActive && (!state.last || dt > BEFORE_LAST_KINEMATICS_DELAY)) {
      state.delta = V.sub(state.offset, previousOffset);
      const absoluteDelta = state.delta.map(Math.abs);
      V.addTo(state.distance, absoluteDelta);
      state.direction = state.delta.map(Math.sign);
      state._direction = state._delta.map(Math.sign);

      if (!state.first && dt > 0) {
        state.velocity = [absoluteDelta[0] / dt, absoluteDelta[1] / dt];
        state.timeDelta = dt;
      }
    }
  }

  emit() {
    const state = this.state;
    const shared = this.shared;
    const config = this.config;
    if (!state._active) this.clean();
    if ((state._blocked || !state.intentional) && !state._force && !config.triggerAllEvents) return;
    const memo = this.handler(_objectSpread2(_objectSpread2(_objectSpread2({}, shared), state), {}, {
      [this.aliasKey]: state.values
    }));
    if (memo !== void 0) state.memo = memo;
  }

  clean() {
    this.eventStore.clean();
    this.timeoutStore.clean();
  }

};

__name(_Engine, "Engine");

var Engine = _Engine;

function selectAxis(_ref77, threshold) {
  let [dx, dy] = _ref77;
  const absDx = Math.abs(dx);
  const absDy = Math.abs(dy);

  if (absDx > absDy && absDx > threshold) {
    return "x";
  }

  if (absDy > absDx && absDy > threshold) {
    return "y";
  }

  return void 0;
}

__name(selectAxis, "selectAxis");

var _CoordinatesEngine = class _CoordinatesEngine2 extends Engine {
  constructor() {
    super(...arguments);

    _defineProperty(this, "aliasKey", "xy");
  }

  reset() {
    super.reset();
    this.state.axis = void 0;
  }

  init() {
    this.state.offset = [0, 0];
    this.state.lastOffset = [0, 0];
  }

  computeOffset() {
    this.state.offset = V.add(this.state.lastOffset, this.state.movement);
  }

  computeMovement() {
    this.state.movement = V.sub(this.state.offset, this.state.lastOffset);
  }

  axisIntent(event) {
    const state = this.state;
    const config = this.config;

    if (!state.axis && event) {
      const threshold = typeof config.axisThreshold === "object" ? config.axisThreshold[getPointerType(event)] : config.axisThreshold;
      state.axis = selectAxis(state._movement, threshold);
    }

    state._blocked = (config.lockDirection || !!config.axis) && !state.axis || !!config.axis && config.axis !== state.axis;
  }

  restrictToAxis(v) {
    if (this.config.axis || this.config.lockDirection) {
      switch (this.state.axis) {
        case "x":
          v[1] = 0;
          break;

        case "y":
          v[0] = 0;
          break;
      }
    }
  }

};

__name(_CoordinatesEngine, "CoordinatesEngine");

var CoordinatesEngine = _CoordinatesEngine;

var identity2 = /* @__PURE__ */__name(v => v, "identity");

var DEFAULT_RUBBERBAND = 0.15;
var commonConfigResolver = {
  enabled() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return value;
  },

  eventOptions(value, _k, config) {
    return _objectSpread2(_objectSpread2({}, config.shared.eventOptions), value);
  },

  preventDefault() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return value;
  },

  triggerAllEvents() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return value;
  },

  rubberband() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    switch (value) {
      case true:
        return [DEFAULT_RUBBERBAND, DEFAULT_RUBBERBAND];

      case false:
        return [0, 0];

      default:
        return V.toVector(value);
    }
  },

  from(value) {
    if (typeof value === "function") return value;
    if (value != null) return V.toVector(value);
  },

  transform(value, _k, config) {
    const transform = value || config.shared.transform;
    this.hasCustomTransform = !!transform;

    if (process.env.NODE_ENV === "development") {
      const originalTransform = transform || identity2;
      return v => {
        const r2 = originalTransform(v);

        if (!isFinite(r2[0]) || !isFinite(r2[1])) {
          console.warn(`[@use-gesture]: config.transform() must produce a valid result, but it was: [${r2[0]},${[1]}]`);
        }

        return r2;
      };
    }

    return transform || identity2;
  },

  threshold(value) {
    return V.toVector(value, 0);
  }

};

if (process.env.NODE_ENV === "development") {
  Object.assign(commonConfigResolver, {
    domTarget(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`domTarget\` option has been renamed to \`target\`.`);
      }

      return NaN;
    },

    lockDirection(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`lockDirection\` option has been merged with \`axis\`. Use it as in \`{ axis: 'lock' }\``);
      }

      return NaN;
    },

    initial(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`initial\` option has been renamed to \`from\`.`);
      }

      return NaN;
    }

  });
}

var DEFAULT_AXIS_THRESHOLD = 0;

var coordinatesConfigResolver = _objectSpread2(_objectSpread2({}, commonConfigResolver), {}, {
  axis(_v, _k, _ref78) {
    let {
      axis
    } = _ref78;
    this.lockDirection = axis === "lock";
    if (!this.lockDirection) return axis;
  },

  axisThreshold() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AXIS_THRESHOLD;
    return value;
  },

  bounds() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (typeof value === "function") {
      return state => coordinatesConfigResolver.bounds(value(state));
    }

    if ("current" in value) {
      return () => value.current;
    }

    if (typeof HTMLElement === "function" && value instanceof HTMLElement) {
      return value;
    }

    const {
      left = -Infinity,
      right = Infinity,
      top = -Infinity,
      bottom = Infinity
    } = value;
    return [[left, right], [top, bottom]];
  }

});

var KEYS_DELTA_MAP = {
  ArrowRight: /* @__PURE__ */__name(function (displacement) {
    let factor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return [displacement * factor, 0];
  }, "ArrowRight"),
  ArrowLeft: /* @__PURE__ */__name(function (displacement) {
    let factor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return [-1 * displacement * factor, 0];
  }, "ArrowLeft"),
  ArrowUp: /* @__PURE__ */__name(function (displacement) {
    let factor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return [0, -1 * displacement * factor];
  }, "ArrowUp"),
  ArrowDown: /* @__PURE__ */__name(function (displacement) {
    let factor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return [0, displacement * factor];
  }, "ArrowDown")
};

var _DragEngine = class _DragEngine2 extends CoordinatesEngine {
  constructor() {
    super(...arguments);

    _defineProperty(this, "ingKey", "dragging");
  }

  reset() {
    super.reset();
    const state = this.state;
    state._pointerId = void 0;
    state._pointerActive = false;
    state._keyboardActive = false;
    state._preventScroll = false;
    state._delayed = false;
    state.swipe = [0, 0];
    state.tap = false;
    state.canceled = false;
    state.cancel = this.cancel.bind(this);
  }

  setup() {
    const state = this.state;

    if (state._bounds instanceof HTMLElement) {
      const boundRect = state._bounds.getBoundingClientRect();

      const targetRect = state.currentTarget.getBoundingClientRect();
      const _bounds = {
        left: boundRect.left - targetRect.left + state.offset[0],
        right: boundRect.right - targetRect.right + state.offset[0],
        top: boundRect.top - targetRect.top + state.offset[1],
        bottom: boundRect.bottom - targetRect.bottom + state.offset[1]
      };
      state._bounds = coordinatesConfigResolver.bounds(_bounds);
    }
  }

  cancel() {
    const state = this.state;
    if (state.canceled) return;
    state.canceled = true;
    state._active = false;
    setTimeout(() => {
      this.compute();
      this.emit();
    }, 0);
  }

  setActive() {
    this.state._active = this.state._pointerActive || this.state._keyboardActive;
  }

  clean() {
    this.pointerClean();
    this.state._pointerActive = false;
    this.state._keyboardActive = false;
    super.clean();
  }

  pointerDown(event) {
    const config = this.config;
    const state = this.state;
    if (event.buttons != null && (Array.isArray(config.pointerButtons) ? !config.pointerButtons.includes(event.buttons) : config.pointerButtons !== -1 && config.pointerButtons !== event.buttons)) return;
    const ctrlIds = this.ctrl.setEventIds(event);

    if (config.pointerCapture) {
      event.target.setPointerCapture(event.pointerId);
    }

    if (ctrlIds && ctrlIds.size > 1 && state._pointerActive) return;
    this.start(event);
    this.setupPointer(event);
    state._pointerId = pointerId(event);
    state._pointerActive = true;
    this.computeValues(pointerValues(event));
    this.computeInitial();

    if (config.preventScrollAxis && getPointerType(event) !== "mouse") {
      state._active = false;
      this.setupScrollPrevention(event);
    } else if (config.delay > 0) {
      this.setupDelayTrigger(event);

      if (config.triggerAllEvents) {
        this.compute(event);
        this.emit();
      }
    } else {
      this.startPointerDrag(event);
    }
  }

  startPointerDrag(event) {
    const state = this.state;
    state._active = true;
    state._preventScroll = true;
    state._delayed = false;
    this.compute(event);
    this.emit();
  }

  pointerMove(event) {
    const state = this.state;
    const config = this.config;
    if (!state._pointerActive) return;
    const id = pointerId(event);
    if (state._pointerId !== void 0 && id !== state._pointerId) return;

    const _values = pointerValues(event);

    if (document.pointerLockElement === event.target) {
      state._delta = [event.movementX, event.movementY];
    } else {
      state._delta = V.sub(_values, state._values);
      this.computeValues(_values);
    }

    V.addTo(state._movement, state._delta);
    this.compute(event);

    if (state._delayed && state.intentional) {
      this.timeoutStore.remove("dragDelay");
      state.active = false;
      this.startPointerDrag(event);
      return;
    }

    if (config.preventScrollAxis && !state._preventScroll) {
      if (state.axis) {
        if (state.axis === config.preventScrollAxis || config.preventScrollAxis === "xy") {
          state._active = false;
          this.clean();
          return;
        } else {
          this.timeoutStore.remove("startPointerDrag");
          this.startPointerDrag(event);
          return;
        }
      } else {
        return;
      }
    }

    this.emit();
  }

  pointerUp(event) {
    this.ctrl.setEventIds(event);

    try {
      if (this.config.pointerCapture && event.target.hasPointerCapture(event.pointerId)) {
        ;
        event.target.releasePointerCapture(event.pointerId);
      }
    } catch (_unused) {
      if (process.env.NODE_ENV === "development") {
        console.warn(`[@use-gesture]: If you see this message, it's likely that you're using an outdated version of \`@react-three/fiber\`. 

Please upgrade to the latest version.`);
      }
    }

    const state = this.state;
    const config = this.config;
    if (!state._active || !state._pointerActive) return;
    const id = pointerId(event);
    if (state._pointerId !== void 0 && id !== state._pointerId) return;
    this.state._pointerActive = false;
    this.setActive();
    this.compute(event);
    const [dx, dy] = state._distance;
    state.tap = dx <= config.tapsThreshold && dy <= config.tapsThreshold;

    if (state.tap && config.filterTaps) {
      state._force = true;
    } else {
      const [_dx, _dy] = state._delta;
      const [_mx, _my] = state._movement;
      const [svx, svy] = config.swipe.velocity;
      const [sx, sy] = config.swipe.distance;
      const sdt = config.swipe.duration;

      if (state.elapsedTime < sdt) {
        const _vx = Math.abs(_dx / state.timeDelta);

        const _vy = Math.abs(_dy / state.timeDelta);

        if (_vx > svx && Math.abs(_mx) > sx) state.swipe[0] = Math.sign(_dx);
        if (_vy > svy && Math.abs(_my) > sy) state.swipe[1] = Math.sign(_dy);
      }
    }

    this.emit();
  }

  pointerClick(event) {
    if (!this.state.tap && event.detail > 0) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  setupPointer(event) {
    const config = this.config;
    const device = config.device;

    if (process.env.NODE_ENV === "development") {
      try {
        if (device === "pointer" && config.preventScrollDelay === void 0) {
          const currentTarget = "uv" in event ? event.sourceEvent.currentTarget : event.currentTarget;
          const style = window.getComputedStyle(currentTarget);

          if (style.touchAction === "auto") {
            console.warn(`[@use-gesture]: The drag target has its \`touch-action\` style property set to \`auto\`. It is recommended to add \`touch-action: 'none'\` so that the drag gesture behaves correctly on touch-enabled devices. For more information read this: https://use-gesture.netlify.app/docs/extras/#touch-action.

This message will only show in development mode. It won't appear in production. If this is intended, you can ignore it.`, currentTarget);
          }
        }
      } catch (_unused2) {}
    }

    if (config.pointerLock) {
      event.currentTarget.requestPointerLock();
    }

    if (!config.pointerCapture) {
      this.eventStore.add(this.sharedConfig.window, device, "change", this.pointerMove.bind(this));
      this.eventStore.add(this.sharedConfig.window, device, "end", this.pointerUp.bind(this));
      this.eventStore.add(this.sharedConfig.window, device, "cancel", this.pointerUp.bind(this));
    }
  }

  pointerClean() {
    if (this.config.pointerLock && document.pointerLockElement === this.state.currentTarget) {
      document.exitPointerLock();
    }
  }

  preventScroll(event) {
    if (this.state._preventScroll && event.cancelable) {
      event.preventDefault();
    }
  }

  setupScrollPrevention(event) {
    this.state._preventScroll = false;
    persistEvent(event);
    const remove = this.eventStore.add(this.sharedConfig.window, "touch", "change", this.preventScroll.bind(this), {
      passive: false
    });
    this.eventStore.add(this.sharedConfig.window, "touch", "end", remove);
    this.eventStore.add(this.sharedConfig.window, "touch", "cancel", remove);
    this.timeoutStore.add("startPointerDrag", this.startPointerDrag.bind(this), this.config.preventScrollDelay, event);
  }

  setupDelayTrigger(event) {
    this.state._delayed = true;
    this.timeoutStore.add("dragDelay", () => {
      this.state._step = [0, 0];
      this.startPointerDrag(event);
    }, this.config.delay);
  }

  keyDown(event) {
    const deltaFn = KEYS_DELTA_MAP[event.key];

    if (deltaFn) {
      const state = this.state;
      const factor = event.shiftKey ? 10 : event.altKey ? 0.1 : 1;
      this.start(event);
      state._delta = deltaFn(this.config.keyboardDisplacement, factor);
      state._keyboardActive = true;
      V.addTo(state._movement, state._delta);
      this.compute(event);
      this.emit();
    }
  }

  keyUp(event) {
    if (!(event.key in KEYS_DELTA_MAP)) return;
    this.state._keyboardActive = false;
    this.setActive();
    this.compute(event);
    this.emit();
  }

  bind(bindFunction) {
    const device = this.config.device;
    bindFunction(device, "start", this.pointerDown.bind(this));

    if (this.config.pointerCapture) {
      bindFunction(device, "change", this.pointerMove.bind(this));
      bindFunction(device, "end", this.pointerUp.bind(this));
      bindFunction(device, "cancel", this.pointerUp.bind(this));
      bindFunction("lostPointerCapture", "", this.pointerUp.bind(this));
    }

    if (this.config.keys) {
      bindFunction("key", "down", this.keyDown.bind(this));
      bindFunction("key", "up", this.keyUp.bind(this));
    }

    if (this.config.filterTaps) {
      bindFunction("click", "", this.pointerClick.bind(this), {
        capture: true,
        passive: false
      });
    }
  }

};

__name(_DragEngine, "DragEngine");

var DragEngine = _DragEngine;

function persistEvent(event) {
  "persist" in event && typeof event.persist === "function" && event.persist();
}

__name(persistEvent, "persistEvent");

var isBrowser = typeof window !== "undefined" && window.document && window.document.createElement;

function supportsTouchEvents() {
  return isBrowser && "ontouchstart" in window;
}

__name(supportsTouchEvents, "supportsTouchEvents");

function isTouchScreen() {
  return supportsTouchEvents() || isBrowser && window.navigator.maxTouchPoints > 1;
}

__name(isTouchScreen, "isTouchScreen");

function supportsPointerEvents() {
  return isBrowser && "onpointerdown" in window;
}

__name(supportsPointerEvents, "supportsPointerEvents");

function supportsPointerLock() {
  return isBrowser && "exitPointerLock" in window.document;
}

__name(supportsPointerLock, "supportsPointerLock");

function supportsGestureEvents() {
  try {
    return "constructor" in GestureEvent;
  } catch (e3) {
    return false;
  }
}

__name(supportsGestureEvents, "supportsGestureEvents");

var SUPPORT = {
  isBrowser,
  gesture: supportsGestureEvents(),
  touch: supportsTouchEvents(),
  touchscreen: isTouchScreen(),
  pointer: supportsPointerEvents(),
  pointerLock: supportsPointerLock()
};
var DEFAULT_PREVENT_SCROLL_DELAY = 250;
var DEFAULT_DRAG_DELAY = 180;
var DEFAULT_SWIPE_VELOCITY = 0.5;
var DEFAULT_SWIPE_DISTANCE = 50;
var DEFAULT_SWIPE_DURATION = 250;
var DEFAULT_KEYBOARD_DISPLACEMENT = 10;
var DEFAULT_DRAG_AXIS_THRESHOLD = {
  mouse: 0,
  touch: 0,
  pen: 8
};

var dragConfigResolver = _objectSpread2(_objectSpread2({}, coordinatesConfigResolver), {}, {
  device(_v, _k, _ref79) {
    let {
      pointer: {
        touch = false,
        lock = false,
        mouse = false
      } = {}
    } = _ref79;
    this.pointerLock = lock && SUPPORT.pointerLock;
    if (SUPPORT.touch && touch) return "touch";
    if (this.pointerLock) return "mouse";
    if (SUPPORT.pointer && !mouse) return "pointer";
    if (SUPPORT.touch) return "touch";
    return "mouse";
  },

  preventScrollAxis(value, _k, _ref80) {
    let {
      preventScroll
    } = _ref80;
    this.preventScrollDelay = typeof preventScroll === "number" ? preventScroll : preventScroll || preventScroll === void 0 && value ? DEFAULT_PREVENT_SCROLL_DELAY : void 0;
    if (!SUPPORT.touchscreen || preventScroll === false) return void 0;
    return value ? value : preventScroll !== void 0 ? "y" : void 0;
  },

  pointerCapture(_v, _k, _ref81) {
    let {
      pointer: {
        capture = true,
        buttons = 1,
        keys = true
      } = {}
    } = _ref81;
    this.pointerButtons = buttons;
    this.keys = keys;
    return !this.pointerLock && this.device === "pointer" && capture;
  },

  threshold(value, _k, _ref82) {
    let {
      filterTaps = false,
      tapsThreshold = 3,
      axis = void 0
    } = _ref82;
    const threshold = V.toVector(value, filterTaps ? tapsThreshold : axis ? 1 : 0);
    this.filterTaps = filterTaps;
    this.tapsThreshold = tapsThreshold;
    return threshold;
  },

  swipe() {
    let {
      velocity = DEFAULT_SWIPE_VELOCITY,
      distance = DEFAULT_SWIPE_DISTANCE,
      duration = DEFAULT_SWIPE_DURATION
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      velocity: this.transform(V.toVector(velocity)),
      distance: this.transform(V.toVector(distance)),
      duration
    };
  },

  delay() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    switch (value) {
      case true:
        return DEFAULT_DRAG_DELAY;

      case false:
        return 0;

      default:
        return value;
    }
  },

  axisThreshold(value) {
    if (!value) return DEFAULT_DRAG_AXIS_THRESHOLD;
    return _objectSpread2(_objectSpread2({}, DEFAULT_DRAG_AXIS_THRESHOLD), value);
  },

  keyboardDisplacement() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_KEYBOARD_DISPLACEMENT;
    return value;
  }

});

if (process.env.NODE_ENV === "development") {
  Object.assign(dragConfigResolver, {
    useTouch(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`useTouch\` option has been renamed to \`pointer.touch\`. Use it as in \`{ pointer: { touch: true } }\`.`);
      }

      return NaN;
    },

    experimental_preventWindowScrollY(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`experimental_preventWindowScrollY\` option has been renamed to \`preventScroll\`.`);
      }

      return NaN;
    },

    swipeVelocity(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`swipeVelocity\` option has been renamed to \`swipe.velocity\`. Use it as in \`{ swipe: { velocity: 0.5 } }\`.`);
      }

      return NaN;
    },

    swipeDistance(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`swipeDistance\` option has been renamed to \`swipe.distance\`. Use it as in \`{ swipe: { distance: 50 } }\`.`);
      }

      return NaN;
    },

    swipeDuration(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`swipeDuration\` option has been renamed to \`swipe.duration\`. Use it as in \`{ swipe: { duration: 250 } }\`.`);
      }

      return NaN;
    }

  });
}

_objectSpread2(_objectSpread2({}, commonConfigResolver), {}, {
  device(_v, _k, _ref83) {
    let {
      shared,
      pointer: {
        touch = false
      } = {}
    } = _ref83;
    const sharedConfig = shared;
    if (sharedConfig.target && !SUPPORT.touch && SUPPORT.gesture) return "gesture";
    if (SUPPORT.touch && touch) return "touch";

    if (SUPPORT.touchscreen) {
      if (SUPPORT.pointer) return "pointer";
      if (SUPPORT.touch) return "touch";
    }
  },

  bounds(_v, _k, _ref84) {
    let {
      scaleBounds = {},
      angleBounds = {}
    } = _ref84;

    const _scaleBounds = /* @__PURE__ */__name(state => {
      const D = assignDefault(call(scaleBounds, state), {
        min: -Infinity,
        max: Infinity
      });
      return [D.min, D.max];
    }, "_scaleBounds");

    const _angleBounds = /* @__PURE__ */__name(state => {
      const A = assignDefault(call(angleBounds, state), {
        min: -Infinity,
        max: Infinity
      });
      return [A.min, A.max];
    }, "_angleBounds");

    if (typeof scaleBounds !== "function" && typeof angleBounds !== "function") return [_scaleBounds(), _angleBounds()];
    return state => [_scaleBounds(state), _angleBounds(state)];
  },

  threshold(value, _k, config) {
    this.lockDirection = config.axis === "lock";
    const threshold = V.toVector(value, this.lockDirection ? [0.1, 3] : 0);
    return threshold;
  },

  modifierKey(value) {
    if (value === void 0) return "ctrlKey";
    return value;
  },

  pinchOnWheel() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return value;
  }

});

_objectSpread2(_objectSpread2({}, coordinatesConfigResolver), {}, {
  mouseOnly: /* @__PURE__ */__name(function () {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return value;
  }, "mouseOnly")
});

_objectSpread2(_objectSpread2({}, coordinatesConfigResolver), {}, {
  mouseOnly: /* @__PURE__ */__name(function () {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return value;
  }, "mouseOnly")
});

var EngineMap = /* @__PURE__ */new Map();
var ConfigResolverMap = /* @__PURE__ */new Map();

function registerAction(action) {
  EngineMap.set(action.key, action.engine);
  ConfigResolverMap.set(action.key, action.resolver);
}

__name(registerAction, "registerAction");

var dragAction = {
  key: "drag",
  engine: DragEngine,
  resolver: dragConfigResolver
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

__name(_objectWithoutProperties, "_objectWithoutProperties");

var sharedConfigResolver = {
  target(value) {
    if (value) {
      return () => "current" in value ? value.current : value;
    }

    return void 0;
  },

  enabled() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return value;
  },

  window() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SUPPORT.isBrowser ? window : void 0;
    return value;
  },

  eventOptions() {
    let {
      passive = true,
      capture = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      passive,
      capture
    };
  },

  transform(value) {
    return value;
  }

};
var _excluded = ["target", "eventOptions", "window", "enabled", "transform"];

function resolveWith() {
  let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let resolvers = arguments.length > 1 ? arguments[1] : undefined;
  const result = {};

  for (const [key, resolver] of Object.entries(resolvers)) {
    switch (typeof resolver) {
      case "function":
        if (process.env.NODE_ENV === "development") {
          const r2 = resolver.call(result, config[key], key, config);
          if (!Number.isNaN(r2)) result[key] = r2;
        } else {
          result[key] = resolver.call(result, config[key], key, config);
        }

        break;

      case "object":
        result[key] = resolveWith(config[key], resolver);
        break;

      case "boolean":
        if (resolver) result[key] = config[key];
        break;
    }
  }

  return result;
}

__name(resolveWith, "resolveWith");

function parse3(newConfig, gestureKey) {
  let _config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  const _ref = newConfig,
        {
    target,
    eventOptions,
    window: window2,
    enabled,
    transform
  } = _ref,
        rest = _objectWithoutProperties(_ref, _excluded);

  _config.shared = resolveWith({
    target,
    eventOptions,
    window: window2,
    enabled,
    transform
  }, sharedConfigResolver);

  if (gestureKey) {
    const resolver = ConfigResolverMap.get(gestureKey);
    _config[gestureKey] = resolveWith(_objectSpread2({
      shared: _config.shared
    }, rest), resolver);
  } else {
    for (const key in rest) {
      const resolver = ConfigResolverMap.get(key);

      if (resolver) {
        _config[key] = resolveWith(_objectSpread2({
          shared: _config.shared
        }, rest[key]), resolver);
      } else if (process.env.NODE_ENV === "development") {
        if (!["drag", "pinch", "scroll", "wheel", "move", "hover"].includes(key)) {
          if (key === "domTarget") {
            throw Error(`[@use-gesture]: \`domTarget\` option has been renamed to \`target\`.`);
          }

          console.warn(`[@use-gesture]: Unknown config key \`${key}\` was used. Please read the documentation for further information.`);
        }
      }
    }
  }

  return _config;
}

__name(parse3, "parse");

var _EventStore = class _EventStore2 {
  constructor(ctrl, gestureKey) {
    _defineProperty(this, "_listeners", /* @__PURE__ */new Set());

    this._ctrl = ctrl;
    this._gestureKey = gestureKey;
  }

  add(element, device, action, handler, options) {
    const listeners = this._listeners;
    const type = toDomEventType(device, action);

    const _options = this._gestureKey ? this._ctrl.config[this._gestureKey].eventOptions : {};

    const eventOptions = _objectSpread2(_objectSpread2({}, _options), options);

    element.addEventListener(type, handler, eventOptions);

    const remove = /* @__PURE__ */__name(() => {
      element.removeEventListener(type, handler, eventOptions);
      listeners.delete(remove);
    }, "remove");

    listeners.add(remove);
    return remove;
  }

  clean() {
    this._listeners.forEach(remove => remove());

    this._listeners.clear();
  }

};

__name(_EventStore, "EventStore");

var EventStore = _EventStore;

var _TimeoutStore = class _TimeoutStore2 {
  constructor() {
    _defineProperty(this, "_timeouts", /* @__PURE__ */new Map());
  }

  add(key, callback) {
    let ms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 140;
    this.remove(key);

    for (var _len3 = arguments.length, args = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
      args[_key3 - 3] = arguments[_key3];
    }

    this._timeouts.set(key, window.setTimeout(callback, ms, ...args));
  }

  remove(key) {
    const timeout = this._timeouts.get(key);

    if (timeout) window.clearTimeout(timeout);
  }

  clean() {
    this._timeouts.forEach(timeout => void window.clearTimeout(timeout));

    this._timeouts.clear();
  }

};

__name(_TimeoutStore, "TimeoutStore");

var TimeoutStore = _TimeoutStore;

var _Controller = class _Controller2 {
  constructor(handlers) {
    _defineProperty(this, "gestures", /* @__PURE__ */new Set());

    _defineProperty(this, "_targetEventStore", new EventStore(this));

    _defineProperty(this, "gestureEventStores", {});

    _defineProperty(this, "gestureTimeoutStores", {});

    _defineProperty(this, "handlers", {});

    _defineProperty(this, "config", {});

    _defineProperty(this, "pointerIds", /* @__PURE__ */new Set());

    _defineProperty(this, "touchIds", /* @__PURE__ */new Set());

    _defineProperty(this, "state", {
      shared: {
        shiftKey: false,
        metaKey: false,
        ctrlKey: false,
        altKey: false
      }
    });

    resolveGestures(this, handlers);
  }

  setEventIds(event) {
    if (isTouch(event)) {
      this.touchIds = new Set(touchIds(event));
      return this.touchIds;
    } else if ("pointerId" in event) {
      if (event.type === "pointerup" || event.type === "pointercancel") this.pointerIds.delete(event.pointerId);else if (event.type === "pointerdown") this.pointerIds.add(event.pointerId);
      return this.pointerIds;
    }
  }

  applyHandlers(handlers, nativeHandlers) {
    this.handlers = handlers;
    this.nativeHandlers = nativeHandlers;
  }

  applyConfig(config, gestureKey) {
    this.config = parse3(config, gestureKey, this.config);
  }

  clean() {
    this._targetEventStore.clean();

    for (const key of this.gestures) {
      this.gestureEventStores[key].clean();
      this.gestureTimeoutStores[key].clean();
    }
  }

  effect() {
    if (this.config.shared.target) this.bind();
    return () => this._targetEventStore.clean();
  }

  bind() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    const sharedConfig = this.config.shared;
    const props = {};
    let target;

    if (sharedConfig.target) {
      target = sharedConfig.target();
      if (!target) return;
    }

    if (sharedConfig.enabled) {
      for (const gestureKey of this.gestures) {
        const gestureConfig = this.config[gestureKey];
        const bindFunction = bindToProps(props, gestureConfig.eventOptions, !!target);

        if (gestureConfig.enabled) {
          const Engine2 = EngineMap.get(gestureKey);
          new Engine2(this, args, gestureKey).bind(bindFunction);
        }
      }

      const nativeBindFunction = bindToProps(props, sharedConfig.eventOptions, !!target);

      for (const eventKey in this.nativeHandlers) {
        nativeBindFunction(eventKey, "", event => this.nativeHandlers[eventKey](_objectSpread2(_objectSpread2({}, this.state.shared), {}, {
          event,
          args
        })), void 0, true);
      }
    }

    for (const handlerProp in props) {
      props[handlerProp] = chain(...props[handlerProp]);
    }

    if (!target) return props;

    for (const handlerProp in props) {
      const {
        device,
        capture,
        passive
      } = parseProp(handlerProp);

      this._targetEventStore.add(target, device, "", props[handlerProp], {
        capture,
        passive
      });
    }
  }

};

__name(_Controller, "Controller");

var Controller = _Controller;

function setupGesture(ctrl, gestureKey) {
  ctrl.gestures.add(gestureKey);
  ctrl.gestureEventStores[gestureKey] = new EventStore(ctrl, gestureKey);
  ctrl.gestureTimeoutStores[gestureKey] = new TimeoutStore();
}

__name(setupGesture, "setupGesture");

function resolveGestures(ctrl, internalHandlers) {
  if (internalHandlers.drag) setupGesture(ctrl, "drag");
  if (internalHandlers.wheel) setupGesture(ctrl, "wheel");
  if (internalHandlers.scroll) setupGesture(ctrl, "scroll");
  if (internalHandlers.move) setupGesture(ctrl, "move");
  if (internalHandlers.pinch) setupGesture(ctrl, "pinch");
  if (internalHandlers.hover) setupGesture(ctrl, "hover");
}

__name(resolveGestures, "resolveGestures");

var bindToProps = /* @__PURE__ */__name((props, eventOptions, withPassiveOption) => function (device, action, handler) {
  let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  let isNative = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var _options$capture, _options$passive;

  const capture = (_options$capture = options.capture) !== null && _options$capture !== void 0 ? _options$capture : eventOptions.capture;
  const passive = (_options$passive = options.passive) !== null && _options$passive !== void 0 ? _options$passive : eventOptions.passive;
  let handlerProp = isNative ? device : toHandlerProp(device, action, capture);
  if (withPassiveOption && passive) handlerProp += "Passive";
  props[handlerProp] = props[handlerProp] || [];
  props[handlerProp].push(handler);
}, "bindToProps");

function useRecognizers(handlers) {
  let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let gestureKey = arguments.length > 2 ? arguments[2] : undefined;
  let nativeHandlers = arguments.length > 3 ? arguments[3] : undefined;
  const ctrl = React__default.useMemo(() => new Controller(handlers), []);
  ctrl.applyHandlers(handlers, nativeHandlers);
  ctrl.applyConfig(config, gestureKey);
  React__default.useEffect(ctrl.effect.bind(ctrl));
  React__default.useEffect(() => {
    return ctrl.clean.bind(ctrl);
  }, []);

  if (config.target === void 0) {
    return ctrl.bind.bind(ctrl);
  }

  return void 0;
}

__name(useRecognizers, "useRecognizers");

function useDrag(handler, config) {
  registerAction(dragAction);
  return useRecognizers({
    drag: handler
  }, config || {}, "drag");
}

__name(useDrag, "useDrag");

var SWIPE_DISTANCE = 50;
var TOAST_MAX_WIDTH = 420;

function Toast(_a) {
  var _b = _a,
      {
    children,
    swipeDirection,
    onDismiss,
    swipeTransitionDuration = 200
  } = _b,
      rest = __objRest(_b, ["children", "swipeDirection", "onDismiss", "swipeTransitionDuration"]);

  const theme = useTheme();
  const bindTouchEvents = useSwipeableToast({
    onDismiss,
    swipeDirection,
    swipeTransitionDuration
  });
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues(__spreadValues({}, bindTouchEvents()), rest), {
    role: "alert",
    css: __spreadProps(__spreadValues({
      background: theme.colors.systemGrayscale80,
      borderRadius: theme.radius.r8,
      margin: `${spacing.s12}px ${spacing.s16}px`,
      maxWidth: TOAST_MAX_WIDTH,
      touchAction: "none",
      transform: "translate(var(--ids-toast-offset-x, 0), var(--ids-toast-offset-y, 0))",
      '&[data-transitioning="true"]': {
        transition: `transform ${swipeTransitionDuration}ms linear`
      },
      userSelect: "none",
      width: "100%"
    }, elevation.pantryHigh3.shadow), {
      [responsive_exports.up("r")]: {
        margin: `${spacing.s12}px ${spacing.s16}px ${spacing.s24}px ${spacing.s24}px`
      }
    }),
    children: /* @__PURE__ */jsx("div", {
      css: {
        alignItems: "start",
        display: "grid",
        gridTemplateColumns: "min-content 1fr max-content",
        gridTemplateAreas: '"icon text action"',
        paddingLeft: TOAST_PADDING,
        paddingRight: TOAST_PADDING,
        "> *": {
          color: theme.colors.systemGrayscale00,
          paddingTop: TOAST_PADDING,
          paddingBottom: TOAST_PADDING
        }
      },
      children
    })
  }));
}

__name(Toast, "Toast");

var ABSOLUTE_X_OFFSET = TOAST_MAX_WIDTH + TOAST_PADDING * 2;
var ABSOLUTE_Y_OFFSET = 68 + TOAST_PADDING * 2;

function useSwipeableToast(_ref85) {
  let {
    onDismiss,
    swipeDirection
  } = _ref85;
  const axis = ["top", "bottom", "vertical"].includes(swipeDirection != null ? swipeDirection : "") ? "y" : "x";
  return useDrag((_ref86) => {
    let {
      swipe: [swipeX, swipeY],
      movement: [mx, my],
      dragging,
      cancel,
      currentTarget
    } = _ref86;
    const targetDiv = currentTarget;

    if (swipeX || swipeY) {
      targetDiv.setAttribute("data-transitioning", "true");

      if (swipeX) {
        if (Math.abs(mx) < ABSOLUTE_X_OFFSET) {
          const newXOffset = `${mx + mx > 0 ? ABSOLUTE_X_OFFSET : -ABSOLUTE_X_OFFSET}px`;
          requestAnimationFrame(() => {
            targetDiv.style.setProperty("--ids-toast-offset-x", newXOffset);
          });
        }
      }

      if (swipeY) {
        if (Math.abs(my) < ABSOLUTE_Y_OFFSET) {
          requestAnimationFrame(() => {
            const newYOffset = `${my + my > 0 ? ABSOLUTE_Y_OFFSET : -ABSOLUTE_Y_OFFSET}px`;
            targetDiv.style.setProperty("--ids-toast-offset-y", newYOffset);
          });
        }
      }

      onDismiss == null ? void 0 : onDismiss();
      return;
    }

    switch (swipeDirection) {
      case "top":
        {
          if (my > 0) {
            cancel();
          }

          break;
        }

      case "right":
        {
          if (mx < 0) {
            cancel();
          }

          break;
        }

      case "bottom":
        {
          if (my < 0) {
            cancel();
          }

          break;
        }

      case "left":
        {
          if (mx > 0) {
            cancel();
          }

          break;
        }
    }

    if (!dragging) {
      targetDiv.setAttribute("data-transitioning", "true");
      requestAnimationFrame(() => {
        targetDiv.style.setProperty("--ids-toast-offset-x", "0px");
        targetDiv.style.setProperty("--ids-toast-offset-y", "0px");
      });
      return;
    }

    if (dragging) {
      targetDiv.removeAttribute("data-transitioning");
    }

    if (axis === "x") {
      targetDiv.style.setProperty("--ids-toast-offset-x", `${mx}px`);
    } else {
      targetDiv.style.setProperty("--ids-toast-offset-y", `${my}px`);
    }
  }, {
    axis,
    enabled: swipeDirection !== void 0,
    swipe: {
      distance: SWIPE_DISTANCE
    }
  });
}

__name(useSwipeableToast, "useSwipeableToast");

function ToastText(_a) {
  var _b = _a,
      {
    children,
    subText
  } = _b,
      rest = __objRest(_b, ["children", "subText"]);

  const theme = useTheme();
  return /* @__PURE__ */jsxs("div", __spreadProps(__spreadValues({}, rest), {
    css: {
      alignSelf: "center",
      // Wrapping the line clamped div because the padding applied by the parent would cause the text to overflow into the padding.
      gridArea: "text"
    },
    children: [/* @__PURE__ */jsx("div", {
      css: __spreadValues(__spreadProps(__spreadValues({}, theme.typography.bodyEmphasized), {
        color: theme.colors.systemGrayscale00
      }), lineClamp(3)),
      children
    }), /* @__PURE__ */jsx("div", {
      css: __spreadValues(__spreadProps(__spreadValues({}, theme.typography.bodyRegular), {
        color: theme.colors.systemGrayscale00
      }), lineClamp(3)),
      children: subText
    })]
  }));
}

__name(ToastText, "ToastText");

function ToastIcon(_a) {
  var _b = _a,
      {
    children
  } = _b,
      rest = __objRest(_b, ["children"]);

  const child = Children.only(children);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({}, rest), {
    "aria-hidden": "true",
    css: {
      height: spacing.s24,
      gridArea: "icon",
      marginRight: spacing.s8
    },
    children: /*#__PURE__*/cloneElement(child, {
      color: "systemGrayscale00",
      size: spacing.s24
    })
  }));
}

__name(ToastIcon, "ToastIcon");

function ToastAction(_a) {
  var _b = _a,
      {
    children
  } = _b,
      rest = __objRest(_b, ["children"]);

  const theme = useTheme();
  return /* @__PURE__ */jsx("button", __spreadProps(__spreadValues({}, rest), {
    css: __spreadProps(__spreadValues({
      padding: TOAST_PADDING,
      // Pulls the action to the edge of the Toast
      right: -TOAST_PADDING,
      borderRadius: `0 ${theme.radius.r8}px ${theme.radius.r8}px 0`,
      gridArea: "action",
      position: "relative",
      border: "none",
      background: "none"
    }, theme.typography.bodyLink), {
      color: theme.colors.systemGrayscale00,
      "&:hover": {
        cursor: "pointer",
        color: theme.colors.systemGrayscale20
      },
      "&:active": {
        cursor: "pointer",
        color: theme.colors.systemGrayscale30
      },
      "&.focus-visible": {
        outline: "none"
      },
      "&.focus-visible::after": {
        position: "absolute",
        content: '""',
        top: -4,
        bottom: -4,
        left: -4,
        right: -4,
        borderRadius: theme.radius.r8,
        border: `2px solid ${theme.colors.systemGrayscale70}`,
        outline: "none",
        boxShadow: "none"
      }
    }),
    children
  }));
}

__name(ToastAction, "ToastAction");

function ToastsContainer(_a) {
  var _b = _a,
      {
    children,
    transitionDuration = 200
  } = _b,
      rest = __objRest(_b, ["children", "transitionDuration"]);

  return /* @__PURE__ */jsx("ul", __spreadProps(__spreadValues({}, rest), {
    css: {
      margin: 0,
      padding: 0,
      listStyle: "none",
      position: "fixed",
      bottom: spacing.s12,
      left: spacing.s16,
      right: spacing.s16
    },
    children: /* @__PURE__ */jsx(TransitionGroup, {
      component: null,
      children: Children.toArray(children).map((x, i) => {
        return /* @__PURE__ */jsx(CSSTransition, {
          classNames: "toast",
          timeout: transitionDuration,
          children: /* @__PURE__ */jsx("li", {
            css: {
              "&:first-of-type": {
                marginTop: 0
              },
              display: "flex",
              justifyContent: "center",
              marginTop: spacing.s12,
              // Transitions
              transition: `opacity ${transitionDuration}ms ease-in-out`,
              "&.toast-enter": {
                opacity: 0
              },
              "&.toast-enter-active": {
                opacity: 1
              },
              "&.toast-exit": {
                opacity: 1
              },
              "&.toast-exit-active": {
                opacity: 0
              }
            },
            children: x
          })
        }, /*#__PURE__*/isValidElement(x) ? x.props.id : `toast-item-${i}`);
      })
    })
  }));
}

__name(ToastsContainer, "ToastsContainer");

var getStyles118 = /* @__PURE__ */__name((_ref87, selected) => {
  let {
    colors
  } = _ref87;
  return {
    button: {
      backgroundColor: selected ? colors.brandPrimaryRegular : colors.systemGrayscale00,
      borderColor: selected ? colors.brandPrimaryDark : colors.systemGrayscale20,
      borderWidth: 1,
      borderStyle: "solid"
    },
    hover: {
      backgroundColor: selected ? colors.brandPrimaryDark : colors.systemGrayscale00,
      borderColor: selected ? colors.brandPrimaryDark : colors.systemGrayscale30
    },
    active: {
      backgroundColor: selected ? colors.brandPrimaryDark : colors.systemGrayscale20,
      borderColor: selected ? colors.brandPrimaryDark : colors.systemGrayscale20
    },
    disabled: {
      backgroundColor: colors.systemGrayscale10,
      borderColor: colors.systemGrayscale20
    },
    content: {},
    focusRing: {}
  };
}, "getStyles");

var Vote = /*#__PURE__*/forwardRef((props, ref) => {
  const _a = props,
        {
    selected,
    variant,
    disabled,
    styles: styles25
  } = _a,
        rest = __objRest(_a, ["selected", "variant", "disabled", "styles"]);

  const useSelectedStyles = selected && !disabled;
  const theme = useTheme();
  const combinedStyles = combineStyles(getStyles118(theme, useSelectedStyles), styles25);
  const Icon = variant === "up" ? LikeIcon_default : DislikeIcon_default;
  const color = disabled ? "systemGrayscale30" : useSelectedStyles ? "systemGrayscale00" : "systemGrayscale80";
  return /* @__PURE__ */jsx(IconButtonBase, __spreadValues({
    styles: combinedStyles,
    icon: Icon,
    color,
    ref,
    disabled,
    "aria-pressed": selected
  }, rest));
});
Vote.displayName = "Vote";
var ServiceMessageButtonBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function ServiceMessageButton(_a, ref) {
  var _b = _a,
      {
    icon: Icon,
    color,
    disabled,
    accessibleLabel,
    onClick
  } = _b,
      rest = __objRest(_b, ["icon", "color", "disabled", "accessibleLabel", "onClick"]);

  const theme = useTheme();
  const interactiveColors = useComputeInteractiveColors({
    backgroundColor: "systemGrayscale10",
    theme
  });
  const styles25 = {
    button: {
      backgroundColor: "transparent",
      height: spacing.s32,
      width: spacing.s32
    },
    hover: {
      backgroundColor: interactiveColors == null ? void 0 : interactiveColors.hoverColor
    },
    active: {
      backgroundColor: interactiveColors == null ? void 0 : interactiveColors.activeColor
    }
  };
  return /* @__PURE__ */jsx(IconButtonBase, __spreadValues({
    icon: Icon,
    accessibleLabel,
    disabled,
    ref,
    styles: styles25,
    onClick
  }, rest));
}, "ServiceMessageButton"));
ServiceMessageButtonBase.displayName = "ServiceMessageButtonBase";

function generateDummyArrayForDefaultElements(numElements) {
  return [...Array(numElements)];
}

__name(generateDummyArrayForDefaultElements, "generateDummyArrayForDefaultElements");

var DEFAULT_NUMBER_ELEMENTS = 12;
var LoadingLockupBLayoutWrapper = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function LoadingLockupBLayoutWrapper2(_a, ref) {
  var _b = _a,
      {
    elementQuantity = DEFAULT_NUMBER_ELEMENTS,
    layoutElement
  } = _b,
      rest = __objRest(_b, ["elementQuantity", "layoutElement"]);

  return /* @__PURE__ */jsx(LoadingLockupLayout, __spreadProps(__spreadValues({
    ref,
    "data-testid": "loading-lockup-b-layout-wrapper"
  }, rest), {
    children: /* @__PURE__ */jsx(LockupB, __spreadProps(__spreadValues({}, rest), {
      children: generateDummyArrayForDefaultElements(elementQuantity).map((_val, i) => // eslint-disable-next-line react/no-array-index-key

      /* @__PURE__ */
      jsx("div", {
        children: layoutElement
      }, i))
    }))
  }));
}, "LoadingLockupBLayoutWrapper"));
var DEFAULT_NUMBER_ELEMENTS2 = 4;

var getStyles119 = /* @__PURE__ */__name(() => ({
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column"
  }
}), "getStyles");

var LoadingLockupLayoutWrapper = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function LoadingLockupLayoutWrapper2(_a, ref) {
  var _b = _a,
      {
    elementQuantity = DEFAULT_NUMBER_ELEMENTS2,
    layoutElement,
    styles: styles25
  } = _b,
      rest = __objRest(_b, ["elementQuantity", "layoutElement", "styles"]);

  const {
    container
  } = combineStyles(getStyles119(), styles25);
  return /* @__PURE__ */jsx(LoadingLockupLayout, __spreadProps(__spreadValues({
    ref,
    "data-testid": "loading-lockup-layout-wrapper"
  }, rest), {
    children: /* @__PURE__ */jsx("div", {
      css: container,
      children: generateDummyArrayForDefaultElements(elementQuantity).map((_val, i) => // eslint-disable-next-line react/no-array-index-key

      /* @__PURE__ */
      jsx("div", {
        children: layoutElement
      }, i))
    })
  }));
}, "LoadingLockupLayoutWrapper"));

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function LoadingLockupIconRowLayout2(props, ref) {
  return /* @__PURE__ */jsx(LoadingLockupLayoutWrapper, __spreadValues({
    ref,
    layoutElement: /* @__PURE__ */jsx(LoadingLockupIconRow, {})
  }, props));
}, "LoadingLockupIconRowLayout"));

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function LoadingLockupImageRowLayout2(props, ref) {
  return /* @__PURE__ */jsx(LoadingLockupLayoutWrapper, __spreadValues({
    ref,
    layoutElement: /* @__PURE__ */jsx(LoadingLockupImageRow, {})
  }, props));
}, "LoadingLockupImageRowLayout"));

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function LoadingLockupItemGridLayout2(props, ref) {
  return /* @__PURE__ */jsx(LoadingLockupBLayoutWrapper, __spreadValues({
    ref,
    layoutElement: /* @__PURE__ */jsx(LoadingLockupGridItem, {})
  }, props));
}, "LoadingLockupItemGridLayout"));

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function LoadingLockupItemListLayout2(props, ref) {
  return /* @__PURE__ */jsx(LoadingLockupLayoutWrapper, __spreadValues({
    ref,
    layoutElement: /* @__PURE__ */jsx(LoadingLockupListItem, {})
  }, props));
}, "LoadingLockupItemListLayout"));

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function LoadingLockupTextRowLayout2(props, ref) {
  return /* @__PURE__ */jsx(LoadingLockupLayoutWrapper, __spreadValues({
    ref,
    layoutElement: /* @__PURE__ */jsx(LoadingLockupTextRow, {})
  }, props));
}, "LoadingLockupTextRowLayout"));
var ModalContext = /*#__PURE__*/createContext({});

var useModalContext = /* @__PURE__ */__name(() => useContext(ModalContext), "useModalContext");

var MODAL_WRAPPER_STYLES = {
  display: "flex",
  flexDirection: "column",
  [responsive_exports.up("r")]: {
    maxHeight: `calc(100vh - ${spacing.s48 * 2}px)`
  }
};

var getStyles120 = /* @__PURE__ */__name(theme => ({
  modal: __spreadProps(__spreadValues(__spreadValues(__spreadProps(__spreadValues({}, MODAL_WRAPPER_STYLES), {
    boxSizing: "border-box",
    borderRadius: theme.radius.r12,
    backgroundColor: theme.colors.systemGrayscale00,
    position: "fixed",
    width: "100%",
    [responsive_exports.down("c")]: {
      marginTop: 0,
      marginBottom: 0,
      borderRadius: 0,
      paddingTop: 0,
      height: "100%"
    }
  }), POSITION_X_Y_CENTER), elevation.high.shadow), {
    "&:focus, &:focus-visible": {
      outline: "none"
    },
    "&.focus-visible": {
      outline: `1px solid ${theme.colors.systemGrayscale80}`
    }
  })
}), "getStyles");

var ModalBase = /*#__PURE__*/forwardRef(function (_ref88, ref) {
  let {
    backdropStyles,
    children,
    styles: styles25,
    initialFocusElem,
    finalFocusElem,
    modal,
    hideOnClickOutside,
    hideOnEsc,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    onlyRenderWhenVisible,
    unmountChildrenDelay,
    onBlur,
    isMounted
  } = _ref88;
  const [mounted, setMounted] = useState(Boolean(isMounted));
  const childrenVisible = useRenderChildrenStatus({
    modalVisible: modal.visible,
    onlyRenderWhenVisible,
    delay: unmountChildrenDelay
  });
  const reakitGeneratedId = unstable_useId();
  const {
    id: accessibleGeneratedAriaLabelledBy
  } = reakitGeneratedId;
  const modalAriaLabelledBy = ariaLabel ? void 0 : ariaLabelledBy || accessibleGeneratedAriaLabelledBy;
  const dialogRef = useRef(null);
  useEffect(() => {
    setMounted(true);
  }, []);
  const theme = useTheme();
  const css = combineStyles(getStyles120(theme), styles25);
  const showChildren = onlyRenderWhenVisible ? childrenVisible : true;
  useInitialFocusElem({
    initialFocusElem,
    rootElem: dialogRef,
    checkFocus: modal.visible
  });
  const finalRef = useMergeRefs(ref, dialogRef);
  return /* @__PURE__ */jsx(Fragment, {
    children: mounted && /* @__PURE__ */jsx(ModalContext.Provider, {
      value: __spreadProps(__spreadValues({}, modal), {
        modalTitleId: modalAriaLabelledBy
      }),
      children: /* @__PURE__ */jsx(Backdrop, __spreadProps(__spreadValues({}, modal), {
        styles: backdropStyles,
        children: /* @__PURE__ */jsx(Dialog, __spreadProps(__spreadValues({
          "data-component-name": "ModalBase",
          ref: finalRef,
          css: css.modal,
          hideOnClickOutside,
          hideOnEsc,
          unstable_finalFocusRef: finalFocusElem,
          preventBodyScroll: false,
          onBlur,
          "aria-label": ariaLabel,
          "aria-labelledby": modalAriaLabelledBy
        }, modal), {
          children: showChildren ? children : null
        }))
      }))
    })
  });
});

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function ModalFixedSize2(props, ref) {
  const {
    children
  } = props;
  const styles25 = {
    modal: {
      [responsive_exports.up("r")]: {
        height: "804px",
        width: "552px"
      }
    }
  };
  return /* @__PURE__ */jsx(ModalBase, __spreadProps(__spreadValues({}, props), {
    ref,
    styles: styles25,
    children
  }));
}, "ModalFixedSize"));

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function ModalAutosize2(props, ref) {
  const {
    children
  } = props;
  const styles25 = {
    modal: {
      [responsive_exports.up("r")]: {
        width: "552px"
      }
    }
  };
  return /* @__PURE__ */jsx(ModalBase, __spreadProps(__spreadValues({}, props), {
    ref,
    styles: styles25,
    children
  }));
}, "ModalAutosize"));

var getStyles121 = /* @__PURE__ */__name(() => ({
  header: {
    display: "grid",
    gridTemplateColumns: "1fr auto 1fr",
    height: `${spacing.s40 + spacing.s4}px`,
    marginTop: spacing.s16
  },
  closeContainer: {
    paddingLeft: spacing.s16
  },
  closeIcon: {
    marginTop: `${spacing.s4 / 2}px`
  }
}), "getStyles");

function ModalHeaderBase(_a) {
  var _b = _a,
      {
    children,
    hide,
    accessibleLabels,
    styles: styles25
  } = _b,
      rest = __objRest(_b, ["children", "hide", "accessibleLabels", "styles"]);

  const {
    header,
    closeContainer,
    closeIcon
  } = combineStyles(getStyles121(), styles25);
  return /* @__PURE__ */jsxs("div", {
    css: header,
    children: [/* @__PURE__ */jsx("div", {
      css: closeContainer,
      children: /* @__PURE__ */jsx(IconButton2, __spreadProps(__spreadValues({}, rest), {
        type: "button",
        css: closeIcon,
        onClick: e3 => {
          rest.onClick && rest.onClick(e3);
          hide();
        },
        icon: ModalHeaderButton,
        accessibleLabel: accessibleLabels.close
      }))
    }), children]
  });
}

__name(ModalHeaderBase, "ModalHeaderBase");

function ModalHeaderButton() {
  return /* @__PURE__ */jsx(CloseIcon_default, {
    size: spacing.s24
  });
}

__name(ModalHeaderButton, "ModalHeaderButton");

function ModalHeader(props) {
  return /* @__PURE__ */jsx(ModalHeaderBase, __spreadValues({}, props));
}

__name(ModalHeader, "ModalHeader");

var getStyles122 = /* @__PURE__ */__name(theme => ({
  title: __spreadValues({
    padding: "0",
    margin: "0",
    placeSelf: "center"
  }, theme.typography.subtitle)
}), "getStyles");

function ModalTitleBase(_ref89) {
  let {
    children,
    styles: styles25,
    headingLevel: Element2 = "h1"
  } = _ref89;
  const theme = useTheme();
  const {
    modalTitleId
  } = useModalContext();
  const {
    title
  } = combineStyles(getStyles122(theme), styles25);
  return /* @__PURE__ */jsx(Element2, {
    css: title,
    id: modalTitleId,
    children
  });
}

__name(ModalTitleBase, "ModalTitleBase");

function ModalTitle(props) {
  return /* @__PURE__ */jsx(ModalTitleBase, __spreadValues({}, props));
}

__name(ModalTitle, "ModalTitle");

var getStyles123 = /* @__PURE__ */__name(() => ({
  content: {
    flex: "1",
    overflowY: "auto",
    paddingLeft: `${spacing.s16}px`,
    paddingRight: `${spacing.s16}px`,
    paddingBottom: `${spacing.s32}px`
  }
}), "getStyles");

var ModalContentBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function ModalContentBase2(_ref90, forwardedRef) {
  let {
    children,
    styles: styles25
  } = _ref90;
  const {
    content
  } = combineStyles(getStyles123(), styles25);
  const ref = useRef(null);
  const modal = useModalContext();
  useEffect(() => {
    const scrollEl = ref.current;

    if (modal.visible && scrollEl) {
      bodyScrollLock.disableBodyScroll(scrollEl, {
        reserveScrollBarGap: true,
        allowTouchMove: /* @__PURE__ */__name(el => {
          if (el instanceof HTMLElement) {
            return !!el.closest("[data-ids-allow-touch-move]");
          }

          return false;
        }, "allowTouchMove")
      });
    }

    return () => {
      if (!scrollEl) return;
      bodyScrollLock.enableBodyScroll(scrollEl);
    };
  }, [modal.visible]);
  const combinedRef = useCallback(node => {
    if (forwardedRef) {
      if (typeof forwardedRef === "function") {
        forwardedRef(node);
      } else {
        forwardedRef.current = node;
      }
    }

    ref.current = node;
  }, [forwardedRef]);
  return /* @__PURE__ */jsx("div", {
    ref: combinedRef,
    css: content,
    children
  });
}, "ModalContentBase"));

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function ModalContent2(props, ref) {
  return /* @__PURE__ */jsx(ModalContentBase, __spreadProps(__spreadValues({}, props), {
    ref
  }));
}, "ModalContent"));

var getStyles124 = /* @__PURE__ */__name(() => ({
  footer: __spreadValues(__spreadValues({
    paddingLeft: `${spacing.s16}px`,
    paddingRight: `${spacing.s16}px`,
    paddingTop: `${spacing.s12}px`,
    paddingBottom: `${spacing.s12}px`
  }, elevation.high.shadow), elevation.high.depth)
}), "getStyles");

function ModalFooterBase(_a) {
  var _b = _a,
      {
    children,
    styles: styles25
  } = _b,
      rest = __objRest(_b, ["children", "styles"]);

  const {
    footer
  } = combineStyles(getStyles124(), styles25);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    css: footer
  }, rest), {
    children
  }));
}

__name(ModalFooterBase, "ModalFooterBase");

function ModalFooter(props) {
  return /* @__PURE__ */jsx(ModalFooterBase, __spreadValues({}, props));
}

__name(ModalFooter, "ModalFooter");

var getStyles125 = /* @__PURE__ */__name(() => ({
  footer: __spreadValues(__spreadValues({}, elevation.primary.depth), elevation.primary.shadow)
}), "getStyles");

function ModalFooterNoShadow(props) {
  const styles25 = getStyles125();
  return /* @__PURE__ */jsx(ModalFooterBase, __spreadProps(__spreadValues({}, props), {
    styles: styles25
  }));
}

__name(ModalFooterNoShadow, "ModalFooterNoShadow");

var DEFAULT_ELEMENT = "div";

function ModalInnerWrapper(_a) {
  var _b = _a,
      {
    as,
    children
  } = _b,
      rest = __objRest(_b, ["as", "children"]);

  const Element2 = as || DEFAULT_ELEMENT;
  return /* @__PURE__ */jsx(Element2, __spreadProps(__spreadValues({
    css: [MODAL_WRAPPER_STYLES, {
      height: "100%"
    }]
  }, rest), {
    children
  }));
}

__name(ModalInnerWrapper, "ModalInnerWrapper");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function PromotionModal2(props, ref) {
  const {
    children
  } = props;
  const styles25 = {
    modal: {
      [responsive_exports.up("r")]: {
        width: "343px"
      }
    }
  };
  return /* @__PURE__ */jsx(ModalBase, __spreadProps(__spreadValues({}, props), {
    ref,
    styles: styles25,
    children
  }));
}, "PromotionModal"));

var getStyles126 = /* @__PURE__ */__name(() => ({
  image: {
    height: "175px",
    width: "311px",
    margin: `${spacing.s16}px`,
    borderRadius: `${spacing.s12}px`
  }
}), "getStyles");

function PromotionModalImage(_ref91) {
  let {
    src,
    alt
  } = _ref91;
  const styles25 = getStyles126();
  return /* @__PURE__ */jsx("img", {
    src,
    alt,
    css: styles25.image
  });
}

__name(PromotionModalImage, "PromotionModalImage");

function PromotionModalBody(props) {
  const styles25 = {
    content: {
      paddingBottom: spacing.s24
    }
  };
  return /* @__PURE__ */jsx(ModalContentBase, __spreadValues({
    styles: styles25
  }, props));
}

__name(PromotionModalBody, "PromotionModalBody");

var getStyles127 = /* @__PURE__ */__name(theme => __spreadProps(__spreadValues({}, theme.typography.bodySmall1), {
  color: theme.colors.brandPromotionalRegular,
  margin: 0
}), "getStyles");

function PromotionModalSubtitle(_ref92) {
  let {
    children
  } = _ref92;
  const theme = useTheme();
  const styles25 = getStyles127(theme);
  return /* @__PURE__ */jsx("p", {
    css: styles25,
    children
  });
}

__name(PromotionModalSubtitle, "PromotionModalSubtitle");

var getStyles128 = /* @__PURE__ */__name(theme => __spreadProps(__spreadValues({}, theme.typography.titleMedium), {
  margin: `0 0 ${spacing.s4}px 0`
}), "getStyles");

function PromotionModalTitle(_ref93) {
  let {
    children
  } = _ref93;
  const theme = useTheme();
  const styles25 = getStyles128(theme);
  return /* @__PURE__ */jsx("p", {
    css: styles25,
    children
  });
}

__name(PromotionModalTitle, "PromotionModalTitle");

var getStyles129 = /* @__PURE__ */__name(theme => __spreadProps(__spreadValues({}, theme.typography.bodyLarge2), {
  margin: 0
}), "getStyles");

function PromotionModalDescription(_ref94) {
  let {
    children
  } = _ref94;
  const theme = useTheme();
  const styles25 = getStyles129(theme);
  return /* @__PURE__ */jsx("p", {
    css: styles25,
    children
  });
}

__name(PromotionModalDescription, "PromotionModalDescription");

var getStyles130 = /* @__PURE__ */__name(theme => ({
  footer: {
    boxShadow: "none",
    borderBottomLeftRadius: theme.radius.r12,
    borderbottomRightRadius: theme.radius.r12,
    " > button:first-of-type": {
      marginBottom: spacing.s12
    }
  }
}), "getStyles");

function PromotionModalButtons(props) {
  const theme = useTheme();
  const styles25 = getStyles130(theme);
  return /* @__PURE__ */jsx(ModalFooterBase, __spreadValues({
    styles: styles25
  }, props));
}

__name(PromotionModalButtons, "PromotionModalButtons");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function TileC2(_ref95, ref) {
  let {
    children
  } = _ref95;
  const styles25 = {
    container: {
      padding: spacing.s8
    }
  };
  return /* @__PURE__ */jsx(TileBase, {
    ref,
    styles: styles25,
    "data-testid": "tile-base",
    children
  });
}, "TileC"));
var styles23 = {
  marginRight: spacing.s12
};

function Left4(props) {
  const {
    children
  } = props;
  return /* @__PURE__ */jsx("div", {
    css: styles23,
    children
  });
}

__name(Left4, "Left");

var styles24 = {
  display: "flex",
  alignSelf: "center",
  minWidth: 0
};

function Center(props) {
  const {
    children
  } = props;
  return /* @__PURE__ */jsx("div", {
    css: styles24,
    children
  });
}

__name(Center, "Center");

var getStyles131 = /* @__PURE__ */__name(theme => ({
  container: __spreadProps(__spreadValues({}, elevation.low.shadow), {
    borderRadius: theme.radius.r12
  })
}), "getStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function TileC3(_a, ref) {
  var _b = _a,
      {
    children
  } = _b,
      rest = __objRest(_b, ["children"]);

  const theme = useTheme();
  const styles25 = getStyles131(theme);
  return /* @__PURE__ */jsx(StoreCardBase, __spreadProps(__spreadValues({
    ref,
    styles: styles25
  }, rest), {
    children
  }));
}, "TileC"));

var getStyles132 = /* @__PURE__ */__name(theme => ({
  anchor: __spreadProps(__spreadValues({
    display: "inline-block",
    padding: `0 ${spacing.s4}px`,
    color: theme.colors.systemGrayscale50
  }, theme.typography.bodySmall1), {
    borderRadius: 4,
    border: `1px solid ${theme.colors.systemGrayscale20}`,
    marginRight: spacing.s4
  })
}), "getStyles");

function StoreCardAttributes(_a) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const theme = useTheme();
  const {
    anchor
  } = combineStyles(getStyles132(theme), styles25);
  return /* @__PURE__ */jsx("span", __spreadProps(__spreadValues({
    css: anchor
  }, rest), {
    children
  }));
}

__name(StoreCardAttributes, "StoreCardAttributes");

var getStyles133 = /* @__PURE__ */__name((theme, grayscale) => ({
  icon: {
    paddingTop: 2,
    paddingRight: spacing.s8
  },
  text: __spreadProps(__spreadValues({
    display: "flex"
  }, theme.typography.bodySmall1), {
    color: grayscale ? theme.colors.systemGrayscale80 : theme.colors.brandPrimaryRegular,
    marginBottom: spacing.s8
  })
}), "getStyles");

function StoreCardETA(_a) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const theme = useTheme();
  const grayscale = useIdsFeatureFlag("grayscale") === "grayscale";
  const {
    icon,
    text
  } = combineStyles(getStyles133(theme, grayscale), styles25);
  return /* @__PURE__ */jsxs("div", __spreadProps(__spreadValues({
    css: text
  }, rest), {
    children: [/* @__PURE__ */jsx("span", {
      css: icon,
      children: /* @__PURE__ */jsx(SpeedIcon_default, {
        size: "12",
        color: grayscale ? "systemGrayscale80" : "brandPrimaryRegular"
      })
    }), children]
  }));
}

__name(StoreCardETA, "StoreCardETA");

var getStyles134 = /* @__PURE__ */__name((theme, grayscale) => ({
  text: __spreadProps(__spreadValues({
    display: "block"
  }, theme.typography.bodySmall1), {
    color: grayscale ? theme.colors.systemGrayscale80 : theme.colors.brandHighlightRegular
  })
}), "getStyles");

function StoreCardTag(_a) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const theme = useTheme();
  const grayscale = useIdsFeatureFlag("grayscale") !== "control";
  const {
    text
  } = combineStyles(getStyles134(theme, grayscale), styles25);
  return /* @__PURE__ */jsx("span", __spreadProps(__spreadValues({
    css: text
  }, rest), {
    children
  }));
}

__name(StoreCardTag, "StoreCardTag");

var IMAGE_MARGIN = 12;

var getStyles135 = /* @__PURE__ */__name((_ref96) => {
  let {
    theme,
    imageSize
  } = _ref96;
  return {
    // Necessary for measurement on resize
    container: {
      overflow: "hidden"
    },
    list: {
      listStyle: "none",
      margin: 0,
      padding: 0,
      display: "flex",
      minHeight: 36
    },
    listItem: {
      display: "inline-block",
      marginLeft: IMAGE_MARGIN,
      "&:first-of-type": {
        marginLeft: 0
      }
    },
    itemCount: __spreadProps(__spreadValues({
      borderRadius: theme.radius.r8,
      background: theme.colors.systemGrayscale10,
      color: theme.colors.systemGrayscale50
    }, theme.typography.bodyMedium1), {
      svg: {
        marginTop: 3,
        fill: theme.colors.systemGrayscale50
      },
      height: imageSize,
      width: imageSize,
      boxSizing: "border-box",
      alignItems: "center",
      display: "flex",
      justifyContent: "center"
    })
  };
}, "getStyles");

function StoreCardImageList(_a) {
  var _b = _a,
      {
    children,
    imageSize,
    styles: propsStyles
  } = _b,
      rest = __objRest(_b, ["children", "imageSize", "styles"]);

  const theme = useTheme();
  const styles25 = combineStyles(getStyles135({
    theme,
    imageSize
  }), propsStyles);
  const childrenArray = Children.toArray(children);
  const ref = useRef(null);
  const {
    width
  } = useResizeObserver({
    ref
  });
  const maxImages = width ? Math.floor((width + IMAGE_MARGIN) / (imageSize + IMAGE_MARGIN)) : childrenArray.length;
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    ref,
    css: styles25.container
  }, rest), {
    children: /* @__PURE__ */jsx("ul", {
      css: styles25.list,
      children: childrenArray.map((child, i) => {
        const isWithinWidth = i < maxImages;
        if (!isWithinWidth) return null;
        const isNotLastImage = i !== childrenArray.length - 1;
        const isNextWithinWidth = i + 1 < maxImages && isNotLastImage;
        return /* @__PURE__ */jsx("li", {
          css: styles25.listItem,
          children: isWithinWidth && !isNextWithinWidth && isNotLastImage ? /* @__PURE__ */jsxs("div", {
            css: styles25.itemCount,
            role: "note",
            children: [/* @__PURE__ */jsx(AddIcon_default, {
              size: 12
            }), childrenArray.length - (maxImages - 1)]
          }) : child
        }, String(`store-card-image-list-image-${i}`));
      })
    })
  }));
}

__name(StoreCardImageList, "StoreCardImageList");

var getStyles136 = /* @__PURE__ */__name(theme => ({
  container: __spreadProps(__spreadValues({}, elevation.low.shadow), {
    borderRadius: theme.radius.r12
  })
}), "getStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function StoreCardCompact2(_ref97, ref) {
  let {
    children
  } = _ref97;
  const theme = useTheme();
  const styles25 = getStyles136(theme);
  return /* @__PURE__ */jsx(StoreCardBase, {
    ref,
    styles: styles25,
    children
  });
}, "StoreCardCompact"));

var getStyles137 = /* @__PURE__ */__name(() => ({
  anchor: {
    padding: spacing.s8
  }
}), "getStyles");

var StoreCardCompactAnchor = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function StoreCardCompactAnchor2(_a, ref) {
  var _b = _a,
      {
    children
  } = _b,
      rest = __objRest(_b, ["children"]);

  const {
    anchor
  } = getStyles137();
  return /* @__PURE__ */jsx(StoreCardAnchor, __spreadProps(__spreadValues({
    ref,
    css: anchor
  }, rest), {
    children
  }));
}, "StoreCardCompactAnchor"));
StoreCardCompactAnchor.displayName = "StoreCardCompactAnchor";

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function TileC4(_ref98, ref) {
  let {
    children
  } = _ref98;
  const styles25 = {
    container: {}
  };
  return /* @__PURE__ */jsx(StoreCardBase, {
    ref,
    styles: styles25,
    children
  });
}, "TileC"));

var getStyles138 = /* @__PURE__ */__name(theme => ({
  text: __spreadProps(__spreadValues({
    display: "flex"
  }, theme.typography.bodySmall1), {
    color: theme.colors.systemGrayscale70
  })
}), "getStyles");

function StoreRowETA(_a) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const theme = useTheme();
  const {
    text
  } = combineStyles(getStyles138(theme), styles25);
  return /* @__PURE__ */jsx("span", __spreadProps(__spreadValues({
    css: text
  }, rest), {
    children
  }));
}

__name(StoreRowETA, "StoreRowETA");

var getStyles139 = /* @__PURE__ */__name(theme => ({
  icon: {
    paddingTop: 2,
    paddingRight: spacing.s4
  },
  text: __spreadProps(__spreadValues({
    display: "flex"
  }, theme.typography.bodySmall1), {
    color: theme.colors.brandPrimaryRegular
  })
}), "getStyles");

function StoreRowChevron(_a) {
  var _b = _a,
      {
    styles: styles25,
    children,
    color
  } = _b,
      rest = __objRest(_b, ["styles", "children", "color"]);

  const theme = useTheme();
  const {
    icon
  } = combineStyles(getStyles139(theme), styles25);
  return /* @__PURE__ */jsx("span", __spreadProps(__spreadValues({
    css: icon
  }, rest), {
    children: /* @__PURE__ */jsx(ChevronRightIcon_default, {
      size: "20",
      color: color || "systemGrayscale30"
    })
  }));
}

__name(StoreRowChevron, "StoreRowChevron");

var getStyles140 = /* @__PURE__ */__name(theme => ({
  anchor: {
    position: "relative",
    padding: `${spacing.s12}px ${spacing.s16}px`,
    "&.focus-visible::after": {
      content: '""',
      display: "block",
      position: "absolute",
      top: -4,
      bottom: -4,
      left: -4,
      right: -4,
      border: `2px solid ${theme.colors.systemGrayscale70}`,
      borderRadius: theme.radius.r12
    }
  }
}), "getStyles");

var StoreRowAnchor = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function StoreRowAnchor2(_a, ref) {
  var _b = _a,
      {
    href,
    children
  } = _b,
      rest = __objRest(_b, ["href", "children"]);

  const theme = useTheme();
  const {
    anchor
  } = getStyles140(theme);
  return /* @__PURE__ */jsx(StoreCardAnchor, __spreadProps(__spreadValues({
    ref,
    href,
    css: anchor
  }, rest), {
    children
  }));
}, "StoreRowAnchor"));
StoreRowAnchor.displayName = "StoreRowAnchor";

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function TileC5(_ref99, ref) {
  let {
    children
  } = _ref99;
  const styles25 = {
    container: {}
  };
  return /* @__PURE__ */jsx(StoreCardBase, {
    ref,
    styles: styles25,
    children
  });
}, "TileC"));

var getStyles141 = /* @__PURE__ */__name(theme => ({
  text: __spreadProps(__spreadValues({
    display: "flex"
  }, theme.typography.bodySmall1), {
    color: theme.colors.systemGrayscale70,
    marginBottom: spacing.s8
  })
}), "getStyles");

function StoreRowCompactETA(_a) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const theme = useTheme();
  const {
    text
  } = combineStyles(getStyles141(theme), styles25);
  return /* @__PURE__ */jsx("span", __spreadProps(__spreadValues({
    css: text
  }, rest), {
    children
  }));
}

__name(StoreRowCompactETA, "StoreRowCompactETA");

var getStyles142 = /* @__PURE__ */__name(theme => ({
  icon: {
    paddingTop: 2
  },
  text: __spreadProps(__spreadValues({
    display: "flex"
  }, theme.typography.bodySmall1), {
    color: theme.colors.brandPrimaryRegular
  })
}), "getStyles");

function StoreRowCompactChevron(_a) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const theme = useTheme();
  const {
    icon
  } = combineStyles(getStyles142(theme), styles25);
  return /* @__PURE__ */jsx("span", __spreadProps(__spreadValues({
    css: icon
  }, rest), {
    children: /* @__PURE__ */jsx(ChevronRightIcon_default, {
      color: "systemGrayscale30",
      size: "20"
    })
  }));
}

__name(StoreRowCompactChevron, "StoreRowCompactChevron");

var getStyles143 = /* @__PURE__ */__name(theme => ({
  anchor: {
    position: "relative",
    padding: `${spacing.s12}px ${spacing.s16}px`,
    "&.focus-visible::after": {
      content: '""',
      display: "block",
      position: "absolute",
      top: -4,
      bottom: -4,
      left: -4,
      right: -4,
      border: `2px solid ${theme.colors.systemGrayscale70}`,
      borderRadius: theme.radius.r12
    }
  }
}), "getStyles");

var StoreRowCompactAnchor = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function StoreRowCompactAnchor2(_a, ref) {
  var _b = _a,
      {
    children
  } = _b,
      rest = __objRest(_b, ["children"]);

  const theme = useTheme();
  const {
    anchor
  } = getStyles143(theme);
  return /* @__PURE__ */jsx(StoreCardAnchor, __spreadProps(__spreadValues({
    ref,
    css: anchor
  }, rest), {
    children
  }));
}, "StoreRowCompactAnchor"));
StoreRowCompactAnchor.displayName = "StoreRowCompactAnchor";

var getStyles144 = /* @__PURE__ */__name((theme, elevated) => ({
  active: {
    '&:active:not([data-disabled="true"])': {
      border: `2px solid ${theme.colors.systemGrayscale80}`
    }
  },
  button: __spreadValues({
    alignItems: "center",
    backgroundColor: theme.colors.systemGrayscale00,
    border: `1px solid ${theme.colors.systemGrayscale30}`,
    borderRadius: theme.radius.round,
    height: 48,
    width: "100%"
  }, elevated && __spreadValues({}, elevation.pantryLow2.shadow)),
  content: __spreadProps(__spreadValues({}, theme.typography.bodyEmphasized), {
    color: theme.colors.systemGrayscale80
  })
}), "getStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function SearchButton2(_a, ref) {
  var _b = _a,
      {
    children,
    elevated = false
  } = _b,
      rest = __objRest(_b, ["children", "elevated"]);

  const theme = useTheme();
  const styles25 = getStyles144(theme, elevated);
  return /* @__PURE__ */jsx(SearchButtonBase, __spreadProps(__spreadValues({
    ref,
    styles: styles25
  }, rest), {
    children
  }));
}, "SearchButton"));
var initialValues = {
  popover: void 0
};
var SheetDropdownContext = /*#__PURE__*/createContext(initialValues);
SheetDropdownContext.displayName = "SheetDropdownContext";
var DEFAULT_DROPDOWN_GUTTER = 4;

function useSheetDropdownBase(options) {
  const popover = usePopoverState(__spreadValues({
    placement: "bottom-start",
    gutter: DEFAULT_DROPDOWN_GUTTER
  }, options));
  return {
    popover
  };
}

__name(useSheetDropdownBase, "useSheetDropdownBase");

function SheetDropdown(_ref100) {
  let {
    options,
    children
  } = _ref100;
  const {
    popover
  } = useSheetDropdownBase(options);
  return /* @__PURE__ */jsx(SheetDropdownContext.Provider, {
    value: {
      popover
    },
    children
  });
}

__name(SheetDropdown, "SheetDropdown");

var DROPDOWN_WIDTH_PX = 300;

var getStyles145 = /* @__PURE__ */__name(theme => ({
  container: __spreadValues({
    boxSizing: "border-box",
    width: DROPDOWN_WIDTH_PX,
    backgroundColor: theme.colors.systemGrayscale00,
    borderRadius: theme.radius.r12,
    padding: `${spacing.s8}px 0`
  }, elevation.low.shadow)
}), "getStyles");

var SheetDropdownBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function SheetDropdownBase2(_a, ref) {
  var _b = _a,
      {
    description
  } = _b,
      rest = __objRest(_b, ["description"]);

  const {
    popover
  } = useContext(SheetDropdownContext);
  const ariaLabel = useAriaLabel({
    description
  });
  const theme = useTheme();
  const {
    container
  } = getStyles145(theme);
  return /* @__PURE__ */jsx(Popover, __spreadValues(__spreadValues(__spreadValues({
    ref,
    css: container
  }, rest), ariaLabel), popover));
}, "SheetDropdownBase"));
SheetDropdownBase.displayName = "SheetDropdownBase";
var SheetDropdownDisclosureBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function SheetDropdownBase3(props, ref) {
  const {
    popover
  } = useContext(SheetDropdownContext);
  const {
    visible
  } = popover || {};

  const _a = props,
        {
    onDropdownVisible,
    onDropdownNotVisible
  } = _a,
        buttonProps = __objRest(_a, ["onDropdownVisible", "onDropdownNotVisible"]);

  useEffect(() => {
    if (visible) return onDropdownVisible == null ? void 0 : onDropdownVisible();
    onDropdownNotVisible == null ? void 0 : onDropdownNotVisible();
  }, [onDropdownNotVisible, onDropdownVisible, visible]);
  return /* @__PURE__ */jsx(PopoverDisclosure, __spreadValues(__spreadValues({
    as: ButtonCore,
    ref
  }, popover), buttonProps));
}, "SheetDropdownBase"));
SheetDropdownDisclosureBase.displayName = "SheetDropdownDisclosureBase";
var ActionSheetDropdown = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function ActionSheetDropdown2(props, ref) {
  return /* @__PURE__ */jsx(SheetDropdownBase, __spreadValues({
    ref
  }, props));
}, "ActionSheetDropdown"));
ActionSheetDropdown.displayName = "ActionSheetDropdown";

var getStyles146 = /* @__PURE__ */__name(theme => ({
  button: __spreadValues({
    width: "100%",
    cursor: "pointer",
    textAlign: "left",
    marginBottom: spacing.s16,
    backgroundColor: "transparent",
    margin: 0,
    padding: `${spacing.s8}px ${spacing.s16}px`
  }, theme.typography.bodyMedium1),
  focusRing: {
    borderRadius: theme.radius.r8,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
}), "getStyles");

var ActionSheetDropdownItem = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function ActionSheetDropdownItem2(_a, ref) {
  var _b = _a,
      {
    children,
    onClick
  } = _b,
      rest = __objRest(_b, ["children", "onClick"]);

  const {
    popover
  } = useContext(SheetDropdownContext);
  const theme = useTheme();
  const overrideStyles = getStyles146(theme);

  const handleClick = /* @__PURE__ */__name(event => {
    onClick && onClick(event);
    popover == null ? void 0 : popover.hide();
  }, "handleClick");

  return /* @__PURE__ */jsx(ButtonBase2, __spreadProps(__spreadValues({
    ref,
    styles: overrideStyles
  }, rest), {
    type: "button",
    onClick: handleClick,
    children
  }));
}, "ActionSheetDropdownItem"));
ActionSheetDropdownItem.displayName = "ActionSheetDropdownItem";

var getStyles147 = /* @__PURE__ */__name(theme => ({
  description: __spreadProps(__spreadValues({}, theme.typography.bodyMedium2), {
    margin: `0 ${spacing.s16}px ${spacing.s4}px`,
    textAlign: "left",
    [responsive_exports.down("c")]: __spreadValues({}, theme.typography.bodyLarge2)
  })
}), "getStyles");

function ActionSheetDescription(props) {
  const theme = useTheme();
  const {
    description
  } = getStyles147(theme);
  return /* @__PURE__ */jsx("p", __spreadValues({
    css: description
  }, props));
}

__name(ActionSheetDescription, "ActionSheetDescription");

var ICON_SIZE2 = 20;

var getStyles148 = /* @__PURE__ */__name(() => ({
  icon: {
    // Offset average whitespace of SVG viewbox
    marginLeft: -2,
    marginRight: spacing.s8,
    verticalAlign: "text-bottom"
  }
}), "getStyles");

function ActionSheetItemIcon(_ref101) {
  let {
    icon: Icon,
    color
  } = _ref101;
  const {
    icon
  } = getStyles148();
  return /* @__PURE__ */jsx(Icon, {
    css: icon,
    size: ICON_SIZE2,
    color,
    "aria-hidden": true
  });
}

__name(ActionSheetItemIcon, "ActionSheetItemIcon");

ActionSheetItemIcon.displayName = "ActionSheetItemIcon";

var getStyles149 = /* @__PURE__ */__name(() => ({
  wrapper: {
    display: "flex",
    flexDirection: "column"
  }
}), "getStyles");

function AlertActions(_a) {
  var _b = _a,
      {
    children,
    styles: styles25
  } = _b,
      rest = __objRest(_b, ["children", "styles"]);

  const {
    wrapper
  } = combineStyles(getStyles149(), styles25);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    css: wrapper
  }, rest), {
    children
  }));
}

__name(AlertActions, "AlertActions");

var ALERT_TITLE_ID = "alert-title";

var getStyles150 = /* @__PURE__ */__name(theme => ({
  title: __spreadProps(__spreadValues({}, theme.typography.subtitleLarge), {
    marginBottom: 0
  })
}), "getStyles");

function AlertTitle(_a) {
  var _b = _a,
      {
    styles: styles25,
    heading: HeadingComponent,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "heading", "children"]);

  const theme = useTheme();
  const {
    title
  } = combineStyles(getStyles150(theme), styles25);
  return /* @__PURE__ */jsx(HeadingComponent, __spreadProps(__spreadValues({
    css: title,
    id: ALERT_TITLE_ID
  }, rest), {
    children
  }));
}

__name(AlertTitle, "AlertTitle");

var CAPPED_WIDTH_IN_PX = 343;

var getStyles151 = /* @__PURE__ */__name(theme => ({
  alert: __spreadValues(__spreadValues(__spreadValues({
    boxSizing: "border-box",
    borderRadius: theme.radius.r8,
    width: CAPPED_WIDTH_IN_PX,
    textAlign: "center",
    backgroundColor: theme.colors.systemGrayscale00,
    position: "fixed"
  }, POSITION_X_Y_CENTER), elevation.high.shadow), elevation.high.depth)
}), "getStyles");

function AlertBase(_a) {
  var _b = _a,
      {
    styles: styles25,
    isVisible,
    hide,
    hideOnClickOutside,
    initialFocusElem,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "isVisible", "hide", "hideOnClickOutside", "initialFocusElem", "children"]);

  const theme = useTheme();
  const dialog = useDialogState({
    modal: isVisible,
    visible: true
  });
  const ariaLabel = useAriaLabel({
    relatedIds: ALERT_TITLE_ID
  });
  const {
    alert
  } = combineStyles(getStyles151(theme), styles25);
  useInitialFocusElem({
    initialFocusElem,
    checkFocus: isVisible
  });
  if (!isVisible) return null;
  return /* @__PURE__ */jsx(Backdrop, __spreadProps(__spreadValues(__spreadValues({}, rest), dialog), {
    children: /* @__PURE__ */jsx(Dialog, __spreadProps(__spreadValues(__spreadValues({
      css: alert
    }, dialog), ariaLabel), {
      role: "alertdialog",
      hide,
      hideOnEsc: true,
      hideOnClickOutside: hideOnClickOutside != null ? hideOnClickOutside : false,
      children
    }))
  }));
}

__name(AlertBase, "AlertBase");

var FOCUS_STROKE_WEIGHT = 2;
var BORDER_TOP_STROKE_WEIGHT = 1;

var getStyles152 = /* @__PURE__ */__name(theme => ({
  button: {
    position: "relative",
    boxSizing: "border-box",
    cursor: "pointer",
    padding: spacing.s16,
    backgroundColor: "transparent",
    border: `${FOCUS_STROKE_WEIGHT}px solid transparent`,
    color: theme.colors.brandPrimaryRegular,
    marginTop: BORDER_TOP_STROKE_WEIGHT,
    "&:focus": {
      outline: "none"
    },
    "&.focus-visible": {
      border: `${FOCUS_STROKE_WEIGHT}px solid ${theme.colors.systemGrayscale70}`
    },
    "&:before": {
      position: "absolute",
      content: '""',
      height: BORDER_TOP_STROKE_WEIGHT,
      top: -FOCUS_STROKE_WEIGHT - BORDER_TOP_STROKE_WEIGHT,
      left: -FOCUS_STROKE_WEIGHT,
      right: -FOCUS_STROKE_WEIGHT,
      backgroundColor: theme.colors.systemGrayscale20
    }
  },
  label: __spreadValues({}, theme.typography.bodyLarge2)
}), "getStyles");

var AlertActionBase = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function AlertActionBase2(_a, ref) {
  var _b = _a,
      {
    styles: styles25,
    children
  } = _b,
      rest = __objRest(_b, ["styles", "children"]);

  const theme = useTheme();
  const {
    button,
    label
  } = combineStyles(getStyles152(theme), styles25);
  return /* @__PURE__ */jsx("button", __spreadProps(__spreadValues({
    ref,
    css: button
  }, rest), {
    children: /* @__PURE__ */jsx("span", {
      css: label,
      children
    })
  }));
}, "AlertActionBase"));
AlertActionBase.displayName = "AlertActionBase";

var getStyles153 = /* @__PURE__ */__name(theme => ({
  button: {
    borderBottomLeftRadius: theme.radius.r4,
    borderBottomRightRadius: theme.radius.r4
  },
  label: __spreadValues({}, theme.typography.bodyLarge1)
}), "getStyles");

var AlertActionPrimary = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function AlertActionPrimary2(props, ref) {
  const theme = useTheme();
  const styles25 = getStyles153(theme);
  return /* @__PURE__ */jsx(AlertActionBase, __spreadValues({
    ref,
    styles: styles25
  }, props));
}, "AlertActionPrimary"));
AlertActionPrimary.displayName = "AlertActionPrimary";
var AlertActionSecondary = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function AlertActionSecondary2(props, ref) {
  return /* @__PURE__ */jsx(AlertActionBase, __spreadValues({
    ref
  }, props));
}, "AlertActionSecondary"));
AlertActionSecondary.displayName = "AlertActionSecondary";

var getStyles154 = /* @__PURE__ */__name(() => ({
  wrapper: {
    margin: spacing.s16
  }
}), "getStyles");

function AlertContent(props) {
  const _a = props,
        {
    styles: styles25,
    children
  } = _a,
        rest = __objRest(_a, ["styles", "children"]);

  const {
    wrapper
  } = combineStyles(getStyles154(), styles25);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    css: wrapper
  }, rest), {
    children
  }));
}

__name(AlertContent, "AlertContent");

var getStyles155 = /* @__PURE__ */__name(theme => ({
  description: __spreadProps(__spreadValues({}, theme.typography.bodyMedium2), {
    marginTop: 0
  })
}), "getStyles");

function AlertDescription(props) {
  const theme = useTheme();

  const _a = props,
        {
    styles: styles25,
    children
  } = _a,
        rest = __objRest(_a, ["styles", "children"]);

  const {
    description
  } = combineStyles(getStyles155(theme), styles25);
  return /* @__PURE__ */jsx("p", __spreadProps(__spreadValues({
    css: description
  }, rest), {
    children
  }));
}

__name(AlertDescription, "AlertDescription");

function AlertA(props) {
  return /* @__PURE__ */jsx(AlertBase, __spreadValues({}, props));
}

__name(AlertA, "AlertA");

function AlertB(props) {
  return /* @__PURE__ */jsx(AlertBase, __spreadValues({}, props));
}

__name(AlertB, "AlertB");

function AlertC(props) {
  return /* @__PURE__ */jsx(AlertBase, __spreadValues({}, props));
}

__name(AlertC, "AlertC");

function AlertD(props) {
  return /* @__PURE__ */jsx(AlertBase, __spreadValues({}, props));
}

__name(AlertD, "AlertD");

function AlertE(props) {
  return /* @__PURE__ */jsx(AlertBase, __spreadValues({}, props));
}

__name(AlertE, "AlertE");

function AlertF(props) {
  return /* @__PURE__ */jsx(AlertBase, __spreadValues({}, props));
}

__name(AlertF, "AlertF");

var BadgeCounter = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function BadgeCounter2(props, ref) {
  const theme = useTheme();
  const badgeStyles = {
    container: {
      backgroundColor: theme.colors.systemGrayscale80
    }
  };
  return /* @__PURE__ */jsx(BadgeBase, __spreadValues({
    ref,
    styles: badgeStyles
  }, props));
}, "BadgeCounter"));

function BadgeCounterLayout(_a) {
  var _b = _a,
      {
    children
  } = _b,
      rest = __objRest(_b, ["children"]);

  return /* @__PURE__ */jsx(BadgeLayoutBase, __spreadProps(__spreadValues({}, rest), {
    children
  }));
}

__name(BadgeCounterLayout, "BadgeCounterLayout");

var getStyles156 = /* @__PURE__ */__name(() => ({
  container: {
    left: `calc(100% - 14px)`,
    margin: 0,
    position: "absolute",
    top: "2px",
    transform: "translate(0%, -50%)",
    [responsive_exports.up("r")]: {
      left: `calc(100% - ${spacing.s16}px)`,
      top: 0
    }
  }
}), "getStyles");

function BadgeCounterInLayout(_a) {
  var _b = _a,
      {
    styles: styles25
  } = _b,
      rest = __objRest(_b, ["styles"]);

  const {
    container
  } = combineStyles(getStyles156(), styles25);
  return /* @__PURE__ */jsx(BadgeCounter, __spreadValues({
    css: container
  }, rest));
}

__name(BadgeCounterInLayout, "BadgeCounterInLayout");

var BadgeNotifier = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function BadgeNotifier2(props, ref) {
  const theme = useTheme();
  const badgeStyles = {
    container: {
      backgroundColor: theme.colors.systemDetrimentalRegular
    }
  };
  return /* @__PURE__ */jsx(BadgeBase, __spreadValues({
    ref,
    styles: badgeStyles
  }, props));
}, "BadgeNotifier"));

function BadgeNotifierLayout(_a) {
  var _b = _a,
      {
    children
  } = _b,
      rest = __objRest(_b, ["children"]);

  return /* @__PURE__ */jsx(BadgeLayoutBase, __spreadProps(__spreadValues({}, rest), {
    children
  }));
}

__name(BadgeNotifierLayout, "BadgeNotifierLayout");

var getStyles157 = /* @__PURE__ */__name(() => ({
  container: {
    left: `calc(100% - 14px)`,
    margin: 0,
    position: "absolute",
    top: "2px",
    transform: "translate(0%, -50%)",
    [responsive_exports.up("r")]: {
      left: `calc(100% - ${spacing.s16}px)`,
      top: 0
    }
  }
}), "getStyles");

function BadgeNotifierInLayout(_a) {
  var _b = _a,
      {
    styles: styles25
  } = _b,
      rest = __objRest(_b, ["styles"]);

  const {
    container
  } = combineStyles(getStyles157(), styles25);
  return /* @__PURE__ */jsx(BadgeNotifier, __spreadValues({
    css: container
  }, rest));
}

__name(BadgeNotifierInLayout, "BadgeNotifierInLayout");

function EmptyStateTitle(_ref102) {
  let {
    children,
    headerLevel
  } = _ref102;
  const theme = useTheme();
  const HeaderLevel = headerLevel || "h1";
  return /* @__PURE__ */jsx(HeaderLevel, {
    css: __spreadProps(__spreadValues({}, theme.typography.bodyLarge1), {
      margin: 0
    }),
    children
  });
}

__name(EmptyStateTitle, "EmptyStateTitle");

EmptyStateTitle.displayName = "EmptyStateTitle";

function EmptyStateDescription(_ref103) {
  let {
    children
  } = _ref103;
  const theme = useTheme();
  return /* @__PURE__ */jsx("p", {
    css: __spreadProps(__spreadValues({}, theme.typography.bodyMedium2), {
      margin: 0
    }),
    children
  });
}

__name(EmptyStateDescription, "EmptyStateDescription");

EmptyStateDescription.displayName = "EmptyStateDescription";
var EmptyStateArtwork = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function EmptyStateArtwork2(props, ref) {
  return /* @__PURE__ */jsx("img", __spreadProps(__spreadValues({}, props), {
    ref,
    alt: "",
    css: {
      display: "block",
      margin: `0 auto ${spacing.s12}px`,
      maxWidth: 235,
      maxHeight: 132,
      width: "100%",
      height: "100%"
    }
  }));
}, "EmptyStateArtwork"));
EmptyStateArtwork.displayName = "EmptyStateArtwork";
var EmptyStateLink = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function EmptyStateLink2(_a, ref) {
  var _b = _a,
      {
    children
  } = _b,
      rest = __objRest(_b, ["children"]);

  const {
    colors,
    typography
  } = useTheme();
  return /* @__PURE__ */jsx("a", __spreadProps(__spreadValues({}, rest), {
    ref,
    css: __spreadProps(__spreadValues({}, typography.bodyLarge1), {
      display: "inline-block",
      marginTop: spacing.s24,
      color: colors.brandPrimaryRegular,
      textDecoration: "none"
    }),
    children
  }));
}, "EmptyStateLink"));
EmptyStateLink.displayName = "EmptyStateLink";

function EmptyState(_ref104) {
  let {
    children
  } = _ref104;
  const {
    colors
  } = useTheme();
  return /* @__PURE__ */jsx("div", {
    css: {
      color: colors.systemGrayscale50,
      textAlign: "center",
      paddingTop: spacing.s48,
      paddingBottom: spacing.s48,
      [responsive_exports.down("c")]: {
        paddingTop: 36,
        paddingBottom: 36
      }
    },
    children
  });
}

__name(EmptyState, "EmptyState");

var SheetBase_exports = {};

__export(SheetBase_exports, {
  SheetBase: () => SheetBase,
  useSheetBase: () => useSheetBase
});

var {
  s24: s242
} = spacing;

var getStyles158 = /* @__PURE__ */__name((_ref105) => {
  let {
    theme
  } = _ref105;
  const {
    r24
  } = theme.radius;
  return {
    backdrop: __spreadValues({
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "flex-end"
    }, elevation.high.depth),
    sheet: __spreadValues({
      paddingTop: s242,
      width: "100%",
      backgroundColor: theme.colors.systemGrayscale00,
      borderTopLeftRadius: r24,
      borderTopRightRadius: r24,
      // max 5/6 of viewport height
      maxHeight: "calc(100vh * 5/6)",
      overflowY: "auto"
    }, elevation.high.shadow)
  };
}, "getStyles");

function SheetBase(props) {
  const {
    ariaLabel,
    children,
    dialog,
    onlyRenderWhenVisible,
    unmountChildrenDelay,
    hideOnClickOutside,
    hideOnEsc
  } = props;
  const theme = useTheme();
  const {
    backdrop,
    sheet
  } = combineStyles(getStyles158({
    theme
  }), props.styles);
  const childrenVisible = useRenderChildrenStatus({
    modalVisible: dialog.visible,
    onlyRenderWhenVisible,
    delay: unmountChildrenDelay
  });
  const showChildren = onlyRenderWhenVisible ? childrenVisible : true;
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return /* @__PURE__ */jsx(Fragment, {
    children: mounted && /* @__PURE__ */jsx(Backdrop, __spreadProps(__spreadValues({
      css: backdrop
    }, dialog), {
      children: /* @__PURE__ */jsx(Dialog, __spreadProps(__spreadValues({
        css: sheet
      }, dialog), {
        "aria-label": ariaLabel,
        "aria-labelledby": props["aria-labelledby"],
        hideOnClickOutside,
        hideOnEsc,
        children: showChildren ? children : null
      }))
    }))
  });
}

__name(SheetBase, "SheetBase");

var useSheetBase = /* @__PURE__ */__name(options => {
  const {
    visible,
    animated
  } = options;
  const dialog = useDialogState({
    // default visible based on prop value
    // NOTE: this is only used for default, like setState
    // https://github.com/reakit/reakit/issues/487
    visible,
    animated,
    modal: true
  });
  return {
    dialog
  };
}, "useSheetBase");

var ConfirmationSheetContext = /*#__PURE__*/createContext(void 0);

var useConfirmationSheetContext = /* @__PURE__ */__name(() => {
  const context = useContext(ConfirmationSheetContext);

  if (!context) {
    throw new Error("ConfirmationSheetContext is required");
  }

  return context;
}, "useConfirmationSheetContext");

var getStyles159 = /* @__PURE__ */__name(theme => ({
  backdrop: {},
  sheet: {
    [responsive_exports.up("r")]: {
      boxSizing: "border-box",
      maxWidth: 375,
      margin: "auto",
      borderRadius: theme.radius.r24,
      overflow: "auto"
    },
    padding: spacing.s16,
    paddingTop: spacing.s24,
    overflow: "hidden"
  }
}), "getStyles");

function ConfirmationSheet(props) {
  const theme = useTheme();
  const styles25 = getStyles159(theme);
  const {
    id
  } = unstable_useId(props);
  const [hasTitleElement, setHasTitleElement] = useState(false);
  return /* @__PURE__ */jsx(ConfirmationSheetContext.Provider, {
    value: {
      labelId: id || "",
      hasTitleElement,
      setHasTitleElement
    },
    children: /* @__PURE__ */jsx(SheetBase, __spreadValues(__spreadProps(__spreadValues({}, props.ariaLabel ? {
      "aria-label": props.ariaLabel
    } : {
      "aria-labelledby": id
    }), {
      styles: styles25
    }), props))
  });
}

__name(ConfirmationSheet, "ConfirmationSheet");

function ConfirmationSheetTitle(_ref106) {
  let {
    children
  } = _ref106;
  const {
    setHasTitleElement,
    labelId
  } = useConfirmationSheetContext();
  useLayoutEffect(() => {
    setHasTitleElement(true);
    return () => {
      setHasTitleElement(false);
    };
  }, [setHasTitleElement]);
  const theme = useTheme();
  return /* @__PURE__ */jsx("h1", {
    id: labelId,
    css: __spreadProps(__spreadValues({
      margin: 0,
      padding: 0
    }, theme.typography.titleMedium), {
      color: theme.colors.systemGrayscale70,
      marginBottom: spacing.s4
    }),
    children
  });
}

__name(ConfirmationSheetTitle, "ConfirmationSheetTitle");

function ConfirmationSheetDescription(_ref107) {
  let {
    children
  } = _ref107;
  const {
    hasTitleElement,
    labelId
  } = useConfirmationSheetContext();
  const theme = useTheme();
  return /* @__PURE__ */jsx("h2", __spreadProps(__spreadValues({}, !hasTitleElement && {
    id: labelId
  }), {
    css: __spreadProps(__spreadValues({
      margin: 0,
      padding: 0
    }, theme.typography.bodyLarge2), {
      color: theme.colors.systemGrayscale70,
      marginBottom: spacing.s24
    }),
    children
  }));
}

__name(ConfirmationSheetDescription, "ConfirmationSheetDescription");

function ConfirmationSheetActions(_ref108) {
  let {
    children
  } = _ref108;
  return /* @__PURE__ */jsx("div", {
    css: {
      display: "flex",
      flexDirection: "column",
      gap: spacing.s12,
      paddingTop: spacing.s12
    },
    children
  });
}

__name(ConfirmationSheetActions, "ConfirmationSheetActions");

var useStyles3 = /* @__PURE__ */__name((_ref109) => {
  let {
    theme
  } = _ref109;
  return {
    closeButton: {
      bottom: "50%",
      height: `${spacing.s24}px`,
      right: spacing.s12,
      position: "absolute",
      transform: "translateY(50%)",
      width: `${spacing.s24}px`,
      display: "none",
      "input:not(:placeholder-shown) + &": {
        display: "block"
      }
    },
    closeButtonFocusRing: {
      borderRadius: theme.radius.round
    },
    searchIcon: {
      bottom: "50%",
      left: spacing.s12,
      position: "absolute",
      transform: "translateY(50%)"
    },
    inputContainer: {
      borderRadius: theme.radius.round,
      boxSizing: "border-box",
      height: `${spacing.s48}px`,
      gap: `${spacing.s8}px`,
      position: "relative",
      width: "100%"
    },
    input: __spreadProps(__spreadValues({
      boxShadow: `0 0 0 1px ${theme.colors.systemGrayscale20}`,
      appearance: "none",
      border: "none",
      borderRadius: theme.radius.round,
      padding: `0 ${spacing.s12 + spacing.s24}px 0 ${spacing.s48}px`
    }, theme.typography.bodyRegular), {
      width: "100%",
      background: theme.colors.systemGrayscale00,
      "&::-webkit-search-cancel-button": {
        appearance: "none"
      },
      '&[data-focused="true"]': {
        boxShadow: `0 0 0 2px ${theme.colors.systemGrayscale80}`,
        outline: "none",
        '& + button[type="submit"]': {
          opacity: 0
        }
      },
      "&::placeholder": __spreadProps(__spreadValues({}, theme.typography.bodyRegular), {
        color: theme.colors.systemGrayscale80,
        opacity: 1
      })
    })
  };
}, "useStyles");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function SearchInput2(_a, ref) {
  var _b = _a,
      {
    children,
    onClear,
    clearButtonLabel,
    styles: styles25
  } = _b,
      props = __objRest(_b, ["children", "onClear", "clearButtonLabel", "styles"]);

  const theme = useTheme();
  const internalRef = useRef(null);
  const mergedRef = useMergeRefs(ref, internalRef);
  const combinedStyles = combineStyles(useStyles3({
    theme
  }), styles25);

  const handleClear = /* @__PURE__ */__name(() => {
    var _a2;

    onClear();
    (_a2 = internalRef.current) == null ? void 0 : _a2.focus();
  }, "handleClear");

  return /* @__PURE__ */jsxs(Flex, {
    css: combinedStyles.inputContainer,
    children: [/* @__PURE__ */jsx(SearchIcon_default, {
      css: combinedStyles.searchIcon,
      size: 24
    }), /* @__PURE__ */jsx(InputCore, __spreadProps(__spreadValues({
      type: "search",
      css: combinedStyles.input,
      ref: mergedRef
    }, props), {
      placeholder: props.placeholder || " "
    })), /* @__PURE__ */jsx(ButtonCore, {
      "aria-label": clearButtonLabel,
      onPress: handleClear,
      styles: {
        button: combinedStyles.closeButton,
        focusRing: combinedStyles.closeButtonFocusRing
      },
      children: /* @__PURE__ */jsx(CloseIcon_default, {
        size: 24
      })
    })]
  });
}, "SearchInput"));
var CountrySelectTextInput_exports = {};

__export(CountrySelectTextInput_exports, {
  CountrySelectTextInput: () => CountrySelectTextInput
});

var getStyles160 = /* @__PURE__ */__name(theme => ({
  countryCallingCodeText: {
    color: theme.colors.systemGrayscale50,
    marginLeft: spacing.s8
  },
  wrapper: {
    display: "flex",
    alignItems: "center"
  },
  icon: {
    marginLeft: -2,
    marginRight: spacing.s8
  }
}), "getStyles");

function SupportedCountryDropdownItem(_ref110) {
  let {
    supportedCountry,
    styles: propStyles
  } = _ref110;
  const theme = useTheme();
  const {
    countryCallingCodeText,
    wrapper,
    icon
  } = combineStyles(getStyles160(theme), propStyles);
  const {
    countryCallingCodeString,
    countryIsoString,
    countryNameString
  } = supportedCountry;
  const IconComponent = flagIconForCountryIso(countryIsoString);
  return /* @__PURE__ */jsxs("div", {
    css: wrapper,
    children: [/* @__PURE__ */jsx(IconComponent, {
      css: icon,
      size: 20,
      color: "systemGrayscale50"
    }), countryNameString, /* @__PURE__ */jsx("span", {
      css: countryCallingCodeText,
      children: countryCallingCodeString
    })]
  });
}

__name(SupportedCountryDropdownItem, "SupportedCountryDropdownItem");

SupportedCountryDropdownItem.displayName = "ActionSheetDropdownItem";
var SupportedCountryDropdownItem_default = SupportedCountryDropdownItem;

function useFocusAndHoverStyles(_ref111) {
  let {
    invalid,
    hasValue
  } = _ref111;
  const theme = useTheme();
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [elementIsHovered, setElementIsHovered] = useState(false);
  const [elementIsFocused, setElementIsFocused] = useState(false);
  const wholeElementDarkFocus = dropdownVisible || elementIsFocused;
  const wholeElementMediumFocus = elementIsHovered || hasValue;
  const focusStyles = {
    border: "none",
    transition: "box-shadow ease-out 100ms",
    boxShadow: wholeElementDarkFocus ? `0 0 0 2px ${invalid ? theme.colors.systemDetrimentalDark : theme.colors.systemGrayscale80} !important` : wholeElementMediumFocus ? `0 0 0 1px ${invalid ? theme.colors.systemDetrimentalDark : theme.colors.systemGrayscale50}` : `0 0 0 1px ${invalid ? theme.colors.systemDetrimentalDark : theme.colors.systemGrayscale30}`
  };
  const sharedFocusProps = {
    onHoverStart: /* @__PURE__ */__name(() => {
      setElementIsHovered(true);
    }, "onHoverStart"),
    onHoverEnd: /* @__PURE__ */__name(() => {
      setElementIsHovered(false);
    }, "onHoverEnd"),
    onFocus: /* @__PURE__ */__name(() => setElementIsFocused(true), "onFocus"),
    onBlur: /* @__PURE__ */__name(() => setElementIsFocused(false), "onBlur")
  };
  const dropdownFocusProps = {
    onDropdownVisible: /* @__PURE__ */__name(() => setDropdownVisible(true), "onDropdownVisible"),
    onDropdownNotVisible: /* @__PURE__ */__name(() => setDropdownVisible(false), "onDropdownNotVisible")
  };
  return {
    focusStyles,
    sharedFocusProps,
    dropdownFocusProps,
    dropdownVisible
  };
}

__name(useFocusAndHoverStyles, "useFocusAndHoverStyles");

var getStyles161 = /* @__PURE__ */__name((theme, invalid, focusStyles) => ({
  button: __spreadProps(__spreadValues(__spreadProps(__spreadValues({
    justifyContent: "space-between",
    boxSizing: "border-box"
  }, theme.typography.bodyMedium1), {
    whiteSpace: "nowrap",
    ":focus-visible:": {
      outline: 0
    },
    "&.focus-visible::after": {
      borderRadius: theme.radius.r8,
      border: `2px solid ${theme.colors.systemGrayscale70}`,
      content: '""',
      position: "absolute",
      top: -4,
      bottom: -4,
      left: -4,
      right: -4
    },
    "&:disabled": {
      backgroundColor: theme.colors.systemGrayscale10,
      color: theme.colors.systemGrayscale30,
      cursor: "default",
      border: `1px solid transparent`
    },
    padding: `0 ${spacing.s8}px 0 ${spacing.s12}px`,
    color: theme.colors.systemGrayscale80,
    borderRadius: `${theme.radius.r8}px 0px 0px ${theme.radius.r8}px`,
    height: 48,
    display: "flex",
    alignItems: "center"
  }), focusStyles), {
    backgroundColor: invalid ? theme.colors.systemDetrimentalLight : theme.colors.systemGrayscale00,
    "&:focus": {
      outline: 0,
      background: theme.colors.systemGrayscale10
    },
    "&:hover": {
      backgroundColor: theme.colors.systemGrayscale10
    },
    "&:active": {
      borderColor: theme.colors.systemGrayscale80,
      backgroundColor: theme.colors.systemGrayscale20
    },
    [responsive_exports.up("r")]: {
      height: 56
    }
  }),
  content: {
    display: "flex",
    alignItems: "center"
  },
  buttonActive: {
    borderColor: theme.colors.systemGrayscale80,
    backgroundColor: theme.colors.systemGrayscale20
  }
}), "getStyles");

var childWrapperStyles2 = {
  textAlign: "left"
};

function CountrySelectButton(props) {
  const _a = props,
        {
    children,
    invalid,
    focusStyles
  } = _a,
        rest = __objRest(_a, ["children", "invalid", "focusStyles"]);

  const {
    isOpen,
    disabled
  } = useSelectContext();
  const theme = useTheme();
  const styles25 = getStyles161(theme, invalid, focusStyles);
  const iconColor6 = disabled ? "systemGrayscale30" : "systemGrayscale80";
  return /* @__PURE__ */jsxs(SelectButtonBase, __spreadProps(__spreadValues({}, rest), {
    styles: styles25,
    children: [/* @__PURE__ */jsx("div", {
      css: childWrapperStyles2,
      children
    }), isOpen ? /* @__PURE__ */jsx(ChevronUpIcon_default, {
      size: 16,
      color: iconColor6
    }) : /* @__PURE__ */jsx(ChevronDownIcon_default, {
      size: 16,
      color: iconColor6
    })]
  }));
}

__name(CountrySelectButton, "CountrySelectButton");

var getStyles162 = /* @__PURE__ */__name((_ref112) => {
  let {
    theme,
    focusStyles,
    inheritWidth
  } = _ref112;
  return {
    countrySelectTextInput: {
      alignItems: "start",
      display: "flex",
      marginBottom: "18px",
      position: "relative",
      [responsive_exports.up("r")]: {
        marginBottom: "20px"
      }
    },
    button: {},
    content: {
      height: "100%",
      display: "flex",
      alignItems: "center"
    },
    focusRing: {
      border: "none"
    },
    wrapper: __spreadProps(__spreadValues({
      borderRadius: `0 ${theme.radius.r8}px ${theme.radius.r8}px 0`
    }, focusStyles), {
      width: inheritWidth ? "inherit" : "unset"
    }),
    fieldWrapper: {
      width: inheritWidth ? "inherit" : "unset"
    },
    dropdown: {},
    input: {
      paddingLeft: `${spacing.s8}px`
    },
    description: {
      position: "relative",
      left: "-50px",
      width: "calc(100% + 50px)"
    },
    invalidText: {
      position: "relative",
      left: "-50px",
      width: "calc(100% + 50px)"
    }
  };
}, "getStyles");

function CountrySelectTextInput(_ref113) {
  let {
    inputLabel,
    phoneValue,
    countryCodeValue,
    onPhoneNumberChange,
    onCountryCodeChange,
    supportedCountryList,
    countrySelectLabel,
    invalidText,
    invalid,
    inheritWidth,
    autoComplete,
    onClickSelect,
    styles: propStyles,
    autoFocus,
    description,
    "aria-describedby": ariaDescribedby
  } = _ref113;
  const theme = useTheme();
  const {
    focusStyles,
    sharedFocusProps
  } = useFocusAndHoverStyles({
    invalid,
    hasValue: Boolean(phoneValue)
  });
  const styles25 = getStyles162({
    theme,
    focusStyles,
    invalid,
    inheritWidth
  });
  const {
    countrySelectTextInput: countrySelectTextInputStyles,
    dropdown
  } = combineStyles(styles25, propStyles);
  const [selectedCountry, setSelectedCountry] = useState(supportedCountryList.find(country => country.countryCallingCodeString === countryCodeValue) || supportedCountryList[0]);
  return /* @__PURE__ */jsx(Fragment, {
    children: /* @__PURE__ */jsxs("div", {
      css: countrySelectTextInputStyles,
      children: [/* @__PURE__ */jsxs(Select, {
        css: dropdown,
        selectedValue: selectedCountry.countryNameString,
        children: [/* @__PURE__ */jsxs(CountrySelectButton, __spreadProps(__spreadValues({
          styles: {
            button: [styles25.button, styles25.focusRing, {
              "& > *": styles25.content
            }]
          },
          onClick: () => onClickSelect == null ? void 0 : onClickSelect(),
          invalid,
          focusStyles
        }, sharedFocusProps), {
          children: [/* @__PURE__ */jsx(VisuallyHidden, {
            children: /* @__PURE__ */jsx(SelectButtonLabel, {
              children: countrySelectLabel
            })
          }), /* @__PURE__ */jsx(SelectButtonValue, {
            styles: {
              text: styles25.content
            },
            children: selectedCountry.countryCallingCodeString
          })]
        })), /* @__PURE__ */jsx(SelectOptions, {
          alignment: "left",
          children: supportedCountryList.map(supportedCountry => {
            const onSupportedCountryClick = /* @__PURE__ */__name(() => {
              if (selectedCountry !== supportedCountry) {
                setSelectedCountry(supportedCountry);
                onCountryCodeChange == null ? void 0 : onCountryCodeChange(supportedCountry.countryCallingCodeString);
              }
            }, "onSupportedCountryClick");

            return /* @__PURE__ */jsx(SelectOption, {
              value: supportedCountry.countryNameString,
              onClick: () => {
                onSupportedCountryClick();
              },
              children: /* @__PURE__ */jsx(SupportedCountryDropdownItem_default, {
                supportedCountry
              })
            }, supportedCountry.countryNameString);
          })
        })]
      }), /* @__PURE__ */jsx(TextInputBase, __spreadProps(__spreadValues({
        styles: {
          wrapper: styles25.wrapper,
          fieldWrapper: styles25.fieldWrapper,
          input: styles25.input,
          description: styles25.description,
          invalidText: styles25.invalidText
        }
      }, sharedFocusProps), {
        value: phoneValue,
        label: inputLabel,
        invalid,
        type: "tel",
        onChange: onPhoneNumberChange,
        autoComplete,
        autoFocus,
        description,
        invalidText,
        "aria-describedby": ariaDescribedby
      }))]
    })
  });
}

__name(CountrySelectTextInput, "CountrySelectTextInput");

var SelectionSheet_exports = {};

__export(SelectionSheet_exports, {
  SelectionSheet: () => SelectionSheet,
  SelectionSheetActions: () => SelectionSheetActions,
  SelectionSheetOption: () => SelectionSheetOption,
  SelectionSheetOptions: () => SelectionSheetOptions,
  useSelectionSheetState: () => useSelectionSheetState
});

var {
  s12: s123,
  s16: s163
} = spacing;

var getStyles163 = /* @__PURE__ */__name((_ref114) => {
  let {
    theme
  } = _ref114;
  const {
    bodyLarge1
  } = theme.typography;
  const {
    systemGrayscale50,
    systemGrayscale70
  } = theme.colors;
  return {
    button: __spreadProps(__spreadValues({
      width: "100%",
      display: "flex",
      alignItems: "center",
      paddingTop: s123,
      paddingBottom: s123,
      paddingLeft: s163,
      paddingRight: s163,
      border: 0,
      color: systemGrayscale50,
      backgroundColor: "transparent"
    }, bodyLarge1), {
      // focus ring styles
      position: "relative",
      "&.focus-visible::after": {
        borderRadius: 119,
        border: `2px solid ${systemGrayscale70}`,
        content: '""',
        display: "block",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      },
      "&:focus": {
        outline: "none"
      },
      "&.focus-visible": {
        outline: "none"
      } // end focus ring styles

    }),
    activeButton: {
      color: systemGrayscale70
    },
    span: {
      textAlign: "left",
      flex: "1 1 auto",
      overflow: "hidden",
      textOverflow: "ellipsis",
      minWidth: 0
    },
    activeIcon: {
      flex: "0 0 auto"
    }
  };
}, "getStyles");

function SheetOptionBase(props) {
  const {
    children,
    dialog,
    currentValue,
    setValue,
    value,
    onClick
  } = props;
  const ref = useRef(null);
  const theme = useTheme();
  const {
    button,
    activeButton,
    span,
    activeIcon
  } = getStyles163({
    theme
  });
  const active = currentValue === value;

  const styles25 = __spreadValues(__spreadValues({}, button), active ? activeButton : {});

  useEffect(() => {
    if (dialog.visible && ref.current && active) {
      ref.current.focus();
      ref.current.scrollIntoView(false);
    }
  }, [dialog.visible, ref]);
  const ariaCurrent = useAriaCurrent({
    current: active
  });

  const handleClick = /* @__PURE__ */__name(() => {
    setValue(value);
    onClick == null ? void 0 : onClick();
  }, "handleClick");

  return /* @__PURE__ */jsxs("button", __spreadProps(__spreadValues({}, ariaCurrent), {
    css: styles25,
    ref,
    onClick: handleClick,
    children: [/* @__PURE__ */jsx("span", {
      css: span,
      children
    }), active ? /* @__PURE__ */jsx(ConfirmIcon_default, {
      "aria-hidden": true,
      css: activeIcon,
      color: "brandPrimaryRegular",
      role: "img"
    }) : null]
  }));
}

__name(SheetOptionBase, "SheetOptionBase");

var getStyles164 = /* @__PURE__ */__name(() => {
  return {
    backdrop: {
      display: "flex",
      flexDirection: "column"
    },
    sheet: {
      display: "inherit",
      flexDirection: "inherit",
      minHeight: 0,
      flex: "0 1 auto"
    },
    menu: {
      display: "inherit",
      flexDirection: "inherit",
      minHeight: "inherit",
      flex: "inherit"
    }
  };
}, "getStyles");

function SelectionSheet(props) {
  const {
    menu,
    sheet,
    backdrop
  } = getStyles164();
  const {
    onChange,
    defaultValue,
    children,
    ariaLabel,
    currentValue,
    setVisible,
    dialog
  } = props;
  const baseProps = {
    ariaLabel,
    dialog
  };
  const [previousValue, setPreviousValue] = useState(defaultValue);
  useEffect(() => {
    if (currentValue !== previousValue) {
      setPreviousValue(currentValue);
      onChange(currentValue);
      setVisible(false);
    }
  }, [setPreviousValue, setVisible, previousValue, currentValue, onChange]);
  return /* @__PURE__ */jsx(SheetBase, __spreadProps(__spreadValues({
    styles: {
      sheet,
      backdrop
    }
  }, baseProps), {
    children: /* @__PURE__ */jsx("div", {
      css: menu,
      children
    })
  }));
}

__name(SelectionSheet, "SelectionSheet");

var {
  s12: s124,
  s16: s164
} = spacing;

var getStyles165 = /* @__PURE__ */__name(() => {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: s124,
      marginBottom: s124,
      marginLeft: s164,
      marginRight: s164
    }
  };
}, "getStyles");

function SelectionSheetActions(props) {
  const {
    children
  } = props;
  const {
    container
  } = getStyles165();
  return /* @__PURE__ */jsx("div", {
    css: container,
    children
  });
}

__name(SelectionSheetActions, "SelectionSheetActions");

var getStyles166 = /* @__PURE__ */__name(() => {
  return {
    container: {
      overflowY: "auto"
    }
  };
}, "getStyles");

function SelectionSheetOptions(props) {
  const {
    children
  } = props;
  const {
    container
  } = getStyles166();
  return /* @__PURE__ */jsx("div", {
    css: container,
    children
  });
}

__name(SelectionSheetOptions, "SelectionSheetOptions");

var useSelectionSheetState = /* @__PURE__ */__name(options => {
  const {
    defaultValue,
    name
  } = options;
  const {
    dialog
  } = useSheetBase({
    visible: options.visible
  });
  const [values, setValues] = useState({
    [name]: defaultValue
  });
  const {
    setVisible,
    visible
  } = dialog;

  const setValue = /* @__PURE__ */__name(value => {
    setValues(__spreadProps(__spreadValues({}, values), {
      [name]: value
    }));
  }, "setValue");

  const currentValue = values[name];
  return [{
    value: currentValue,
    setValue,
    visible,
    setVisible
  }, {
    dialog,
    name,
    currentValue,
    setVisible,
    setValue
  }];
}, "useSelectionSheetState");

var SelectionSheetOption = SheetOptionBase;
var DeprecatedCoachmark_exports = {};

__export(DeprecatedCoachmark_exports, {
  Coachmark: () => Coachmark3
});

var COACHMARK_MAX_WIDTH = 30;

var getStyles167 = /* @__PURE__ */__name((theme, grayscale) => ({
  popover: {
    outline: "none",
    zIndex: layers.l1
  },
  content: __spreadValues({
    backgroundColor: grayscale ? theme.colors.systemGrayscale80 : theme.colors.brandHighlightDark,
    padding: "11px 12px 13px",
    borderRadius: theme.radius.r8,
    color: theme.colors.systemGrayscale00,
    maxWidth: `${COACHMARK_MAX_WIDTH}rem`
  }, theme.typography.bodyMedium1),
  arrow: {
    fill: grayscale ? theme.colors.systemGrayscale80 : theme.colors.brandHighlightDark
  }
}), "getStyles");

var Coachmark3 = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function DeprecatedCoachmark(_ref115, ref) {
  let {
    styles: styles25,
    popover,
    children,
    label,
    hideOnEsc,
    hideOnClickOutside,

    /* eslint-disable @typescript-eslint/naming-convention */
    unstable_autoFocusOnHide,
    unstable_autoFocusOnShow,
    unstable_initialFocusRef,
    unstable_finalFocusRef
    /* eslint-enable @typescript-eslint/naming-convention */

  } = _ref115;
  const theme = useTheme();
  const grayscale = useIdsFeatureFlag("grayscale") !== "control";
  const {
    popover: popoverCss,
    content,
    arrow
  } = combineStyles(getStyles167(theme, grayscale), styles25);
  return /* @__PURE__ */jsx(Popover, __spreadProps(__spreadValues({}, popover), {
    hideOnEsc,
    hideOnClickOutside,
    unstable_autoFocusOnHide,
    unstable_autoFocusOnShow,
    unstable_initialFocusRef,
    unstable_finalFocusRef,
    css: popoverCss,
    ref,
    "aria-label": label,
    children: /* @__PURE__ */jsxs("div", {
      css: content,
      children: [/* @__PURE__ */jsx(PopoverArrow, __spreadValues({
        size: 20,
        css: arrow
      }, popover)), children]
    })
  }));
}, "DeprecatedCoachmark"));
export { ALERT_TITLE_ID, AVATAR_BORDER_PX, ActionSheetDescription, ActionSheetDropdown, ActionSheetDropdownItem, ActionSheetItemIcon, AddItem, AddItemButton, AddItemButtonBase, AddItemExpanded, AddItemExpandedDisclaimer, AddItemExpandedUnit, AddItemStepperBase, AdvertiserAvatarLarge, AdvertiserAvatarMedium, AdvertiserAvatarSmall, AlertA, AlertActionBase, AlertActionPrimary, AlertActionSecondary, AlertActions, AlertB, AlertBase, AlertC, AlertContent, AlertD, AlertDescription, AlertE, AlertF, AlertTitle, AvatarBase, BORDER_WIDTH, Backdrop, BackdropBase, BadgeBase, BadgeCounter, BadgeCounterInLayout, BadgeCounterLayout, BadgeLayoutBase, BadgeNotifier, BadgeNotifierInLayout, BadgeNotifierLayout, ButtonBase2 as ButtonBase, ButtonCompactBase, ButtonPillBase, ButtonSmallBase, CartButtonBase, CategoryTab, CategoryTabList, CategoryTabPanel, CategoryTabs, Center, Coachmark, CoachmarkDisclosure, ConfirmationSheet, ConfirmationSheetActions, ConfirmationSheetDescription, ConfirmationSheetTitle, CouponClipButton, DROP_DOWN_WIDTH, DarkOverlayIconButton, Divider, DividerBase, EmptyState, EmptyStateArtwork, EmptyStateDescription, EmptyStateLink, EmptyStateTitle, GroupCartButtonBase, IconButton2 as IconButton, IconButtonBase, Image, InlineTextButton, InputBase, InstacartPlusSwitch, ItemAttribute, ItemAttributeBase, ItemBase, ItemDynamicLabel, ItemDynamicLabelBase, ItemImageBase, ItemLinkBase, ItemName, ItemNameBase, ItemPrice, ItemPriceBase, ItemPriceSet, ItemPriceSetBase, ItemRegularPrice, ItemRegularPriceBase, ItemSalePrice, ItemWeight, ItemWeightBase, Left4 as Left, LegacyCheckboxBase, LightOverlayIconButton, LinkBase, LoadingDots, LoadingGenericAnimation, LoadingGenericBase, LoadingLockupGridItem, LoadingLockupIconBase, LoadingLockupIconRow, LoadingLockupImageBase, LoadingLockupImageRow, LoadingLockupLayout, LoadingLockupListItem, LoadingLockupTextBase, LoadingLockupTextRow, LoadingSpinner, LockupB, LockupD, Marker, MarkerBase, MarkerChip, MarkerIconLeft, MarkerIconRight, MaxBadge, ModalBase, ModalContentBase, ModalFooter, ModalFooterBase, ModalFooterNoShadow, ModalHeader, ModalHeaderBase, ModalInnerWrapper, ModalTitle, ModalTitleBase, MultiSelectListOption, MultiSelectListOptionBase, OverflowingStack, PersonAvatarLarge, PersonAvatarMedium, PersonAvatarSmall, PrimaryButtonSmall, PrimaryIconButton, PromotionModalBody, PromotionModalButtons, PromotionModalDescription, PromotionModalImage, PromotionModalSubtitle, PromotionModalTitle, RadioButtonGroupWrap, RadioPill, RadioPillBase, RadioPillGroup, RadioPillGroupBase, RadioSelectorBase, RetailerAvatarLarge, RetailerAvatarMedium, RetailerAvatarSmall, RetailerLogoIcon, RowBase, RowLayoutLeftBase, RowLayoutRightBase, RowLayoutTextBase, RowTextPrimaryBase, RowTextSecondaryBase, SIZE_COMPACT, SIZE_REGULAR, SIZE_SMALL, SearchButtonBase, SecondaryButtonSmall, SecondaryIconButton, Select, SelectBase, SelectButton, SelectButtonBase, SelectButtonLabel, SelectButtonLabelBase, SelectButtonValue, SelectButtonValueBase, SelectMenu, SelectMenuButton, SelectMenuContext, SelectMenuDropdown, SelectMenuFooter, SelectMenuFooterButton, SelectMenuList, SelectOption, SelectOptionBase, SelectOptions, SelectOptionsBase, SelectionRow, SelectionRowCheckbox, SelectionRowLabel, SelectionRowLayoutLeft, SelectionRowLayoutRight, SelectionRowRadioSelector, SelectionRowSwitch, SelectionRowTextPrimary, SelectionRowTextSecondary, ServiceMessageA3 as ServiceMessageA, ServiceMessageBase, ServiceMessageButtonBase, ServiceMessageCloseButton, ServiceMessageDescriptionBase, ServiceMessageInfoBase, ServiceMessageMoreButton, SheetDropdown, SheetDropdownBase, SheetDropdownContext, SheetDropdownDisclosureBase, SingleSelectOption, SingleSelectSubOption, SingleSelectViewMoreButton, SteppedProgressIndicatorBase, StepperBase, StoreCardAnchor, StoreCardAttributes, StoreCardBase, StoreCardCenter, StoreCardCenterFooter, StoreCardCompactAnchor, StoreCardETA, StoreCardFooter, StoreCardImage, StoreCardImageList, StoreCardRight, StoreCardTag, StoreCardTitle, StoreRowAnchor, StoreRowChevron, StoreRowCompactAnchor, StoreRowCompactChevron, StoreRowCompactETA, StoreRowETA, SwitchBase, Tab, TabContext, TabList, TabPanel, Tabs, TertiaryIconButton, Text, TextAreaBase, TextAreaDynamic, TextAreaFixed, TextButton, TextInputBase, TileBase, TileImage, TileTitle, Toast, ToastAction, ToastIcon, ToastText, ToastsContainer, Tooltip, TooltipBase, Vote, buttonSizeStyles, flagIconForCountryIso, generateInteractiveRowStyles, getStyles80 as getStyles, loadingDotGap, loadingDotSize, DeprecatedCoachmark_exports as unstableCoachmark, CountrySelectTextInput_exports as unstableCountrySelectTextInput, SelectionSheet_exports as unstableSelectionSheet, ServiceMessageA_exports as unstableServiceMessageA, SheetBase_exports as unstableSheetBase, useComputeInteractiveColors, useScrollButtonVisibilityHandler, useSelect, useSelectMenuContext, useSheetDropdownBase };